import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  exam_types: any;
  float8: any;
  jsonb: any;
  numeric: any;
  timestamp: any;
  timestamptz: any;
};



/** expression to compare columns of type Boolean. All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

/** expression to compare columns of type Float. All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: Maybe<Scalars['Float']>;
  _gt?: Maybe<Scalars['Float']>;
  _gte?: Maybe<Scalars['Float']>;
  _in?: Maybe<Array<Scalars['Float']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Float']>;
  _lte?: Maybe<Scalars['Float']>;
  _neq?: Maybe<Scalars['Float']>;
  _nin?: Maybe<Array<Scalars['Float']>>;
};

/** expression to compare columns of type Int. All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

/** expression to compare columns of type String. All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  _nlike?: Maybe<Scalars['String']>;
  _nsimilar?: Maybe<Scalars['String']>;
  _similar?: Maybe<Scalars['String']>;
};

/** columns and relationships of "activation_codes" */
export type Activation_Codes = {
  __typename?: 'activation_codes';
  activated_by?: Maybe<Scalars['Int']>;
  activation_date?: Maybe<Scalars['timestamp']>;
  code: Scalars['String'];
  extra_days: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  profile?: Maybe<Profiles>;
  type: Scalars['String'];
};

/** aggregated selection of "activation_codes" */
export type Activation_Codes_Aggregate = {
  __typename?: 'activation_codes_aggregate';
  aggregate?: Maybe<Activation_Codes_Aggregate_Fields>;
  nodes: Array<Activation_Codes>;
};

/** aggregate fields of "activation_codes" */
export type Activation_Codes_Aggregate_Fields = {
  __typename?: 'activation_codes_aggregate_fields';
  avg?: Maybe<Activation_Codes_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Activation_Codes_Max_Fields>;
  min?: Maybe<Activation_Codes_Min_Fields>;
  stddev?: Maybe<Activation_Codes_Stddev_Fields>;
  stddev_pop?: Maybe<Activation_Codes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Activation_Codes_Stddev_Samp_Fields>;
  sum?: Maybe<Activation_Codes_Sum_Fields>;
  var_pop?: Maybe<Activation_Codes_Var_Pop_Fields>;
  var_samp?: Maybe<Activation_Codes_Var_Samp_Fields>;
  variance?: Maybe<Activation_Codes_Variance_Fields>;
};


/** aggregate fields of "activation_codes" */
export type Activation_Codes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Activation_Codes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "activation_codes" */
export type Activation_Codes_Aggregate_Order_By = {
  avg?: Maybe<Activation_Codes_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Activation_Codes_Max_Order_By>;
  min?: Maybe<Activation_Codes_Min_Order_By>;
  stddev?: Maybe<Activation_Codes_Stddev_Order_By>;
  stddev_pop?: Maybe<Activation_Codes_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Activation_Codes_Stddev_Samp_Order_By>;
  sum?: Maybe<Activation_Codes_Sum_Order_By>;
  var_pop?: Maybe<Activation_Codes_Var_Pop_Order_By>;
  var_samp?: Maybe<Activation_Codes_Var_Samp_Order_By>;
  variance?: Maybe<Activation_Codes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "activation_codes" */
export type Activation_Codes_Arr_Rel_Insert_Input = {
  data: Array<Activation_Codes_Insert_Input>;
  on_conflict?: Maybe<Activation_Codes_On_Conflict>;
};

/** aggregate avg on columns */
export type Activation_Codes_Avg_Fields = {
  __typename?: 'activation_codes_avg_fields';
  activated_by?: Maybe<Scalars['Float']>;
  extra_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "activation_codes" */
export type Activation_Codes_Avg_Order_By = {
  activated_by?: Maybe<Order_By>;
  extra_days?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "activation_codes". All fields are combined with a logical 'AND'. */
export type Activation_Codes_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Activation_Codes_Bool_Exp>>>;
  _not?: Maybe<Activation_Codes_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Activation_Codes_Bool_Exp>>>;
  activated_by?: Maybe<Int_Comparison_Exp>;
  activation_date?: Maybe<Timestamp_Comparison_Exp>;
  code?: Maybe<String_Comparison_Exp>;
  extra_days?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  profile?: Maybe<Profiles_Bool_Exp>;
  type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "activation_codes" */
export enum Activation_Codes_Constraint {
  /** unique or primary key constraint */
  ActivationCodesPkey = 'activation_codes_pkey'
}

/** input type for incrementing integer column in table "activation_codes" */
export type Activation_Codes_Inc_Input = {
  activated_by?: Maybe<Scalars['Int']>;
  extra_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "activation_codes" */
export type Activation_Codes_Insert_Input = {
  activated_by?: Maybe<Scalars['Int']>;
  activation_date?: Maybe<Scalars['timestamp']>;
  code?: Maybe<Scalars['String']>;
  extra_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  profile?: Maybe<Profiles_Obj_Rel_Insert_Input>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Activation_Codes_Max_Fields = {
  __typename?: 'activation_codes_max_fields';
  activated_by?: Maybe<Scalars['Int']>;
  activation_date?: Maybe<Scalars['timestamp']>;
  code?: Maybe<Scalars['String']>;
  extra_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "activation_codes" */
export type Activation_Codes_Max_Order_By = {
  activated_by?: Maybe<Order_By>;
  activation_date?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  extra_days?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Activation_Codes_Min_Fields = {
  __typename?: 'activation_codes_min_fields';
  activated_by?: Maybe<Scalars['Int']>;
  activation_date?: Maybe<Scalars['timestamp']>;
  code?: Maybe<Scalars['String']>;
  extra_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "activation_codes" */
export type Activation_Codes_Min_Order_By = {
  activated_by?: Maybe<Order_By>;
  activation_date?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  extra_days?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
};

/** response of any mutation on the table "activation_codes" */
export type Activation_Codes_Mutation_Response = {
  __typename?: 'activation_codes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Activation_Codes>;
};

/** input type for inserting object relation for remote table "activation_codes" */
export type Activation_Codes_Obj_Rel_Insert_Input = {
  data: Activation_Codes_Insert_Input;
  on_conflict?: Maybe<Activation_Codes_On_Conflict>;
};

/** on conflict condition type for table "activation_codes" */
export type Activation_Codes_On_Conflict = {
  constraint: Activation_Codes_Constraint;
  update_columns: Array<Activation_Codes_Update_Column>;
  where?: Maybe<Activation_Codes_Bool_Exp>;
};

/** ordering options when selecting data from "activation_codes" */
export type Activation_Codes_Order_By = {
  activated_by?: Maybe<Order_By>;
  activation_date?: Maybe<Order_By>;
  code?: Maybe<Order_By>;
  extra_days?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  profile?: Maybe<Profiles_Order_By>;
  type?: Maybe<Order_By>;
};

/** primary key columns input for table: "activation_codes" */
export type Activation_Codes_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "activation_codes" */
export enum Activation_Codes_Select_Column {
  /** column name */
  ActivatedBy = 'activated_by',
  /** column name */
  ActivationDate = 'activation_date',
  /** column name */
  Code = 'code',
  /** column name */
  ExtraDays = 'extra_days',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "activation_codes" */
export type Activation_Codes_Set_Input = {
  activated_by?: Maybe<Scalars['Int']>;
  activation_date?: Maybe<Scalars['timestamp']>;
  code?: Maybe<Scalars['String']>;
  extra_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Activation_Codes_Stddev_Fields = {
  __typename?: 'activation_codes_stddev_fields';
  activated_by?: Maybe<Scalars['Float']>;
  extra_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "activation_codes" */
export type Activation_Codes_Stddev_Order_By = {
  activated_by?: Maybe<Order_By>;
  extra_days?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Activation_Codes_Stddev_Pop_Fields = {
  __typename?: 'activation_codes_stddev_pop_fields';
  activated_by?: Maybe<Scalars['Float']>;
  extra_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "activation_codes" */
export type Activation_Codes_Stddev_Pop_Order_By = {
  activated_by?: Maybe<Order_By>;
  extra_days?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Activation_Codes_Stddev_Samp_Fields = {
  __typename?: 'activation_codes_stddev_samp_fields';
  activated_by?: Maybe<Scalars['Float']>;
  extra_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "activation_codes" */
export type Activation_Codes_Stddev_Samp_Order_By = {
  activated_by?: Maybe<Order_By>;
  extra_days?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Activation_Codes_Sum_Fields = {
  __typename?: 'activation_codes_sum_fields';
  activated_by?: Maybe<Scalars['Int']>;
  extra_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "activation_codes" */
export type Activation_Codes_Sum_Order_By = {
  activated_by?: Maybe<Order_By>;
  extra_days?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "activation_codes" */
export enum Activation_Codes_Update_Column {
  /** column name */
  ActivatedBy = 'activated_by',
  /** column name */
  ActivationDate = 'activation_date',
  /** column name */
  Code = 'code',
  /** column name */
  ExtraDays = 'extra_days',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

/** aggregate var_pop on columns */
export type Activation_Codes_Var_Pop_Fields = {
  __typename?: 'activation_codes_var_pop_fields';
  activated_by?: Maybe<Scalars['Float']>;
  extra_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "activation_codes" */
export type Activation_Codes_Var_Pop_Order_By = {
  activated_by?: Maybe<Order_By>;
  extra_days?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Activation_Codes_Var_Samp_Fields = {
  __typename?: 'activation_codes_var_samp_fields';
  activated_by?: Maybe<Scalars['Float']>;
  extra_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "activation_codes" */
export type Activation_Codes_Var_Samp_Order_By = {
  activated_by?: Maybe<Order_By>;
  extra_days?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Activation_Codes_Variance_Fields = {
  __typename?: 'activation_codes_variance_fields';
  activated_by?: Maybe<Scalars['Float']>;
  extra_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "activation_codes" */
export type Activation_Codes_Variance_Order_By = {
  activated_by?: Maybe<Order_By>;
  extra_days?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** columns and relationships of "answers" */
export type Answers = {
  __typename?: 'answers';
  /** An array relationship */
  answers_choice_associations: Array<Answers_Choice_Association>;
  /** An aggregated array relationship */
  answers_choice_associations_aggregate: Answers_Choice_Association_Aggregate;
  created_at: Scalars['timestamp'];
  exam_type: Scalars['exam_types'];
  extra_value?: Maybe<Scalars['String']>;
  feedback?: Maybe<Scalars['String']>;
  /** An object relationship */
  feedbackAuthor?: Maybe<Profiles>;
  feedback_at?: Maybe<Scalars['timestamptz']>;
  feedback_by?: Maybe<Scalars['Int']>;
  feedback_score?: Maybe<Scalars['numeric']>;
  id: Scalars['Int'];
  is_correct: Scalars['Boolean'];
  is_mock: Scalars['Boolean'];
  need_feedback?: Maybe<Scalars['Boolean']>;
  part: Scalars['Int'];
  /** An object relationship */
  profile?: Maybe<Profiles>;
  /** An object relationship */
  question: Questions;
  question_id: Scalars['Int'];
  /** An object relationship */
  result?: Maybe<Results>;
  result_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
};


/** columns and relationships of "answers" */
export type AnswersAnswers_Choice_AssociationsArgs = {
  distinct_on?: Maybe<Array<Answers_Choice_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Choice_Association_Order_By>>;
  where?: Maybe<Answers_Choice_Association_Bool_Exp>;
};


/** columns and relationships of "answers" */
export type AnswersAnswers_Choice_Associations_AggregateArgs = {
  distinct_on?: Maybe<Array<Answers_Choice_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Choice_Association_Order_By>>;
  where?: Maybe<Answers_Choice_Association_Bool_Exp>;
};

/** aggregated selection of "answers" */
export type Answers_Aggregate = {
  __typename?: 'answers_aggregate';
  aggregate?: Maybe<Answers_Aggregate_Fields>;
  nodes: Array<Answers>;
};

/** aggregate fields of "answers" */
export type Answers_Aggregate_Fields = {
  __typename?: 'answers_aggregate_fields';
  avg?: Maybe<Answers_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Answers_Max_Fields>;
  min?: Maybe<Answers_Min_Fields>;
  stddev?: Maybe<Answers_Stddev_Fields>;
  stddev_pop?: Maybe<Answers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Answers_Stddev_Samp_Fields>;
  sum?: Maybe<Answers_Sum_Fields>;
  var_pop?: Maybe<Answers_Var_Pop_Fields>;
  var_samp?: Maybe<Answers_Var_Samp_Fields>;
  variance?: Maybe<Answers_Variance_Fields>;
};


/** aggregate fields of "answers" */
export type Answers_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Answers_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "answers" */
export type Answers_Aggregate_Order_By = {
  avg?: Maybe<Answers_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Answers_Max_Order_By>;
  min?: Maybe<Answers_Min_Order_By>;
  stddev?: Maybe<Answers_Stddev_Order_By>;
  stddev_pop?: Maybe<Answers_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Answers_Stddev_Samp_Order_By>;
  sum?: Maybe<Answers_Sum_Order_By>;
  var_pop?: Maybe<Answers_Var_Pop_Order_By>;
  var_samp?: Maybe<Answers_Var_Samp_Order_By>;
  variance?: Maybe<Answers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "answers" */
export type Answers_Arr_Rel_Insert_Input = {
  data: Array<Answers_Insert_Input>;
  on_conflict?: Maybe<Answers_On_Conflict>;
};

/** aggregate avg on columns */
export type Answers_Avg_Fields = {
  __typename?: 'answers_avg_fields';
  feedback_by?: Maybe<Scalars['Float']>;
  feedback_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "answers" */
export type Answers_Avg_Order_By = {
  feedback_by?: Maybe<Order_By>;
  feedback_score?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "answers". All fields are combined with a logical 'AND'. */
export type Answers_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Answers_Bool_Exp>>>;
  _not?: Maybe<Answers_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Answers_Bool_Exp>>>;
  answers_choice_associations?: Maybe<Answers_Choice_Association_Bool_Exp>;
  created_at?: Maybe<Timestamp_Comparison_Exp>;
  exam_type?: Maybe<Exam_Types_Comparison_Exp>;
  extra_value?: Maybe<String_Comparison_Exp>;
  feedback?: Maybe<String_Comparison_Exp>;
  feedbackAuthor?: Maybe<Profiles_Bool_Exp>;
  feedback_at?: Maybe<Timestamptz_Comparison_Exp>;
  feedback_by?: Maybe<Int_Comparison_Exp>;
  feedback_score?: Maybe<Numeric_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_correct?: Maybe<Boolean_Comparison_Exp>;
  is_mock?: Maybe<Boolean_Comparison_Exp>;
  need_feedback?: Maybe<Boolean_Comparison_Exp>;
  part?: Maybe<Int_Comparison_Exp>;
  profile?: Maybe<Profiles_Bool_Exp>;
  question?: Maybe<Questions_Bool_Exp>;
  question_id?: Maybe<Int_Comparison_Exp>;
  result?: Maybe<Results_Bool_Exp>;
  result_id?: Maybe<Int_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Int_Comparison_Exp>;
};

/** columns and relationships of "answers_choice_association" */
export type Answers_Choice_Association = {
  __typename?: 'answers_choice_association';
  /** An object relationship */
  answer?: Maybe<Answers>;
  answer_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  choice?: Maybe<Choices>;
  choice_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "answers_choice_association" */
export type Answers_Choice_Association_Aggregate = {
  __typename?: 'answers_choice_association_aggregate';
  aggregate?: Maybe<Answers_Choice_Association_Aggregate_Fields>;
  nodes: Array<Answers_Choice_Association>;
};

/** aggregate fields of "answers_choice_association" */
export type Answers_Choice_Association_Aggregate_Fields = {
  __typename?: 'answers_choice_association_aggregate_fields';
  avg?: Maybe<Answers_Choice_Association_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Answers_Choice_Association_Max_Fields>;
  min?: Maybe<Answers_Choice_Association_Min_Fields>;
  stddev?: Maybe<Answers_Choice_Association_Stddev_Fields>;
  stddev_pop?: Maybe<Answers_Choice_Association_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Answers_Choice_Association_Stddev_Samp_Fields>;
  sum?: Maybe<Answers_Choice_Association_Sum_Fields>;
  var_pop?: Maybe<Answers_Choice_Association_Var_Pop_Fields>;
  var_samp?: Maybe<Answers_Choice_Association_Var_Samp_Fields>;
  variance?: Maybe<Answers_Choice_Association_Variance_Fields>;
};


/** aggregate fields of "answers_choice_association" */
export type Answers_Choice_Association_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Answers_Choice_Association_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "answers_choice_association" */
export type Answers_Choice_Association_Aggregate_Order_By = {
  avg?: Maybe<Answers_Choice_Association_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Answers_Choice_Association_Max_Order_By>;
  min?: Maybe<Answers_Choice_Association_Min_Order_By>;
  stddev?: Maybe<Answers_Choice_Association_Stddev_Order_By>;
  stddev_pop?: Maybe<Answers_Choice_Association_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Answers_Choice_Association_Stddev_Samp_Order_By>;
  sum?: Maybe<Answers_Choice_Association_Sum_Order_By>;
  var_pop?: Maybe<Answers_Choice_Association_Var_Pop_Order_By>;
  var_samp?: Maybe<Answers_Choice_Association_Var_Samp_Order_By>;
  variance?: Maybe<Answers_Choice_Association_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "answers_choice_association" */
export type Answers_Choice_Association_Arr_Rel_Insert_Input = {
  data: Array<Answers_Choice_Association_Insert_Input>;
};

/** aggregate avg on columns */
export type Answers_Choice_Association_Avg_Fields = {
  __typename?: 'answers_choice_association_avg_fields';
  answer_id?: Maybe<Scalars['Float']>;
  choice_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "answers_choice_association" */
export type Answers_Choice_Association_Avg_Order_By = {
  answer_id?: Maybe<Order_By>;
  choice_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "answers_choice_association". All fields are combined with a logical 'AND'. */
export type Answers_Choice_Association_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Answers_Choice_Association_Bool_Exp>>>;
  _not?: Maybe<Answers_Choice_Association_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Answers_Choice_Association_Bool_Exp>>>;
  answer?: Maybe<Answers_Bool_Exp>;
  answer_id?: Maybe<Int_Comparison_Exp>;
  choice?: Maybe<Choices_Bool_Exp>;
  choice_id?: Maybe<Int_Comparison_Exp>;
};

/** input type for incrementing integer column in table "answers_choice_association" */
export type Answers_Choice_Association_Inc_Input = {
  answer_id?: Maybe<Scalars['Int']>;
  choice_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "answers_choice_association" */
export type Answers_Choice_Association_Insert_Input = {
  answer?: Maybe<Answers_Obj_Rel_Insert_Input>;
  answer_id?: Maybe<Scalars['Int']>;
  choice?: Maybe<Choices_Obj_Rel_Insert_Input>;
  choice_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Answers_Choice_Association_Max_Fields = {
  __typename?: 'answers_choice_association_max_fields';
  answer_id?: Maybe<Scalars['Int']>;
  choice_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "answers_choice_association" */
export type Answers_Choice_Association_Max_Order_By = {
  answer_id?: Maybe<Order_By>;
  choice_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Answers_Choice_Association_Min_Fields = {
  __typename?: 'answers_choice_association_min_fields';
  answer_id?: Maybe<Scalars['Int']>;
  choice_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "answers_choice_association" */
export type Answers_Choice_Association_Min_Order_By = {
  answer_id?: Maybe<Order_By>;
  choice_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "answers_choice_association" */
export type Answers_Choice_Association_Mutation_Response = {
  __typename?: 'answers_choice_association_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Answers_Choice_Association>;
};

/** input type for inserting object relation for remote table "answers_choice_association" */
export type Answers_Choice_Association_Obj_Rel_Insert_Input = {
  data: Answers_Choice_Association_Insert_Input;
};

/** ordering options when selecting data from "answers_choice_association" */
export type Answers_Choice_Association_Order_By = {
  answer?: Maybe<Answers_Order_By>;
  answer_id?: Maybe<Order_By>;
  choice?: Maybe<Choices_Order_By>;
  choice_id?: Maybe<Order_By>;
};

/** select columns of table "answers_choice_association" */
export enum Answers_Choice_Association_Select_Column {
  /** column name */
  AnswerId = 'answer_id',
  /** column name */
  ChoiceId = 'choice_id'
}

/** input type for updating data in table "answers_choice_association" */
export type Answers_Choice_Association_Set_Input = {
  answer_id?: Maybe<Scalars['Int']>;
  choice_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Answers_Choice_Association_Stddev_Fields = {
  __typename?: 'answers_choice_association_stddev_fields';
  answer_id?: Maybe<Scalars['Float']>;
  choice_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "answers_choice_association" */
export type Answers_Choice_Association_Stddev_Order_By = {
  answer_id?: Maybe<Order_By>;
  choice_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Answers_Choice_Association_Stddev_Pop_Fields = {
  __typename?: 'answers_choice_association_stddev_pop_fields';
  answer_id?: Maybe<Scalars['Float']>;
  choice_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "answers_choice_association" */
export type Answers_Choice_Association_Stddev_Pop_Order_By = {
  answer_id?: Maybe<Order_By>;
  choice_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Answers_Choice_Association_Stddev_Samp_Fields = {
  __typename?: 'answers_choice_association_stddev_samp_fields';
  answer_id?: Maybe<Scalars['Float']>;
  choice_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "answers_choice_association" */
export type Answers_Choice_Association_Stddev_Samp_Order_By = {
  answer_id?: Maybe<Order_By>;
  choice_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Answers_Choice_Association_Sum_Fields = {
  __typename?: 'answers_choice_association_sum_fields';
  answer_id?: Maybe<Scalars['Int']>;
  choice_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "answers_choice_association" */
export type Answers_Choice_Association_Sum_Order_By = {
  answer_id?: Maybe<Order_By>;
  choice_id?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Answers_Choice_Association_Var_Pop_Fields = {
  __typename?: 'answers_choice_association_var_pop_fields';
  answer_id?: Maybe<Scalars['Float']>;
  choice_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "answers_choice_association" */
export type Answers_Choice_Association_Var_Pop_Order_By = {
  answer_id?: Maybe<Order_By>;
  choice_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Answers_Choice_Association_Var_Samp_Fields = {
  __typename?: 'answers_choice_association_var_samp_fields';
  answer_id?: Maybe<Scalars['Float']>;
  choice_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "answers_choice_association" */
export type Answers_Choice_Association_Var_Samp_Order_By = {
  answer_id?: Maybe<Order_By>;
  choice_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Answers_Choice_Association_Variance_Fields = {
  __typename?: 'answers_choice_association_variance_fields';
  answer_id?: Maybe<Scalars['Float']>;
  choice_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "answers_choice_association" */
export type Answers_Choice_Association_Variance_Order_By = {
  answer_id?: Maybe<Order_By>;
  choice_id?: Maybe<Order_By>;
};

/** unique or primary key constraints on table "answers" */
export enum Answers_Constraint {
  /** unique or primary key constraint */
  AnswersPkey = 'answers_pkey'
}

/** input type for incrementing integer column in table "answers" */
export type Answers_Inc_Input = {
  feedback_by?: Maybe<Scalars['Int']>;
  feedback_score?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  part?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "answers" */
export type Answers_Insert_Input = {
  answers_choice_associations?: Maybe<Answers_Choice_Association_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamp']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  extra_value?: Maybe<Scalars['String']>;
  feedback?: Maybe<Scalars['String']>;
  feedbackAuthor?: Maybe<Profiles_Obj_Rel_Insert_Input>;
  feedback_at?: Maybe<Scalars['timestamptz']>;
  feedback_by?: Maybe<Scalars['Int']>;
  feedback_score?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  is_mock?: Maybe<Scalars['Boolean']>;
  need_feedback?: Maybe<Scalars['Boolean']>;
  part?: Maybe<Scalars['Int']>;
  profile?: Maybe<Profiles_Obj_Rel_Insert_Input>;
  question?: Maybe<Questions_Obj_Rel_Insert_Input>;
  question_id?: Maybe<Scalars['Int']>;
  result?: Maybe<Results_Obj_Rel_Insert_Input>;
  result_id?: Maybe<Scalars['Int']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Answers_Max_Fields = {
  __typename?: 'answers_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  extra_value?: Maybe<Scalars['String']>;
  feedback?: Maybe<Scalars['String']>;
  feedback_at?: Maybe<Scalars['timestamptz']>;
  feedback_by?: Maybe<Scalars['Int']>;
  feedback_score?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  part?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "answers" */
export type Answers_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  extra_value?: Maybe<Order_By>;
  feedback?: Maybe<Order_By>;
  feedback_at?: Maybe<Order_By>;
  feedback_by?: Maybe<Order_By>;
  feedback_score?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Answers_Min_Fields = {
  __typename?: 'answers_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  extra_value?: Maybe<Scalars['String']>;
  feedback?: Maybe<Scalars['String']>;
  feedback_at?: Maybe<Scalars['timestamptz']>;
  feedback_by?: Maybe<Scalars['Int']>;
  feedback_score?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  part?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "answers" */
export type Answers_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  extra_value?: Maybe<Order_By>;
  feedback?: Maybe<Order_By>;
  feedback_at?: Maybe<Order_By>;
  feedback_by?: Maybe<Order_By>;
  feedback_score?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "answers" */
export type Answers_Mutation_Response = {
  __typename?: 'answers_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Answers>;
};

/** input type for inserting object relation for remote table "answers" */
export type Answers_Obj_Rel_Insert_Input = {
  data: Answers_Insert_Input;
  on_conflict?: Maybe<Answers_On_Conflict>;
};

/** on conflict condition type for table "answers" */
export type Answers_On_Conflict = {
  constraint: Answers_Constraint;
  update_columns: Array<Answers_Update_Column>;
  where?: Maybe<Answers_Bool_Exp>;
};

/** ordering options when selecting data from "answers" */
export type Answers_Order_By = {
  answers_choice_associations_aggregate?: Maybe<Answers_Choice_Association_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  exam_type?: Maybe<Order_By>;
  extra_value?: Maybe<Order_By>;
  feedback?: Maybe<Order_By>;
  feedbackAuthor?: Maybe<Profiles_Order_By>;
  feedback_at?: Maybe<Order_By>;
  feedback_by?: Maybe<Order_By>;
  feedback_score?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_correct?: Maybe<Order_By>;
  is_mock?: Maybe<Order_By>;
  need_feedback?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  profile?: Maybe<Profiles_Order_By>;
  question?: Maybe<Questions_Order_By>;
  question_id?: Maybe<Order_By>;
  result?: Maybe<Results_Order_By>;
  result_id?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "answers" */
export type Answers_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "answers" */
export enum Answers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  ExtraValue = 'extra_value',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  FeedbackAt = 'feedback_at',
  /** column name */
  FeedbackBy = 'feedback_by',
  /** column name */
  FeedbackScore = 'feedback_score',
  /** column name */
  Id = 'id',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  IsMock = 'is_mock',
  /** column name */
  NeedFeedback = 'need_feedback',
  /** column name */
  Part = 'part',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  ResultId = 'result_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "answers" */
export type Answers_Set_Input = {
  created_at?: Maybe<Scalars['timestamp']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  extra_value?: Maybe<Scalars['String']>;
  feedback?: Maybe<Scalars['String']>;
  feedback_at?: Maybe<Scalars['timestamptz']>;
  feedback_by?: Maybe<Scalars['Int']>;
  feedback_score?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  is_mock?: Maybe<Scalars['Boolean']>;
  need_feedback?: Maybe<Scalars['Boolean']>;
  part?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Answers_Stddev_Fields = {
  __typename?: 'answers_stddev_fields';
  feedback_by?: Maybe<Scalars['Float']>;
  feedback_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "answers" */
export type Answers_Stddev_Order_By = {
  feedback_by?: Maybe<Order_By>;
  feedback_score?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Answers_Stddev_Pop_Fields = {
  __typename?: 'answers_stddev_pop_fields';
  feedback_by?: Maybe<Scalars['Float']>;
  feedback_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "answers" */
export type Answers_Stddev_Pop_Order_By = {
  feedback_by?: Maybe<Order_By>;
  feedback_score?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Answers_Stddev_Samp_Fields = {
  __typename?: 'answers_stddev_samp_fields';
  feedback_by?: Maybe<Scalars['Float']>;
  feedback_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "answers" */
export type Answers_Stddev_Samp_Order_By = {
  feedback_by?: Maybe<Order_By>;
  feedback_score?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Answers_Sum_Fields = {
  __typename?: 'answers_sum_fields';
  feedback_by?: Maybe<Scalars['Int']>;
  feedback_score?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  part?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "answers" */
export type Answers_Sum_Order_By = {
  feedback_by?: Maybe<Order_By>;
  feedback_score?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** update columns of table "answers" */
export enum Answers_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  ExtraValue = 'extra_value',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  FeedbackAt = 'feedback_at',
  /** column name */
  FeedbackBy = 'feedback_by',
  /** column name */
  FeedbackScore = 'feedback_score',
  /** column name */
  Id = 'id',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  IsMock = 'is_mock',
  /** column name */
  NeedFeedback = 'need_feedback',
  /** column name */
  Part = 'part',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  ResultId = 'result_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Answers_Var_Pop_Fields = {
  __typename?: 'answers_var_pop_fields';
  feedback_by?: Maybe<Scalars['Float']>;
  feedback_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "answers" */
export type Answers_Var_Pop_Order_By = {
  feedback_by?: Maybe<Order_By>;
  feedback_score?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Answers_Var_Samp_Fields = {
  __typename?: 'answers_var_samp_fields';
  feedback_by?: Maybe<Scalars['Float']>;
  feedback_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "answers" */
export type Answers_Var_Samp_Order_By = {
  feedback_by?: Maybe<Order_By>;
  feedback_score?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Answers_Variance_Fields = {
  __typename?: 'answers_variance_fields';
  feedback_by?: Maybe<Scalars['Float']>;
  feedback_score?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "answers" */
export type Answers_Variance_Order_By = {
  feedback_by?: Maybe<Order_By>;
  feedback_score?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** columns and relationships of "bills" */
export type Bills = {
  __typename?: 'bills';
  address: Scalars['String'];
  city: Scalars['String'];
  date: Scalars['timestamp'];
  days: Scalars['Int'];
  discount_fix: Scalars['float8'];
  discount_per: Scalars['float8'];
  exam_type: Scalars['exam_types'];
  first_name: Scalars['String'];
  id: Scalars['Int'];
  last_name: Scalars['String'];
  postal_code: Scalars['String'];
  pretax_price: Scalars['float8'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "bills" */
export type Bills_Aggregate = {
  __typename?: 'bills_aggregate';
  aggregate?: Maybe<Bills_Aggregate_Fields>;
  nodes: Array<Bills>;
};

/** aggregate fields of "bills" */
export type Bills_Aggregate_Fields = {
  __typename?: 'bills_aggregate_fields';
  avg?: Maybe<Bills_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Bills_Max_Fields>;
  min?: Maybe<Bills_Min_Fields>;
  stddev?: Maybe<Bills_Stddev_Fields>;
  stddev_pop?: Maybe<Bills_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bills_Stddev_Samp_Fields>;
  sum?: Maybe<Bills_Sum_Fields>;
  var_pop?: Maybe<Bills_Var_Pop_Fields>;
  var_samp?: Maybe<Bills_Var_Samp_Fields>;
  variance?: Maybe<Bills_Variance_Fields>;
};


/** aggregate fields of "bills" */
export type Bills_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bills_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bills" */
export type Bills_Aggregate_Order_By = {
  avg?: Maybe<Bills_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Bills_Max_Order_By>;
  min?: Maybe<Bills_Min_Order_By>;
  stddev?: Maybe<Bills_Stddev_Order_By>;
  stddev_pop?: Maybe<Bills_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Bills_Stddev_Samp_Order_By>;
  sum?: Maybe<Bills_Sum_Order_By>;
  var_pop?: Maybe<Bills_Var_Pop_Order_By>;
  var_samp?: Maybe<Bills_Var_Samp_Order_By>;
  variance?: Maybe<Bills_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bills" */
export type Bills_Arr_Rel_Insert_Input = {
  data: Array<Bills_Insert_Input>;
  on_conflict?: Maybe<Bills_On_Conflict>;
};

/** aggregate avg on columns */
export type Bills_Avg_Fields = {
  __typename?: 'bills_avg_fields';
  days?: Maybe<Scalars['Float']>;
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pretax_price?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bills" */
export type Bills_Avg_Order_By = {
  days?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pretax_price?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bills". All fields are combined with a logical 'AND'. */
export type Bills_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bills_Bool_Exp>>>;
  _not?: Maybe<Bills_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Bills_Bool_Exp>>>;
  address?: Maybe<String_Comparison_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  date?: Maybe<Timestamp_Comparison_Exp>;
  days?: Maybe<Int_Comparison_Exp>;
  discount_fix?: Maybe<Float8_Comparison_Exp>;
  discount_per?: Maybe<Float8_Comparison_Exp>;
  exam_type?: Maybe<Exam_Types_Comparison_Exp>;
  first_name?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  last_name?: Maybe<String_Comparison_Exp>;
  postal_code?: Maybe<String_Comparison_Exp>;
  pretax_price?: Maybe<Float8_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "bills" */
export enum Bills_Constraint {
  /** unique or primary key constraint */
  BillsPkey = 'bills_pkey'
}

/** input type for incrementing integer column in table "bills" */
export type Bills_Inc_Input = {
  days?: Maybe<Scalars['Int']>;
  discount_fix?: Maybe<Scalars['float8']>;
  discount_per?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  pretax_price?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "bills" */
export type Bills_Insert_Input = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['timestamp']>;
  days?: Maybe<Scalars['Int']>;
  discount_fix?: Maybe<Scalars['float8']>;
  discount_per?: Maybe<Scalars['float8']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  pretax_price?: Maybe<Scalars['float8']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Bills_Max_Fields = {
  __typename?: 'bills_max_fields';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['timestamp']>;
  days?: Maybe<Scalars['Int']>;
  discount_fix?: Maybe<Scalars['float8']>;
  discount_per?: Maybe<Scalars['float8']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  pretax_price?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "bills" */
export type Bills_Max_Order_By = {
  address?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  days?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  pretax_price?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Bills_Min_Fields = {
  __typename?: 'bills_min_fields';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['timestamp']>;
  days?: Maybe<Scalars['Int']>;
  discount_fix?: Maybe<Scalars['float8']>;
  discount_per?: Maybe<Scalars['float8']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  pretax_price?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "bills" */
export type Bills_Min_Order_By = {
  address?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  days?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  pretax_price?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "bills" */
export type Bills_Mutation_Response = {
  __typename?: 'bills_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Bills>;
};

/** input type for inserting object relation for remote table "bills" */
export type Bills_Obj_Rel_Insert_Input = {
  data: Bills_Insert_Input;
  on_conflict?: Maybe<Bills_On_Conflict>;
};

/** on conflict condition type for table "bills" */
export type Bills_On_Conflict = {
  constraint: Bills_Constraint;
  update_columns: Array<Bills_Update_Column>;
  where?: Maybe<Bills_Bool_Exp>;
};

/** ordering options when selecting data from "bills" */
export type Bills_Order_By = {
  address?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  days?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  exam_type?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  pretax_price?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "bills" */
export type Bills_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "bills" */
export enum Bills_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Date = 'date',
  /** column name */
  Days = 'days',
  /** column name */
  DiscountFix = 'discount_fix',
  /** column name */
  DiscountPer = 'discount_per',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  PretaxPrice = 'pretax_price',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "bills" */
export type Bills_Set_Input = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['timestamp']>;
  days?: Maybe<Scalars['Int']>;
  discount_fix?: Maybe<Scalars['float8']>;
  discount_per?: Maybe<Scalars['float8']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  pretax_price?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Bills_Stddev_Fields = {
  __typename?: 'bills_stddev_fields';
  days?: Maybe<Scalars['Float']>;
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pretax_price?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bills" */
export type Bills_Stddev_Order_By = {
  days?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pretax_price?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bills_Stddev_Pop_Fields = {
  __typename?: 'bills_stddev_pop_fields';
  days?: Maybe<Scalars['Float']>;
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pretax_price?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "bills" */
export type Bills_Stddev_Pop_Order_By = {
  days?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pretax_price?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bills_Stddev_Samp_Fields = {
  __typename?: 'bills_stddev_samp_fields';
  days?: Maybe<Scalars['Float']>;
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pretax_price?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "bills" */
export type Bills_Stddev_Samp_Order_By = {
  days?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pretax_price?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Bills_Sum_Fields = {
  __typename?: 'bills_sum_fields';
  days?: Maybe<Scalars['Int']>;
  discount_fix?: Maybe<Scalars['float8']>;
  discount_per?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  pretax_price?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "bills" */
export type Bills_Sum_Order_By = {
  days?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pretax_price?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** update columns of table "bills" */
export enum Bills_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Date = 'date',
  /** column name */
  Days = 'days',
  /** column name */
  DiscountFix = 'discount_fix',
  /** column name */
  DiscountPer = 'discount_per',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  PretaxPrice = 'pretax_price',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Bills_Var_Pop_Fields = {
  __typename?: 'bills_var_pop_fields';
  days?: Maybe<Scalars['Float']>;
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pretax_price?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "bills" */
export type Bills_Var_Pop_Order_By = {
  days?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pretax_price?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bills_Var_Samp_Fields = {
  __typename?: 'bills_var_samp_fields';
  days?: Maybe<Scalars['Float']>;
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pretax_price?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "bills" */
export type Bills_Var_Samp_Order_By = {
  days?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pretax_price?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Bills_Variance_Fields = {
  __typename?: 'bills_variance_fields';
  days?: Maybe<Scalars['Float']>;
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pretax_price?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bills" */
export type Bills_Variance_Order_By = {
  days?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pretax_price?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** columns and relationships of "bright_assessment" */
export type Bright_Assessment = {
  __typename?: 'bright_assessment';
  assessments_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  bright_assessment: Bright_Assessments;
  bright_assessment_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  profile: Profiles;
  tester_id: Scalars['Int'];
};

/** aggregated selection of "bright_assessment" */
export type Bright_Assessment_Aggregate = {
  __typename?: 'bright_assessment_aggregate';
  aggregate?: Maybe<Bright_Assessment_Aggregate_Fields>;
  nodes: Array<Bright_Assessment>;
};

/** aggregate fields of "bright_assessment" */
export type Bright_Assessment_Aggregate_Fields = {
  __typename?: 'bright_assessment_aggregate_fields';
  avg?: Maybe<Bright_Assessment_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Bright_Assessment_Max_Fields>;
  min?: Maybe<Bright_Assessment_Min_Fields>;
  stddev?: Maybe<Bright_Assessment_Stddev_Fields>;
  stddev_pop?: Maybe<Bright_Assessment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bright_Assessment_Stddev_Samp_Fields>;
  sum?: Maybe<Bright_Assessment_Sum_Fields>;
  var_pop?: Maybe<Bright_Assessment_Var_Pop_Fields>;
  var_samp?: Maybe<Bright_Assessment_Var_Samp_Fields>;
  variance?: Maybe<Bright_Assessment_Variance_Fields>;
};


/** aggregate fields of "bright_assessment" */
export type Bright_Assessment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bright_Assessment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bright_assessment" */
export type Bright_Assessment_Aggregate_Order_By = {
  avg?: Maybe<Bright_Assessment_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Bright_Assessment_Max_Order_By>;
  min?: Maybe<Bright_Assessment_Min_Order_By>;
  stddev?: Maybe<Bright_Assessment_Stddev_Order_By>;
  stddev_pop?: Maybe<Bright_Assessment_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Bright_Assessment_Stddev_Samp_Order_By>;
  sum?: Maybe<Bright_Assessment_Sum_Order_By>;
  var_pop?: Maybe<Bright_Assessment_Var_Pop_Order_By>;
  var_samp?: Maybe<Bright_Assessment_Var_Samp_Order_By>;
  variance?: Maybe<Bright_Assessment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bright_assessment" */
export type Bright_Assessment_Arr_Rel_Insert_Input = {
  data: Array<Bright_Assessment_Insert_Input>;
  on_conflict?: Maybe<Bright_Assessment_On_Conflict>;
};

/** aggregate avg on columns */
export type Bright_Assessment_Avg_Fields = {
  __typename?: 'bright_assessment_avg_fields';
  assessments_id?: Maybe<Scalars['Float']>;
  bright_assessment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tester_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bright_assessment" */
export type Bright_Assessment_Avg_Order_By = {
  assessments_id?: Maybe<Order_By>;
  bright_assessment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tester_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bright_assessment". All fields are combined with a logical 'AND'. */
export type Bright_Assessment_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bright_Assessment_Bool_Exp>>>;
  _not?: Maybe<Bright_Assessment_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Bright_Assessment_Bool_Exp>>>;
  assessments_id?: Maybe<Int_Comparison_Exp>;
  bright_assessment?: Maybe<Bright_Assessments_Bool_Exp>;
  bright_assessment_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  profile?: Maybe<Profiles_Bool_Exp>;
  tester_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "bright_assessment" */
export enum Bright_Assessment_Constraint {
  /** unique or primary key constraint */
  BrightAssessmentIdKey = 'bright_assessment_id_key',
  /** unique or primary key constraint */
  BrightAssessmentPkey = 'bright_assessment_pkey'
}

/** input type for incrementing integer column in table "bright_assessment" */
export type Bright_Assessment_Inc_Input = {
  assessments_id?: Maybe<Scalars['Int']>;
  bright_assessment_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  tester_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "bright_assessment" */
export type Bright_Assessment_Insert_Input = {
  assessments_id?: Maybe<Scalars['Int']>;
  bright_assessment?: Maybe<Bright_Assessments_Obj_Rel_Insert_Input>;
  bright_assessment_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  profile?: Maybe<Profiles_Obj_Rel_Insert_Input>;
  tester_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Bright_Assessment_Max_Fields = {
  __typename?: 'bright_assessment_max_fields';
  assessments_id?: Maybe<Scalars['Int']>;
  bright_assessment_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  tester_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "bright_assessment" */
export type Bright_Assessment_Max_Order_By = {
  assessments_id?: Maybe<Order_By>;
  bright_assessment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tester_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Bright_Assessment_Min_Fields = {
  __typename?: 'bright_assessment_min_fields';
  assessments_id?: Maybe<Scalars['Int']>;
  bright_assessment_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  tester_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "bright_assessment" */
export type Bright_Assessment_Min_Order_By = {
  assessments_id?: Maybe<Order_By>;
  bright_assessment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tester_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "bright_assessment" */
export type Bright_Assessment_Mutation_Response = {
  __typename?: 'bright_assessment_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Bright_Assessment>;
};

/** input type for inserting object relation for remote table "bright_assessment" */
export type Bright_Assessment_Obj_Rel_Insert_Input = {
  data: Bright_Assessment_Insert_Input;
  on_conflict?: Maybe<Bright_Assessment_On_Conflict>;
};

/** on conflict condition type for table "bright_assessment" */
export type Bright_Assessment_On_Conflict = {
  constraint: Bright_Assessment_Constraint;
  update_columns: Array<Bright_Assessment_Update_Column>;
  where?: Maybe<Bright_Assessment_Bool_Exp>;
};

/** ordering options when selecting data from "bright_assessment" */
export type Bright_Assessment_Order_By = {
  assessments_id?: Maybe<Order_By>;
  bright_assessment?: Maybe<Bright_Assessments_Order_By>;
  bright_assessment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  profile?: Maybe<Profiles_Order_By>;
  tester_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "bright_assessment" */
export type Bright_Assessment_Pk_Columns_Input = {
  bright_assessment_id: Scalars['Int'];
  tester_id: Scalars['Int'];
};

/** select columns of table "bright_assessment" */
export enum Bright_Assessment_Select_Column {
  /** column name */
  AssessmentsId = 'assessments_id',
  /** column name */
  BrightAssessmentId = 'bright_assessment_id',
  /** column name */
  Id = 'id',
  /** column name */
  TesterId = 'tester_id'
}

/** input type for updating data in table "bright_assessment" */
export type Bright_Assessment_Set_Input = {
  assessments_id?: Maybe<Scalars['Int']>;
  bright_assessment_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  tester_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Bright_Assessment_Stddev_Fields = {
  __typename?: 'bright_assessment_stddev_fields';
  assessments_id?: Maybe<Scalars['Float']>;
  bright_assessment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tester_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bright_assessment" */
export type Bright_Assessment_Stddev_Order_By = {
  assessments_id?: Maybe<Order_By>;
  bright_assessment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tester_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bright_Assessment_Stddev_Pop_Fields = {
  __typename?: 'bright_assessment_stddev_pop_fields';
  assessments_id?: Maybe<Scalars['Float']>;
  bright_assessment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tester_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "bright_assessment" */
export type Bright_Assessment_Stddev_Pop_Order_By = {
  assessments_id?: Maybe<Order_By>;
  bright_assessment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tester_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bright_Assessment_Stddev_Samp_Fields = {
  __typename?: 'bright_assessment_stddev_samp_fields';
  assessments_id?: Maybe<Scalars['Float']>;
  bright_assessment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tester_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "bright_assessment" */
export type Bright_Assessment_Stddev_Samp_Order_By = {
  assessments_id?: Maybe<Order_By>;
  bright_assessment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tester_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Bright_Assessment_Sum_Fields = {
  __typename?: 'bright_assessment_sum_fields';
  assessments_id?: Maybe<Scalars['Int']>;
  bright_assessment_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  tester_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "bright_assessment" */
export type Bright_Assessment_Sum_Order_By = {
  assessments_id?: Maybe<Order_By>;
  bright_assessment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tester_id?: Maybe<Order_By>;
};

/** update columns of table "bright_assessment" */
export enum Bright_Assessment_Update_Column {
  /** column name */
  AssessmentsId = 'assessments_id',
  /** column name */
  BrightAssessmentId = 'bright_assessment_id',
  /** column name */
  Id = 'id',
  /** column name */
  TesterId = 'tester_id'
}

/** aggregate var_pop on columns */
export type Bright_Assessment_Var_Pop_Fields = {
  __typename?: 'bright_assessment_var_pop_fields';
  assessments_id?: Maybe<Scalars['Float']>;
  bright_assessment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tester_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "bright_assessment" */
export type Bright_Assessment_Var_Pop_Order_By = {
  assessments_id?: Maybe<Order_By>;
  bright_assessment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tester_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bright_Assessment_Var_Samp_Fields = {
  __typename?: 'bright_assessment_var_samp_fields';
  assessments_id?: Maybe<Scalars['Float']>;
  bright_assessment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tester_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "bright_assessment" */
export type Bright_Assessment_Var_Samp_Order_By = {
  assessments_id?: Maybe<Order_By>;
  bright_assessment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tester_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Bright_Assessment_Variance_Fields = {
  __typename?: 'bright_assessment_variance_fields';
  assessments_id?: Maybe<Scalars['Float']>;
  bright_assessment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  tester_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bright_assessment" */
export type Bright_Assessment_Variance_Order_By = {
  assessments_id?: Maybe<Order_By>;
  bright_assessment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  tester_id?: Maybe<Order_By>;
};

/** columns and relationships of "bright_assessments" */
export type Bright_Assessments = {
  __typename?: 'bright_assessments';
  /** An array relationship */
  bright_assessments: Array<Bright_Assessment>;
  /** An aggregated array relationship */
  bright_assessments_aggregate: Bright_Assessment_Aggregate;
  createdDate?: Maybe<Scalars['timestamptz']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  institutionId: Scalars['Int'];
  openedDate?: Maybe<Scalars['timestamptz']>;
  teacherId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};


/** columns and relationships of "bright_assessments" */
export type Bright_AssessmentsBright_AssessmentsArgs = {
  distinct_on?: Maybe<Array<Bright_Assessment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Assessment_Order_By>>;
  where?: Maybe<Bright_Assessment_Bool_Exp>;
};


/** columns and relationships of "bright_assessments" */
export type Bright_AssessmentsBright_Assessments_AggregateArgs = {
  distinct_on?: Maybe<Array<Bright_Assessment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Assessment_Order_By>>;
  where?: Maybe<Bright_Assessment_Bool_Exp>;
};

/** aggregated selection of "bright_assessments" */
export type Bright_Assessments_Aggregate = {
  __typename?: 'bright_assessments_aggregate';
  aggregate?: Maybe<Bright_Assessments_Aggregate_Fields>;
  nodes: Array<Bright_Assessments>;
};

/** aggregate fields of "bright_assessments" */
export type Bright_Assessments_Aggregate_Fields = {
  __typename?: 'bright_assessments_aggregate_fields';
  avg?: Maybe<Bright_Assessments_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Bright_Assessments_Max_Fields>;
  min?: Maybe<Bright_Assessments_Min_Fields>;
  stddev?: Maybe<Bright_Assessments_Stddev_Fields>;
  stddev_pop?: Maybe<Bright_Assessments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bright_Assessments_Stddev_Samp_Fields>;
  sum?: Maybe<Bright_Assessments_Sum_Fields>;
  var_pop?: Maybe<Bright_Assessments_Var_Pop_Fields>;
  var_samp?: Maybe<Bright_Assessments_Var_Samp_Fields>;
  variance?: Maybe<Bright_Assessments_Variance_Fields>;
};


/** aggregate fields of "bright_assessments" */
export type Bright_Assessments_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bright_Assessments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bright_assessments" */
export type Bright_Assessments_Aggregate_Order_By = {
  avg?: Maybe<Bright_Assessments_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Bright_Assessments_Max_Order_By>;
  min?: Maybe<Bright_Assessments_Min_Order_By>;
  stddev?: Maybe<Bright_Assessments_Stddev_Order_By>;
  stddev_pop?: Maybe<Bright_Assessments_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Bright_Assessments_Stddev_Samp_Order_By>;
  sum?: Maybe<Bright_Assessments_Sum_Order_By>;
  var_pop?: Maybe<Bright_Assessments_Var_Pop_Order_By>;
  var_samp?: Maybe<Bright_Assessments_Var_Samp_Order_By>;
  variance?: Maybe<Bright_Assessments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bright_assessments" */
export type Bright_Assessments_Arr_Rel_Insert_Input = {
  data: Array<Bright_Assessments_Insert_Input>;
  on_conflict?: Maybe<Bright_Assessments_On_Conflict>;
};

/** aggregate avg on columns */
export type Bright_Assessments_Avg_Fields = {
  __typename?: 'bright_assessments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  institutionId?: Maybe<Scalars['Float']>;
  teacherId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bright_assessments" */
export type Bright_Assessments_Avg_Order_By = {
  id?: Maybe<Order_By>;
  institutionId?: Maybe<Order_By>;
  teacherId?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bright_assessments". All fields are combined with a logical 'AND'. */
export type Bright_Assessments_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bright_Assessments_Bool_Exp>>>;
  _not?: Maybe<Bright_Assessments_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Bright_Assessments_Bool_Exp>>>;
  bright_assessments?: Maybe<Bright_Assessment_Bool_Exp>;
  createdDate?: Maybe<Timestamptz_Comparison_Exp>;
  endDate?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  institutionId?: Maybe<Int_Comparison_Exp>;
  openedDate?: Maybe<Timestamptz_Comparison_Exp>;
  teacherId?: Maybe<Int_Comparison_Exp>;
  title?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bright_assessments" */
export enum Bright_Assessments_Constraint {
  /** unique or primary key constraint */
  BrightAssessmentsPkey = 'bright_assessments_pkey'
}

/** input type for incrementing integer column in table "bright_assessments" */
export type Bright_Assessments_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  institutionId?: Maybe<Scalars['Int']>;
  teacherId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "bright_assessments" */
export type Bright_Assessments_Insert_Input = {
  bright_assessments?: Maybe<Bright_Assessment_Arr_Rel_Insert_Input>;
  createdDate?: Maybe<Scalars['timestamptz']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  institutionId?: Maybe<Scalars['Int']>;
  openedDate?: Maybe<Scalars['timestamptz']>;
  teacherId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Bright_Assessments_Max_Fields = {
  __typename?: 'bright_assessments_max_fields';
  createdDate?: Maybe<Scalars['timestamptz']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  institutionId?: Maybe<Scalars['Int']>;
  openedDate?: Maybe<Scalars['timestamptz']>;
  teacherId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "bright_assessments" */
export type Bright_Assessments_Max_Order_By = {
  createdDate?: Maybe<Order_By>;
  endDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institutionId?: Maybe<Order_By>;
  openedDate?: Maybe<Order_By>;
  teacherId?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Bright_Assessments_Min_Fields = {
  __typename?: 'bright_assessments_min_fields';
  createdDate?: Maybe<Scalars['timestamptz']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  institutionId?: Maybe<Scalars['Int']>;
  openedDate?: Maybe<Scalars['timestamptz']>;
  teacherId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "bright_assessments" */
export type Bright_Assessments_Min_Order_By = {
  createdDate?: Maybe<Order_By>;
  endDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institutionId?: Maybe<Order_By>;
  openedDate?: Maybe<Order_By>;
  teacherId?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
};

/** response of any mutation on the table "bright_assessments" */
export type Bright_Assessments_Mutation_Response = {
  __typename?: 'bright_assessments_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Bright_Assessments>;
};

/** input type for inserting object relation for remote table "bright_assessments" */
export type Bright_Assessments_Obj_Rel_Insert_Input = {
  data: Bright_Assessments_Insert_Input;
  on_conflict?: Maybe<Bright_Assessments_On_Conflict>;
};

/** on conflict condition type for table "bright_assessments" */
export type Bright_Assessments_On_Conflict = {
  constraint: Bright_Assessments_Constraint;
  update_columns: Array<Bright_Assessments_Update_Column>;
  where?: Maybe<Bright_Assessments_Bool_Exp>;
};

/** ordering options when selecting data from "bright_assessments" */
export type Bright_Assessments_Order_By = {
  bright_assessments_aggregate?: Maybe<Bright_Assessment_Aggregate_Order_By>;
  createdDate?: Maybe<Order_By>;
  endDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institutionId?: Maybe<Order_By>;
  openedDate?: Maybe<Order_By>;
  teacherId?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
};

/** primary key columns input for table: "bright_assessments" */
export type Bright_Assessments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "bright_assessments" */
export enum Bright_Assessments_Select_Column {
  /** column name */
  CreatedDate = 'createdDate',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  InstitutionId = 'institutionId',
  /** column name */
  OpenedDate = 'openedDate',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "bright_assessments" */
export type Bright_Assessments_Set_Input = {
  createdDate?: Maybe<Scalars['timestamptz']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  institutionId?: Maybe<Scalars['Int']>;
  openedDate?: Maybe<Scalars['timestamptz']>;
  teacherId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Bright_Assessments_Stddev_Fields = {
  __typename?: 'bright_assessments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  institutionId?: Maybe<Scalars['Float']>;
  teacherId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bright_assessments" */
export type Bright_Assessments_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  institutionId?: Maybe<Order_By>;
  teacherId?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bright_Assessments_Stddev_Pop_Fields = {
  __typename?: 'bright_assessments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  institutionId?: Maybe<Scalars['Float']>;
  teacherId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "bright_assessments" */
export type Bright_Assessments_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  institutionId?: Maybe<Order_By>;
  teacherId?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bright_Assessments_Stddev_Samp_Fields = {
  __typename?: 'bright_assessments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  institutionId?: Maybe<Scalars['Float']>;
  teacherId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "bright_assessments" */
export type Bright_Assessments_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  institutionId?: Maybe<Order_By>;
  teacherId?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Bright_Assessments_Sum_Fields = {
  __typename?: 'bright_assessments_sum_fields';
  id?: Maybe<Scalars['Int']>;
  institutionId?: Maybe<Scalars['Int']>;
  teacherId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "bright_assessments" */
export type Bright_Assessments_Sum_Order_By = {
  id?: Maybe<Order_By>;
  institutionId?: Maybe<Order_By>;
  teacherId?: Maybe<Order_By>;
};

/** update columns of table "bright_assessments" */
export enum Bright_Assessments_Update_Column {
  /** column name */
  CreatedDate = 'createdDate',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  InstitutionId = 'institutionId',
  /** column name */
  OpenedDate = 'openedDate',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Title = 'title'
}

/** aggregate var_pop on columns */
export type Bright_Assessments_Var_Pop_Fields = {
  __typename?: 'bright_assessments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  institutionId?: Maybe<Scalars['Float']>;
  teacherId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "bright_assessments" */
export type Bright_Assessments_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  institutionId?: Maybe<Order_By>;
  teacherId?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bright_Assessments_Var_Samp_Fields = {
  __typename?: 'bright_assessments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  institutionId?: Maybe<Scalars['Float']>;
  teacherId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "bright_assessments" */
export type Bright_Assessments_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  institutionId?: Maybe<Order_By>;
  teacherId?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Bright_Assessments_Variance_Fields = {
  __typename?: 'bright_assessments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  institutionId?: Maybe<Scalars['Float']>;
  teacherId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bright_assessments" */
export type Bright_Assessments_Variance_Order_By = {
  id?: Maybe<Order_By>;
  institutionId?: Maybe<Order_By>;
  teacherId?: Maybe<Order_By>;
};

/** columns and relationships of "bright_branch" */
export type Bright_Branch = {
  __typename?: 'bright_branch';
  bright_branch_id: Scalars['Int'];
  institution_id: Scalars['Int'];
};

/** aggregated selection of "bright_branch" */
export type Bright_Branch_Aggregate = {
  __typename?: 'bright_branch_aggregate';
  aggregate?: Maybe<Bright_Branch_Aggregate_Fields>;
  nodes: Array<Bright_Branch>;
};

/** aggregate fields of "bright_branch" */
export type Bright_Branch_Aggregate_Fields = {
  __typename?: 'bright_branch_aggregate_fields';
  avg?: Maybe<Bright_Branch_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Bright_Branch_Max_Fields>;
  min?: Maybe<Bright_Branch_Min_Fields>;
  stddev?: Maybe<Bright_Branch_Stddev_Fields>;
  stddev_pop?: Maybe<Bright_Branch_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bright_Branch_Stddev_Samp_Fields>;
  sum?: Maybe<Bright_Branch_Sum_Fields>;
  var_pop?: Maybe<Bright_Branch_Var_Pop_Fields>;
  var_samp?: Maybe<Bright_Branch_Var_Samp_Fields>;
  variance?: Maybe<Bright_Branch_Variance_Fields>;
};


/** aggregate fields of "bright_branch" */
export type Bright_Branch_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bright_Branch_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bright_branch" */
export type Bright_Branch_Aggregate_Order_By = {
  avg?: Maybe<Bright_Branch_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Bright_Branch_Max_Order_By>;
  min?: Maybe<Bright_Branch_Min_Order_By>;
  stddev?: Maybe<Bright_Branch_Stddev_Order_By>;
  stddev_pop?: Maybe<Bright_Branch_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Bright_Branch_Stddev_Samp_Order_By>;
  sum?: Maybe<Bright_Branch_Sum_Order_By>;
  var_pop?: Maybe<Bright_Branch_Var_Pop_Order_By>;
  var_samp?: Maybe<Bright_Branch_Var_Samp_Order_By>;
  variance?: Maybe<Bright_Branch_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bright_branch" */
export type Bright_Branch_Arr_Rel_Insert_Input = {
  data: Array<Bright_Branch_Insert_Input>;
  on_conflict?: Maybe<Bright_Branch_On_Conflict>;
};

/** aggregate avg on columns */
export type Bright_Branch_Avg_Fields = {
  __typename?: 'bright_branch_avg_fields';
  bright_branch_id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bright_branch" */
export type Bright_Branch_Avg_Order_By = {
  bright_branch_id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bright_branch". All fields are combined with a logical 'AND'. */
export type Bright_Branch_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bright_Branch_Bool_Exp>>>;
  _not?: Maybe<Bright_Branch_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Bright_Branch_Bool_Exp>>>;
  bright_branch_id?: Maybe<Int_Comparison_Exp>;
  institution_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "bright_branch" */
export enum Bright_Branch_Constraint {
  /** unique or primary key constraint */
  BrightBranchBrightBranchIdKey = 'bright_branch_bright_branch_id_key',
  /** unique or primary key constraint */
  BrightBranchPkey = 'bright_branch_pkey'
}

/** input type for incrementing integer column in table "bright_branch" */
export type Bright_Branch_Inc_Input = {
  bright_branch_id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "bright_branch" */
export type Bright_Branch_Insert_Input = {
  bright_branch_id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Bright_Branch_Max_Fields = {
  __typename?: 'bright_branch_max_fields';
  bright_branch_id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "bright_branch" */
export type Bright_Branch_Max_Order_By = {
  bright_branch_id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Bright_Branch_Min_Fields = {
  __typename?: 'bright_branch_min_fields';
  bright_branch_id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "bright_branch" */
export type Bright_Branch_Min_Order_By = {
  bright_branch_id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "bright_branch" */
export type Bright_Branch_Mutation_Response = {
  __typename?: 'bright_branch_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Bright_Branch>;
};

/** input type for inserting object relation for remote table "bright_branch" */
export type Bright_Branch_Obj_Rel_Insert_Input = {
  data: Bright_Branch_Insert_Input;
  on_conflict?: Maybe<Bright_Branch_On_Conflict>;
};

/** on conflict condition type for table "bright_branch" */
export type Bright_Branch_On_Conflict = {
  constraint: Bright_Branch_Constraint;
  update_columns: Array<Bright_Branch_Update_Column>;
  where?: Maybe<Bright_Branch_Bool_Exp>;
};

/** ordering options when selecting data from "bright_branch" */
export type Bright_Branch_Order_By = {
  bright_branch_id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "bright_branch" */
export type Bright_Branch_Pk_Columns_Input = {
  institution_id: Scalars['Int'];
};

/** select columns of table "bright_branch" */
export enum Bright_Branch_Select_Column {
  /** column name */
  BrightBranchId = 'bright_branch_id',
  /** column name */
  InstitutionId = 'institution_id'
}

/** input type for updating data in table "bright_branch" */
export type Bright_Branch_Set_Input = {
  bright_branch_id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Bright_Branch_Stddev_Fields = {
  __typename?: 'bright_branch_stddev_fields';
  bright_branch_id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bright_branch" */
export type Bright_Branch_Stddev_Order_By = {
  bright_branch_id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bright_Branch_Stddev_Pop_Fields = {
  __typename?: 'bright_branch_stddev_pop_fields';
  bright_branch_id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "bright_branch" */
export type Bright_Branch_Stddev_Pop_Order_By = {
  bright_branch_id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bright_Branch_Stddev_Samp_Fields = {
  __typename?: 'bright_branch_stddev_samp_fields';
  bright_branch_id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "bright_branch" */
export type Bright_Branch_Stddev_Samp_Order_By = {
  bright_branch_id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Bright_Branch_Sum_Fields = {
  __typename?: 'bright_branch_sum_fields';
  bright_branch_id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "bright_branch" */
export type Bright_Branch_Sum_Order_By = {
  bright_branch_id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** update columns of table "bright_branch" */
export enum Bright_Branch_Update_Column {
  /** column name */
  BrightBranchId = 'bright_branch_id',
  /** column name */
  InstitutionId = 'institution_id'
}

/** aggregate var_pop on columns */
export type Bright_Branch_Var_Pop_Fields = {
  __typename?: 'bright_branch_var_pop_fields';
  bright_branch_id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "bright_branch" */
export type Bright_Branch_Var_Pop_Order_By = {
  bright_branch_id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bright_Branch_Var_Samp_Fields = {
  __typename?: 'bright_branch_var_samp_fields';
  bright_branch_id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "bright_branch" */
export type Bright_Branch_Var_Samp_Order_By = {
  bright_branch_id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Bright_Branch_Variance_Fields = {
  __typename?: 'bright_branch_variance_fields';
  bright_branch_id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bright_branch" */
export type Bright_Branch_Variance_Order_By = {
  bright_branch_id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** columns and relationships of "bright_candidate" */
export type Bright_Candidate = {
  __typename?: 'bright_candidate';
  bright_candidate_id: Scalars['Int'];
  candidate_id: Scalars['Int'];
  manager_id: Scalars['Int'];
};

/** aggregated selection of "bright_candidate" */
export type Bright_Candidate_Aggregate = {
  __typename?: 'bright_candidate_aggregate';
  aggregate?: Maybe<Bright_Candidate_Aggregate_Fields>;
  nodes: Array<Bright_Candidate>;
};

/** aggregate fields of "bright_candidate" */
export type Bright_Candidate_Aggregate_Fields = {
  __typename?: 'bright_candidate_aggregate_fields';
  avg?: Maybe<Bright_Candidate_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Bright_Candidate_Max_Fields>;
  min?: Maybe<Bright_Candidate_Min_Fields>;
  stddev?: Maybe<Bright_Candidate_Stddev_Fields>;
  stddev_pop?: Maybe<Bright_Candidate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bright_Candidate_Stddev_Samp_Fields>;
  sum?: Maybe<Bright_Candidate_Sum_Fields>;
  var_pop?: Maybe<Bright_Candidate_Var_Pop_Fields>;
  var_samp?: Maybe<Bright_Candidate_Var_Samp_Fields>;
  variance?: Maybe<Bright_Candidate_Variance_Fields>;
};


/** aggregate fields of "bright_candidate" */
export type Bright_Candidate_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bright_Candidate_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bright_candidate" */
export type Bright_Candidate_Aggregate_Order_By = {
  avg?: Maybe<Bright_Candidate_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Bright_Candidate_Max_Order_By>;
  min?: Maybe<Bright_Candidate_Min_Order_By>;
  stddev?: Maybe<Bright_Candidate_Stddev_Order_By>;
  stddev_pop?: Maybe<Bright_Candidate_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Bright_Candidate_Stddev_Samp_Order_By>;
  sum?: Maybe<Bright_Candidate_Sum_Order_By>;
  var_pop?: Maybe<Bright_Candidate_Var_Pop_Order_By>;
  var_samp?: Maybe<Bright_Candidate_Var_Samp_Order_By>;
  variance?: Maybe<Bright_Candidate_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bright_candidate" */
export type Bright_Candidate_Arr_Rel_Insert_Input = {
  data: Array<Bright_Candidate_Insert_Input>;
  on_conflict?: Maybe<Bright_Candidate_On_Conflict>;
};

/** aggregate avg on columns */
export type Bright_Candidate_Avg_Fields = {
  __typename?: 'bright_candidate_avg_fields';
  bright_candidate_id?: Maybe<Scalars['Float']>;
  candidate_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bright_candidate" */
export type Bright_Candidate_Avg_Order_By = {
  bright_candidate_id?: Maybe<Order_By>;
  candidate_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bright_candidate". All fields are combined with a logical 'AND'. */
export type Bright_Candidate_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bright_Candidate_Bool_Exp>>>;
  _not?: Maybe<Bright_Candidate_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Bright_Candidate_Bool_Exp>>>;
  bright_candidate_id?: Maybe<Int_Comparison_Exp>;
  candidate_id?: Maybe<Int_Comparison_Exp>;
  manager_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "bright_candidate" */
export enum Bright_Candidate_Constraint {
  /** unique or primary key constraint */
  BrightCandidateBrightCandidateIdKey = 'bright_candidate_bright_candidate_id_key',
  /** unique or primary key constraint */
  BrightCandidatePkey = 'bright_candidate_pkey'
}

/** input type for incrementing integer column in table "bright_candidate" */
export type Bright_Candidate_Inc_Input = {
  bright_candidate_id?: Maybe<Scalars['Int']>;
  candidate_id?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "bright_candidate" */
export type Bright_Candidate_Insert_Input = {
  bright_candidate_id?: Maybe<Scalars['Int']>;
  candidate_id?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Bright_Candidate_Max_Fields = {
  __typename?: 'bright_candidate_max_fields';
  bright_candidate_id?: Maybe<Scalars['Int']>;
  candidate_id?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "bright_candidate" */
export type Bright_Candidate_Max_Order_By = {
  bright_candidate_id?: Maybe<Order_By>;
  candidate_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Bright_Candidate_Min_Fields = {
  __typename?: 'bright_candidate_min_fields';
  bright_candidate_id?: Maybe<Scalars['Int']>;
  candidate_id?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "bright_candidate" */
export type Bright_Candidate_Min_Order_By = {
  bright_candidate_id?: Maybe<Order_By>;
  candidate_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "bright_candidate" */
export type Bright_Candidate_Mutation_Response = {
  __typename?: 'bright_candidate_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Bright_Candidate>;
};

/** input type for inserting object relation for remote table "bright_candidate" */
export type Bright_Candidate_Obj_Rel_Insert_Input = {
  data: Bright_Candidate_Insert_Input;
  on_conflict?: Maybe<Bright_Candidate_On_Conflict>;
};

/** on conflict condition type for table "bright_candidate" */
export type Bright_Candidate_On_Conflict = {
  constraint: Bright_Candidate_Constraint;
  update_columns: Array<Bright_Candidate_Update_Column>;
  where?: Maybe<Bright_Candidate_Bool_Exp>;
};

/** ordering options when selecting data from "bright_candidate" */
export type Bright_Candidate_Order_By = {
  bright_candidate_id?: Maybe<Order_By>;
  candidate_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "bright_candidate" */
export type Bright_Candidate_Pk_Columns_Input = {
  candidate_id: Scalars['Int'];
  manager_id: Scalars['Int'];
};

/** select columns of table "bright_candidate" */
export enum Bright_Candidate_Select_Column {
  /** column name */
  BrightCandidateId = 'bright_candidate_id',
  /** column name */
  CandidateId = 'candidate_id',
  /** column name */
  ManagerId = 'manager_id'
}

/** input type for updating data in table "bright_candidate" */
export type Bright_Candidate_Set_Input = {
  bright_candidate_id?: Maybe<Scalars['Int']>;
  candidate_id?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Bright_Candidate_Stddev_Fields = {
  __typename?: 'bright_candidate_stddev_fields';
  bright_candidate_id?: Maybe<Scalars['Float']>;
  candidate_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bright_candidate" */
export type Bright_Candidate_Stddev_Order_By = {
  bright_candidate_id?: Maybe<Order_By>;
  candidate_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bright_Candidate_Stddev_Pop_Fields = {
  __typename?: 'bright_candidate_stddev_pop_fields';
  bright_candidate_id?: Maybe<Scalars['Float']>;
  candidate_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "bright_candidate" */
export type Bright_Candidate_Stddev_Pop_Order_By = {
  bright_candidate_id?: Maybe<Order_By>;
  candidate_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bright_Candidate_Stddev_Samp_Fields = {
  __typename?: 'bright_candidate_stddev_samp_fields';
  bright_candidate_id?: Maybe<Scalars['Float']>;
  candidate_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "bright_candidate" */
export type Bright_Candidate_Stddev_Samp_Order_By = {
  bright_candidate_id?: Maybe<Order_By>;
  candidate_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Bright_Candidate_Sum_Fields = {
  __typename?: 'bright_candidate_sum_fields';
  bright_candidate_id?: Maybe<Scalars['Int']>;
  candidate_id?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "bright_candidate" */
export type Bright_Candidate_Sum_Order_By = {
  bright_candidate_id?: Maybe<Order_By>;
  candidate_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** update columns of table "bright_candidate" */
export enum Bright_Candidate_Update_Column {
  /** column name */
  BrightCandidateId = 'bright_candidate_id',
  /** column name */
  CandidateId = 'candidate_id',
  /** column name */
  ManagerId = 'manager_id'
}

/** aggregate var_pop on columns */
export type Bright_Candidate_Var_Pop_Fields = {
  __typename?: 'bright_candidate_var_pop_fields';
  bright_candidate_id?: Maybe<Scalars['Float']>;
  candidate_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "bright_candidate" */
export type Bright_Candidate_Var_Pop_Order_By = {
  bright_candidate_id?: Maybe<Order_By>;
  candidate_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bright_Candidate_Var_Samp_Fields = {
  __typename?: 'bright_candidate_var_samp_fields';
  bright_candidate_id?: Maybe<Scalars['Float']>;
  candidate_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "bright_candidate" */
export type Bright_Candidate_Var_Samp_Order_By = {
  bright_candidate_id?: Maybe<Order_By>;
  candidate_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Bright_Candidate_Variance_Fields = {
  __typename?: 'bright_candidate_variance_fields';
  bright_candidate_id?: Maybe<Scalars['Float']>;
  candidate_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bright_candidate" */
export type Bright_Candidate_Variance_Order_By = {
  bright_candidate_id?: Maybe<Order_By>;
  candidate_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** columns and relationships of "bright_manager" */
export type Bright_Manager = {
  __typename?: 'bright_manager';
  bright_manager_id: Scalars['Int'];
  manager_id: Scalars['Int'];
  /** An object relationship */
  profile: Profiles;
};

/** aggregated selection of "bright_manager" */
export type Bright_Manager_Aggregate = {
  __typename?: 'bright_manager_aggregate';
  aggregate?: Maybe<Bright_Manager_Aggregate_Fields>;
  nodes: Array<Bright_Manager>;
};

/** aggregate fields of "bright_manager" */
export type Bright_Manager_Aggregate_Fields = {
  __typename?: 'bright_manager_aggregate_fields';
  avg?: Maybe<Bright_Manager_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Bright_Manager_Max_Fields>;
  min?: Maybe<Bright_Manager_Min_Fields>;
  stddev?: Maybe<Bright_Manager_Stddev_Fields>;
  stddev_pop?: Maybe<Bright_Manager_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bright_Manager_Stddev_Samp_Fields>;
  sum?: Maybe<Bright_Manager_Sum_Fields>;
  var_pop?: Maybe<Bright_Manager_Var_Pop_Fields>;
  var_samp?: Maybe<Bright_Manager_Var_Samp_Fields>;
  variance?: Maybe<Bright_Manager_Variance_Fields>;
};


/** aggregate fields of "bright_manager" */
export type Bright_Manager_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bright_Manager_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bright_manager" */
export type Bright_Manager_Aggregate_Order_By = {
  avg?: Maybe<Bright_Manager_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Bright_Manager_Max_Order_By>;
  min?: Maybe<Bright_Manager_Min_Order_By>;
  stddev?: Maybe<Bright_Manager_Stddev_Order_By>;
  stddev_pop?: Maybe<Bright_Manager_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Bright_Manager_Stddev_Samp_Order_By>;
  sum?: Maybe<Bright_Manager_Sum_Order_By>;
  var_pop?: Maybe<Bright_Manager_Var_Pop_Order_By>;
  var_samp?: Maybe<Bright_Manager_Var_Samp_Order_By>;
  variance?: Maybe<Bright_Manager_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bright_manager" */
export type Bright_Manager_Arr_Rel_Insert_Input = {
  data: Array<Bright_Manager_Insert_Input>;
  on_conflict?: Maybe<Bright_Manager_On_Conflict>;
};

/** aggregate avg on columns */
export type Bright_Manager_Avg_Fields = {
  __typename?: 'bright_manager_avg_fields';
  bright_manager_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bright_manager" */
export type Bright_Manager_Avg_Order_By = {
  bright_manager_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bright_manager". All fields are combined with a logical 'AND'. */
export type Bright_Manager_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bright_Manager_Bool_Exp>>>;
  _not?: Maybe<Bright_Manager_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Bright_Manager_Bool_Exp>>>;
  bright_manager_id?: Maybe<Int_Comparison_Exp>;
  manager_id?: Maybe<Int_Comparison_Exp>;
  profile?: Maybe<Profiles_Bool_Exp>;
};

/** unique or primary key constraints on table "bright_manager" */
export enum Bright_Manager_Constraint {
  /** unique or primary key constraint */
  BrightManagerBrightManagerIdKey = 'bright_manager_bright_manager_id_key',
  /** unique or primary key constraint */
  BrightManagerPkey = 'bright_manager_pkey'
}

/** input type for incrementing integer column in table "bright_manager" */
export type Bright_Manager_Inc_Input = {
  bright_manager_id?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "bright_manager" */
export type Bright_Manager_Insert_Input = {
  bright_manager_id?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['Int']>;
  profile?: Maybe<Profiles_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Bright_Manager_Max_Fields = {
  __typename?: 'bright_manager_max_fields';
  bright_manager_id?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "bright_manager" */
export type Bright_Manager_Max_Order_By = {
  bright_manager_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Bright_Manager_Min_Fields = {
  __typename?: 'bright_manager_min_fields';
  bright_manager_id?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "bright_manager" */
export type Bright_Manager_Min_Order_By = {
  bright_manager_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "bright_manager" */
export type Bright_Manager_Mutation_Response = {
  __typename?: 'bright_manager_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Bright_Manager>;
};

/** input type for inserting object relation for remote table "bright_manager" */
export type Bright_Manager_Obj_Rel_Insert_Input = {
  data: Bright_Manager_Insert_Input;
  on_conflict?: Maybe<Bright_Manager_On_Conflict>;
};

/** on conflict condition type for table "bright_manager" */
export type Bright_Manager_On_Conflict = {
  constraint: Bright_Manager_Constraint;
  update_columns: Array<Bright_Manager_Update_Column>;
  where?: Maybe<Bright_Manager_Bool_Exp>;
};

/** ordering options when selecting data from "bright_manager" */
export type Bright_Manager_Order_By = {
  bright_manager_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  profile?: Maybe<Profiles_Order_By>;
};

/** primary key columns input for table: "bright_manager" */
export type Bright_Manager_Pk_Columns_Input = {
  manager_id: Scalars['Int'];
};

/** select columns of table "bright_manager" */
export enum Bright_Manager_Select_Column {
  /** column name */
  BrightManagerId = 'bright_manager_id',
  /** column name */
  ManagerId = 'manager_id'
}

/** input type for updating data in table "bright_manager" */
export type Bright_Manager_Set_Input = {
  bright_manager_id?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Bright_Manager_Stddev_Fields = {
  __typename?: 'bright_manager_stddev_fields';
  bright_manager_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bright_manager" */
export type Bright_Manager_Stddev_Order_By = {
  bright_manager_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bright_Manager_Stddev_Pop_Fields = {
  __typename?: 'bright_manager_stddev_pop_fields';
  bright_manager_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "bright_manager" */
export type Bright_Manager_Stddev_Pop_Order_By = {
  bright_manager_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bright_Manager_Stddev_Samp_Fields = {
  __typename?: 'bright_manager_stddev_samp_fields';
  bright_manager_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "bright_manager" */
export type Bright_Manager_Stddev_Samp_Order_By = {
  bright_manager_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Bright_Manager_Sum_Fields = {
  __typename?: 'bright_manager_sum_fields';
  bright_manager_id?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "bright_manager" */
export type Bright_Manager_Sum_Order_By = {
  bright_manager_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** update columns of table "bright_manager" */
export enum Bright_Manager_Update_Column {
  /** column name */
  BrightManagerId = 'bright_manager_id',
  /** column name */
  ManagerId = 'manager_id'
}

/** aggregate var_pop on columns */
export type Bright_Manager_Var_Pop_Fields = {
  __typename?: 'bright_manager_var_pop_fields';
  bright_manager_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "bright_manager" */
export type Bright_Manager_Var_Pop_Order_By = {
  bright_manager_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bright_Manager_Var_Samp_Fields = {
  __typename?: 'bright_manager_var_samp_fields';
  bright_manager_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "bright_manager" */
export type Bright_Manager_Var_Samp_Order_By = {
  bright_manager_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Bright_Manager_Variance_Fields = {
  __typename?: 'bright_manager_variance_fields';
  bright_manager_id?: Maybe<Scalars['Float']>;
  manager_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bright_manager" */
export type Bright_Manager_Variance_Order_By = {
  bright_manager_id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** columns and relationships of "categories" */
export type Categories = {
  __typename?: 'categories';
  id: Scalars['Int'];
  /** An array relationship */
  lessons: Array<Lessons>;
  /** An aggregated array relationship */
  lessons_aggregate: Lessons_Aggregate;
  name?: Maybe<Scalars['String']>;
};


/** columns and relationships of "categories" */
export type CategoriesLessonsArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** columns and relationships of "categories" */
export type CategoriesLessons_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};

/** aggregated selection of "categories" */
export type Categories_Aggregate = {
  __typename?: 'categories_aggregate';
  aggregate?: Maybe<Categories_Aggregate_Fields>;
  nodes: Array<Categories>;
};

/** aggregate fields of "categories" */
export type Categories_Aggregate_Fields = {
  __typename?: 'categories_aggregate_fields';
  avg?: Maybe<Categories_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Categories_Max_Fields>;
  min?: Maybe<Categories_Min_Fields>;
  stddev?: Maybe<Categories_Stddev_Fields>;
  stddev_pop?: Maybe<Categories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Categories_Stddev_Samp_Fields>;
  sum?: Maybe<Categories_Sum_Fields>;
  var_pop?: Maybe<Categories_Var_Pop_Fields>;
  var_samp?: Maybe<Categories_Var_Samp_Fields>;
  variance?: Maybe<Categories_Variance_Fields>;
};


/** aggregate fields of "categories" */
export type Categories_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Categories_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "categories" */
export type Categories_Aggregate_Order_By = {
  avg?: Maybe<Categories_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Categories_Max_Order_By>;
  min?: Maybe<Categories_Min_Order_By>;
  stddev?: Maybe<Categories_Stddev_Order_By>;
  stddev_pop?: Maybe<Categories_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Categories_Stddev_Samp_Order_By>;
  sum?: Maybe<Categories_Sum_Order_By>;
  var_pop?: Maybe<Categories_Var_Pop_Order_By>;
  var_samp?: Maybe<Categories_Var_Samp_Order_By>;
  variance?: Maybe<Categories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "categories" */
export type Categories_Arr_Rel_Insert_Input = {
  data: Array<Categories_Insert_Input>;
  on_conflict?: Maybe<Categories_On_Conflict>;
};

/** aggregate avg on columns */
export type Categories_Avg_Fields = {
  __typename?: 'categories_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "categories" */
export type Categories_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type Categories_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Categories_Bool_Exp>>>;
  _not?: Maybe<Categories_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Categories_Bool_Exp>>>;
  id?: Maybe<Int_Comparison_Exp>;
  lessons?: Maybe<Lessons_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "categories" */
export enum Categories_Constraint {
  /** unique or primary key constraint */
  CategoriesPkey = 'categories_pkey'
}

/** input type for incrementing integer column in table "categories" */
export type Categories_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "categories" */
export type Categories_Insert_Input = {
  id?: Maybe<Scalars['Int']>;
  lessons?: Maybe<Lessons_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Categories_Max_Fields = {
  __typename?: 'categories_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "categories" */
export type Categories_Max_Order_By = {
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Categories_Min_Fields = {
  __typename?: 'categories_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "categories" */
export type Categories_Min_Order_By = {
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** response of any mutation on the table "categories" */
export type Categories_Mutation_Response = {
  __typename?: 'categories_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Categories>;
};

/** input type for inserting object relation for remote table "categories" */
export type Categories_Obj_Rel_Insert_Input = {
  data: Categories_Insert_Input;
  on_conflict?: Maybe<Categories_On_Conflict>;
};

/** on conflict condition type for table "categories" */
export type Categories_On_Conflict = {
  constraint: Categories_Constraint;
  update_columns: Array<Categories_Update_Column>;
  where?: Maybe<Categories_Bool_Exp>;
};

/** ordering options when selecting data from "categories" */
export type Categories_Order_By = {
  id?: Maybe<Order_By>;
  lessons_aggregate?: Maybe<Lessons_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
};

/** primary key columns input for table: "categories" */
export type Categories_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "categories" */
export enum Categories_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "categories" */
export type Categories_Set_Input = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Categories_Stddev_Fields = {
  __typename?: 'categories_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "categories" */
export type Categories_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Categories_Stddev_Pop_Fields = {
  __typename?: 'categories_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "categories" */
export type Categories_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Categories_Stddev_Samp_Fields = {
  __typename?: 'categories_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "categories" */
export type Categories_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Categories_Sum_Fields = {
  __typename?: 'categories_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "categories" */
export type Categories_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "categories" */
export enum Categories_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** aggregate var_pop on columns */
export type Categories_Var_Pop_Fields = {
  __typename?: 'categories_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "categories" */
export type Categories_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Categories_Var_Samp_Fields = {
  __typename?: 'categories_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "categories" */
export type Categories_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Categories_Variance_Fields = {
  __typename?: 'categories_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "categories" */
export type Categories_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** columns and relationships of "choices" */
export type Choices = {
  __typename?: 'choices';
  /** An array relationship */
  answers_choice_associations: Array<Answers_Choice_Association>;
  /** An aggregated array relationship */
  answers_choice_associations_aggregate: Answers_Choice_Association_Aggregate;
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  question: Questions;
  question_id: Scalars['Int'];
  text?: Maybe<Scalars['String']>;
};


/** columns and relationships of "choices" */
export type ChoicesAnswers_Choice_AssociationsArgs = {
  distinct_on?: Maybe<Array<Answers_Choice_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Choice_Association_Order_By>>;
  where?: Maybe<Answers_Choice_Association_Bool_Exp>;
};


/** columns and relationships of "choices" */
export type ChoicesAnswers_Choice_Associations_AggregateArgs = {
  distinct_on?: Maybe<Array<Answers_Choice_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Choice_Association_Order_By>>;
  where?: Maybe<Answers_Choice_Association_Bool_Exp>;
};

/** aggregated selection of "choices" */
export type Choices_Aggregate = {
  __typename?: 'choices_aggregate';
  aggregate?: Maybe<Choices_Aggregate_Fields>;
  nodes: Array<Choices>;
};

/** aggregate fields of "choices" */
export type Choices_Aggregate_Fields = {
  __typename?: 'choices_aggregate_fields';
  avg?: Maybe<Choices_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Choices_Max_Fields>;
  min?: Maybe<Choices_Min_Fields>;
  stddev?: Maybe<Choices_Stddev_Fields>;
  stddev_pop?: Maybe<Choices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Choices_Stddev_Samp_Fields>;
  sum?: Maybe<Choices_Sum_Fields>;
  var_pop?: Maybe<Choices_Var_Pop_Fields>;
  var_samp?: Maybe<Choices_Var_Samp_Fields>;
  variance?: Maybe<Choices_Variance_Fields>;
};


/** aggregate fields of "choices" */
export type Choices_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Choices_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "choices" */
export type Choices_Aggregate_Order_By = {
  avg?: Maybe<Choices_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Choices_Max_Order_By>;
  min?: Maybe<Choices_Min_Order_By>;
  stddev?: Maybe<Choices_Stddev_Order_By>;
  stddev_pop?: Maybe<Choices_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Choices_Stddev_Samp_Order_By>;
  sum?: Maybe<Choices_Sum_Order_By>;
  var_pop?: Maybe<Choices_Var_Pop_Order_By>;
  var_samp?: Maybe<Choices_Var_Samp_Order_By>;
  variance?: Maybe<Choices_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "choices" */
export type Choices_Arr_Rel_Insert_Input = {
  data: Array<Choices_Insert_Input>;
  on_conflict?: Maybe<Choices_On_Conflict>;
};

/** aggregate avg on columns */
export type Choices_Avg_Fields = {
  __typename?: 'choices_avg_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "choices" */
export type Choices_Avg_Order_By = {
  id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "choices". All fields are combined with a logical 'AND'. */
export type Choices_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Choices_Bool_Exp>>>;
  _not?: Maybe<Choices_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Choices_Bool_Exp>>>;
  answers_choice_associations?: Maybe<Answers_Choice_Association_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  image?: Maybe<String_Comparison_Exp>;
  is_correct?: Maybe<Boolean_Comparison_Exp>;
  question?: Maybe<Questions_Bool_Exp>;
  question_id?: Maybe<Int_Comparison_Exp>;
  text?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "choices" */
export enum Choices_Constraint {
  /** unique or primary key constraint */
  ChoicesPkey = 'choices_pkey'
}

/** input type for incrementing integer column in table "choices" */
export type Choices_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "choices" */
export type Choices_Insert_Input = {
  answers_choice_associations?: Maybe<Answers_Choice_Association_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  question?: Maybe<Questions_Obj_Rel_Insert_Input>;
  question_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Choices_Max_Fields = {
  __typename?: 'choices_max_fields';
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  question_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "choices" */
export type Choices_Max_Order_By = {
  id?: Maybe<Order_By>;
  image?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Choices_Min_Fields = {
  __typename?: 'choices_min_fields';
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  question_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "choices" */
export type Choices_Min_Order_By = {
  id?: Maybe<Order_By>;
  image?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
};

/** response of any mutation on the table "choices" */
export type Choices_Mutation_Response = {
  __typename?: 'choices_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Choices>;
};

/** input type for inserting object relation for remote table "choices" */
export type Choices_Obj_Rel_Insert_Input = {
  data: Choices_Insert_Input;
  on_conflict?: Maybe<Choices_On_Conflict>;
};

/** on conflict condition type for table "choices" */
export type Choices_On_Conflict = {
  constraint: Choices_Constraint;
  update_columns: Array<Choices_Update_Column>;
  where?: Maybe<Choices_Bool_Exp>;
};

/** ordering options when selecting data from "choices" */
export type Choices_Order_By = {
  answers_choice_associations_aggregate?: Maybe<Answers_Choice_Association_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  image?: Maybe<Order_By>;
  is_correct?: Maybe<Order_By>;
  question?: Maybe<Questions_Order_By>;
  question_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
};

/** primary key columns input for table: "choices" */
export type Choices_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "choices" */
export enum Choices_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "choices" */
export type Choices_Set_Input = {
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  question_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Choices_Stddev_Fields = {
  __typename?: 'choices_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "choices" */
export type Choices_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Choices_Stddev_Pop_Fields = {
  __typename?: 'choices_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "choices" */
export type Choices_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Choices_Stddev_Samp_Fields = {
  __typename?: 'choices_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "choices" */
export type Choices_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Choices_Sum_Fields = {
  __typename?: 'choices_sum_fields';
  id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "choices" */
export type Choices_Sum_Order_By = {
  id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** update columns of table "choices" */
export enum Choices_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsCorrect = 'is_correct',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  Text = 'text'
}

/** aggregate var_pop on columns */
export type Choices_Var_Pop_Fields = {
  __typename?: 'choices_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "choices" */
export type Choices_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Choices_Var_Samp_Fields = {
  __typename?: 'choices_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "choices" */
export type Choices_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Choices_Variance_Fields = {
  __typename?: 'choices_variance_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "choices" */
export type Choices_Variance_Order_By = {
  id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** columns and relationships of "credits_log" */
export type Credits_Log = {
  __typename?: 'credits_log';
  billed_at?: Maybe<Scalars['timestamp']>;
  created_at: Scalars['timestamp'];
  created_by: Scalars['Int'];
  credits: Scalars['Int'];
  id: Scalars['Int'];
  info?: Maybe<Scalars['String']>;
  /** An object relationship */
  institution: Institutions;
  institution_id: Scalars['Int'];
  level?: Maybe<Scalars['String']>;
  /** An object relationship */
  profile: Profiles;
};

/** aggregated selection of "credits_log" */
export type Credits_Log_Aggregate = {
  __typename?: 'credits_log_aggregate';
  aggregate?: Maybe<Credits_Log_Aggregate_Fields>;
  nodes: Array<Credits_Log>;
};

/** aggregate fields of "credits_log" */
export type Credits_Log_Aggregate_Fields = {
  __typename?: 'credits_log_aggregate_fields';
  avg?: Maybe<Credits_Log_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Credits_Log_Max_Fields>;
  min?: Maybe<Credits_Log_Min_Fields>;
  stddev?: Maybe<Credits_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Credits_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credits_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Credits_Log_Sum_Fields>;
  var_pop?: Maybe<Credits_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Credits_Log_Var_Samp_Fields>;
  variance?: Maybe<Credits_Log_Variance_Fields>;
};


/** aggregate fields of "credits_log" */
export type Credits_Log_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Credits_Log_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "credits_log" */
export type Credits_Log_Aggregate_Order_By = {
  avg?: Maybe<Credits_Log_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Credits_Log_Max_Order_By>;
  min?: Maybe<Credits_Log_Min_Order_By>;
  stddev?: Maybe<Credits_Log_Stddev_Order_By>;
  stddev_pop?: Maybe<Credits_Log_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Credits_Log_Stddev_Samp_Order_By>;
  sum?: Maybe<Credits_Log_Sum_Order_By>;
  var_pop?: Maybe<Credits_Log_Var_Pop_Order_By>;
  var_samp?: Maybe<Credits_Log_Var_Samp_Order_By>;
  variance?: Maybe<Credits_Log_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "credits_log" */
export type Credits_Log_Arr_Rel_Insert_Input = {
  data: Array<Credits_Log_Insert_Input>;
  on_conflict?: Maybe<Credits_Log_On_Conflict>;
};

/** aggregate avg on columns */
export type Credits_Log_Avg_Fields = {
  __typename?: 'credits_log_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "credits_log" */
export type Credits_Log_Avg_Order_By = {
  created_by?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credits_log". All fields are combined with a logical 'AND'. */
export type Credits_Log_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Credits_Log_Bool_Exp>>>;
  _not?: Maybe<Credits_Log_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Credits_Log_Bool_Exp>>>;
  billed_at?: Maybe<Timestamp_Comparison_Exp>;
  created_at?: Maybe<Timestamp_Comparison_Exp>;
  created_by?: Maybe<Int_Comparison_Exp>;
  credits?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  info?: Maybe<String_Comparison_Exp>;
  institution?: Maybe<Institutions_Bool_Exp>;
  institution_id?: Maybe<Int_Comparison_Exp>;
  level?: Maybe<String_Comparison_Exp>;
  profile?: Maybe<Profiles_Bool_Exp>;
};

/** unique or primary key constraints on table "credits_log" */
export enum Credits_Log_Constraint {
  /** unique or primary key constraint */
  CreditsLogPkey = 'credits_log_pkey'
}

/** input type for incrementing integer column in table "credits_log" */
export type Credits_Log_Inc_Input = {
  created_by?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "credits_log" */
export type Credits_Log_Insert_Input = {
  billed_at?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<Scalars['String']>;
  institution?: Maybe<Institutions_Obj_Rel_Insert_Input>;
  institution_id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
  profile?: Maybe<Profiles_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Credits_Log_Max_Fields = {
  __typename?: 'credits_log_max_fields';
  billed_at?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<Scalars['String']>;
  institution_id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "credits_log" */
export type Credits_Log_Max_Order_By = {
  billed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  info?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Credits_Log_Min_Fields = {
  __typename?: 'credits_log_min_fields';
  billed_at?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<Scalars['String']>;
  institution_id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "credits_log" */
export type Credits_Log_Min_Order_By = {
  billed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  info?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
};

/** response of any mutation on the table "credits_log" */
export type Credits_Log_Mutation_Response = {
  __typename?: 'credits_log_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Credits_Log>;
};

/** input type for inserting object relation for remote table "credits_log" */
export type Credits_Log_Obj_Rel_Insert_Input = {
  data: Credits_Log_Insert_Input;
  on_conflict?: Maybe<Credits_Log_On_Conflict>;
};

/** on conflict condition type for table "credits_log" */
export type Credits_Log_On_Conflict = {
  constraint: Credits_Log_Constraint;
  update_columns: Array<Credits_Log_Update_Column>;
  where?: Maybe<Credits_Log_Bool_Exp>;
};

/** ordering options when selecting data from "credits_log" */
export type Credits_Log_Order_By = {
  billed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  info?: Maybe<Order_By>;
  institution?: Maybe<Institutions_Order_By>;
  institution_id?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
  profile?: Maybe<Profiles_Order_By>;
};

/** primary key columns input for table: "credits_log" */
export type Credits_Log_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "credits_log" */
export enum Credits_Log_Select_Column {
  /** column name */
  BilledAt = 'billed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Credits = 'credits',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  InstitutionId = 'institution_id',
  /** column name */
  Level = 'level'
}

/** input type for updating data in table "credits_log" */
export type Credits_Log_Set_Input = {
  billed_at?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<Scalars['String']>;
  institution_id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Credits_Log_Stddev_Fields = {
  __typename?: 'credits_log_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "credits_log" */
export type Credits_Log_Stddev_Order_By = {
  created_by?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Credits_Log_Stddev_Pop_Fields = {
  __typename?: 'credits_log_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "credits_log" */
export type Credits_Log_Stddev_Pop_Order_By = {
  created_by?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Credits_Log_Stddev_Samp_Fields = {
  __typename?: 'credits_log_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "credits_log" */
export type Credits_Log_Stddev_Samp_Order_By = {
  created_by?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Credits_Log_Sum_Fields = {
  __typename?: 'credits_log_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "credits_log" */
export type Credits_Log_Sum_Order_By = {
  created_by?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** update columns of table "credits_log" */
export enum Credits_Log_Update_Column {
  /** column name */
  BilledAt = 'billed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Credits = 'credits',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  InstitutionId = 'institution_id',
  /** column name */
  Level = 'level'
}

/** aggregate var_pop on columns */
export type Credits_Log_Var_Pop_Fields = {
  __typename?: 'credits_log_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "credits_log" */
export type Credits_Log_Var_Pop_Order_By = {
  created_by?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Credits_Log_Var_Samp_Fields = {
  __typename?: 'credits_log_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "credits_log" */
export type Credits_Log_Var_Samp_Order_By = {
  created_by?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Credits_Log_Variance_Fields = {
  __typename?: 'credits_log_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "credits_log" */
export type Credits_Log_Variance_Order_By = {
  created_by?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** columns and relationships of "discount_codes" */
export type Discount_Codes = {
  __typename?: 'discount_codes';
  code: Scalars['String'];
  discount_fix: Scalars['float8'];
  discount_per: Scalars['float8'];
  exam_type: Scalars['exam_types'];
  id: Scalars['Int'];
  valid_until: Scalars['timestamp'];
};

/** aggregated selection of "discount_codes" */
export type Discount_Codes_Aggregate = {
  __typename?: 'discount_codes_aggregate';
  aggregate?: Maybe<Discount_Codes_Aggregate_Fields>;
  nodes: Array<Discount_Codes>;
};

/** aggregate fields of "discount_codes" */
export type Discount_Codes_Aggregate_Fields = {
  __typename?: 'discount_codes_aggregate_fields';
  avg?: Maybe<Discount_Codes_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Discount_Codes_Max_Fields>;
  min?: Maybe<Discount_Codes_Min_Fields>;
  stddev?: Maybe<Discount_Codes_Stddev_Fields>;
  stddev_pop?: Maybe<Discount_Codes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Discount_Codes_Stddev_Samp_Fields>;
  sum?: Maybe<Discount_Codes_Sum_Fields>;
  var_pop?: Maybe<Discount_Codes_Var_Pop_Fields>;
  var_samp?: Maybe<Discount_Codes_Var_Samp_Fields>;
  variance?: Maybe<Discount_Codes_Variance_Fields>;
};


/** aggregate fields of "discount_codes" */
export type Discount_Codes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Discount_Codes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "discount_codes" */
export type Discount_Codes_Aggregate_Order_By = {
  avg?: Maybe<Discount_Codes_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Discount_Codes_Max_Order_By>;
  min?: Maybe<Discount_Codes_Min_Order_By>;
  stddev?: Maybe<Discount_Codes_Stddev_Order_By>;
  stddev_pop?: Maybe<Discount_Codes_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Discount_Codes_Stddev_Samp_Order_By>;
  sum?: Maybe<Discount_Codes_Sum_Order_By>;
  var_pop?: Maybe<Discount_Codes_Var_Pop_Order_By>;
  var_samp?: Maybe<Discount_Codes_Var_Samp_Order_By>;
  variance?: Maybe<Discount_Codes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "discount_codes" */
export type Discount_Codes_Arr_Rel_Insert_Input = {
  data: Array<Discount_Codes_Insert_Input>;
  on_conflict?: Maybe<Discount_Codes_On_Conflict>;
};

/** aggregate avg on columns */
export type Discount_Codes_Avg_Fields = {
  __typename?: 'discount_codes_avg_fields';
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "discount_codes" */
export type Discount_Codes_Avg_Order_By = {
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "discount_codes". All fields are combined with a logical 'AND'. */
export type Discount_Codes_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Discount_Codes_Bool_Exp>>>;
  _not?: Maybe<Discount_Codes_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Discount_Codes_Bool_Exp>>>;
  code?: Maybe<String_Comparison_Exp>;
  discount_fix?: Maybe<Float8_Comparison_Exp>;
  discount_per?: Maybe<Float8_Comparison_Exp>;
  exam_type?: Maybe<Exam_Types_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  valid_until?: Maybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "discount_codes" */
export enum Discount_Codes_Constraint {
  /** unique or primary key constraint */
  DiscountCodesCodeKey = 'discount_codes_code_key',
  /** unique or primary key constraint */
  DiscountCodesPkey = 'discount_codes_pkey'
}

/** input type for incrementing integer column in table "discount_codes" */
export type Discount_Codes_Inc_Input = {
  discount_fix?: Maybe<Scalars['float8']>;
  discount_per?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "discount_codes" */
export type Discount_Codes_Insert_Input = {
  code?: Maybe<Scalars['String']>;
  discount_fix?: Maybe<Scalars['float8']>;
  discount_per?: Maybe<Scalars['float8']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  id?: Maybe<Scalars['Int']>;
  valid_until?: Maybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Discount_Codes_Max_Fields = {
  __typename?: 'discount_codes_max_fields';
  code?: Maybe<Scalars['String']>;
  discount_fix?: Maybe<Scalars['float8']>;
  discount_per?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  valid_until?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "discount_codes" */
export type Discount_Codes_Max_Order_By = {
  code?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  valid_until?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Discount_Codes_Min_Fields = {
  __typename?: 'discount_codes_min_fields';
  code?: Maybe<Scalars['String']>;
  discount_fix?: Maybe<Scalars['float8']>;
  discount_per?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  valid_until?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "discount_codes" */
export type Discount_Codes_Min_Order_By = {
  code?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  valid_until?: Maybe<Order_By>;
};

/** response of any mutation on the table "discount_codes" */
export type Discount_Codes_Mutation_Response = {
  __typename?: 'discount_codes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Discount_Codes>;
};

/** input type for inserting object relation for remote table "discount_codes" */
export type Discount_Codes_Obj_Rel_Insert_Input = {
  data: Discount_Codes_Insert_Input;
  on_conflict?: Maybe<Discount_Codes_On_Conflict>;
};

/** on conflict condition type for table "discount_codes" */
export type Discount_Codes_On_Conflict = {
  constraint: Discount_Codes_Constraint;
  update_columns: Array<Discount_Codes_Update_Column>;
  where?: Maybe<Discount_Codes_Bool_Exp>;
};

/** ordering options when selecting data from "discount_codes" */
export type Discount_Codes_Order_By = {
  code?: Maybe<Order_By>;
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  exam_type?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  valid_until?: Maybe<Order_By>;
};

/** primary key columns input for table: "discount_codes" */
export type Discount_Codes_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "discount_codes" */
export enum Discount_Codes_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  DiscountFix = 'discount_fix',
  /** column name */
  DiscountPer = 'discount_per',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  Id = 'id',
  /** column name */
  ValidUntil = 'valid_until'
}

/** input type for updating data in table "discount_codes" */
export type Discount_Codes_Set_Input = {
  code?: Maybe<Scalars['String']>;
  discount_fix?: Maybe<Scalars['float8']>;
  discount_per?: Maybe<Scalars['float8']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  id?: Maybe<Scalars['Int']>;
  valid_until?: Maybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Discount_Codes_Stddev_Fields = {
  __typename?: 'discount_codes_stddev_fields';
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "discount_codes" */
export type Discount_Codes_Stddev_Order_By = {
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Discount_Codes_Stddev_Pop_Fields = {
  __typename?: 'discount_codes_stddev_pop_fields';
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "discount_codes" */
export type Discount_Codes_Stddev_Pop_Order_By = {
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Discount_Codes_Stddev_Samp_Fields = {
  __typename?: 'discount_codes_stddev_samp_fields';
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "discount_codes" */
export type Discount_Codes_Stddev_Samp_Order_By = {
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Discount_Codes_Sum_Fields = {
  __typename?: 'discount_codes_sum_fields';
  discount_fix?: Maybe<Scalars['float8']>;
  discount_per?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "discount_codes" */
export type Discount_Codes_Sum_Order_By = {
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "discount_codes" */
export enum Discount_Codes_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  DiscountFix = 'discount_fix',
  /** column name */
  DiscountPer = 'discount_per',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  Id = 'id',
  /** column name */
  ValidUntil = 'valid_until'
}

/** aggregate var_pop on columns */
export type Discount_Codes_Var_Pop_Fields = {
  __typename?: 'discount_codes_var_pop_fields';
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "discount_codes" */
export type Discount_Codes_Var_Pop_Order_By = {
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Discount_Codes_Var_Samp_Fields = {
  __typename?: 'discount_codes_var_samp_fields';
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "discount_codes" */
export type Discount_Codes_Var_Samp_Order_By = {
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Discount_Codes_Variance_Fields = {
  __typename?: 'discount_codes_variance_fields';
  discount_fix?: Maybe<Scalars['Float']>;
  discount_per?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "discount_codes" */
export type Discount_Codes_Variance_Order_By = {
  discount_fix?: Maybe<Order_By>;
  discount_per?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** columns and relationships of "estimated_scores" */
export type Estimated_Scores = {
  __typename?: 'estimated_scores';
  created_at: Scalars['timestamptz'];
  exam_type: Scalars['exam_types'];
  id: Scalars['Int'];
  /** An object relationship */
  profile?: Maybe<Profiles>;
  score?: Maybe<Scalars['float8']>;
  type: Scalars['String'];
  user_id: Scalars['Int'];
};

/** aggregated selection of "estimated_scores" */
export type Estimated_Scores_Aggregate = {
  __typename?: 'estimated_scores_aggregate';
  aggregate?: Maybe<Estimated_Scores_Aggregate_Fields>;
  nodes: Array<Estimated_Scores>;
};

/** aggregate fields of "estimated_scores" */
export type Estimated_Scores_Aggregate_Fields = {
  __typename?: 'estimated_scores_aggregate_fields';
  avg?: Maybe<Estimated_Scores_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Estimated_Scores_Max_Fields>;
  min?: Maybe<Estimated_Scores_Min_Fields>;
  stddev?: Maybe<Estimated_Scores_Stddev_Fields>;
  stddev_pop?: Maybe<Estimated_Scores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Estimated_Scores_Stddev_Samp_Fields>;
  sum?: Maybe<Estimated_Scores_Sum_Fields>;
  var_pop?: Maybe<Estimated_Scores_Var_Pop_Fields>;
  var_samp?: Maybe<Estimated_Scores_Var_Samp_Fields>;
  variance?: Maybe<Estimated_Scores_Variance_Fields>;
};


/** aggregate fields of "estimated_scores" */
export type Estimated_Scores_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Estimated_Scores_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "estimated_scores" */
export type Estimated_Scores_Aggregate_Order_By = {
  avg?: Maybe<Estimated_Scores_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Estimated_Scores_Max_Order_By>;
  min?: Maybe<Estimated_Scores_Min_Order_By>;
  stddev?: Maybe<Estimated_Scores_Stddev_Order_By>;
  stddev_pop?: Maybe<Estimated_Scores_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Estimated_Scores_Stddev_Samp_Order_By>;
  sum?: Maybe<Estimated_Scores_Sum_Order_By>;
  var_pop?: Maybe<Estimated_Scores_Var_Pop_Order_By>;
  var_samp?: Maybe<Estimated_Scores_Var_Samp_Order_By>;
  variance?: Maybe<Estimated_Scores_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "estimated_scores" */
export type Estimated_Scores_Arr_Rel_Insert_Input = {
  data: Array<Estimated_Scores_Insert_Input>;
  on_conflict?: Maybe<Estimated_Scores_On_Conflict>;
};

/** aggregate avg on columns */
export type Estimated_Scores_Avg_Fields = {
  __typename?: 'estimated_scores_avg_fields';
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "estimated_scores" */
export type Estimated_Scores_Avg_Order_By = {
  id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "estimated_scores". All fields are combined with a logical 'AND'. */
export type Estimated_Scores_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Estimated_Scores_Bool_Exp>>>;
  _not?: Maybe<Estimated_Scores_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Estimated_Scores_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  exam_type?: Maybe<Exam_Types_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  profile?: Maybe<Profiles_Bool_Exp>;
  score?: Maybe<Float8_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  user_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "estimated_scores" */
export enum Estimated_Scores_Constraint {
  /** unique or primary key constraint */
  EstimatedScoresPkey = 'estimated_scores_pkey'
}

/** input type for incrementing integer column in table "estimated_scores" */
export type Estimated_Scores_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "estimated_scores" */
export type Estimated_Scores_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  id?: Maybe<Scalars['Int']>;
  profile?: Maybe<Profiles_Obj_Rel_Insert_Input>;
  score?: Maybe<Scalars['float8']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Estimated_Scores_Max_Fields = {
  __typename?: 'estimated_scores_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "estimated_scores" */
export type Estimated_Scores_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Estimated_Scores_Min_Fields = {
  __typename?: 'estimated_scores_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "estimated_scores" */
export type Estimated_Scores_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "estimated_scores" */
export type Estimated_Scores_Mutation_Response = {
  __typename?: 'estimated_scores_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Estimated_Scores>;
};

/** input type for inserting object relation for remote table "estimated_scores" */
export type Estimated_Scores_Obj_Rel_Insert_Input = {
  data: Estimated_Scores_Insert_Input;
  on_conflict?: Maybe<Estimated_Scores_On_Conflict>;
};

/** on conflict condition type for table "estimated_scores" */
export type Estimated_Scores_On_Conflict = {
  constraint: Estimated_Scores_Constraint;
  update_columns: Array<Estimated_Scores_Update_Column>;
  where?: Maybe<Estimated_Scores_Bool_Exp>;
};

/** ordering options when selecting data from "estimated_scores" */
export type Estimated_Scores_Order_By = {
  created_at?: Maybe<Order_By>;
  exam_type?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  profile?: Maybe<Profiles_Order_By>;
  score?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "estimated_scores" */
export type Estimated_Scores_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "estimated_scores" */
export enum Estimated_Scores_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  Id = 'id',
  /** column name */
  Score = 'score',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "estimated_scores" */
export type Estimated_Scores_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Estimated_Scores_Stddev_Fields = {
  __typename?: 'estimated_scores_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "estimated_scores" */
export type Estimated_Scores_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Estimated_Scores_Stddev_Pop_Fields = {
  __typename?: 'estimated_scores_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "estimated_scores" */
export type Estimated_Scores_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Estimated_Scores_Stddev_Samp_Fields = {
  __typename?: 'estimated_scores_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "estimated_scores" */
export type Estimated_Scores_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Estimated_Scores_Sum_Fields = {
  __typename?: 'estimated_scores_sum_fields';
  id?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "estimated_scores" */
export type Estimated_Scores_Sum_Order_By = {
  id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** update columns of table "estimated_scores" */
export enum Estimated_Scores_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  Id = 'id',
  /** column name */
  Score = 'score',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Estimated_Scores_Var_Pop_Fields = {
  __typename?: 'estimated_scores_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "estimated_scores" */
export type Estimated_Scores_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Estimated_Scores_Var_Samp_Fields = {
  __typename?: 'estimated_scores_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "estimated_scores" */
export type Estimated_Scores_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Estimated_Scores_Variance_Fields = {
  __typename?: 'estimated_scores_variance_fields';
  id?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "estimated_scores" */
export type Estimated_Scores_Variance_Order_By = {
  id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};


/** expression to compare columns of type exam_types. All fields are combined with logical 'AND'. */
export type Exam_Types_Comparison_Exp = {
  _eq?: Maybe<Scalars['exam_types']>;
  _gt?: Maybe<Scalars['exam_types']>;
  _gte?: Maybe<Scalars['exam_types']>;
  _in?: Maybe<Array<Scalars['exam_types']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['exam_types']>;
  _lte?: Maybe<Scalars['exam_types']>;
  _neq?: Maybe<Scalars['exam_types']>;
  _nin?: Maybe<Array<Scalars['exam_types']>>;
};

/** columns and relationships of "exams" */
export type Exams = {
  __typename?: 'exams';
  exam_type: Scalars['exam_types'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_exercises: Scalars['Boolean'];
  level?: Maybe<Scalars['String']>;
  /** An array relationship */
  supports: Array<Supports>;
  /** An aggregated array relationship */
  supports_aggregate: Supports_Aggregate;
};


/** columns and relationships of "exams" */
export type ExamsSupportsArgs = {
  distinct_on?: Maybe<Array<Supports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Supports_Order_By>>;
  where?: Maybe<Supports_Bool_Exp>;
};


/** columns and relationships of "exams" */
export type ExamsSupports_AggregateArgs = {
  distinct_on?: Maybe<Array<Supports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Supports_Order_By>>;
  where?: Maybe<Supports_Bool_Exp>;
};

/** aggregated selection of "exams" */
export type Exams_Aggregate = {
  __typename?: 'exams_aggregate';
  aggregate?: Maybe<Exams_Aggregate_Fields>;
  nodes: Array<Exams>;
};

/** aggregate fields of "exams" */
export type Exams_Aggregate_Fields = {
  __typename?: 'exams_aggregate_fields';
  avg?: Maybe<Exams_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Exams_Max_Fields>;
  min?: Maybe<Exams_Min_Fields>;
  stddev?: Maybe<Exams_Stddev_Fields>;
  stddev_pop?: Maybe<Exams_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Exams_Stddev_Samp_Fields>;
  sum?: Maybe<Exams_Sum_Fields>;
  var_pop?: Maybe<Exams_Var_Pop_Fields>;
  var_samp?: Maybe<Exams_Var_Samp_Fields>;
  variance?: Maybe<Exams_Variance_Fields>;
};


/** aggregate fields of "exams" */
export type Exams_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Exams_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exams" */
export type Exams_Aggregate_Order_By = {
  avg?: Maybe<Exams_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Exams_Max_Order_By>;
  min?: Maybe<Exams_Min_Order_By>;
  stddev?: Maybe<Exams_Stddev_Order_By>;
  stddev_pop?: Maybe<Exams_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Exams_Stddev_Samp_Order_By>;
  sum?: Maybe<Exams_Sum_Order_By>;
  var_pop?: Maybe<Exams_Var_Pop_Order_By>;
  var_samp?: Maybe<Exams_Var_Samp_Order_By>;
  variance?: Maybe<Exams_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "exams" */
export type Exams_Arr_Rel_Insert_Input = {
  data: Array<Exams_Insert_Input>;
  on_conflict?: Maybe<Exams_On_Conflict>;
};

/** aggregate avg on columns */
export type Exams_Avg_Fields = {
  __typename?: 'exams_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "exams" */
export type Exams_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "exams". All fields are combined with a logical 'AND'. */
export type Exams_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Exams_Bool_Exp>>>;
  _not?: Maybe<Exams_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Exams_Bool_Exp>>>;
  exam_type?: Maybe<Exam_Types_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_active?: Maybe<Boolean_Comparison_Exp>;
  is_exercises?: Maybe<Boolean_Comparison_Exp>;
  level?: Maybe<String_Comparison_Exp>;
  supports?: Maybe<Supports_Bool_Exp>;
};

/** unique or primary key constraints on table "exams" */
export enum Exams_Constraint {
  /** unique or primary key constraint */
  ExamsPkey = 'exams_pkey'
}

/** input type for incrementing integer column in table "exams" */
export type Exams_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "exams" */
export type Exams_Insert_Input = {
  exam_type?: Maybe<Scalars['exam_types']>;
  id?: Maybe<Scalars['Int']>;
  is_active?: Maybe<Scalars['Boolean']>;
  is_exercises?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['String']>;
  supports?: Maybe<Supports_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Exams_Max_Fields = {
  __typename?: 'exams_max_fields';
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "exams" */
export type Exams_Max_Order_By = {
  id?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Exams_Min_Fields = {
  __typename?: 'exams_min_fields';
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "exams" */
export type Exams_Min_Order_By = {
  id?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
};

/** response of any mutation on the table "exams" */
export type Exams_Mutation_Response = {
  __typename?: 'exams_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Exams>;
};

/** input type for inserting object relation for remote table "exams" */
export type Exams_Obj_Rel_Insert_Input = {
  data: Exams_Insert_Input;
  on_conflict?: Maybe<Exams_On_Conflict>;
};

/** on conflict condition type for table "exams" */
export type Exams_On_Conflict = {
  constraint: Exams_Constraint;
  update_columns: Array<Exams_Update_Column>;
  where?: Maybe<Exams_Bool_Exp>;
};

/** ordering options when selecting data from "exams" */
export type Exams_Order_By = {
  exam_type?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_active?: Maybe<Order_By>;
  is_exercises?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
  supports_aggregate?: Maybe<Supports_Aggregate_Order_By>;
};

/** primary key columns input for table: "exams" */
export type Exams_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "exams" */
export enum Exams_Select_Column {
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsExercises = 'is_exercises',
  /** column name */
  Level = 'level'
}

/** input type for updating data in table "exams" */
export type Exams_Set_Input = {
  exam_type?: Maybe<Scalars['exam_types']>;
  id?: Maybe<Scalars['Int']>;
  is_active?: Maybe<Scalars['Boolean']>;
  is_exercises?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Exams_Stddev_Fields = {
  __typename?: 'exams_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "exams" */
export type Exams_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Exams_Stddev_Pop_Fields = {
  __typename?: 'exams_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "exams" */
export type Exams_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Exams_Stddev_Samp_Fields = {
  __typename?: 'exams_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "exams" */
export type Exams_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Exams_Sum_Fields = {
  __typename?: 'exams_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "exams" */
export type Exams_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "exams" */
export enum Exams_Update_Column {
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsExercises = 'is_exercises',
  /** column name */
  Level = 'level'
}

/** aggregate var_pop on columns */
export type Exams_Var_Pop_Fields = {
  __typename?: 'exams_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "exams" */
export type Exams_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Exams_Var_Samp_Fields = {
  __typename?: 'exams_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "exams" */
export type Exams_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Exams_Variance_Fields = {
  __typename?: 'exams_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "exams" */
export type Exams_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** columns and relationships of "feedbacks" */
export type Feedbacks = {
  __typename?: 'feedbacks';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  information?: Maybe<Scalars['String']>;
  /** An object relationship */
  support: Supports;
  supportCopy?: Maybe<Scalars['jsonb']>;
  supportId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** columns and relationships of "feedbacks" */
export type FeedbacksSupportCopyArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "feedbacks" */
export type Feedbacks_Aggregate = {
  __typename?: 'feedbacks_aggregate';
  aggregate?: Maybe<Feedbacks_Aggregate_Fields>;
  nodes: Array<Feedbacks>;
};

/** aggregate fields of "feedbacks" */
export type Feedbacks_Aggregate_Fields = {
  __typename?: 'feedbacks_aggregate_fields';
  avg?: Maybe<Feedbacks_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Feedbacks_Max_Fields>;
  min?: Maybe<Feedbacks_Min_Fields>;
  stddev?: Maybe<Feedbacks_Stddev_Fields>;
  stddev_pop?: Maybe<Feedbacks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feedbacks_Stddev_Samp_Fields>;
  sum?: Maybe<Feedbacks_Sum_Fields>;
  var_pop?: Maybe<Feedbacks_Var_Pop_Fields>;
  var_samp?: Maybe<Feedbacks_Var_Samp_Fields>;
  variance?: Maybe<Feedbacks_Variance_Fields>;
};


/** aggregate fields of "feedbacks" */
export type Feedbacks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Feedbacks_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "feedbacks" */
export type Feedbacks_Aggregate_Order_By = {
  avg?: Maybe<Feedbacks_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Feedbacks_Max_Order_By>;
  min?: Maybe<Feedbacks_Min_Order_By>;
  stddev?: Maybe<Feedbacks_Stddev_Order_By>;
  stddev_pop?: Maybe<Feedbacks_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Feedbacks_Stddev_Samp_Order_By>;
  sum?: Maybe<Feedbacks_Sum_Order_By>;
  var_pop?: Maybe<Feedbacks_Var_Pop_Order_By>;
  var_samp?: Maybe<Feedbacks_Var_Samp_Order_By>;
  variance?: Maybe<Feedbacks_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Feedbacks_Append_Input = {
  supportCopy?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "feedbacks" */
export type Feedbacks_Arr_Rel_Insert_Input = {
  data: Array<Feedbacks_Insert_Input>;
  on_conflict?: Maybe<Feedbacks_On_Conflict>;
};

/** aggregate avg on columns */
export type Feedbacks_Avg_Fields = {
  __typename?: 'feedbacks_avg_fields';
  id?: Maybe<Scalars['Float']>;
  supportId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "feedbacks" */
export type Feedbacks_Avg_Order_By = {
  id?: Maybe<Order_By>;
  supportId?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "feedbacks". All fields are combined with a logical 'AND'. */
export type Feedbacks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Feedbacks_Bool_Exp>>>;
  _not?: Maybe<Feedbacks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Feedbacks_Bool_Exp>>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  information?: Maybe<String_Comparison_Exp>;
  support?: Maybe<Supports_Bool_Exp>;
  supportCopy?: Maybe<Jsonb_Comparison_Exp>;
  supportId?: Maybe<Int_Comparison_Exp>;
  userId?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedbacks" */
export enum Feedbacks_Constraint {
  /** unique or primary key constraint */
  FeedbacksPkey = 'feedbacks_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Feedbacks_Delete_At_Path_Input = {
  supportCopy?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Feedbacks_Delete_Elem_Input = {
  supportCopy?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Feedbacks_Delete_Key_Input = {
  supportCopy?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "feedbacks" */
export type Feedbacks_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  supportId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "feedbacks" */
export type Feedbacks_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  information?: Maybe<Scalars['String']>;
  support?: Maybe<Supports_Obj_Rel_Insert_Input>;
  supportCopy?: Maybe<Scalars['jsonb']>;
  supportId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Feedbacks_Max_Fields = {
  __typename?: 'feedbacks_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  information?: Maybe<Scalars['String']>;
  supportId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "feedbacks" */
export type Feedbacks_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  information?: Maybe<Order_By>;
  supportId?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Feedbacks_Min_Fields = {
  __typename?: 'feedbacks_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  information?: Maybe<Scalars['String']>;
  supportId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "feedbacks" */
export type Feedbacks_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  information?: Maybe<Order_By>;
  supportId?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** response of any mutation on the table "feedbacks" */
export type Feedbacks_Mutation_Response = {
  __typename?: 'feedbacks_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Feedbacks>;
};

/** input type for inserting object relation for remote table "feedbacks" */
export type Feedbacks_Obj_Rel_Insert_Input = {
  data: Feedbacks_Insert_Input;
  on_conflict?: Maybe<Feedbacks_On_Conflict>;
};

/** on conflict condition type for table "feedbacks" */
export type Feedbacks_On_Conflict = {
  constraint: Feedbacks_Constraint;
  update_columns: Array<Feedbacks_Update_Column>;
  where?: Maybe<Feedbacks_Bool_Exp>;
};

/** ordering options when selecting data from "feedbacks" */
export type Feedbacks_Order_By = {
  createdAt?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  information?: Maybe<Order_By>;
  support?: Maybe<Supports_Order_By>;
  supportCopy?: Maybe<Order_By>;
  supportId?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** primary key columns input for table: "feedbacks" */
export type Feedbacks_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Feedbacks_Prepend_Input = {
  supportCopy?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "feedbacks" */
export enum Feedbacks_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Information = 'information',
  /** column name */
  SupportCopy = 'supportCopy',
  /** column name */
  SupportId = 'supportId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "feedbacks" */
export type Feedbacks_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  information?: Maybe<Scalars['String']>;
  supportCopy?: Maybe<Scalars['jsonb']>;
  supportId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Feedbacks_Stddev_Fields = {
  __typename?: 'feedbacks_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  supportId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "feedbacks" */
export type Feedbacks_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  supportId?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Feedbacks_Stddev_Pop_Fields = {
  __typename?: 'feedbacks_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  supportId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "feedbacks" */
export type Feedbacks_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  supportId?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Feedbacks_Stddev_Samp_Fields = {
  __typename?: 'feedbacks_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  supportId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "feedbacks" */
export type Feedbacks_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  supportId?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Feedbacks_Sum_Fields = {
  __typename?: 'feedbacks_sum_fields';
  id?: Maybe<Scalars['Int']>;
  supportId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "feedbacks" */
export type Feedbacks_Sum_Order_By = {
  id?: Maybe<Order_By>;
  supportId?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** update columns of table "feedbacks" */
export enum Feedbacks_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Information = 'information',
  /** column name */
  SupportCopy = 'supportCopy',
  /** column name */
  SupportId = 'supportId',
  /** column name */
  UserId = 'userId'
}

/** aggregate var_pop on columns */
export type Feedbacks_Var_Pop_Fields = {
  __typename?: 'feedbacks_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  supportId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "feedbacks" */
export type Feedbacks_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  supportId?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Feedbacks_Var_Samp_Fields = {
  __typename?: 'feedbacks_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  supportId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "feedbacks" */
export type Feedbacks_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  supportId?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Feedbacks_Variance_Fields = {
  __typename?: 'feedbacks_variance_fields';
  id?: Maybe<Scalars['Float']>;
  supportId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "feedbacks" */
export type Feedbacks_Variance_Order_By = {
  id?: Maybe<Order_By>;
  supportId?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};


/** expression to compare columns of type float8. All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "institutions" */
export type Institutions = {
  __typename?: 'institutions';
  /** An object relationship */
  bright_branch?: Maybe<Bright_Branch>;
  credit_duration: Scalars['Int'];
  credits: Scalars['Int'];
  /** An array relationship */
  credits_logs: Array<Credits_Log>;
  /** An aggregated array relationship */
  credits_logs_aggregate: Credits_Log_Aggregate;
  exams?: Maybe<Scalars['jsonb']>;
  id: Scalars['Int'];
  is_root_institution: Scalars['Boolean'];
  logo: Scalars['String'];
  multi_credits?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  nb_of_exclusive_mock_exams: Scalars['Int'];
  /** An object relationship */
  parent_institution?: Maybe<Institutions>;
  parent_institution_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  profiles: Array<Profiles>;
  /** An aggregated array relationship */
  profiles_aggregate: Profiles_Aggregate;
  /** An array relationship */
  registration_billings: Array<Registration_Billings>;
  /** An aggregated array relationship */
  registration_billings_aggregate: Registration_Billings_Aggregate;
  /** An array relationship */
  registrations: Array<Registrations>;
  /** An aggregated array relationship */
  registrations_aggregate: Registrations_Aggregate;
  slug?: Maybe<Scalars['String']>;
  /** An array relationship */
  subInstitutions: Array<Institutions>;
  /** An aggregated array relationship */
  subInstitutions_aggregate: Institutions_Aggregate;
};


/** columns and relationships of "institutions" */
export type InstitutionsCredits_LogsArgs = {
  distinct_on?: Maybe<Array<Credits_Log_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credits_Log_Order_By>>;
  where?: Maybe<Credits_Log_Bool_Exp>;
};


/** columns and relationships of "institutions" */
export type InstitutionsCredits_Logs_AggregateArgs = {
  distinct_on?: Maybe<Array<Credits_Log_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credits_Log_Order_By>>;
  where?: Maybe<Credits_Log_Bool_Exp>;
};


/** columns and relationships of "institutions" */
export type InstitutionsExamsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "institutions" */
export type InstitutionsMulti_CreditsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "institutions" */
export type InstitutionsProfilesArgs = {
  distinct_on?: Maybe<Array<Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profiles_Order_By>>;
  where?: Maybe<Profiles_Bool_Exp>;
};


/** columns and relationships of "institutions" */
export type InstitutionsProfiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profiles_Order_By>>;
  where?: Maybe<Profiles_Bool_Exp>;
};


/** columns and relationships of "institutions" */
export type InstitutionsRegistration_BillingsArgs = {
  distinct_on?: Maybe<Array<Registration_Billings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registration_Billings_Order_By>>;
  where?: Maybe<Registration_Billings_Bool_Exp>;
};


/** columns and relationships of "institutions" */
export type InstitutionsRegistration_Billings_AggregateArgs = {
  distinct_on?: Maybe<Array<Registration_Billings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registration_Billings_Order_By>>;
  where?: Maybe<Registration_Billings_Bool_Exp>;
};


/** columns and relationships of "institutions" */
export type InstitutionsRegistrationsArgs = {
  distinct_on?: Maybe<Array<Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registrations_Order_By>>;
  where?: Maybe<Registrations_Bool_Exp>;
};


/** columns and relationships of "institutions" */
export type InstitutionsRegistrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registrations_Order_By>>;
  where?: Maybe<Registrations_Bool_Exp>;
};


/** columns and relationships of "institutions" */
export type InstitutionsSubInstitutionsArgs = {
  distinct_on?: Maybe<Array<Institutions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Institutions_Order_By>>;
  where?: Maybe<Institutions_Bool_Exp>;
};


/** columns and relationships of "institutions" */
export type InstitutionsSubInstitutions_AggregateArgs = {
  distinct_on?: Maybe<Array<Institutions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Institutions_Order_By>>;
  where?: Maybe<Institutions_Bool_Exp>;
};

/** aggregated selection of "institutions" */
export type Institutions_Aggregate = {
  __typename?: 'institutions_aggregate';
  aggregate?: Maybe<Institutions_Aggregate_Fields>;
  nodes: Array<Institutions>;
};

/** aggregate fields of "institutions" */
export type Institutions_Aggregate_Fields = {
  __typename?: 'institutions_aggregate_fields';
  avg?: Maybe<Institutions_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Institutions_Max_Fields>;
  min?: Maybe<Institutions_Min_Fields>;
  stddev?: Maybe<Institutions_Stddev_Fields>;
  stddev_pop?: Maybe<Institutions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Institutions_Stddev_Samp_Fields>;
  sum?: Maybe<Institutions_Sum_Fields>;
  var_pop?: Maybe<Institutions_Var_Pop_Fields>;
  var_samp?: Maybe<Institutions_Var_Samp_Fields>;
  variance?: Maybe<Institutions_Variance_Fields>;
};


/** aggregate fields of "institutions" */
export type Institutions_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Institutions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "institutions" */
export type Institutions_Aggregate_Order_By = {
  avg?: Maybe<Institutions_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Institutions_Max_Order_By>;
  min?: Maybe<Institutions_Min_Order_By>;
  stddev?: Maybe<Institutions_Stddev_Order_By>;
  stddev_pop?: Maybe<Institutions_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Institutions_Stddev_Samp_Order_By>;
  sum?: Maybe<Institutions_Sum_Order_By>;
  var_pop?: Maybe<Institutions_Var_Pop_Order_By>;
  var_samp?: Maybe<Institutions_Var_Samp_Order_By>;
  variance?: Maybe<Institutions_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Institutions_Append_Input = {
  exams?: Maybe<Scalars['jsonb']>;
  multi_credits?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "institutions" */
export type Institutions_Arr_Rel_Insert_Input = {
  data: Array<Institutions_Insert_Input>;
  on_conflict?: Maybe<Institutions_On_Conflict>;
};

/** aggregate avg on columns */
export type Institutions_Avg_Fields = {
  __typename?: 'institutions_avg_fields';
  credit_duration?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Float']>;
  parent_institution_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "institutions" */
export type Institutions_Avg_Order_By = {
  credit_duration?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  nb_of_exclusive_mock_exams?: Maybe<Order_By>;
  parent_institution_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "institutions". All fields are combined with a logical 'AND'. */
export type Institutions_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Institutions_Bool_Exp>>>;
  _not?: Maybe<Institutions_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Institutions_Bool_Exp>>>;
  bright_branch?: Maybe<Bright_Branch_Bool_Exp>;
  credit_duration?: Maybe<Int_Comparison_Exp>;
  credits?: Maybe<Int_Comparison_Exp>;
  credits_logs?: Maybe<Credits_Log_Bool_Exp>;
  exams?: Maybe<Jsonb_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_root_institution?: Maybe<Boolean_Comparison_Exp>;
  logo?: Maybe<String_Comparison_Exp>;
  multi_credits?: Maybe<Jsonb_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  nb_of_exclusive_mock_exams?: Maybe<Int_Comparison_Exp>;
  parent_institution?: Maybe<Institutions_Bool_Exp>;
  parent_institution_id?: Maybe<Int_Comparison_Exp>;
  profiles?: Maybe<Profiles_Bool_Exp>;
  registration_billings?: Maybe<Registration_Billings_Bool_Exp>;
  registrations?: Maybe<Registrations_Bool_Exp>;
  slug?: Maybe<String_Comparison_Exp>;
  subInstitutions?: Maybe<Institutions_Bool_Exp>;
};

/** unique or primary key constraints on table "institutions" */
export enum Institutions_Constraint {
  /** unique or primary key constraint */
  InstitutionsPkey = 'institutions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Institutions_Delete_At_Path_Input = {
  exams?: Maybe<Array<Maybe<Scalars['String']>>>;
  multi_credits?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Institutions_Delete_Elem_Input = {
  exams?: Maybe<Scalars['Int']>;
  multi_credits?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Institutions_Delete_Key_Input = {
  exams?: Maybe<Scalars['String']>;
  multi_credits?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "institutions" */
export type Institutions_Inc_Input = {
  credit_duration?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Int']>;
  parent_institution_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "institutions" */
export type Institutions_Insert_Input = {
  bright_branch?: Maybe<Bright_Branch_Obj_Rel_Insert_Input>;
  credit_duration?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  credits_logs?: Maybe<Credits_Log_Arr_Rel_Insert_Input>;
  exams?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['Int']>;
  is_root_institution?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  multi_credits?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Int']>;
  parent_institution?: Maybe<Institutions_Obj_Rel_Insert_Input>;
  parent_institution_id?: Maybe<Scalars['Int']>;
  profiles?: Maybe<Profiles_Arr_Rel_Insert_Input>;
  registration_billings?: Maybe<Registration_Billings_Arr_Rel_Insert_Input>;
  registrations?: Maybe<Registrations_Arr_Rel_Insert_Input>;
  slug?: Maybe<Scalars['String']>;
  subInstitutions?: Maybe<Institutions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Institutions_Max_Fields = {
  __typename?: 'institutions_max_fields';
  credit_duration?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Int']>;
  parent_institution_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "institutions" */
export type Institutions_Max_Order_By = {
  credit_duration?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  logo?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  nb_of_exclusive_mock_exams?: Maybe<Order_By>;
  parent_institution_id?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Institutions_Min_Fields = {
  __typename?: 'institutions_min_fields';
  credit_duration?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Int']>;
  parent_institution_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "institutions" */
export type Institutions_Min_Order_By = {
  credit_duration?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  logo?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  nb_of_exclusive_mock_exams?: Maybe<Order_By>;
  parent_institution_id?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
};

/** response of any mutation on the table "institutions" */
export type Institutions_Mutation_Response = {
  __typename?: 'institutions_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Institutions>;
};

/** input type for inserting object relation for remote table "institutions" */
export type Institutions_Obj_Rel_Insert_Input = {
  data: Institutions_Insert_Input;
  on_conflict?: Maybe<Institutions_On_Conflict>;
};

/** on conflict condition type for table "institutions" */
export type Institutions_On_Conflict = {
  constraint: Institutions_Constraint;
  update_columns: Array<Institutions_Update_Column>;
  where?: Maybe<Institutions_Bool_Exp>;
};

/** ordering options when selecting data from "institutions" */
export type Institutions_Order_By = {
  bright_branch?: Maybe<Bright_Branch_Order_By>;
  credit_duration?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  credits_logs_aggregate?: Maybe<Credits_Log_Aggregate_Order_By>;
  exams?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_root_institution?: Maybe<Order_By>;
  logo?: Maybe<Order_By>;
  multi_credits?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  nb_of_exclusive_mock_exams?: Maybe<Order_By>;
  parent_institution?: Maybe<Institutions_Order_By>;
  parent_institution_id?: Maybe<Order_By>;
  profiles_aggregate?: Maybe<Profiles_Aggregate_Order_By>;
  registration_billings_aggregate?: Maybe<Registration_Billings_Aggregate_Order_By>;
  registrations_aggregate?: Maybe<Registrations_Aggregate_Order_By>;
  slug?: Maybe<Order_By>;
  subInstitutions_aggregate?: Maybe<Institutions_Aggregate_Order_By>;
};

/** primary key columns input for table: "institutions" */
export type Institutions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Institutions_Prepend_Input = {
  exams?: Maybe<Scalars['jsonb']>;
  multi_credits?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "institutions" */
export enum Institutions_Select_Column {
  /** column name */
  CreditDuration = 'credit_duration',
  /** column name */
  Credits = 'credits',
  /** column name */
  Exams = 'exams',
  /** column name */
  Id = 'id',
  /** column name */
  IsRootInstitution = 'is_root_institution',
  /** column name */
  Logo = 'logo',
  /** column name */
  MultiCredits = 'multi_credits',
  /** column name */
  Name = 'name',
  /** column name */
  NbOfExclusiveMockExams = 'nb_of_exclusive_mock_exams',
  /** column name */
  ParentInstitutionId = 'parent_institution_id',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "institutions" */
export type Institutions_Set_Input = {
  credit_duration?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  exams?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['Int']>;
  is_root_institution?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  multi_credits?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Int']>;
  parent_institution_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Institutions_Stddev_Fields = {
  __typename?: 'institutions_stddev_fields';
  credit_duration?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Float']>;
  parent_institution_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "institutions" */
export type Institutions_Stddev_Order_By = {
  credit_duration?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  nb_of_exclusive_mock_exams?: Maybe<Order_By>;
  parent_institution_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Institutions_Stddev_Pop_Fields = {
  __typename?: 'institutions_stddev_pop_fields';
  credit_duration?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Float']>;
  parent_institution_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "institutions" */
export type Institutions_Stddev_Pop_Order_By = {
  credit_duration?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  nb_of_exclusive_mock_exams?: Maybe<Order_By>;
  parent_institution_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Institutions_Stddev_Samp_Fields = {
  __typename?: 'institutions_stddev_samp_fields';
  credit_duration?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Float']>;
  parent_institution_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "institutions" */
export type Institutions_Stddev_Samp_Order_By = {
  credit_duration?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  nb_of_exclusive_mock_exams?: Maybe<Order_By>;
  parent_institution_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Institutions_Sum_Fields = {
  __typename?: 'institutions_sum_fields';
  credit_duration?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Int']>;
  parent_institution_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "institutions" */
export type Institutions_Sum_Order_By = {
  credit_duration?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  nb_of_exclusive_mock_exams?: Maybe<Order_By>;
  parent_institution_id?: Maybe<Order_By>;
};

/** update columns of table "institutions" */
export enum Institutions_Update_Column {
  /** column name */
  CreditDuration = 'credit_duration',
  /** column name */
  Credits = 'credits',
  /** column name */
  Exams = 'exams',
  /** column name */
  Id = 'id',
  /** column name */
  IsRootInstitution = 'is_root_institution',
  /** column name */
  Logo = 'logo',
  /** column name */
  MultiCredits = 'multi_credits',
  /** column name */
  Name = 'name',
  /** column name */
  NbOfExclusiveMockExams = 'nb_of_exclusive_mock_exams',
  /** column name */
  ParentInstitutionId = 'parent_institution_id',
  /** column name */
  Slug = 'slug'
}

/** aggregate var_pop on columns */
export type Institutions_Var_Pop_Fields = {
  __typename?: 'institutions_var_pop_fields';
  credit_duration?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Float']>;
  parent_institution_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "institutions" */
export type Institutions_Var_Pop_Order_By = {
  credit_duration?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  nb_of_exclusive_mock_exams?: Maybe<Order_By>;
  parent_institution_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Institutions_Var_Samp_Fields = {
  __typename?: 'institutions_var_samp_fields';
  credit_duration?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Float']>;
  parent_institution_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "institutions" */
export type Institutions_Var_Samp_Order_By = {
  credit_duration?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  nb_of_exclusive_mock_exams?: Maybe<Order_By>;
  parent_institution_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Institutions_Variance_Fields = {
  __typename?: 'institutions_variance_fields';
  credit_duration?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nb_of_exclusive_mock_exams?: Maybe<Scalars['Float']>;
  parent_institution_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "institutions" */
export type Institutions_Variance_Order_By = {
  credit_duration?: Maybe<Order_By>;
  credits?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  nb_of_exclusive_mock_exams?: Maybe<Order_By>;
  parent_institution_id?: Maybe<Order_By>;
};


/** expression to compare columns of type jsonb. All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "lessons" */
export type Lessons = {
  __typename?: 'lessons';
  /** An object relationship */
  category: Categories;
  category_id: Scalars['Int'];
  detail?: Maybe<Scalars['String']>;
  exam_type: Scalars['exam_types'];
  id: Scalars['Int'];
  level?: Maybe<Scalars['String']>;
  /** An array relationship */
  question_lesson_associations: Array<Question_Lesson_Association>;
  /** An aggregated array relationship */
  question_lesson_associations_aggregate: Question_Lesson_Association_Aggregate;
  /** An array relationship */
  scores: Array<Scores>;
  /** An aggregated array relationship */
  scores_aggregate: Scores_Aggregate;
  /** An array relationship */
  supports: Array<Supports>;
  /** An aggregated array relationship */
  supports_aggregate: Supports_Aggregate;
  title?: Maybe<Scalars['String']>;
};


/** columns and relationships of "lessons" */
export type LessonsQuestion_Lesson_AssociationsArgs = {
  distinct_on?: Maybe<Array<Question_Lesson_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Question_Lesson_Association_Order_By>>;
  where?: Maybe<Question_Lesson_Association_Bool_Exp>;
};


/** columns and relationships of "lessons" */
export type LessonsQuestion_Lesson_Associations_AggregateArgs = {
  distinct_on?: Maybe<Array<Question_Lesson_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Question_Lesson_Association_Order_By>>;
  where?: Maybe<Question_Lesson_Association_Bool_Exp>;
};


/** columns and relationships of "lessons" */
export type LessonsScoresArgs = {
  distinct_on?: Maybe<Array<Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scores_Order_By>>;
  where?: Maybe<Scores_Bool_Exp>;
};


/** columns and relationships of "lessons" */
export type LessonsScores_AggregateArgs = {
  distinct_on?: Maybe<Array<Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scores_Order_By>>;
  where?: Maybe<Scores_Bool_Exp>;
};


/** columns and relationships of "lessons" */
export type LessonsSupportsArgs = {
  distinct_on?: Maybe<Array<Supports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Supports_Order_By>>;
  where?: Maybe<Supports_Bool_Exp>;
};


/** columns and relationships of "lessons" */
export type LessonsSupports_AggregateArgs = {
  distinct_on?: Maybe<Array<Supports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Supports_Order_By>>;
  where?: Maybe<Supports_Bool_Exp>;
};

/** aggregated selection of "lessons" */
export type Lessons_Aggregate = {
  __typename?: 'lessons_aggregate';
  aggregate?: Maybe<Lessons_Aggregate_Fields>;
  nodes: Array<Lessons>;
};

/** aggregate fields of "lessons" */
export type Lessons_Aggregate_Fields = {
  __typename?: 'lessons_aggregate_fields';
  avg?: Maybe<Lessons_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Lessons_Max_Fields>;
  min?: Maybe<Lessons_Min_Fields>;
  stddev?: Maybe<Lessons_Stddev_Fields>;
  stddev_pop?: Maybe<Lessons_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lessons_Stddev_Samp_Fields>;
  sum?: Maybe<Lessons_Sum_Fields>;
  var_pop?: Maybe<Lessons_Var_Pop_Fields>;
  var_samp?: Maybe<Lessons_Var_Samp_Fields>;
  variance?: Maybe<Lessons_Variance_Fields>;
};


/** aggregate fields of "lessons" */
export type Lessons_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Lessons_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lessons" */
export type Lessons_Aggregate_Order_By = {
  avg?: Maybe<Lessons_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Lessons_Max_Order_By>;
  min?: Maybe<Lessons_Min_Order_By>;
  stddev?: Maybe<Lessons_Stddev_Order_By>;
  stddev_pop?: Maybe<Lessons_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Lessons_Stddev_Samp_Order_By>;
  sum?: Maybe<Lessons_Sum_Order_By>;
  var_pop?: Maybe<Lessons_Var_Pop_Order_By>;
  var_samp?: Maybe<Lessons_Var_Samp_Order_By>;
  variance?: Maybe<Lessons_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lessons" */
export type Lessons_Arr_Rel_Insert_Input = {
  data: Array<Lessons_Insert_Input>;
  on_conflict?: Maybe<Lessons_On_Conflict>;
};

/** aggregate avg on columns */
export type Lessons_Avg_Fields = {
  __typename?: 'lessons_avg_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lessons" */
export type Lessons_Avg_Order_By = {
  category_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lessons". All fields are combined with a logical 'AND'. */
export type Lessons_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Lessons_Bool_Exp>>>;
  _not?: Maybe<Lessons_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Lessons_Bool_Exp>>>;
  category?: Maybe<Categories_Bool_Exp>;
  category_id?: Maybe<Int_Comparison_Exp>;
  detail?: Maybe<String_Comparison_Exp>;
  exam_type?: Maybe<Exam_Types_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  level?: Maybe<String_Comparison_Exp>;
  question_lesson_associations?: Maybe<Question_Lesson_Association_Bool_Exp>;
  scores?: Maybe<Scores_Bool_Exp>;
  supports?: Maybe<Supports_Bool_Exp>;
  title?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "lessons" */
export enum Lessons_Constraint {
  /** unique or primary key constraint */
  LessonsPkey = 'lessons_pkey'
}

/** input type for incrementing integer column in table "lessons" */
export type Lessons_Inc_Input = {
  category_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "lessons" */
export type Lessons_Insert_Input = {
  category?: Maybe<Categories_Obj_Rel_Insert_Input>;
  category_id?: Maybe<Scalars['Int']>;
  detail?: Maybe<Scalars['String']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
  question_lesson_associations?: Maybe<Question_Lesson_Association_Arr_Rel_Insert_Input>;
  scores?: Maybe<Scores_Arr_Rel_Insert_Input>;
  supports?: Maybe<Supports_Arr_Rel_Insert_Input>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Lessons_Max_Fields = {
  __typename?: 'lessons_max_fields';
  category_id?: Maybe<Scalars['Int']>;
  detail?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "lessons" */
export type Lessons_Max_Order_By = {
  category_id?: Maybe<Order_By>;
  detail?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Lessons_Min_Fields = {
  __typename?: 'lessons_min_fields';
  category_id?: Maybe<Scalars['Int']>;
  detail?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "lessons" */
export type Lessons_Min_Order_By = {
  category_id?: Maybe<Order_By>;
  detail?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
};

/** response of any mutation on the table "lessons" */
export type Lessons_Mutation_Response = {
  __typename?: 'lessons_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Lessons>;
};

/** input type for inserting object relation for remote table "lessons" */
export type Lessons_Obj_Rel_Insert_Input = {
  data: Lessons_Insert_Input;
  on_conflict?: Maybe<Lessons_On_Conflict>;
};

/** on conflict condition type for table "lessons" */
export type Lessons_On_Conflict = {
  constraint: Lessons_Constraint;
  update_columns: Array<Lessons_Update_Column>;
  where?: Maybe<Lessons_Bool_Exp>;
};

/** ordering options when selecting data from "lessons" */
export type Lessons_Order_By = {
  category?: Maybe<Categories_Order_By>;
  category_id?: Maybe<Order_By>;
  detail?: Maybe<Order_By>;
  exam_type?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
  question_lesson_associations_aggregate?: Maybe<Question_Lesson_Association_Aggregate_Order_By>;
  scores_aggregate?: Maybe<Scores_Aggregate_Order_By>;
  supports_aggregate?: Maybe<Supports_Aggregate_Order_By>;
  title?: Maybe<Order_By>;
};

/** primary key columns input for table: "lessons" */
export type Lessons_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "lessons" */
export enum Lessons_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Detail = 'detail',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "lessons" */
export type Lessons_Set_Input = {
  category_id?: Maybe<Scalars['Int']>;
  detail?: Maybe<Scalars['String']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Lessons_Stddev_Fields = {
  __typename?: 'lessons_stddev_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lessons" */
export type Lessons_Stddev_Order_By = {
  category_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lessons_Stddev_Pop_Fields = {
  __typename?: 'lessons_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "lessons" */
export type Lessons_Stddev_Pop_Order_By = {
  category_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lessons_Stddev_Samp_Fields = {
  __typename?: 'lessons_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "lessons" */
export type Lessons_Stddev_Samp_Order_By = {
  category_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Lessons_Sum_Fields = {
  __typename?: 'lessons_sum_fields';
  category_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "lessons" */
export type Lessons_Sum_Order_By = {
  category_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "lessons" */
export enum Lessons_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Detail = 'detail',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Title = 'title'
}

/** aggregate var_pop on columns */
export type Lessons_Var_Pop_Fields = {
  __typename?: 'lessons_var_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "lessons" */
export type Lessons_Var_Pop_Order_By = {
  category_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lessons_Var_Samp_Fields = {
  __typename?: 'lessons_var_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "lessons" */
export type Lessons_Var_Samp_Order_By = {
  category_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Lessons_Variance_Fields = {
  __typename?: 'lessons_variance_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lessons" */
export type Lessons_Variance_Order_By = {
  category_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "activation_codes" */
  delete_activation_codes?: Maybe<Activation_Codes_Mutation_Response>;
  /** delete single row from the table: "activation_codes" */
  delete_activation_codes_by_pk?: Maybe<Activation_Codes>;
  /** delete data from the table: "answers" */
  delete_answers?: Maybe<Answers_Mutation_Response>;
  /** delete single row from the table: "answers" */
  delete_answers_by_pk?: Maybe<Answers>;
  /** delete data from the table: "answers_choice_association" */
  delete_answers_choice_association?: Maybe<Answers_Choice_Association_Mutation_Response>;
  /** delete data from the table: "bills" */
  delete_bills?: Maybe<Bills_Mutation_Response>;
  /** delete single row from the table: "bills" */
  delete_bills_by_pk?: Maybe<Bills>;
  /** delete data from the table: "bright_assessment" */
  delete_bright_assessment?: Maybe<Bright_Assessment_Mutation_Response>;
  /** delete single row from the table: "bright_assessment" */
  delete_bright_assessment_by_pk?: Maybe<Bright_Assessment>;
  /** delete data from the table: "bright_assessments" */
  delete_bright_assessments?: Maybe<Bright_Assessments_Mutation_Response>;
  /** delete single row from the table: "bright_assessments" */
  delete_bright_assessments_by_pk?: Maybe<Bright_Assessments>;
  /** delete data from the table: "bright_branch" */
  delete_bright_branch?: Maybe<Bright_Branch_Mutation_Response>;
  /** delete single row from the table: "bright_branch" */
  delete_bright_branch_by_pk?: Maybe<Bright_Branch>;
  /** delete data from the table: "bright_candidate" */
  delete_bright_candidate?: Maybe<Bright_Candidate_Mutation_Response>;
  /** delete single row from the table: "bright_candidate" */
  delete_bright_candidate_by_pk?: Maybe<Bright_Candidate>;
  /** delete data from the table: "bright_manager" */
  delete_bright_manager?: Maybe<Bright_Manager_Mutation_Response>;
  /** delete single row from the table: "bright_manager" */
  delete_bright_manager_by_pk?: Maybe<Bright_Manager>;
  /** delete data from the table: "categories" */
  delete_categories?: Maybe<Categories_Mutation_Response>;
  /** delete single row from the table: "categories" */
  delete_categories_by_pk?: Maybe<Categories>;
  /** delete data from the table: "choices" */
  delete_choices?: Maybe<Choices_Mutation_Response>;
  /** delete single row from the table: "choices" */
  delete_choices_by_pk?: Maybe<Choices>;
  /** delete data from the table: "credits_log" */
  delete_credits_log?: Maybe<Credits_Log_Mutation_Response>;
  /** delete single row from the table: "credits_log" */
  delete_credits_log_by_pk?: Maybe<Credits_Log>;
  /** delete data from the table: "discount_codes" */
  delete_discount_codes?: Maybe<Discount_Codes_Mutation_Response>;
  /** delete single row from the table: "discount_codes" */
  delete_discount_codes_by_pk?: Maybe<Discount_Codes>;
  /** delete data from the table: "estimated_scores" */
  delete_estimated_scores?: Maybe<Estimated_Scores_Mutation_Response>;
  /** delete single row from the table: "estimated_scores" */
  delete_estimated_scores_by_pk?: Maybe<Estimated_Scores>;
  /** delete data from the table: "exams" */
  delete_exams?: Maybe<Exams_Mutation_Response>;
  /** delete single row from the table: "exams" */
  delete_exams_by_pk?: Maybe<Exams>;
  /** delete data from the table: "feedbacks" */
  delete_feedbacks?: Maybe<Feedbacks_Mutation_Response>;
  /** delete single row from the table: "feedbacks" */
  delete_feedbacks_by_pk?: Maybe<Feedbacks>;
  /** delete data from the table: "institutions" */
  delete_institutions?: Maybe<Institutions_Mutation_Response>;
  /** delete single row from the table: "institutions" */
  delete_institutions_by_pk?: Maybe<Institutions>;
  /** delete data from the table: "lessons" */
  delete_lessons?: Maybe<Lessons_Mutation_Response>;
  /** delete single row from the table: "lessons" */
  delete_lessons_by_pk?: Maybe<Lessons>;
  /** delete data from the table: "plans" */
  delete_plans?: Maybe<Plans_Mutation_Response>;
  /** delete single row from the table: "plans" */
  delete_plans_by_pk?: Maybe<Plans>;
  /** delete data from the table: "profile_sphere_association" */
  delete_profile_sphere_association?: Maybe<Profile_Sphere_Association_Mutation_Response>;
  /** delete data from the table: "profiles" */
  delete_profiles?: Maybe<Profiles_Mutation_Response>;
  /** delete single row from the table: "profiles" */
  delete_profiles_by_pk?: Maybe<Profiles>;
  /** delete data from the table: "question_lesson_association" */
  delete_question_lesson_association?: Maybe<Question_Lesson_Association_Mutation_Response>;
  /** delete single row from the table: "question_lesson_association" */
  delete_question_lesson_association_by_pk?: Maybe<Question_Lesson_Association>;
  /** delete data from the table: "questions" */
  delete_questions?: Maybe<Questions_Mutation_Response>;
  /** delete single row from the table: "questions" */
  delete_questions_by_pk?: Maybe<Questions>;
  /** delete data from the table: "registration_billings" */
  delete_registration_billings?: Maybe<Registration_Billings_Mutation_Response>;
  /** delete single row from the table: "registration_billings" */
  delete_registration_billings_by_pk?: Maybe<Registration_Billings>;
  /** delete data from the table: "registrations" */
  delete_registrations?: Maybe<Registrations_Mutation_Response>;
  /** delete single row from the table: "registrations" */
  delete_registrations_by_pk?: Maybe<Registrations>;
  /** delete data from the table: "result_plan_association" */
  delete_result_plan_association?: Maybe<Result_Plan_Association_Mutation_Response>;
  /** delete single row from the table: "result_plan_association" */
  delete_result_plan_association_by_pk?: Maybe<Result_Plan_Association>;
  /** delete data from the table: "results" */
  delete_results?: Maybe<Results_Mutation_Response>;
  /** delete single row from the table: "results" */
  delete_results_by_pk?: Maybe<Results>;
  /** delete data from the table: "scores" */
  delete_scores?: Maybe<Scores_Mutation_Response>;
  /** delete single row from the table: "scores" */
  delete_scores_by_pk?: Maybe<Scores>;
  /** delete data from the table: "spheres" */
  delete_spheres?: Maybe<Spheres_Mutation_Response>;
  /** delete single row from the table: "spheres" */
  delete_spheres_by_pk?: Maybe<Spheres>;
  /** delete data from the table: "supports" */
  delete_supports?: Maybe<Supports_Mutation_Response>;
  /** delete single row from the table: "supports" */
  delete_supports_by_pk?: Maybe<Supports>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** insert data into the table: "activation_codes" */
  insert_activation_codes?: Maybe<Activation_Codes_Mutation_Response>;
  /** insert a single row into the table: "activation_codes" */
  insert_activation_codes_one?: Maybe<Activation_Codes>;
  /** insert data into the table: "answers" */
  insert_answers?: Maybe<Answers_Mutation_Response>;
  /** insert data into the table: "answers_choice_association" */
  insert_answers_choice_association?: Maybe<Answers_Choice_Association_Mutation_Response>;
  /** insert a single row into the table: "answers_choice_association" */
  insert_answers_choice_association_one?: Maybe<Answers_Choice_Association>;
  /** insert a single row into the table: "answers" */
  insert_answers_one?: Maybe<Answers>;
  /** insert data into the table: "bills" */
  insert_bills?: Maybe<Bills_Mutation_Response>;
  /** insert a single row into the table: "bills" */
  insert_bills_one?: Maybe<Bills>;
  /** insert data into the table: "bright_assessment" */
  insert_bright_assessment?: Maybe<Bright_Assessment_Mutation_Response>;
  /** insert a single row into the table: "bright_assessment" */
  insert_bright_assessment_one?: Maybe<Bright_Assessment>;
  /** insert data into the table: "bright_assessments" */
  insert_bright_assessments?: Maybe<Bright_Assessments_Mutation_Response>;
  /** insert a single row into the table: "bright_assessments" */
  insert_bright_assessments_one?: Maybe<Bright_Assessments>;
  /** insert data into the table: "bright_branch" */
  insert_bright_branch?: Maybe<Bright_Branch_Mutation_Response>;
  /** insert a single row into the table: "bright_branch" */
  insert_bright_branch_one?: Maybe<Bright_Branch>;
  /** insert data into the table: "bright_candidate" */
  insert_bright_candidate?: Maybe<Bright_Candidate_Mutation_Response>;
  /** insert a single row into the table: "bright_candidate" */
  insert_bright_candidate_one?: Maybe<Bright_Candidate>;
  /** insert data into the table: "bright_manager" */
  insert_bright_manager?: Maybe<Bright_Manager_Mutation_Response>;
  /** insert a single row into the table: "bright_manager" */
  insert_bright_manager_one?: Maybe<Bright_Manager>;
  /** insert data into the table: "categories" */
  insert_categories?: Maybe<Categories_Mutation_Response>;
  /** insert a single row into the table: "categories" */
  insert_categories_one?: Maybe<Categories>;
  /** insert data into the table: "choices" */
  insert_choices?: Maybe<Choices_Mutation_Response>;
  /** insert a single row into the table: "choices" */
  insert_choices_one?: Maybe<Choices>;
  /** insert data into the table: "credits_log" */
  insert_credits_log?: Maybe<Credits_Log_Mutation_Response>;
  /** insert a single row into the table: "credits_log" */
  insert_credits_log_one?: Maybe<Credits_Log>;
  /** insert data into the table: "discount_codes" */
  insert_discount_codes?: Maybe<Discount_Codes_Mutation_Response>;
  /** insert a single row into the table: "discount_codes" */
  insert_discount_codes_one?: Maybe<Discount_Codes>;
  /** insert data into the table: "estimated_scores" */
  insert_estimated_scores?: Maybe<Estimated_Scores_Mutation_Response>;
  /** insert a single row into the table: "estimated_scores" */
  insert_estimated_scores_one?: Maybe<Estimated_Scores>;
  /** insert data into the table: "exams" */
  insert_exams?: Maybe<Exams_Mutation_Response>;
  /** insert a single row into the table: "exams" */
  insert_exams_one?: Maybe<Exams>;
  /** insert data into the table: "feedbacks" */
  insert_feedbacks?: Maybe<Feedbacks_Mutation_Response>;
  /** insert a single row into the table: "feedbacks" */
  insert_feedbacks_one?: Maybe<Feedbacks>;
  /** insert data into the table: "institutions" */
  insert_institutions?: Maybe<Institutions_Mutation_Response>;
  /** insert a single row into the table: "institutions" */
  insert_institutions_one?: Maybe<Institutions>;
  /** insert data into the table: "lessons" */
  insert_lessons?: Maybe<Lessons_Mutation_Response>;
  /** insert a single row into the table: "lessons" */
  insert_lessons_one?: Maybe<Lessons>;
  /** insert data into the table: "plans" */
  insert_plans?: Maybe<Plans_Mutation_Response>;
  /** insert a single row into the table: "plans" */
  insert_plans_one?: Maybe<Plans>;
  /** insert data into the table: "profile_sphere_association" */
  insert_profile_sphere_association?: Maybe<Profile_Sphere_Association_Mutation_Response>;
  /** insert a single row into the table: "profile_sphere_association" */
  insert_profile_sphere_association_one?: Maybe<Profile_Sphere_Association>;
  /** insert data into the table: "profiles" */
  insert_profiles?: Maybe<Profiles_Mutation_Response>;
  /** insert a single row into the table: "profiles" */
  insert_profiles_one?: Maybe<Profiles>;
  /** insert data into the table: "question_lesson_association" */
  insert_question_lesson_association?: Maybe<Question_Lesson_Association_Mutation_Response>;
  /** insert a single row into the table: "question_lesson_association" */
  insert_question_lesson_association_one?: Maybe<Question_Lesson_Association>;
  /** insert data into the table: "questions" */
  insert_questions?: Maybe<Questions_Mutation_Response>;
  /** insert a single row into the table: "questions" */
  insert_questions_one?: Maybe<Questions>;
  /** insert data into the table: "registration_billings" */
  insert_registration_billings?: Maybe<Registration_Billings_Mutation_Response>;
  /** insert a single row into the table: "registration_billings" */
  insert_registration_billings_one?: Maybe<Registration_Billings>;
  /** insert data into the table: "registrations" */
  insert_registrations?: Maybe<Registrations_Mutation_Response>;
  /** insert a single row into the table: "registrations" */
  insert_registrations_one?: Maybe<Registrations>;
  /** insert data into the table: "result_plan_association" */
  insert_result_plan_association?: Maybe<Result_Plan_Association_Mutation_Response>;
  /** insert a single row into the table: "result_plan_association" */
  insert_result_plan_association_one?: Maybe<Result_Plan_Association>;
  /** insert data into the table: "results" */
  insert_results?: Maybe<Results_Mutation_Response>;
  /** insert a single row into the table: "results" */
  insert_results_one?: Maybe<Results>;
  /** insert data into the table: "scores" */
  insert_scores?: Maybe<Scores_Mutation_Response>;
  /** insert a single row into the table: "scores" */
  insert_scores_one?: Maybe<Scores>;
  /** insert data into the table: "spheres" */
  insert_spheres?: Maybe<Spheres_Mutation_Response>;
  /** insert a single row into the table: "spheres" */
  insert_spheres_one?: Maybe<Spheres>;
  /** insert data into the table: "supports" */
  insert_supports?: Maybe<Supports_Mutation_Response>;
  /** insert a single row into the table: "supports" */
  insert_supports_one?: Maybe<Supports>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** update data of the table: "activation_codes" */
  update_activation_codes?: Maybe<Activation_Codes_Mutation_Response>;
  /** update single row of the table: "activation_codes" */
  update_activation_codes_by_pk?: Maybe<Activation_Codes>;
  /** update data of the table: "answers" */
  update_answers?: Maybe<Answers_Mutation_Response>;
  /** update single row of the table: "answers" */
  update_answers_by_pk?: Maybe<Answers>;
  /** update data of the table: "answers_choice_association" */
  update_answers_choice_association?: Maybe<Answers_Choice_Association_Mutation_Response>;
  /** update data of the table: "bills" */
  update_bills?: Maybe<Bills_Mutation_Response>;
  /** update single row of the table: "bills" */
  update_bills_by_pk?: Maybe<Bills>;
  /** update data of the table: "bright_assessment" */
  update_bright_assessment?: Maybe<Bright_Assessment_Mutation_Response>;
  /** update single row of the table: "bright_assessment" */
  update_bright_assessment_by_pk?: Maybe<Bright_Assessment>;
  /** update data of the table: "bright_assessments" */
  update_bright_assessments?: Maybe<Bright_Assessments_Mutation_Response>;
  /** update single row of the table: "bright_assessments" */
  update_bright_assessments_by_pk?: Maybe<Bright_Assessments>;
  /** update data of the table: "bright_branch" */
  update_bright_branch?: Maybe<Bright_Branch_Mutation_Response>;
  /** update single row of the table: "bright_branch" */
  update_bright_branch_by_pk?: Maybe<Bright_Branch>;
  /** update data of the table: "bright_candidate" */
  update_bright_candidate?: Maybe<Bright_Candidate_Mutation_Response>;
  /** update single row of the table: "bright_candidate" */
  update_bright_candidate_by_pk?: Maybe<Bright_Candidate>;
  /** update data of the table: "bright_manager" */
  update_bright_manager?: Maybe<Bright_Manager_Mutation_Response>;
  /** update single row of the table: "bright_manager" */
  update_bright_manager_by_pk?: Maybe<Bright_Manager>;
  /** update data of the table: "categories" */
  update_categories?: Maybe<Categories_Mutation_Response>;
  /** update single row of the table: "categories" */
  update_categories_by_pk?: Maybe<Categories>;
  /** update data of the table: "choices" */
  update_choices?: Maybe<Choices_Mutation_Response>;
  /** update single row of the table: "choices" */
  update_choices_by_pk?: Maybe<Choices>;
  /** update data of the table: "credits_log" */
  update_credits_log?: Maybe<Credits_Log_Mutation_Response>;
  /** update single row of the table: "credits_log" */
  update_credits_log_by_pk?: Maybe<Credits_Log>;
  /** update data of the table: "discount_codes" */
  update_discount_codes?: Maybe<Discount_Codes_Mutation_Response>;
  /** update single row of the table: "discount_codes" */
  update_discount_codes_by_pk?: Maybe<Discount_Codes>;
  /** update data of the table: "estimated_scores" */
  update_estimated_scores?: Maybe<Estimated_Scores_Mutation_Response>;
  /** update single row of the table: "estimated_scores" */
  update_estimated_scores_by_pk?: Maybe<Estimated_Scores>;
  /** update data of the table: "exams" */
  update_exams?: Maybe<Exams_Mutation_Response>;
  /** update single row of the table: "exams" */
  update_exams_by_pk?: Maybe<Exams>;
  /** update data of the table: "feedbacks" */
  update_feedbacks?: Maybe<Feedbacks_Mutation_Response>;
  /** update single row of the table: "feedbacks" */
  update_feedbacks_by_pk?: Maybe<Feedbacks>;
  /** update data of the table: "institutions" */
  update_institutions?: Maybe<Institutions_Mutation_Response>;
  /** update single row of the table: "institutions" */
  update_institutions_by_pk?: Maybe<Institutions>;
  /** update data of the table: "lessons" */
  update_lessons?: Maybe<Lessons_Mutation_Response>;
  /** update single row of the table: "lessons" */
  update_lessons_by_pk?: Maybe<Lessons>;
  /** update data of the table: "plans" */
  update_plans?: Maybe<Plans_Mutation_Response>;
  /** update single row of the table: "plans" */
  update_plans_by_pk?: Maybe<Plans>;
  /** update data of the table: "profile_sphere_association" */
  update_profile_sphere_association?: Maybe<Profile_Sphere_Association_Mutation_Response>;
  /** update data of the table: "profiles" */
  update_profiles?: Maybe<Profiles_Mutation_Response>;
  /** update single row of the table: "profiles" */
  update_profiles_by_pk?: Maybe<Profiles>;
  /** update data of the table: "question_lesson_association" */
  update_question_lesson_association?: Maybe<Question_Lesson_Association_Mutation_Response>;
  /** update single row of the table: "question_lesson_association" */
  update_question_lesson_association_by_pk?: Maybe<Question_Lesson_Association>;
  /** update data of the table: "questions" */
  update_questions?: Maybe<Questions_Mutation_Response>;
  /** update single row of the table: "questions" */
  update_questions_by_pk?: Maybe<Questions>;
  /** update data of the table: "registration_billings" */
  update_registration_billings?: Maybe<Registration_Billings_Mutation_Response>;
  /** update single row of the table: "registration_billings" */
  update_registration_billings_by_pk?: Maybe<Registration_Billings>;
  /** update data of the table: "registrations" */
  update_registrations?: Maybe<Registrations_Mutation_Response>;
  /** update single row of the table: "registrations" */
  update_registrations_by_pk?: Maybe<Registrations>;
  /** update data of the table: "result_plan_association" */
  update_result_plan_association?: Maybe<Result_Plan_Association_Mutation_Response>;
  /** update single row of the table: "result_plan_association" */
  update_result_plan_association_by_pk?: Maybe<Result_Plan_Association>;
  /** update data of the table: "results" */
  update_results?: Maybe<Results_Mutation_Response>;
  /** update single row of the table: "results" */
  update_results_by_pk?: Maybe<Results>;
  /** update data of the table: "scores" */
  update_scores?: Maybe<Scores_Mutation_Response>;
  /** update single row of the table: "scores" */
  update_scores_by_pk?: Maybe<Scores>;
  /** update data of the table: "spheres" */
  update_spheres?: Maybe<Spheres_Mutation_Response>;
  /** update single row of the table: "spheres" */
  update_spheres_by_pk?: Maybe<Spheres>;
  /** update data of the table: "supports" */
  update_supports?: Maybe<Supports_Mutation_Response>;
  /** update single row of the table: "supports" */
  update_supports_by_pk?: Maybe<Supports>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
};


/** mutation root */
export type Mutation_RootDelete_Activation_CodesArgs = {
  where: Activation_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Activation_Codes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AnswersArgs = {
  where: Answers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Answers_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Answers_Choice_AssociationArgs = {
  where: Answers_Choice_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BillsArgs = {
  where: Bills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bills_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Bright_AssessmentArgs = {
  where: Bright_Assessment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bright_Assessment_By_PkArgs = {
  bright_assessment_id: Scalars['Int'];
  tester_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Bright_AssessmentsArgs = {
  where: Bright_Assessments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bright_Assessments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Bright_BranchArgs = {
  where: Bright_Branch_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bright_Branch_By_PkArgs = {
  institution_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Bright_CandidateArgs = {
  where: Bright_Candidate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bright_Candidate_By_PkArgs = {
  candidate_id: Scalars['Int'];
  manager_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Bright_ManagerArgs = {
  where: Bright_Manager_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bright_Manager_By_PkArgs = {
  manager_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CategoriesArgs = {
  where: Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Categories_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ChoicesArgs = {
  where: Choices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Choices_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Credits_LogArgs = {
  where: Credits_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Credits_Log_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Discount_CodesArgs = {
  where: Discount_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discount_Codes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Estimated_ScoresArgs = {
  where: Estimated_Scores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Estimated_Scores_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ExamsArgs = {
  where: Exams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exams_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FeedbacksArgs = {
  where: Feedbacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedbacks_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_InstitutionsArgs = {
  where: Institutions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Institutions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LessonsArgs = {
  where: Lessons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lessons_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PlansArgs = {
  where: Plans_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plans_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Profile_Sphere_AssociationArgs = {
  where: Profile_Sphere_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProfilesArgs = {
  where: Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Profiles_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Question_Lesson_AssociationArgs = {
  where: Question_Lesson_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Lesson_Association_By_PkArgs = {
  lesson_id: Scalars['Int'];
  question_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionsArgs = {
  where: Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Registration_BillingsArgs = {
  where: Registration_Billings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Registration_Billings_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_RegistrationsArgs = {
  where: Registrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Registrations_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Result_Plan_AssociationArgs = {
  where: Result_Plan_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Result_Plan_Association_By_PkArgs = {
  plan_id: Scalars['Int'];
  result_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ResultsArgs = {
  where: Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Results_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ScoresArgs = {
  where: Scores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scores_By_PkArgs = {
  lesson_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SpheresArgs = {
  where: Spheres_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Spheres_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SupportsArgs = {
  where: Supports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Supports_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootInsert_Activation_CodesArgs = {
  objects: Array<Activation_Codes_Insert_Input>;
  on_conflict?: Maybe<Activation_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activation_Codes_OneArgs = {
  object: Activation_Codes_Insert_Input;
  on_conflict?: Maybe<Activation_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AnswersArgs = {
  objects: Array<Answers_Insert_Input>;
  on_conflict?: Maybe<Answers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Answers_Choice_AssociationArgs = {
  objects: Array<Answers_Choice_Association_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Answers_Choice_Association_OneArgs = {
  object: Answers_Choice_Association_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Answers_OneArgs = {
  object: Answers_Insert_Input;
  on_conflict?: Maybe<Answers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BillsArgs = {
  objects: Array<Bills_Insert_Input>;
  on_conflict?: Maybe<Bills_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bills_OneArgs = {
  object: Bills_Insert_Input;
  on_conflict?: Maybe<Bills_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bright_AssessmentArgs = {
  objects: Array<Bright_Assessment_Insert_Input>;
  on_conflict?: Maybe<Bright_Assessment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bright_Assessment_OneArgs = {
  object: Bright_Assessment_Insert_Input;
  on_conflict?: Maybe<Bright_Assessment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bright_AssessmentsArgs = {
  objects: Array<Bright_Assessments_Insert_Input>;
  on_conflict?: Maybe<Bright_Assessments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bright_Assessments_OneArgs = {
  object: Bright_Assessments_Insert_Input;
  on_conflict?: Maybe<Bright_Assessments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bright_BranchArgs = {
  objects: Array<Bright_Branch_Insert_Input>;
  on_conflict?: Maybe<Bright_Branch_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bright_Branch_OneArgs = {
  object: Bright_Branch_Insert_Input;
  on_conflict?: Maybe<Bright_Branch_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bright_CandidateArgs = {
  objects: Array<Bright_Candidate_Insert_Input>;
  on_conflict?: Maybe<Bright_Candidate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bright_Candidate_OneArgs = {
  object: Bright_Candidate_Insert_Input;
  on_conflict?: Maybe<Bright_Candidate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bright_ManagerArgs = {
  objects: Array<Bright_Manager_Insert_Input>;
  on_conflict?: Maybe<Bright_Manager_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bright_Manager_OneArgs = {
  object: Bright_Manager_Insert_Input;
  on_conflict?: Maybe<Bright_Manager_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CategoriesArgs = {
  objects: Array<Categories_Insert_Input>;
  on_conflict?: Maybe<Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Categories_OneArgs = {
  object: Categories_Insert_Input;
  on_conflict?: Maybe<Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ChoicesArgs = {
  objects: Array<Choices_Insert_Input>;
  on_conflict?: Maybe<Choices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Choices_OneArgs = {
  object: Choices_Insert_Input;
  on_conflict?: Maybe<Choices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credits_LogArgs = {
  objects: Array<Credits_Log_Insert_Input>;
  on_conflict?: Maybe<Credits_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credits_Log_OneArgs = {
  object: Credits_Log_Insert_Input;
  on_conflict?: Maybe<Credits_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_CodesArgs = {
  objects: Array<Discount_Codes_Insert_Input>;
  on_conflict?: Maybe<Discount_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_Codes_OneArgs = {
  object: Discount_Codes_Insert_Input;
  on_conflict?: Maybe<Discount_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estimated_ScoresArgs = {
  objects: Array<Estimated_Scores_Insert_Input>;
  on_conflict?: Maybe<Estimated_Scores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Estimated_Scores_OneArgs = {
  object: Estimated_Scores_Insert_Input;
  on_conflict?: Maybe<Estimated_Scores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExamsArgs = {
  objects: Array<Exams_Insert_Input>;
  on_conflict?: Maybe<Exams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exams_OneArgs = {
  object: Exams_Insert_Input;
  on_conflict?: Maybe<Exams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FeedbacksArgs = {
  objects: Array<Feedbacks_Insert_Input>;
  on_conflict?: Maybe<Feedbacks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedbacks_OneArgs = {
  object: Feedbacks_Insert_Input;
  on_conflict?: Maybe<Feedbacks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InstitutionsArgs = {
  objects: Array<Institutions_Insert_Input>;
  on_conflict?: Maybe<Institutions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Institutions_OneArgs = {
  object: Institutions_Insert_Input;
  on_conflict?: Maybe<Institutions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LessonsArgs = {
  objects: Array<Lessons_Insert_Input>;
  on_conflict?: Maybe<Lessons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lessons_OneArgs = {
  object: Lessons_Insert_Input;
  on_conflict?: Maybe<Lessons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlansArgs = {
  objects: Array<Plans_Insert_Input>;
  on_conflict?: Maybe<Plans_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plans_OneArgs = {
  object: Plans_Insert_Input;
  on_conflict?: Maybe<Plans_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_Sphere_AssociationArgs = {
  objects: Array<Profile_Sphere_Association_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_Sphere_Association_OneArgs = {
  object: Profile_Sphere_Association_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_ProfilesArgs = {
  objects: Array<Profiles_Insert_Input>;
  on_conflict?: Maybe<Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profiles_OneArgs = {
  object: Profiles_Insert_Input;
  on_conflict?: Maybe<Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Lesson_AssociationArgs = {
  objects: Array<Question_Lesson_Association_Insert_Input>;
  on_conflict?: Maybe<Question_Lesson_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Lesson_Association_OneArgs = {
  object: Question_Lesson_Association_Insert_Input;
  on_conflict?: Maybe<Question_Lesson_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionsArgs = {
  objects: Array<Questions_Insert_Input>;
  on_conflict?: Maybe<Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questions_OneArgs = {
  object: Questions_Insert_Input;
  on_conflict?: Maybe<Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Registration_BillingsArgs = {
  objects: Array<Registration_Billings_Insert_Input>;
  on_conflict?: Maybe<Registration_Billings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Registration_Billings_OneArgs = {
  object: Registration_Billings_Insert_Input;
  on_conflict?: Maybe<Registration_Billings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RegistrationsArgs = {
  objects: Array<Registrations_Insert_Input>;
  on_conflict?: Maybe<Registrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Registrations_OneArgs = {
  object: Registrations_Insert_Input;
  on_conflict?: Maybe<Registrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_Plan_AssociationArgs = {
  objects: Array<Result_Plan_Association_Insert_Input>;
  on_conflict?: Maybe<Result_Plan_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_Plan_Association_OneArgs = {
  object: Result_Plan_Association_Insert_Input;
  on_conflict?: Maybe<Result_Plan_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ResultsArgs = {
  objects: Array<Results_Insert_Input>;
  on_conflict?: Maybe<Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Results_OneArgs = {
  object: Results_Insert_Input;
  on_conflict?: Maybe<Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScoresArgs = {
  objects: Array<Scores_Insert_Input>;
  on_conflict?: Maybe<Scores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scores_OneArgs = {
  object: Scores_Insert_Input;
  on_conflict?: Maybe<Scores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpheresArgs = {
  objects: Array<Spheres_Insert_Input>;
  on_conflict?: Maybe<Spheres_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spheres_OneArgs = {
  object: Spheres_Insert_Input;
  on_conflict?: Maybe<Spheres_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SupportsArgs = {
  objects: Array<Supports_Insert_Input>;
  on_conflict?: Maybe<Supports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supports_OneArgs = {
  object: Supports_Insert_Input;
  on_conflict?: Maybe<Supports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_Activation_CodesArgs = {
  _inc?: Maybe<Activation_Codes_Inc_Input>;
  _set?: Maybe<Activation_Codes_Set_Input>;
  where: Activation_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activation_Codes_By_PkArgs = {
  _inc?: Maybe<Activation_Codes_Inc_Input>;
  _set?: Maybe<Activation_Codes_Set_Input>;
  pk_columns: Activation_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AnswersArgs = {
  _inc?: Maybe<Answers_Inc_Input>;
  _set?: Maybe<Answers_Set_Input>;
  where: Answers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Answers_By_PkArgs = {
  _inc?: Maybe<Answers_Inc_Input>;
  _set?: Maybe<Answers_Set_Input>;
  pk_columns: Answers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Answers_Choice_AssociationArgs = {
  _inc?: Maybe<Answers_Choice_Association_Inc_Input>;
  _set?: Maybe<Answers_Choice_Association_Set_Input>;
  where: Answers_Choice_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BillsArgs = {
  _inc?: Maybe<Bills_Inc_Input>;
  _set?: Maybe<Bills_Set_Input>;
  where: Bills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bills_By_PkArgs = {
  _inc?: Maybe<Bills_Inc_Input>;
  _set?: Maybe<Bills_Set_Input>;
  pk_columns: Bills_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bright_AssessmentArgs = {
  _inc?: Maybe<Bright_Assessment_Inc_Input>;
  _set?: Maybe<Bright_Assessment_Set_Input>;
  where: Bright_Assessment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bright_Assessment_By_PkArgs = {
  _inc?: Maybe<Bright_Assessment_Inc_Input>;
  _set?: Maybe<Bright_Assessment_Set_Input>;
  pk_columns: Bright_Assessment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bright_AssessmentsArgs = {
  _inc?: Maybe<Bright_Assessments_Inc_Input>;
  _set?: Maybe<Bright_Assessments_Set_Input>;
  where: Bright_Assessments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bright_Assessments_By_PkArgs = {
  _inc?: Maybe<Bright_Assessments_Inc_Input>;
  _set?: Maybe<Bright_Assessments_Set_Input>;
  pk_columns: Bright_Assessments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bright_BranchArgs = {
  _inc?: Maybe<Bright_Branch_Inc_Input>;
  _set?: Maybe<Bright_Branch_Set_Input>;
  where: Bright_Branch_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bright_Branch_By_PkArgs = {
  _inc?: Maybe<Bright_Branch_Inc_Input>;
  _set?: Maybe<Bright_Branch_Set_Input>;
  pk_columns: Bright_Branch_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bright_CandidateArgs = {
  _inc?: Maybe<Bright_Candidate_Inc_Input>;
  _set?: Maybe<Bright_Candidate_Set_Input>;
  where: Bright_Candidate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bright_Candidate_By_PkArgs = {
  _inc?: Maybe<Bright_Candidate_Inc_Input>;
  _set?: Maybe<Bright_Candidate_Set_Input>;
  pk_columns: Bright_Candidate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bright_ManagerArgs = {
  _inc?: Maybe<Bright_Manager_Inc_Input>;
  _set?: Maybe<Bright_Manager_Set_Input>;
  where: Bright_Manager_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bright_Manager_By_PkArgs = {
  _inc?: Maybe<Bright_Manager_Inc_Input>;
  _set?: Maybe<Bright_Manager_Set_Input>;
  pk_columns: Bright_Manager_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CategoriesArgs = {
  _inc?: Maybe<Categories_Inc_Input>;
  _set?: Maybe<Categories_Set_Input>;
  where: Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Categories_By_PkArgs = {
  _inc?: Maybe<Categories_Inc_Input>;
  _set?: Maybe<Categories_Set_Input>;
  pk_columns: Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ChoicesArgs = {
  _inc?: Maybe<Choices_Inc_Input>;
  _set?: Maybe<Choices_Set_Input>;
  where: Choices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Choices_By_PkArgs = {
  _inc?: Maybe<Choices_Inc_Input>;
  _set?: Maybe<Choices_Set_Input>;
  pk_columns: Choices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Credits_LogArgs = {
  _inc?: Maybe<Credits_Log_Inc_Input>;
  _set?: Maybe<Credits_Log_Set_Input>;
  where: Credits_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Credits_Log_By_PkArgs = {
  _inc?: Maybe<Credits_Log_Inc_Input>;
  _set?: Maybe<Credits_Log_Set_Input>;
  pk_columns: Credits_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_CodesArgs = {
  _inc?: Maybe<Discount_Codes_Inc_Input>;
  _set?: Maybe<Discount_Codes_Set_Input>;
  where: Discount_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Codes_By_PkArgs = {
  _inc?: Maybe<Discount_Codes_Inc_Input>;
  _set?: Maybe<Discount_Codes_Set_Input>;
  pk_columns: Discount_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Estimated_ScoresArgs = {
  _inc?: Maybe<Estimated_Scores_Inc_Input>;
  _set?: Maybe<Estimated_Scores_Set_Input>;
  where: Estimated_Scores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Estimated_Scores_By_PkArgs = {
  _inc?: Maybe<Estimated_Scores_Inc_Input>;
  _set?: Maybe<Estimated_Scores_Set_Input>;
  pk_columns: Estimated_Scores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ExamsArgs = {
  _inc?: Maybe<Exams_Inc_Input>;
  _set?: Maybe<Exams_Set_Input>;
  where: Exams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exams_By_PkArgs = {
  _inc?: Maybe<Exams_Inc_Input>;
  _set?: Maybe<Exams_Set_Input>;
  pk_columns: Exams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FeedbacksArgs = {
  _append?: Maybe<Feedbacks_Append_Input>;
  _delete_at_path?: Maybe<Feedbacks_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Feedbacks_Delete_Elem_Input>;
  _delete_key?: Maybe<Feedbacks_Delete_Key_Input>;
  _inc?: Maybe<Feedbacks_Inc_Input>;
  _prepend?: Maybe<Feedbacks_Prepend_Input>;
  _set?: Maybe<Feedbacks_Set_Input>;
  where: Feedbacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedbacks_By_PkArgs = {
  _append?: Maybe<Feedbacks_Append_Input>;
  _delete_at_path?: Maybe<Feedbacks_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Feedbacks_Delete_Elem_Input>;
  _delete_key?: Maybe<Feedbacks_Delete_Key_Input>;
  _inc?: Maybe<Feedbacks_Inc_Input>;
  _prepend?: Maybe<Feedbacks_Prepend_Input>;
  _set?: Maybe<Feedbacks_Set_Input>;
  pk_columns: Feedbacks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_InstitutionsArgs = {
  _append?: Maybe<Institutions_Append_Input>;
  _delete_at_path?: Maybe<Institutions_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Institutions_Delete_Elem_Input>;
  _delete_key?: Maybe<Institutions_Delete_Key_Input>;
  _inc?: Maybe<Institutions_Inc_Input>;
  _prepend?: Maybe<Institutions_Prepend_Input>;
  _set?: Maybe<Institutions_Set_Input>;
  where: Institutions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Institutions_By_PkArgs = {
  _append?: Maybe<Institutions_Append_Input>;
  _delete_at_path?: Maybe<Institutions_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Institutions_Delete_Elem_Input>;
  _delete_key?: Maybe<Institutions_Delete_Key_Input>;
  _inc?: Maybe<Institutions_Inc_Input>;
  _prepend?: Maybe<Institutions_Prepend_Input>;
  _set?: Maybe<Institutions_Set_Input>;
  pk_columns: Institutions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LessonsArgs = {
  _inc?: Maybe<Lessons_Inc_Input>;
  _set?: Maybe<Lessons_Set_Input>;
  where: Lessons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lessons_By_PkArgs = {
  _inc?: Maybe<Lessons_Inc_Input>;
  _set?: Maybe<Lessons_Set_Input>;
  pk_columns: Lessons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PlansArgs = {
  _inc?: Maybe<Plans_Inc_Input>;
  _set?: Maybe<Plans_Set_Input>;
  where: Plans_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plans_By_PkArgs = {
  _inc?: Maybe<Plans_Inc_Input>;
  _set?: Maybe<Plans_Set_Input>;
  pk_columns: Plans_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_Sphere_AssociationArgs = {
  _inc?: Maybe<Profile_Sphere_Association_Inc_Input>;
  _set?: Maybe<Profile_Sphere_Association_Set_Input>;
  where: Profile_Sphere_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProfilesArgs = {
  _inc?: Maybe<Profiles_Inc_Input>;
  _set?: Maybe<Profiles_Set_Input>;
  where: Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Profiles_By_PkArgs = {
  _inc?: Maybe<Profiles_Inc_Input>;
  _set?: Maybe<Profiles_Set_Input>;
  pk_columns: Profiles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Lesson_AssociationArgs = {
  _inc?: Maybe<Question_Lesson_Association_Inc_Input>;
  _set?: Maybe<Question_Lesson_Association_Set_Input>;
  where: Question_Lesson_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Lesson_Association_By_PkArgs = {
  _inc?: Maybe<Question_Lesson_Association_Inc_Input>;
  _set?: Maybe<Question_Lesson_Association_Set_Input>;
  pk_columns: Question_Lesson_Association_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionsArgs = {
  _inc?: Maybe<Questions_Inc_Input>;
  _set?: Maybe<Questions_Set_Input>;
  where: Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questions_By_PkArgs = {
  _inc?: Maybe<Questions_Inc_Input>;
  _set?: Maybe<Questions_Set_Input>;
  pk_columns: Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Registration_BillingsArgs = {
  _inc?: Maybe<Registration_Billings_Inc_Input>;
  _set?: Maybe<Registration_Billings_Set_Input>;
  where: Registration_Billings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Registration_Billings_By_PkArgs = {
  _inc?: Maybe<Registration_Billings_Inc_Input>;
  _set?: Maybe<Registration_Billings_Set_Input>;
  pk_columns: Registration_Billings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RegistrationsArgs = {
  _inc?: Maybe<Registrations_Inc_Input>;
  _set?: Maybe<Registrations_Set_Input>;
  where: Registrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Registrations_By_PkArgs = {
  _inc?: Maybe<Registrations_Inc_Input>;
  _set?: Maybe<Registrations_Set_Input>;
  pk_columns: Registrations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Plan_AssociationArgs = {
  _inc?: Maybe<Result_Plan_Association_Inc_Input>;
  _set?: Maybe<Result_Plan_Association_Set_Input>;
  where: Result_Plan_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Plan_Association_By_PkArgs = {
  _inc?: Maybe<Result_Plan_Association_Inc_Input>;
  _set?: Maybe<Result_Plan_Association_Set_Input>;
  pk_columns: Result_Plan_Association_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ResultsArgs = {
  _inc?: Maybe<Results_Inc_Input>;
  _set?: Maybe<Results_Set_Input>;
  where: Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Results_By_PkArgs = {
  _inc?: Maybe<Results_Inc_Input>;
  _set?: Maybe<Results_Set_Input>;
  pk_columns: Results_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ScoresArgs = {
  _inc?: Maybe<Scores_Inc_Input>;
  _set?: Maybe<Scores_Set_Input>;
  where: Scores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scores_By_PkArgs = {
  _inc?: Maybe<Scores_Inc_Input>;
  _set?: Maybe<Scores_Set_Input>;
  pk_columns: Scores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SpheresArgs = {
  _inc?: Maybe<Spheres_Inc_Input>;
  _set?: Maybe<Spheres_Set_Input>;
  where: Spheres_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Spheres_By_PkArgs = {
  _inc?: Maybe<Spheres_Inc_Input>;
  _set?: Maybe<Spheres_Set_Input>;
  pk_columns: Spheres_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SupportsArgs = {
  _inc?: Maybe<Supports_Inc_Input>;
  _set?: Maybe<Supports_Set_Input>;
  where: Supports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Supports_By_PkArgs = {
  _inc?: Maybe<Supports_Inc_Input>;
  _set?: Maybe<Supports_Set_Input>;
  pk_columns: Supports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: Maybe<Users_Inc_Input>;
  _set?: Maybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: Maybe<Users_Inc_Input>;
  _set?: Maybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** expression to compare columns of type numeric. All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in the ascending order, nulls last */
  Asc = 'asc',
  /** in the ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in the ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in the descending order, nulls first */
  Desc = 'desc',
  /** in the descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in the descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "plans" */
export type Plans = {
  __typename?: 'plans';
  begin_date: Scalars['timestamp'];
  end_date: Scalars['timestamp'];
  id: Scalars['Int'];
  /** An object relationship */
  sphere: Spheres;
  sphere_id: Scalars['Int'];
  task_id: Scalars['String'];
  /** An object relationship */
  teacher: Profiles;
  teacher_id: Scalars['Int'];
};

/** aggregated selection of "plans" */
export type Plans_Aggregate = {
  __typename?: 'plans_aggregate';
  aggregate?: Maybe<Plans_Aggregate_Fields>;
  nodes: Array<Plans>;
};

/** aggregate fields of "plans" */
export type Plans_Aggregate_Fields = {
  __typename?: 'plans_aggregate_fields';
  avg?: Maybe<Plans_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Plans_Max_Fields>;
  min?: Maybe<Plans_Min_Fields>;
  stddev?: Maybe<Plans_Stddev_Fields>;
  stddev_pop?: Maybe<Plans_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plans_Stddev_Samp_Fields>;
  sum?: Maybe<Plans_Sum_Fields>;
  var_pop?: Maybe<Plans_Var_Pop_Fields>;
  var_samp?: Maybe<Plans_Var_Samp_Fields>;
  variance?: Maybe<Plans_Variance_Fields>;
};


/** aggregate fields of "plans" */
export type Plans_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Plans_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plans" */
export type Plans_Aggregate_Order_By = {
  avg?: Maybe<Plans_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Plans_Max_Order_By>;
  min?: Maybe<Plans_Min_Order_By>;
  stddev?: Maybe<Plans_Stddev_Order_By>;
  stddev_pop?: Maybe<Plans_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Plans_Stddev_Samp_Order_By>;
  sum?: Maybe<Plans_Sum_Order_By>;
  var_pop?: Maybe<Plans_Var_Pop_Order_By>;
  var_samp?: Maybe<Plans_Var_Samp_Order_By>;
  variance?: Maybe<Plans_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plans" */
export type Plans_Arr_Rel_Insert_Input = {
  data: Array<Plans_Insert_Input>;
  on_conflict?: Maybe<Plans_On_Conflict>;
};

/** aggregate avg on columns */
export type Plans_Avg_Fields = {
  __typename?: 'plans_avg_fields';
  id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plans" */
export type Plans_Avg_Order_By = {
  id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plans". All fields are combined with a logical 'AND'. */
export type Plans_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Plans_Bool_Exp>>>;
  _not?: Maybe<Plans_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Plans_Bool_Exp>>>;
  begin_date?: Maybe<Timestamp_Comparison_Exp>;
  end_date?: Maybe<Timestamp_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  sphere?: Maybe<Spheres_Bool_Exp>;
  sphere_id?: Maybe<Int_Comparison_Exp>;
  task_id?: Maybe<String_Comparison_Exp>;
  teacher?: Maybe<Profiles_Bool_Exp>;
  teacher_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plans" */
export enum Plans_Constraint {
  /** unique or primary key constraint */
  PlansPkey = 'plans_pkey'
}

/** input type for incrementing integer column in table "plans" */
export type Plans_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  sphere_id?: Maybe<Scalars['Int']>;
  teacher_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "plans" */
export type Plans_Insert_Input = {
  begin_date?: Maybe<Scalars['timestamp']>;
  end_date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  sphere?: Maybe<Spheres_Obj_Rel_Insert_Input>;
  sphere_id?: Maybe<Scalars['Int']>;
  task_id?: Maybe<Scalars['String']>;
  teacher?: Maybe<Profiles_Obj_Rel_Insert_Input>;
  teacher_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plans_Max_Fields = {
  __typename?: 'plans_max_fields';
  begin_date?: Maybe<Scalars['timestamp']>;
  end_date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  sphere_id?: Maybe<Scalars['Int']>;
  task_id?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plans" */
export type Plans_Max_Order_By = {
  begin_date?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
  task_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Plans_Min_Fields = {
  __typename?: 'plans_min_fields';
  begin_date?: Maybe<Scalars['timestamp']>;
  end_date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  sphere_id?: Maybe<Scalars['Int']>;
  task_id?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plans" */
export type Plans_Min_Order_By = {
  begin_date?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
  task_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "plans" */
export type Plans_Mutation_Response = {
  __typename?: 'plans_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Plans>;
};

/** input type for inserting object relation for remote table "plans" */
export type Plans_Obj_Rel_Insert_Input = {
  data: Plans_Insert_Input;
  on_conflict?: Maybe<Plans_On_Conflict>;
};

/** on conflict condition type for table "plans" */
export type Plans_On_Conflict = {
  constraint: Plans_Constraint;
  update_columns: Array<Plans_Update_Column>;
  where?: Maybe<Plans_Bool_Exp>;
};

/** ordering options when selecting data from "plans" */
export type Plans_Order_By = {
  begin_date?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  sphere?: Maybe<Spheres_Order_By>;
  sphere_id?: Maybe<Order_By>;
  task_id?: Maybe<Order_By>;
  teacher?: Maybe<Profiles_Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "plans" */
export type Plans_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plans" */
export enum Plans_Select_Column {
  /** column name */
  BeginDate = 'begin_date',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  SphereId = 'sphere_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  TeacherId = 'teacher_id'
}

/** input type for updating data in table "plans" */
export type Plans_Set_Input = {
  begin_date?: Maybe<Scalars['timestamp']>;
  end_date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  sphere_id?: Maybe<Scalars['Int']>;
  task_id?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plans_Stddev_Fields = {
  __typename?: 'plans_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plans" */
export type Plans_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plans_Stddev_Pop_Fields = {
  __typename?: 'plans_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plans" */
export type Plans_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plans_Stddev_Samp_Fields = {
  __typename?: 'plans_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plans" */
export type Plans_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Plans_Sum_Fields = {
  __typename?: 'plans_sum_fields';
  id?: Maybe<Scalars['Int']>;
  sphere_id?: Maybe<Scalars['Int']>;
  teacher_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plans" */
export type Plans_Sum_Order_By = {
  id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** update columns of table "plans" */
export enum Plans_Update_Column {
  /** column name */
  BeginDate = 'begin_date',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  SphereId = 'sphere_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  TeacherId = 'teacher_id'
}

/** aggregate var_pop on columns */
export type Plans_Var_Pop_Fields = {
  __typename?: 'plans_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plans" */
export type Plans_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plans_Var_Samp_Fields = {
  __typename?: 'plans_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plans" */
export type Plans_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Plans_Variance_Fields = {
  __typename?: 'plans_variance_fields';
  id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plans" */
export type Plans_Variance_Order_By = {
  id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** columns and relationships of "profile_sphere_association" */
export type Profile_Sphere_Association = {
  __typename?: 'profile_sphere_association';
  /** An object relationship */
  profile?: Maybe<Profiles>;
  profile_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  sphere?: Maybe<Spheres>;
  sphere_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "profile_sphere_association" */
export type Profile_Sphere_Association_Aggregate = {
  __typename?: 'profile_sphere_association_aggregate';
  aggregate?: Maybe<Profile_Sphere_Association_Aggregate_Fields>;
  nodes: Array<Profile_Sphere_Association>;
};

/** aggregate fields of "profile_sphere_association" */
export type Profile_Sphere_Association_Aggregate_Fields = {
  __typename?: 'profile_sphere_association_aggregate_fields';
  avg?: Maybe<Profile_Sphere_Association_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Profile_Sphere_Association_Max_Fields>;
  min?: Maybe<Profile_Sphere_Association_Min_Fields>;
  stddev?: Maybe<Profile_Sphere_Association_Stddev_Fields>;
  stddev_pop?: Maybe<Profile_Sphere_Association_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Profile_Sphere_Association_Stddev_Samp_Fields>;
  sum?: Maybe<Profile_Sphere_Association_Sum_Fields>;
  var_pop?: Maybe<Profile_Sphere_Association_Var_Pop_Fields>;
  var_samp?: Maybe<Profile_Sphere_Association_Var_Samp_Fields>;
  variance?: Maybe<Profile_Sphere_Association_Variance_Fields>;
};


/** aggregate fields of "profile_sphere_association" */
export type Profile_Sphere_Association_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Profile_Sphere_Association_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "profile_sphere_association" */
export type Profile_Sphere_Association_Aggregate_Order_By = {
  avg?: Maybe<Profile_Sphere_Association_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Profile_Sphere_Association_Max_Order_By>;
  min?: Maybe<Profile_Sphere_Association_Min_Order_By>;
  stddev?: Maybe<Profile_Sphere_Association_Stddev_Order_By>;
  stddev_pop?: Maybe<Profile_Sphere_Association_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Profile_Sphere_Association_Stddev_Samp_Order_By>;
  sum?: Maybe<Profile_Sphere_Association_Sum_Order_By>;
  var_pop?: Maybe<Profile_Sphere_Association_Var_Pop_Order_By>;
  var_samp?: Maybe<Profile_Sphere_Association_Var_Samp_Order_By>;
  variance?: Maybe<Profile_Sphere_Association_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "profile_sphere_association" */
export type Profile_Sphere_Association_Arr_Rel_Insert_Input = {
  data: Array<Profile_Sphere_Association_Insert_Input>;
};

/** aggregate avg on columns */
export type Profile_Sphere_Association_Avg_Fields = {
  __typename?: 'profile_sphere_association_avg_fields';
  profile_id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "profile_sphere_association" */
export type Profile_Sphere_Association_Avg_Order_By = {
  profile_id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "profile_sphere_association". All fields are combined with a logical 'AND'. */
export type Profile_Sphere_Association_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Profile_Sphere_Association_Bool_Exp>>>;
  _not?: Maybe<Profile_Sphere_Association_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Profile_Sphere_Association_Bool_Exp>>>;
  profile?: Maybe<Profiles_Bool_Exp>;
  profile_id?: Maybe<Int_Comparison_Exp>;
  sphere?: Maybe<Spheres_Bool_Exp>;
  sphere_id?: Maybe<Int_Comparison_Exp>;
};

/** input type for incrementing integer column in table "profile_sphere_association" */
export type Profile_Sphere_Association_Inc_Input = {
  profile_id?: Maybe<Scalars['Int']>;
  sphere_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "profile_sphere_association" */
export type Profile_Sphere_Association_Insert_Input = {
  profile?: Maybe<Profiles_Obj_Rel_Insert_Input>;
  profile_id?: Maybe<Scalars['Int']>;
  sphere?: Maybe<Spheres_Obj_Rel_Insert_Input>;
  sphere_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Profile_Sphere_Association_Max_Fields = {
  __typename?: 'profile_sphere_association_max_fields';
  profile_id?: Maybe<Scalars['Int']>;
  sphere_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "profile_sphere_association" */
export type Profile_Sphere_Association_Max_Order_By = {
  profile_id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Profile_Sphere_Association_Min_Fields = {
  __typename?: 'profile_sphere_association_min_fields';
  profile_id?: Maybe<Scalars['Int']>;
  sphere_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "profile_sphere_association" */
export type Profile_Sphere_Association_Min_Order_By = {
  profile_id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "profile_sphere_association" */
export type Profile_Sphere_Association_Mutation_Response = {
  __typename?: 'profile_sphere_association_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Profile_Sphere_Association>;
};

/** input type for inserting object relation for remote table "profile_sphere_association" */
export type Profile_Sphere_Association_Obj_Rel_Insert_Input = {
  data: Profile_Sphere_Association_Insert_Input;
};

/** ordering options when selecting data from "profile_sphere_association" */
export type Profile_Sphere_Association_Order_By = {
  profile?: Maybe<Profiles_Order_By>;
  profile_id?: Maybe<Order_By>;
  sphere?: Maybe<Spheres_Order_By>;
  sphere_id?: Maybe<Order_By>;
};

/** select columns of table "profile_sphere_association" */
export enum Profile_Sphere_Association_Select_Column {
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SphereId = 'sphere_id'
}

/** input type for updating data in table "profile_sphere_association" */
export type Profile_Sphere_Association_Set_Input = {
  profile_id?: Maybe<Scalars['Int']>;
  sphere_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Profile_Sphere_Association_Stddev_Fields = {
  __typename?: 'profile_sphere_association_stddev_fields';
  profile_id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "profile_sphere_association" */
export type Profile_Sphere_Association_Stddev_Order_By = {
  profile_id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Profile_Sphere_Association_Stddev_Pop_Fields = {
  __typename?: 'profile_sphere_association_stddev_pop_fields';
  profile_id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "profile_sphere_association" */
export type Profile_Sphere_Association_Stddev_Pop_Order_By = {
  profile_id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Profile_Sphere_Association_Stddev_Samp_Fields = {
  __typename?: 'profile_sphere_association_stddev_samp_fields';
  profile_id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "profile_sphere_association" */
export type Profile_Sphere_Association_Stddev_Samp_Order_By = {
  profile_id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Profile_Sphere_Association_Sum_Fields = {
  __typename?: 'profile_sphere_association_sum_fields';
  profile_id?: Maybe<Scalars['Int']>;
  sphere_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "profile_sphere_association" */
export type Profile_Sphere_Association_Sum_Order_By = {
  profile_id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Profile_Sphere_Association_Var_Pop_Fields = {
  __typename?: 'profile_sphere_association_var_pop_fields';
  profile_id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "profile_sphere_association" */
export type Profile_Sphere_Association_Var_Pop_Order_By = {
  profile_id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Profile_Sphere_Association_Var_Samp_Fields = {
  __typename?: 'profile_sphere_association_var_samp_fields';
  profile_id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "profile_sphere_association" */
export type Profile_Sphere_Association_Var_Samp_Order_By = {
  profile_id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Profile_Sphere_Association_Variance_Fields = {
  __typename?: 'profile_sphere_association_variance_fields';
  profile_id?: Maybe<Scalars['Float']>;
  sphere_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "profile_sphere_association" */
export type Profile_Sphere_Association_Variance_Order_By = {
  profile_id?: Maybe<Order_By>;
  sphere_id?: Maybe<Order_By>;
};

/** columns and relationships of "profiles" */
export type Profiles = {
  __typename?: 'profiles';
  /** An array relationship */
  activation_codes: Array<Activation_Codes>;
  /** An aggregated array relationship */
  activation_codes_aggregate: Activation_Codes_Aggregate;
  /** An array relationship */
  answers: Array<Answers>;
  /** An aggregated array relationship */
  answers_aggregate: Answers_Aggregate;
  /** An array relationship */
  bills: Array<Bills>;
  /** An aggregated array relationship */
  bills_aggregate: Bills_Aggregate;
  /** An array relationship */
  bright_candidates: Array<Bright_Candidate>;
  /** An aggregated array relationship */
  bright_candidates_aggregate: Bright_Candidate_Aggregate;
  /** An object relationship */
  bright_manager?: Maybe<Bright_Manager>;
  current_exam_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  estimated_scores: Array<Estimated_Scores>;
  /** An aggregated array relationship */
  estimated_scores_aggregate: Estimated_Scores_Aggregate;
  exam_type: Scalars['exam_types'];
  expiration_date: Scalars['timestamp'];
  /** An array relationship */
  feedbacks: Array<Answers>;
  /** An aggregated array relationship */
  feedbacks_aggregate: Answers_Aggregate;
  id: Scalars['Int'];
  /** An object relationship */
  institution?: Maybe<Institutions>;
  institution_id?: Maybe<Scalars['Int']>;
  is_admin: Scalars['Boolean'];
  is_guest: Scalars['Boolean'];
  is_manager: Scalars['Boolean'];
  is_teacher: Scalars['Boolean'];
  last_time_spent_update: Scalars['timestamp'];
  level?: Maybe<Scalars['String']>;
  objective?: Maybe<Scalars['Int']>;
  /** An array relationship */
  profile_sphere_associations: Array<Profile_Sphere_Association>;
  /** An aggregated array relationship */
  profile_sphere_associations_aggregate: Profile_Sphere_Association_Aggregate;
  time_spent: Scalars['Int'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
};


/** columns and relationships of "profiles" */
export type ProfilesActivation_CodesArgs = {
  distinct_on?: Maybe<Array<Activation_Codes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Activation_Codes_Order_By>>;
  where?: Maybe<Activation_Codes_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesActivation_Codes_AggregateArgs = {
  distinct_on?: Maybe<Array<Activation_Codes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Activation_Codes_Order_By>>;
  where?: Maybe<Activation_Codes_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesAnswersArgs = {
  distinct_on?: Maybe<Array<Answers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Order_By>>;
  where?: Maybe<Answers_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesAnswers_AggregateArgs = {
  distinct_on?: Maybe<Array<Answers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Order_By>>;
  where?: Maybe<Answers_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesBillsArgs = {
  distinct_on?: Maybe<Array<Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bills_Order_By>>;
  where?: Maybe<Bills_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesBills_AggregateArgs = {
  distinct_on?: Maybe<Array<Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bills_Order_By>>;
  where?: Maybe<Bills_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesBright_CandidatesArgs = {
  distinct_on?: Maybe<Array<Bright_Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Candidate_Order_By>>;
  where?: Maybe<Bright_Candidate_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesBright_Candidates_AggregateArgs = {
  distinct_on?: Maybe<Array<Bright_Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Candidate_Order_By>>;
  where?: Maybe<Bright_Candidate_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesEstimated_ScoresArgs = {
  distinct_on?: Maybe<Array<Estimated_Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Estimated_Scores_Order_By>>;
  where?: Maybe<Estimated_Scores_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesEstimated_Scores_AggregateArgs = {
  distinct_on?: Maybe<Array<Estimated_Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Estimated_Scores_Order_By>>;
  where?: Maybe<Estimated_Scores_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesFeedbacksArgs = {
  distinct_on?: Maybe<Array<Answers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Order_By>>;
  where?: Maybe<Answers_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesFeedbacks_AggregateArgs = {
  distinct_on?: Maybe<Array<Answers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Order_By>>;
  where?: Maybe<Answers_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesProfile_Sphere_AssociationsArgs = {
  distinct_on?: Maybe<Array<Profile_Sphere_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_Sphere_Association_Order_By>>;
  where?: Maybe<Profile_Sphere_Association_Bool_Exp>;
};


/** columns and relationships of "profiles" */
export type ProfilesProfile_Sphere_Associations_AggregateArgs = {
  distinct_on?: Maybe<Array<Profile_Sphere_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_Sphere_Association_Order_By>>;
  where?: Maybe<Profile_Sphere_Association_Bool_Exp>;
};

/** aggregated selection of "profiles" */
export type Profiles_Aggregate = {
  __typename?: 'profiles_aggregate';
  aggregate?: Maybe<Profiles_Aggregate_Fields>;
  nodes: Array<Profiles>;
};

/** aggregate fields of "profiles" */
export type Profiles_Aggregate_Fields = {
  __typename?: 'profiles_aggregate_fields';
  avg?: Maybe<Profiles_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Profiles_Max_Fields>;
  min?: Maybe<Profiles_Min_Fields>;
  stddev?: Maybe<Profiles_Stddev_Fields>;
  stddev_pop?: Maybe<Profiles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Profiles_Stddev_Samp_Fields>;
  sum?: Maybe<Profiles_Sum_Fields>;
  var_pop?: Maybe<Profiles_Var_Pop_Fields>;
  var_samp?: Maybe<Profiles_Var_Samp_Fields>;
  variance?: Maybe<Profiles_Variance_Fields>;
};


/** aggregate fields of "profiles" */
export type Profiles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Profiles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "profiles" */
export type Profiles_Aggregate_Order_By = {
  avg?: Maybe<Profiles_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Profiles_Max_Order_By>;
  min?: Maybe<Profiles_Min_Order_By>;
  stddev?: Maybe<Profiles_Stddev_Order_By>;
  stddev_pop?: Maybe<Profiles_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Profiles_Stddev_Samp_Order_By>;
  sum?: Maybe<Profiles_Sum_Order_By>;
  var_pop?: Maybe<Profiles_Var_Pop_Order_By>;
  var_samp?: Maybe<Profiles_Var_Samp_Order_By>;
  variance?: Maybe<Profiles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "profiles" */
export type Profiles_Arr_Rel_Insert_Input = {
  data: Array<Profiles_Insert_Input>;
  on_conflict?: Maybe<Profiles_On_Conflict>;
};

/** aggregate avg on columns */
export type Profiles_Avg_Fields = {
  __typename?: 'profiles_avg_fields';
  current_exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  objective?: Maybe<Scalars['Float']>;
  time_spent?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "profiles" */
export type Profiles_Avg_Order_By = {
  current_exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  objective?: Maybe<Order_By>;
  time_spent?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "profiles". All fields are combined with a logical 'AND'. */
export type Profiles_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Profiles_Bool_Exp>>>;
  _not?: Maybe<Profiles_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Profiles_Bool_Exp>>>;
  activation_codes?: Maybe<Activation_Codes_Bool_Exp>;
  answers?: Maybe<Answers_Bool_Exp>;
  bills?: Maybe<Bills_Bool_Exp>;
  bright_candidates?: Maybe<Bright_Candidate_Bool_Exp>;
  bright_manager?: Maybe<Bright_Manager_Bool_Exp>;
  current_exam_id?: Maybe<Int_Comparison_Exp>;
  estimated_scores?: Maybe<Estimated_Scores_Bool_Exp>;
  exam_type?: Maybe<Exam_Types_Comparison_Exp>;
  expiration_date?: Maybe<Timestamp_Comparison_Exp>;
  feedbacks?: Maybe<Answers_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  institution?: Maybe<Institutions_Bool_Exp>;
  institution_id?: Maybe<Int_Comparison_Exp>;
  is_admin?: Maybe<Boolean_Comparison_Exp>;
  is_guest?: Maybe<Boolean_Comparison_Exp>;
  is_manager?: Maybe<Boolean_Comparison_Exp>;
  is_teacher?: Maybe<Boolean_Comparison_Exp>;
  last_time_spent_update?: Maybe<Timestamp_Comparison_Exp>;
  level?: Maybe<String_Comparison_Exp>;
  objective?: Maybe<Int_Comparison_Exp>;
  profile_sphere_associations?: Maybe<Profile_Sphere_Association_Bool_Exp>;
  time_spent?: Maybe<Int_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "profiles" */
export enum Profiles_Constraint {
  /** unique or primary key constraint */
  ProfilesPkey = 'profiles_pkey'
}

/** input type for incrementing integer column in table "profiles" */
export type Profiles_Inc_Input = {
  current_exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  objective?: Maybe<Scalars['Int']>;
  time_spent?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "profiles" */
export type Profiles_Insert_Input = {
  activation_codes?: Maybe<Activation_Codes_Arr_Rel_Insert_Input>;
  answers?: Maybe<Answers_Arr_Rel_Insert_Input>;
  bills?: Maybe<Bills_Arr_Rel_Insert_Input>;
  bright_candidates?: Maybe<Bright_Candidate_Arr_Rel_Insert_Input>;
  bright_manager?: Maybe<Bright_Manager_Obj_Rel_Insert_Input>;
  current_exam_id?: Maybe<Scalars['Int']>;
  estimated_scores?: Maybe<Estimated_Scores_Arr_Rel_Insert_Input>;
  exam_type?: Maybe<Scalars['exam_types']>;
  expiration_date?: Maybe<Scalars['timestamp']>;
  feedbacks?: Maybe<Answers_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  institution?: Maybe<Institutions_Obj_Rel_Insert_Input>;
  institution_id?: Maybe<Scalars['Int']>;
  is_admin?: Maybe<Scalars['Boolean']>;
  is_guest?: Maybe<Scalars['Boolean']>;
  is_manager?: Maybe<Scalars['Boolean']>;
  is_teacher?: Maybe<Scalars['Boolean']>;
  last_time_spent_update?: Maybe<Scalars['timestamp']>;
  level?: Maybe<Scalars['String']>;
  objective?: Maybe<Scalars['Int']>;
  profile_sphere_associations?: Maybe<Profile_Sphere_Association_Arr_Rel_Insert_Input>;
  time_spent?: Maybe<Scalars['Int']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Profiles_Max_Fields = {
  __typename?: 'profiles_max_fields';
  current_exam_id?: Maybe<Scalars['Int']>;
  expiration_date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  last_time_spent_update?: Maybe<Scalars['timestamp']>;
  level?: Maybe<Scalars['String']>;
  objective?: Maybe<Scalars['Int']>;
  time_spent?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "profiles" */
export type Profiles_Max_Order_By = {
  current_exam_id?: Maybe<Order_By>;
  expiration_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  last_time_spent_update?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
  objective?: Maybe<Order_By>;
  time_spent?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Profiles_Min_Fields = {
  __typename?: 'profiles_min_fields';
  current_exam_id?: Maybe<Scalars['Int']>;
  expiration_date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  last_time_spent_update?: Maybe<Scalars['timestamp']>;
  level?: Maybe<Scalars['String']>;
  objective?: Maybe<Scalars['Int']>;
  time_spent?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "profiles" */
export type Profiles_Min_Order_By = {
  current_exam_id?: Maybe<Order_By>;
  expiration_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  last_time_spent_update?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
  objective?: Maybe<Order_By>;
  time_spent?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "profiles" */
export type Profiles_Mutation_Response = {
  __typename?: 'profiles_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Profiles>;
};

/** input type for inserting object relation for remote table "profiles" */
export type Profiles_Obj_Rel_Insert_Input = {
  data: Profiles_Insert_Input;
  on_conflict?: Maybe<Profiles_On_Conflict>;
};

/** on conflict condition type for table "profiles" */
export type Profiles_On_Conflict = {
  constraint: Profiles_Constraint;
  update_columns: Array<Profiles_Update_Column>;
  where?: Maybe<Profiles_Bool_Exp>;
};

/** ordering options when selecting data from "profiles" */
export type Profiles_Order_By = {
  activation_codes_aggregate?: Maybe<Activation_Codes_Aggregate_Order_By>;
  answers_aggregate?: Maybe<Answers_Aggregate_Order_By>;
  bills_aggregate?: Maybe<Bills_Aggregate_Order_By>;
  bright_candidates_aggregate?: Maybe<Bright_Candidate_Aggregate_Order_By>;
  bright_manager?: Maybe<Bright_Manager_Order_By>;
  current_exam_id?: Maybe<Order_By>;
  estimated_scores_aggregate?: Maybe<Estimated_Scores_Aggregate_Order_By>;
  exam_type?: Maybe<Order_By>;
  expiration_date?: Maybe<Order_By>;
  feedbacks_aggregate?: Maybe<Answers_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  institution?: Maybe<Institutions_Order_By>;
  institution_id?: Maybe<Order_By>;
  is_admin?: Maybe<Order_By>;
  is_guest?: Maybe<Order_By>;
  is_manager?: Maybe<Order_By>;
  is_teacher?: Maybe<Order_By>;
  last_time_spent_update?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
  objective?: Maybe<Order_By>;
  profile_sphere_associations_aggregate?: Maybe<Profile_Sphere_Association_Aggregate_Order_By>;
  time_spent?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "profiles" */
export type Profiles_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "profiles" */
export enum Profiles_Select_Column {
  /** column name */
  CurrentExamId = 'current_exam_id',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  Id = 'id',
  /** column name */
  InstitutionId = 'institution_id',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsGuest = 'is_guest',
  /** column name */
  IsManager = 'is_manager',
  /** column name */
  IsTeacher = 'is_teacher',
  /** column name */
  LastTimeSpentUpdate = 'last_time_spent_update',
  /** column name */
  Level = 'level',
  /** column name */
  Objective = 'objective',
  /** column name */
  TimeSpent = 'time_spent',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "profiles" */
export type Profiles_Set_Input = {
  current_exam_id?: Maybe<Scalars['Int']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  expiration_date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  is_admin?: Maybe<Scalars['Boolean']>;
  is_guest?: Maybe<Scalars['Boolean']>;
  is_manager?: Maybe<Scalars['Boolean']>;
  is_teacher?: Maybe<Scalars['Boolean']>;
  last_time_spent_update?: Maybe<Scalars['timestamp']>;
  level?: Maybe<Scalars['String']>;
  objective?: Maybe<Scalars['Int']>;
  time_spent?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Profiles_Stddev_Fields = {
  __typename?: 'profiles_stddev_fields';
  current_exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  objective?: Maybe<Scalars['Float']>;
  time_spent?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "profiles" */
export type Profiles_Stddev_Order_By = {
  current_exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  objective?: Maybe<Order_By>;
  time_spent?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Profiles_Stddev_Pop_Fields = {
  __typename?: 'profiles_stddev_pop_fields';
  current_exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  objective?: Maybe<Scalars['Float']>;
  time_spent?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "profiles" */
export type Profiles_Stddev_Pop_Order_By = {
  current_exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  objective?: Maybe<Order_By>;
  time_spent?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Profiles_Stddev_Samp_Fields = {
  __typename?: 'profiles_stddev_samp_fields';
  current_exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  objective?: Maybe<Scalars['Float']>;
  time_spent?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "profiles" */
export type Profiles_Stddev_Samp_Order_By = {
  current_exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  objective?: Maybe<Order_By>;
  time_spent?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Profiles_Sum_Fields = {
  __typename?: 'profiles_sum_fields';
  current_exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  objective?: Maybe<Scalars['Int']>;
  time_spent?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "profiles" */
export type Profiles_Sum_Order_By = {
  current_exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  objective?: Maybe<Order_By>;
  time_spent?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** update columns of table "profiles" */
export enum Profiles_Update_Column {
  /** column name */
  CurrentExamId = 'current_exam_id',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  Id = 'id',
  /** column name */
  InstitutionId = 'institution_id',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsGuest = 'is_guest',
  /** column name */
  IsManager = 'is_manager',
  /** column name */
  IsTeacher = 'is_teacher',
  /** column name */
  LastTimeSpentUpdate = 'last_time_spent_update',
  /** column name */
  Level = 'level',
  /** column name */
  Objective = 'objective',
  /** column name */
  TimeSpent = 'time_spent',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Profiles_Var_Pop_Fields = {
  __typename?: 'profiles_var_pop_fields';
  current_exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  objective?: Maybe<Scalars['Float']>;
  time_spent?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "profiles" */
export type Profiles_Var_Pop_Order_By = {
  current_exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  objective?: Maybe<Order_By>;
  time_spent?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Profiles_Var_Samp_Fields = {
  __typename?: 'profiles_var_samp_fields';
  current_exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  objective?: Maybe<Scalars['Float']>;
  time_spent?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "profiles" */
export type Profiles_Var_Samp_Order_By = {
  current_exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  objective?: Maybe<Order_By>;
  time_spent?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Profiles_Variance_Fields = {
  __typename?: 'profiles_variance_fields';
  current_exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  objective?: Maybe<Scalars['Float']>;
  time_spent?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "profiles" */
export type Profiles_Variance_Order_By = {
  current_exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  objective?: Maybe<Order_By>;
  time_spent?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** query root */
export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "activation_codes" */
  activation_codes: Array<Activation_Codes>;
  /** fetch aggregated fields from the table: "activation_codes" */
  activation_codes_aggregate: Activation_Codes_Aggregate;
  /** fetch data from the table: "activation_codes" using primary key columns */
  activation_codes_by_pk?: Maybe<Activation_Codes>;
  /** fetch data from the table: "answers" */
  answers: Array<Answers>;
  /** fetch aggregated fields from the table: "answers" */
  answers_aggregate: Answers_Aggregate;
  /** fetch data from the table: "answers" using primary key columns */
  answers_by_pk?: Maybe<Answers>;
  /** fetch data from the table: "answers_choice_association" */
  answers_choice_association: Array<Answers_Choice_Association>;
  /** fetch aggregated fields from the table: "answers_choice_association" */
  answers_choice_association_aggregate: Answers_Choice_Association_Aggregate;
  /** fetch data from the table: "bills" */
  bills: Array<Bills>;
  /** fetch aggregated fields from the table: "bills" */
  bills_aggregate: Bills_Aggregate;
  /** fetch data from the table: "bills" using primary key columns */
  bills_by_pk?: Maybe<Bills>;
  /** fetch data from the table: "bright_assessment" */
  bright_assessment: Array<Bright_Assessment>;
  /** fetch aggregated fields from the table: "bright_assessment" */
  bright_assessment_aggregate: Bright_Assessment_Aggregate;
  /** fetch data from the table: "bright_assessment" using primary key columns */
  bright_assessment_by_pk?: Maybe<Bright_Assessment>;
  /** fetch data from the table: "bright_assessments" */
  bright_assessments: Array<Bright_Assessments>;
  /** fetch aggregated fields from the table: "bright_assessments" */
  bright_assessments_aggregate: Bright_Assessments_Aggregate;
  /** fetch data from the table: "bright_assessments" using primary key columns */
  bright_assessments_by_pk?: Maybe<Bright_Assessments>;
  /** fetch data from the table: "bright_branch" */
  bright_branch: Array<Bright_Branch>;
  /** fetch aggregated fields from the table: "bright_branch" */
  bright_branch_aggregate: Bright_Branch_Aggregate;
  /** fetch data from the table: "bright_branch" using primary key columns */
  bright_branch_by_pk?: Maybe<Bright_Branch>;
  /** fetch data from the table: "bright_candidate" */
  bright_candidate: Array<Bright_Candidate>;
  /** fetch aggregated fields from the table: "bright_candidate" */
  bright_candidate_aggregate: Bright_Candidate_Aggregate;
  /** fetch data from the table: "bright_candidate" using primary key columns */
  bright_candidate_by_pk?: Maybe<Bright_Candidate>;
  /** fetch data from the table: "bright_manager" */
  bright_manager: Array<Bright_Manager>;
  /** fetch aggregated fields from the table: "bright_manager" */
  bright_manager_aggregate: Bright_Manager_Aggregate;
  /** fetch data from the table: "bright_manager" using primary key columns */
  bright_manager_by_pk?: Maybe<Bright_Manager>;
  /** fetch data from the table: "categories" */
  categories: Array<Categories>;
  /** fetch aggregated fields from the table: "categories" */
  categories_aggregate: Categories_Aggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>;
  /** fetch data from the table: "choices" */
  choices: Array<Choices>;
  /** fetch aggregated fields from the table: "choices" */
  choices_aggregate: Choices_Aggregate;
  /** fetch data from the table: "choices" using primary key columns */
  choices_by_pk?: Maybe<Choices>;
  /** fetch data from the table: "credits_log" */
  credits_log: Array<Credits_Log>;
  /** fetch aggregated fields from the table: "credits_log" */
  credits_log_aggregate: Credits_Log_Aggregate;
  /** fetch data from the table: "credits_log" using primary key columns */
  credits_log_by_pk?: Maybe<Credits_Log>;
  /** fetch data from the table: "discount_codes" */
  discount_codes: Array<Discount_Codes>;
  /** fetch aggregated fields from the table: "discount_codes" */
  discount_codes_aggregate: Discount_Codes_Aggregate;
  /** fetch data from the table: "discount_codes" using primary key columns */
  discount_codes_by_pk?: Maybe<Discount_Codes>;
  /** fetch data from the table: "estimated_scores" */
  estimated_scores: Array<Estimated_Scores>;
  /** fetch aggregated fields from the table: "estimated_scores" */
  estimated_scores_aggregate: Estimated_Scores_Aggregate;
  /** fetch data from the table: "estimated_scores" using primary key columns */
  estimated_scores_by_pk?: Maybe<Estimated_Scores>;
  /** fetch data from the table: "exams" */
  exams: Array<Exams>;
  /** fetch aggregated fields from the table: "exams" */
  exams_aggregate: Exams_Aggregate;
  /** fetch data from the table: "exams" using primary key columns */
  exams_by_pk?: Maybe<Exams>;
  /** fetch data from the table: "feedbacks" */
  feedbacks: Array<Feedbacks>;
  /** fetch aggregated fields from the table: "feedbacks" */
  feedbacks_aggregate: Feedbacks_Aggregate;
  /** fetch data from the table: "feedbacks" using primary key columns */
  feedbacks_by_pk?: Maybe<Feedbacks>;
  /** fetch data from the table: "institutions" */
  institutions: Array<Institutions>;
  /** fetch aggregated fields from the table: "institutions" */
  institutions_aggregate: Institutions_Aggregate;
  /** fetch data from the table: "institutions" using primary key columns */
  institutions_by_pk?: Maybe<Institutions>;
  /** fetch data from the table: "lessons" */
  lessons: Array<Lessons>;
  /** fetch aggregated fields from the table: "lessons" */
  lessons_aggregate: Lessons_Aggregate;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: Maybe<Lessons>;
  /** fetch data from the table: "plans" */
  plans: Array<Plans>;
  /** fetch aggregated fields from the table: "plans" */
  plans_aggregate: Plans_Aggregate;
  /** fetch data from the table: "plans" using primary key columns */
  plans_by_pk?: Maybe<Plans>;
  /** fetch data from the table: "profile_sphere_association" */
  profile_sphere_association: Array<Profile_Sphere_Association>;
  /** fetch aggregated fields from the table: "profile_sphere_association" */
  profile_sphere_association_aggregate: Profile_Sphere_Association_Aggregate;
  /** fetch data from the table: "profiles" */
  profiles: Array<Profiles>;
  /** fetch aggregated fields from the table: "profiles" */
  profiles_aggregate: Profiles_Aggregate;
  /** fetch data from the table: "profiles" using primary key columns */
  profiles_by_pk?: Maybe<Profiles>;
  /** fetch data from the table: "question_lesson_association" */
  question_lesson_association: Array<Question_Lesson_Association>;
  /** fetch aggregated fields from the table: "question_lesson_association" */
  question_lesson_association_aggregate: Question_Lesson_Association_Aggregate;
  /** fetch data from the table: "question_lesson_association" using primary key columns */
  question_lesson_association_by_pk?: Maybe<Question_Lesson_Association>;
  /** fetch data from the table: "questions" */
  questions: Array<Questions>;
  /** fetch aggregated fields from the table: "questions" */
  questions_aggregate: Questions_Aggregate;
  /** fetch data from the table: "questions" using primary key columns */
  questions_by_pk?: Maybe<Questions>;
  /** fetch data from the table: "registration_billings" */
  registration_billings: Array<Registration_Billings>;
  /** fetch aggregated fields from the table: "registration_billings" */
  registration_billings_aggregate: Registration_Billings_Aggregate;
  /** fetch data from the table: "registration_billings" using primary key columns */
  registration_billings_by_pk?: Maybe<Registration_Billings>;
  /** fetch data from the table: "registrations" */
  registrations: Array<Registrations>;
  /** fetch aggregated fields from the table: "registrations" */
  registrations_aggregate: Registrations_Aggregate;
  /** fetch data from the table: "registrations" using primary key columns */
  registrations_by_pk?: Maybe<Registrations>;
  /** fetch data from the table: "result_plan_association" */
  result_plan_association: Array<Result_Plan_Association>;
  /** fetch aggregated fields from the table: "result_plan_association" */
  result_plan_association_aggregate: Result_Plan_Association_Aggregate;
  /** fetch data from the table: "result_plan_association" using primary key columns */
  result_plan_association_by_pk?: Maybe<Result_Plan_Association>;
  /** fetch data from the table: "results" */
  results: Array<Results>;
  /** fetch aggregated fields from the table: "results" */
  results_aggregate: Results_Aggregate;
  /** fetch data from the table: "results" using primary key columns */
  results_by_pk?: Maybe<Results>;
  /** fetch data from the table: "scores" */
  scores: Array<Scores>;
  /** fetch aggregated fields from the table: "scores" */
  scores_aggregate: Scores_Aggregate;
  /** fetch data from the table: "scores" using primary key columns */
  scores_by_pk?: Maybe<Scores>;
  /** fetch data from the table: "spheres" */
  spheres: Array<Spheres>;
  /** fetch aggregated fields from the table: "spheres" */
  spheres_aggregate: Spheres_Aggregate;
  /** fetch data from the table: "spheres" using primary key columns */
  spheres_by_pk?: Maybe<Spheres>;
  /** fetch data from the table: "supports" */
  supports: Array<Supports>;
  /** fetch aggregated fields from the table: "supports" */
  supports_aggregate: Supports_Aggregate;
  /** fetch data from the table: "supports" using primary key columns */
  supports_by_pk?: Maybe<Supports>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


/** query root */
export type Query_RootActivation_CodesArgs = {
  distinct_on?: Maybe<Array<Activation_Codes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Activation_Codes_Order_By>>;
  where?: Maybe<Activation_Codes_Bool_Exp>;
};


/** query root */
export type Query_RootActivation_Codes_AggregateArgs = {
  distinct_on?: Maybe<Array<Activation_Codes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Activation_Codes_Order_By>>;
  where?: Maybe<Activation_Codes_Bool_Exp>;
};


/** query root */
export type Query_RootActivation_Codes_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootAnswersArgs = {
  distinct_on?: Maybe<Array<Answers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Order_By>>;
  where?: Maybe<Answers_Bool_Exp>;
};


/** query root */
export type Query_RootAnswers_AggregateArgs = {
  distinct_on?: Maybe<Array<Answers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Order_By>>;
  where?: Maybe<Answers_Bool_Exp>;
};


/** query root */
export type Query_RootAnswers_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootAnswers_Choice_AssociationArgs = {
  distinct_on?: Maybe<Array<Answers_Choice_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Choice_Association_Order_By>>;
  where?: Maybe<Answers_Choice_Association_Bool_Exp>;
};


/** query root */
export type Query_RootAnswers_Choice_Association_AggregateArgs = {
  distinct_on?: Maybe<Array<Answers_Choice_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Choice_Association_Order_By>>;
  where?: Maybe<Answers_Choice_Association_Bool_Exp>;
};


/** query root */
export type Query_RootBillsArgs = {
  distinct_on?: Maybe<Array<Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bills_Order_By>>;
  where?: Maybe<Bills_Bool_Exp>;
};


/** query root */
export type Query_RootBills_AggregateArgs = {
  distinct_on?: Maybe<Array<Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bills_Order_By>>;
  where?: Maybe<Bills_Bool_Exp>;
};


/** query root */
export type Query_RootBills_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootBright_AssessmentArgs = {
  distinct_on?: Maybe<Array<Bright_Assessment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Assessment_Order_By>>;
  where?: Maybe<Bright_Assessment_Bool_Exp>;
};


/** query root */
export type Query_RootBright_Assessment_AggregateArgs = {
  distinct_on?: Maybe<Array<Bright_Assessment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Assessment_Order_By>>;
  where?: Maybe<Bright_Assessment_Bool_Exp>;
};


/** query root */
export type Query_RootBright_Assessment_By_PkArgs = {
  bright_assessment_id: Scalars['Int'];
  tester_id: Scalars['Int'];
};


/** query root */
export type Query_RootBright_AssessmentsArgs = {
  distinct_on?: Maybe<Array<Bright_Assessments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Assessments_Order_By>>;
  where?: Maybe<Bright_Assessments_Bool_Exp>;
};


/** query root */
export type Query_RootBright_Assessments_AggregateArgs = {
  distinct_on?: Maybe<Array<Bright_Assessments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Assessments_Order_By>>;
  where?: Maybe<Bright_Assessments_Bool_Exp>;
};


/** query root */
export type Query_RootBright_Assessments_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootBright_BranchArgs = {
  distinct_on?: Maybe<Array<Bright_Branch_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Branch_Order_By>>;
  where?: Maybe<Bright_Branch_Bool_Exp>;
};


/** query root */
export type Query_RootBright_Branch_AggregateArgs = {
  distinct_on?: Maybe<Array<Bright_Branch_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Branch_Order_By>>;
  where?: Maybe<Bright_Branch_Bool_Exp>;
};


/** query root */
export type Query_RootBright_Branch_By_PkArgs = {
  institution_id: Scalars['Int'];
};


/** query root */
export type Query_RootBright_CandidateArgs = {
  distinct_on?: Maybe<Array<Bright_Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Candidate_Order_By>>;
  where?: Maybe<Bright_Candidate_Bool_Exp>;
};


/** query root */
export type Query_RootBright_Candidate_AggregateArgs = {
  distinct_on?: Maybe<Array<Bright_Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Candidate_Order_By>>;
  where?: Maybe<Bright_Candidate_Bool_Exp>;
};


/** query root */
export type Query_RootBright_Candidate_By_PkArgs = {
  candidate_id: Scalars['Int'];
  manager_id: Scalars['Int'];
};


/** query root */
export type Query_RootBright_ManagerArgs = {
  distinct_on?: Maybe<Array<Bright_Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Manager_Order_By>>;
  where?: Maybe<Bright_Manager_Bool_Exp>;
};


/** query root */
export type Query_RootBright_Manager_AggregateArgs = {
  distinct_on?: Maybe<Array<Bright_Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Manager_Order_By>>;
  where?: Maybe<Bright_Manager_Bool_Exp>;
};


/** query root */
export type Query_RootBright_Manager_By_PkArgs = {
  manager_id: Scalars['Int'];
};


/** query root */
export type Query_RootCategoriesArgs = {
  distinct_on?: Maybe<Array<Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Categories_Order_By>>;
  where?: Maybe<Categories_Bool_Exp>;
};


/** query root */
export type Query_RootCategories_AggregateArgs = {
  distinct_on?: Maybe<Array<Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Categories_Order_By>>;
  where?: Maybe<Categories_Bool_Exp>;
};


/** query root */
export type Query_RootCategories_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootChoicesArgs = {
  distinct_on?: Maybe<Array<Choices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Choices_Order_By>>;
  where?: Maybe<Choices_Bool_Exp>;
};


/** query root */
export type Query_RootChoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Choices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Choices_Order_By>>;
  where?: Maybe<Choices_Bool_Exp>;
};


/** query root */
export type Query_RootChoices_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootCredits_LogArgs = {
  distinct_on?: Maybe<Array<Credits_Log_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credits_Log_Order_By>>;
  where?: Maybe<Credits_Log_Bool_Exp>;
};


/** query root */
export type Query_RootCredits_Log_AggregateArgs = {
  distinct_on?: Maybe<Array<Credits_Log_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credits_Log_Order_By>>;
  where?: Maybe<Credits_Log_Bool_Exp>;
};


/** query root */
export type Query_RootCredits_Log_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootDiscount_CodesArgs = {
  distinct_on?: Maybe<Array<Discount_Codes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Codes_Order_By>>;
  where?: Maybe<Discount_Codes_Bool_Exp>;
};


/** query root */
export type Query_RootDiscount_Codes_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Codes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Codes_Order_By>>;
  where?: Maybe<Discount_Codes_Bool_Exp>;
};


/** query root */
export type Query_RootDiscount_Codes_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootEstimated_ScoresArgs = {
  distinct_on?: Maybe<Array<Estimated_Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Estimated_Scores_Order_By>>;
  where?: Maybe<Estimated_Scores_Bool_Exp>;
};


/** query root */
export type Query_RootEstimated_Scores_AggregateArgs = {
  distinct_on?: Maybe<Array<Estimated_Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Estimated_Scores_Order_By>>;
  where?: Maybe<Estimated_Scores_Bool_Exp>;
};


/** query root */
export type Query_RootEstimated_Scores_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootExamsArgs = {
  distinct_on?: Maybe<Array<Exams_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Exams_Order_By>>;
  where?: Maybe<Exams_Bool_Exp>;
};


/** query root */
export type Query_RootExams_AggregateArgs = {
  distinct_on?: Maybe<Array<Exams_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Exams_Order_By>>;
  where?: Maybe<Exams_Bool_Exp>;
};


/** query root */
export type Query_RootExams_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootFeedbacksArgs = {
  distinct_on?: Maybe<Array<Feedbacks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Feedbacks_Order_By>>;
  where?: Maybe<Feedbacks_Bool_Exp>;
};


/** query root */
export type Query_RootFeedbacks_AggregateArgs = {
  distinct_on?: Maybe<Array<Feedbacks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Feedbacks_Order_By>>;
  where?: Maybe<Feedbacks_Bool_Exp>;
};


/** query root */
export type Query_RootFeedbacks_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootInstitutionsArgs = {
  distinct_on?: Maybe<Array<Institutions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Institutions_Order_By>>;
  where?: Maybe<Institutions_Bool_Exp>;
};


/** query root */
export type Query_RootInstitutions_AggregateArgs = {
  distinct_on?: Maybe<Array<Institutions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Institutions_Order_By>>;
  where?: Maybe<Institutions_Bool_Exp>;
};


/** query root */
export type Query_RootInstitutions_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootLessonsArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** query root */
export type Query_RootLessons_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** query root */
export type Query_RootLessons_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootPlansArgs = {
  distinct_on?: Maybe<Array<Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plans_Order_By>>;
  where?: Maybe<Plans_Bool_Exp>;
};


/** query root */
export type Query_RootPlans_AggregateArgs = {
  distinct_on?: Maybe<Array<Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plans_Order_By>>;
  where?: Maybe<Plans_Bool_Exp>;
};


/** query root */
export type Query_RootPlans_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootProfile_Sphere_AssociationArgs = {
  distinct_on?: Maybe<Array<Profile_Sphere_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_Sphere_Association_Order_By>>;
  where?: Maybe<Profile_Sphere_Association_Bool_Exp>;
};


/** query root */
export type Query_RootProfile_Sphere_Association_AggregateArgs = {
  distinct_on?: Maybe<Array<Profile_Sphere_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_Sphere_Association_Order_By>>;
  where?: Maybe<Profile_Sphere_Association_Bool_Exp>;
};


/** query root */
export type Query_RootProfilesArgs = {
  distinct_on?: Maybe<Array<Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profiles_Order_By>>;
  where?: Maybe<Profiles_Bool_Exp>;
};


/** query root */
export type Query_RootProfiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profiles_Order_By>>;
  where?: Maybe<Profiles_Bool_Exp>;
};


/** query root */
export type Query_RootProfiles_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootQuestion_Lesson_AssociationArgs = {
  distinct_on?: Maybe<Array<Question_Lesson_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Question_Lesson_Association_Order_By>>;
  where?: Maybe<Question_Lesson_Association_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Lesson_Association_AggregateArgs = {
  distinct_on?: Maybe<Array<Question_Lesson_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Question_Lesson_Association_Order_By>>;
  where?: Maybe<Question_Lesson_Association_Bool_Exp>;
};


/** query root */
export type Query_RootQuestion_Lesson_Association_By_PkArgs = {
  lesson_id: Scalars['Int'];
  question_id: Scalars['Int'];
};


/** query root */
export type Query_RootQuestionsArgs = {
  distinct_on?: Maybe<Array<Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Questions_Order_By>>;
  where?: Maybe<Questions_Bool_Exp>;
};


/** query root */
export type Query_RootQuestions_AggregateArgs = {
  distinct_on?: Maybe<Array<Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Questions_Order_By>>;
  where?: Maybe<Questions_Bool_Exp>;
};


/** query root */
export type Query_RootQuestions_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootRegistration_BillingsArgs = {
  distinct_on?: Maybe<Array<Registration_Billings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registration_Billings_Order_By>>;
  where?: Maybe<Registration_Billings_Bool_Exp>;
};


/** query root */
export type Query_RootRegistration_Billings_AggregateArgs = {
  distinct_on?: Maybe<Array<Registration_Billings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registration_Billings_Order_By>>;
  where?: Maybe<Registration_Billings_Bool_Exp>;
};


/** query root */
export type Query_RootRegistration_Billings_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootRegistrationsArgs = {
  distinct_on?: Maybe<Array<Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registrations_Order_By>>;
  where?: Maybe<Registrations_Bool_Exp>;
};


/** query root */
export type Query_RootRegistrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registrations_Order_By>>;
  where?: Maybe<Registrations_Bool_Exp>;
};


/** query root */
export type Query_RootRegistrations_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootResult_Plan_AssociationArgs = {
  distinct_on?: Maybe<Array<Result_Plan_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Result_Plan_Association_Order_By>>;
  where?: Maybe<Result_Plan_Association_Bool_Exp>;
};


/** query root */
export type Query_RootResult_Plan_Association_AggregateArgs = {
  distinct_on?: Maybe<Array<Result_Plan_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Result_Plan_Association_Order_By>>;
  where?: Maybe<Result_Plan_Association_Bool_Exp>;
};


/** query root */
export type Query_RootResult_Plan_Association_By_PkArgs = {
  plan_id: Scalars['Int'];
  result_id: Scalars['Int'];
};


/** query root */
export type Query_RootResultsArgs = {
  distinct_on?: Maybe<Array<Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Results_Order_By>>;
  where?: Maybe<Results_Bool_Exp>;
};


/** query root */
export type Query_RootResults_AggregateArgs = {
  distinct_on?: Maybe<Array<Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Results_Order_By>>;
  where?: Maybe<Results_Bool_Exp>;
};


/** query root */
export type Query_RootResults_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootScoresArgs = {
  distinct_on?: Maybe<Array<Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scores_Order_By>>;
  where?: Maybe<Scores_Bool_Exp>;
};


/** query root */
export type Query_RootScores_AggregateArgs = {
  distinct_on?: Maybe<Array<Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scores_Order_By>>;
  where?: Maybe<Scores_Bool_Exp>;
};


/** query root */
export type Query_RootScores_By_PkArgs = {
  lesson_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** query root */
export type Query_RootSpheresArgs = {
  distinct_on?: Maybe<Array<Spheres_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Spheres_Order_By>>;
  where?: Maybe<Spheres_Bool_Exp>;
};


/** query root */
export type Query_RootSpheres_AggregateArgs = {
  distinct_on?: Maybe<Array<Spheres_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Spheres_Order_By>>;
  where?: Maybe<Spheres_Bool_Exp>;
};


/** query root */
export type Query_RootSpheres_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootSupportsArgs = {
  distinct_on?: Maybe<Array<Supports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Supports_Order_By>>;
  where?: Maybe<Supports_Bool_Exp>;
};


/** query root */
export type Query_RootSupports_AggregateArgs = {
  distinct_on?: Maybe<Array<Supports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Supports_Order_By>>;
  where?: Maybe<Supports_Bool_Exp>;
};


/** query root */
export type Query_RootSupports_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_By_PkArgs = {
  id: Scalars['Int'];
};

/** columns and relationships of "question_lesson_association" */
export type Question_Lesson_Association = {
  __typename?: 'question_lesson_association';
  /** An object relationship */
  lesson: Lessons;
  lesson_id: Scalars['Int'];
  /** An object relationship */
  question: Questions;
  question_id: Scalars['Int'];
};

/** aggregated selection of "question_lesson_association" */
export type Question_Lesson_Association_Aggregate = {
  __typename?: 'question_lesson_association_aggregate';
  aggregate?: Maybe<Question_Lesson_Association_Aggregate_Fields>;
  nodes: Array<Question_Lesson_Association>;
};

/** aggregate fields of "question_lesson_association" */
export type Question_Lesson_Association_Aggregate_Fields = {
  __typename?: 'question_lesson_association_aggregate_fields';
  avg?: Maybe<Question_Lesson_Association_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Question_Lesson_Association_Max_Fields>;
  min?: Maybe<Question_Lesson_Association_Min_Fields>;
  stddev?: Maybe<Question_Lesson_Association_Stddev_Fields>;
  stddev_pop?: Maybe<Question_Lesson_Association_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Question_Lesson_Association_Stddev_Samp_Fields>;
  sum?: Maybe<Question_Lesson_Association_Sum_Fields>;
  var_pop?: Maybe<Question_Lesson_Association_Var_Pop_Fields>;
  var_samp?: Maybe<Question_Lesson_Association_Var_Samp_Fields>;
  variance?: Maybe<Question_Lesson_Association_Variance_Fields>;
};


/** aggregate fields of "question_lesson_association" */
export type Question_Lesson_Association_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Question_Lesson_Association_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "question_lesson_association" */
export type Question_Lesson_Association_Aggregate_Order_By = {
  avg?: Maybe<Question_Lesson_Association_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Question_Lesson_Association_Max_Order_By>;
  min?: Maybe<Question_Lesson_Association_Min_Order_By>;
  stddev?: Maybe<Question_Lesson_Association_Stddev_Order_By>;
  stddev_pop?: Maybe<Question_Lesson_Association_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Question_Lesson_Association_Stddev_Samp_Order_By>;
  sum?: Maybe<Question_Lesson_Association_Sum_Order_By>;
  var_pop?: Maybe<Question_Lesson_Association_Var_Pop_Order_By>;
  var_samp?: Maybe<Question_Lesson_Association_Var_Samp_Order_By>;
  variance?: Maybe<Question_Lesson_Association_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "question_lesson_association" */
export type Question_Lesson_Association_Arr_Rel_Insert_Input = {
  data: Array<Question_Lesson_Association_Insert_Input>;
  on_conflict?: Maybe<Question_Lesson_Association_On_Conflict>;
};

/** aggregate avg on columns */
export type Question_Lesson_Association_Avg_Fields = {
  __typename?: 'question_lesson_association_avg_fields';
  lesson_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "question_lesson_association" */
export type Question_Lesson_Association_Avg_Order_By = {
  lesson_id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "question_lesson_association". All fields are combined with a logical 'AND'. */
export type Question_Lesson_Association_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Question_Lesson_Association_Bool_Exp>>>;
  _not?: Maybe<Question_Lesson_Association_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Question_Lesson_Association_Bool_Exp>>>;
  lesson?: Maybe<Lessons_Bool_Exp>;
  lesson_id?: Maybe<Int_Comparison_Exp>;
  question?: Maybe<Questions_Bool_Exp>;
  question_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_lesson_association" */
export enum Question_Lesson_Association_Constraint {
  /** unique or primary key constraint */
  QuestionLessonAssociationPkey = 'question_lesson_association_pkey'
}

/** input type for incrementing integer column in table "question_lesson_association" */
export type Question_Lesson_Association_Inc_Input = {
  lesson_id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "question_lesson_association" */
export type Question_Lesson_Association_Insert_Input = {
  lesson?: Maybe<Lessons_Obj_Rel_Insert_Input>;
  lesson_id?: Maybe<Scalars['Int']>;
  question?: Maybe<Questions_Obj_Rel_Insert_Input>;
  question_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Question_Lesson_Association_Max_Fields = {
  __typename?: 'question_lesson_association_max_fields';
  lesson_id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "question_lesson_association" */
export type Question_Lesson_Association_Max_Order_By = {
  lesson_id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Question_Lesson_Association_Min_Fields = {
  __typename?: 'question_lesson_association_min_fields';
  lesson_id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "question_lesson_association" */
export type Question_Lesson_Association_Min_Order_By = {
  lesson_id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "question_lesson_association" */
export type Question_Lesson_Association_Mutation_Response = {
  __typename?: 'question_lesson_association_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Question_Lesson_Association>;
};

/** input type for inserting object relation for remote table "question_lesson_association" */
export type Question_Lesson_Association_Obj_Rel_Insert_Input = {
  data: Question_Lesson_Association_Insert_Input;
  on_conflict?: Maybe<Question_Lesson_Association_On_Conflict>;
};

/** on conflict condition type for table "question_lesson_association" */
export type Question_Lesson_Association_On_Conflict = {
  constraint: Question_Lesson_Association_Constraint;
  update_columns: Array<Question_Lesson_Association_Update_Column>;
  where?: Maybe<Question_Lesson_Association_Bool_Exp>;
};

/** ordering options when selecting data from "question_lesson_association" */
export type Question_Lesson_Association_Order_By = {
  lesson?: Maybe<Lessons_Order_By>;
  lesson_id?: Maybe<Order_By>;
  question?: Maybe<Questions_Order_By>;
  question_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "question_lesson_association" */
export type Question_Lesson_Association_Pk_Columns_Input = {
  lesson_id: Scalars['Int'];
  question_id: Scalars['Int'];
};

/** select columns of table "question_lesson_association" */
export enum Question_Lesson_Association_Select_Column {
  /** column name */
  LessonId = 'lesson_id',
  /** column name */
  QuestionId = 'question_id'
}

/** input type for updating data in table "question_lesson_association" */
export type Question_Lesson_Association_Set_Input = {
  lesson_id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Question_Lesson_Association_Stddev_Fields = {
  __typename?: 'question_lesson_association_stddev_fields';
  lesson_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "question_lesson_association" */
export type Question_Lesson_Association_Stddev_Order_By = {
  lesson_id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Question_Lesson_Association_Stddev_Pop_Fields = {
  __typename?: 'question_lesson_association_stddev_pop_fields';
  lesson_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "question_lesson_association" */
export type Question_Lesson_Association_Stddev_Pop_Order_By = {
  lesson_id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Question_Lesson_Association_Stddev_Samp_Fields = {
  __typename?: 'question_lesson_association_stddev_samp_fields';
  lesson_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "question_lesson_association" */
export type Question_Lesson_Association_Stddev_Samp_Order_By = {
  lesson_id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Question_Lesson_Association_Sum_Fields = {
  __typename?: 'question_lesson_association_sum_fields';
  lesson_id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "question_lesson_association" */
export type Question_Lesson_Association_Sum_Order_By = {
  lesson_id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** update columns of table "question_lesson_association" */
export enum Question_Lesson_Association_Update_Column {
  /** column name */
  LessonId = 'lesson_id',
  /** column name */
  QuestionId = 'question_id'
}

/** aggregate var_pop on columns */
export type Question_Lesson_Association_Var_Pop_Fields = {
  __typename?: 'question_lesson_association_var_pop_fields';
  lesson_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "question_lesson_association" */
export type Question_Lesson_Association_Var_Pop_Order_By = {
  lesson_id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Question_Lesson_Association_Var_Samp_Fields = {
  __typename?: 'question_lesson_association_var_samp_fields';
  lesson_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "question_lesson_association" */
export type Question_Lesson_Association_Var_Samp_Order_By = {
  lesson_id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Question_Lesson_Association_Variance_Fields = {
  __typename?: 'question_lesson_association_variance_fields';
  lesson_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "question_lesson_association" */
export type Question_Lesson_Association_Variance_Order_By = {
  lesson_id?: Maybe<Order_By>;
  question_id?: Maybe<Order_By>;
};

/** columns and relationships of "questions" */
export type Questions = {
  __typename?: 'questions';
  /** An array relationship */
  answers: Array<Answers>;
  /** An aggregated array relationship */
  answers_aggregate: Answers_Aggregate;
  /** An array relationship */
  choices: Array<Choices>;
  /** An aggregated array relationship */
  choices_aggregate: Choices_Aggregate;
  correction?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An array relationship */
  question_lesson_associations: Array<Question_Lesson_Association>;
  /** An aggregated array relationship */
  question_lesson_associations_aggregate: Question_Lesson_Association_Aggregate;
  /** An object relationship */
  support: Supports;
  support_id: Scalars['Int'];
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};


/** columns and relationships of "questions" */
export type QuestionsAnswersArgs = {
  distinct_on?: Maybe<Array<Answers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Order_By>>;
  where?: Maybe<Answers_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsAnswers_AggregateArgs = {
  distinct_on?: Maybe<Array<Answers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Order_By>>;
  where?: Maybe<Answers_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsChoicesArgs = {
  distinct_on?: Maybe<Array<Choices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Choices_Order_By>>;
  where?: Maybe<Choices_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsChoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Choices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Choices_Order_By>>;
  where?: Maybe<Choices_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsQuestion_Lesson_AssociationsArgs = {
  distinct_on?: Maybe<Array<Question_Lesson_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Question_Lesson_Association_Order_By>>;
  where?: Maybe<Question_Lesson_Association_Bool_Exp>;
};


/** columns and relationships of "questions" */
export type QuestionsQuestion_Lesson_Associations_AggregateArgs = {
  distinct_on?: Maybe<Array<Question_Lesson_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Question_Lesson_Association_Order_By>>;
  where?: Maybe<Question_Lesson_Association_Bool_Exp>;
};

/** aggregated selection of "questions" */
export type Questions_Aggregate = {
  __typename?: 'questions_aggregate';
  aggregate?: Maybe<Questions_Aggregate_Fields>;
  nodes: Array<Questions>;
};

/** aggregate fields of "questions" */
export type Questions_Aggregate_Fields = {
  __typename?: 'questions_aggregate_fields';
  avg?: Maybe<Questions_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Questions_Max_Fields>;
  min?: Maybe<Questions_Min_Fields>;
  stddev?: Maybe<Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Questions_Sum_Fields>;
  var_pop?: Maybe<Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Questions_Var_Samp_Fields>;
  variance?: Maybe<Questions_Variance_Fields>;
};


/** aggregate fields of "questions" */
export type Questions_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Questions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "questions" */
export type Questions_Aggregate_Order_By = {
  avg?: Maybe<Questions_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Questions_Max_Order_By>;
  min?: Maybe<Questions_Min_Order_By>;
  stddev?: Maybe<Questions_Stddev_Order_By>;
  stddev_pop?: Maybe<Questions_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Questions_Stddev_Samp_Order_By>;
  sum?: Maybe<Questions_Sum_Order_By>;
  var_pop?: Maybe<Questions_Var_Pop_Order_By>;
  var_samp?: Maybe<Questions_Var_Samp_Order_By>;
  variance?: Maybe<Questions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "questions" */
export type Questions_Arr_Rel_Insert_Input = {
  data: Array<Questions_Insert_Input>;
  on_conflict?: Maybe<Questions_On_Conflict>;
};

/** aggregate avg on columns */
export type Questions_Avg_Fields = {
  __typename?: 'questions_avg_fields';
  id?: Maybe<Scalars['Float']>;
  support_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "questions" */
export type Questions_Avg_Order_By = {
  id?: Maybe<Order_By>;
  support_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "questions". All fields are combined with a logical 'AND'. */
export type Questions_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Questions_Bool_Exp>>>;
  _not?: Maybe<Questions_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Questions_Bool_Exp>>>;
  answers?: Maybe<Answers_Bool_Exp>;
  choices?: Maybe<Choices_Bool_Exp>;
  correction?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  question_lesson_associations?: Maybe<Question_Lesson_Association_Bool_Exp>;
  support?: Maybe<Supports_Bool_Exp>;
  support_id?: Maybe<Int_Comparison_Exp>;
  text?: Maybe<String_Comparison_Exp>;
  value?: Maybe<Float_Comparison_Exp>;
};

/** unique or primary key constraints on table "questions" */
export enum Questions_Constraint {
  /** unique or primary key constraint */
  QuestionsPkey = 'questions_pkey'
}

/** input type for incrementing integer column in table "questions" */
export type Questions_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  support_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
};

/** input type for inserting data into table "questions" */
export type Questions_Insert_Input = {
  answers?: Maybe<Answers_Arr_Rel_Insert_Input>;
  choices?: Maybe<Choices_Arr_Rel_Insert_Input>;
  correction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  question_lesson_associations?: Maybe<Question_Lesson_Association_Arr_Rel_Insert_Input>;
  support?: Maybe<Supports_Obj_Rel_Insert_Input>;
  support_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Questions_Max_Fields = {
  __typename?: 'questions_max_fields';
  correction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  support_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by max() on columns of table "questions" */
export type Questions_Max_Order_By = {
  correction?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  support_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Questions_Min_Fields = {
  __typename?: 'questions_min_fields';
  correction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  support_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by min() on columns of table "questions" */
export type Questions_Min_Order_By = {
  correction?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  support_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "questions" */
export type Questions_Mutation_Response = {
  __typename?: 'questions_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Questions>;
};

/** input type for inserting object relation for remote table "questions" */
export type Questions_Obj_Rel_Insert_Input = {
  data: Questions_Insert_Input;
  on_conflict?: Maybe<Questions_On_Conflict>;
};

/** on conflict condition type for table "questions" */
export type Questions_On_Conflict = {
  constraint: Questions_Constraint;
  update_columns: Array<Questions_Update_Column>;
  where?: Maybe<Questions_Bool_Exp>;
};

/** ordering options when selecting data from "questions" */
export type Questions_Order_By = {
  answers_aggregate?: Maybe<Answers_Aggregate_Order_By>;
  choices_aggregate?: Maybe<Choices_Aggregate_Order_By>;
  correction?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  question_lesson_associations_aggregate?: Maybe<Question_Lesson_Association_Aggregate_Order_By>;
  support?: Maybe<Supports_Order_By>;
  support_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "questions" */
export type Questions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "questions" */
export enum Questions_Select_Column {
  /** column name */
  Correction = 'correction',
  /** column name */
  Id = 'id',
  /** column name */
  SupportId = 'support_id',
  /** column name */
  Text = 'text',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "questions" */
export type Questions_Set_Input = {
  correction?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  support_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Questions_Stddev_Fields = {
  __typename?: 'questions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  support_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "questions" */
export type Questions_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  support_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Questions_Stddev_Pop_Fields = {
  __typename?: 'questions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  support_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "questions" */
export type Questions_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  support_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Questions_Stddev_Samp_Fields = {
  __typename?: 'questions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  support_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "questions" */
export type Questions_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  support_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Questions_Sum_Fields = {
  __typename?: 'questions_sum_fields';
  id?: Maybe<Scalars['Int']>;
  support_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by sum() on columns of table "questions" */
export type Questions_Sum_Order_By = {
  id?: Maybe<Order_By>;
  support_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** update columns of table "questions" */
export enum Questions_Update_Column {
  /** column name */
  Correction = 'correction',
  /** column name */
  Id = 'id',
  /** column name */
  SupportId = 'support_id',
  /** column name */
  Text = 'text',
  /** column name */
  Value = 'value'
}

/** aggregate var_pop on columns */
export type Questions_Var_Pop_Fields = {
  __typename?: 'questions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  support_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "questions" */
export type Questions_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  support_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Questions_Var_Samp_Fields = {
  __typename?: 'questions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  support_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "questions" */
export type Questions_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  support_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Questions_Variance_Fields = {
  __typename?: 'questions_variance_fields';
  id?: Maybe<Scalars['Float']>;
  support_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "questions" */
export type Questions_Variance_Order_By = {
  id?: Maybe<Order_By>;
  support_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** columns and relationships of "registration_billings" */
export type Registration_Billings = {
  __typename?: 'registration_billings';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['Int'];
  id: Scalars['Int'];
  info?: Maybe<Scalars['String']>;
  /** An object relationship */
  institution: Institutions;
  institution_id: Scalars['Int'];
  /** An object relationship */
  profile: Profiles;
  /** An array relationship */
  registrations: Array<Registrations>;
  /** An aggregated array relationship */
  registrations_aggregate: Registrations_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "registration_billings" */
export type Registration_BillingsRegistrationsArgs = {
  distinct_on?: Maybe<Array<Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registrations_Order_By>>;
  where?: Maybe<Registrations_Bool_Exp>;
};


/** columns and relationships of "registration_billings" */
export type Registration_BillingsRegistrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registrations_Order_By>>;
  where?: Maybe<Registrations_Bool_Exp>;
};

/** aggregated selection of "registration_billings" */
export type Registration_Billings_Aggregate = {
  __typename?: 'registration_billings_aggregate';
  aggregate?: Maybe<Registration_Billings_Aggregate_Fields>;
  nodes: Array<Registration_Billings>;
};

/** aggregate fields of "registration_billings" */
export type Registration_Billings_Aggregate_Fields = {
  __typename?: 'registration_billings_aggregate_fields';
  avg?: Maybe<Registration_Billings_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Registration_Billings_Max_Fields>;
  min?: Maybe<Registration_Billings_Min_Fields>;
  stddev?: Maybe<Registration_Billings_Stddev_Fields>;
  stddev_pop?: Maybe<Registration_Billings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Registration_Billings_Stddev_Samp_Fields>;
  sum?: Maybe<Registration_Billings_Sum_Fields>;
  var_pop?: Maybe<Registration_Billings_Var_Pop_Fields>;
  var_samp?: Maybe<Registration_Billings_Var_Samp_Fields>;
  variance?: Maybe<Registration_Billings_Variance_Fields>;
};


/** aggregate fields of "registration_billings" */
export type Registration_Billings_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Registration_Billings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "registration_billings" */
export type Registration_Billings_Aggregate_Order_By = {
  avg?: Maybe<Registration_Billings_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Registration_Billings_Max_Order_By>;
  min?: Maybe<Registration_Billings_Min_Order_By>;
  stddev?: Maybe<Registration_Billings_Stddev_Order_By>;
  stddev_pop?: Maybe<Registration_Billings_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Registration_Billings_Stddev_Samp_Order_By>;
  sum?: Maybe<Registration_Billings_Sum_Order_By>;
  var_pop?: Maybe<Registration_Billings_Var_Pop_Order_By>;
  var_samp?: Maybe<Registration_Billings_Var_Samp_Order_By>;
  variance?: Maybe<Registration_Billings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "registration_billings" */
export type Registration_Billings_Arr_Rel_Insert_Input = {
  data: Array<Registration_Billings_Insert_Input>;
  on_conflict?: Maybe<Registration_Billings_On_Conflict>;
};

/** aggregate avg on columns */
export type Registration_Billings_Avg_Fields = {
  __typename?: 'registration_billings_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "registration_billings" */
export type Registration_Billings_Avg_Order_By = {
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "registration_billings". All fields are combined with a logical 'AND'. */
export type Registration_Billings_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Registration_Billings_Bool_Exp>>>;
  _not?: Maybe<Registration_Billings_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Registration_Billings_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  info?: Maybe<String_Comparison_Exp>;
  institution?: Maybe<Institutions_Bool_Exp>;
  institution_id?: Maybe<Int_Comparison_Exp>;
  profile?: Maybe<Profiles_Bool_Exp>;
  registrations?: Maybe<Registrations_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "registration_billings" */
export enum Registration_Billings_Constraint {
  /** unique or primary key constraint */
  RegistrationBillingsPkey = 'registration_billings_pkey'
}

/** input type for incrementing integer column in table "registration_billings" */
export type Registration_Billings_Inc_Input = {
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "registration_billings" */
export type Registration_Billings_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<Scalars['String']>;
  institution?: Maybe<Institutions_Obj_Rel_Insert_Input>;
  institution_id?: Maybe<Scalars['Int']>;
  profile?: Maybe<Profiles_Obj_Rel_Insert_Input>;
  registrations?: Maybe<Registrations_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Registration_Billings_Max_Fields = {
  __typename?: 'registration_billings_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<Scalars['String']>;
  institution_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "registration_billings" */
export type Registration_Billings_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  info?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Registration_Billings_Min_Fields = {
  __typename?: 'registration_billings_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<Scalars['String']>;
  institution_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "registration_billings" */
export type Registration_Billings_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  info?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "registration_billings" */
export type Registration_Billings_Mutation_Response = {
  __typename?: 'registration_billings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Registration_Billings>;
};

/** input type for inserting object relation for remote table "registration_billings" */
export type Registration_Billings_Obj_Rel_Insert_Input = {
  data: Registration_Billings_Insert_Input;
  on_conflict?: Maybe<Registration_Billings_On_Conflict>;
};

/** on conflict condition type for table "registration_billings" */
export type Registration_Billings_On_Conflict = {
  constraint: Registration_Billings_Constraint;
  update_columns: Array<Registration_Billings_Update_Column>;
  where?: Maybe<Registration_Billings_Bool_Exp>;
};

/** ordering options when selecting data from "registration_billings" */
export type Registration_Billings_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  info?: Maybe<Order_By>;
  institution?: Maybe<Institutions_Order_By>;
  institution_id?: Maybe<Order_By>;
  profile?: Maybe<Profiles_Order_By>;
  registrations_aggregate?: Maybe<Registrations_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "registration_billings" */
export type Registration_Billings_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "registration_billings" */
export enum Registration_Billings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  InstitutionId = 'institution_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "registration_billings" */
export type Registration_Billings_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<Scalars['String']>;
  institution_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Registration_Billings_Stddev_Fields = {
  __typename?: 'registration_billings_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "registration_billings" */
export type Registration_Billings_Stddev_Order_By = {
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Registration_Billings_Stddev_Pop_Fields = {
  __typename?: 'registration_billings_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "registration_billings" */
export type Registration_Billings_Stddev_Pop_Order_By = {
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Registration_Billings_Stddev_Samp_Fields = {
  __typename?: 'registration_billings_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "registration_billings" */
export type Registration_Billings_Stddev_Samp_Order_By = {
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Registration_Billings_Sum_Fields = {
  __typename?: 'registration_billings_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "registration_billings" */
export type Registration_Billings_Sum_Order_By = {
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** update columns of table "registration_billings" */
export enum Registration_Billings_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  InstitutionId = 'institution_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Registration_Billings_Var_Pop_Fields = {
  __typename?: 'registration_billings_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "registration_billings" */
export type Registration_Billings_Var_Pop_Order_By = {
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Registration_Billings_Var_Samp_Fields = {
  __typename?: 'registration_billings_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "registration_billings" */
export type Registration_Billings_Var_Samp_Order_By = {
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Registration_Billings_Variance_Fields = {
  __typename?: 'registration_billings_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "registration_billings" */
export type Registration_Billings_Variance_Order_By = {
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
};

/** columns and relationships of "registrations" */
export type Registrations = {
  __typename?: 'registrations';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['Int']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  duration: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  exam_type: Scalars['exam_types'];
  id: Scalars['Int'];
  /** An object relationship */
  institution: Institutions;
  institution_id: Scalars['Int'];
  level?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['Int']>;
  registration_billing_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "registrations" */
export type Registrations_Aggregate = {
  __typename?: 'registrations_aggregate';
  aggregate?: Maybe<Registrations_Aggregate_Fields>;
  nodes: Array<Registrations>;
};

/** aggregate fields of "registrations" */
export type Registrations_Aggregate_Fields = {
  __typename?: 'registrations_aggregate_fields';
  avg?: Maybe<Registrations_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Registrations_Max_Fields>;
  min?: Maybe<Registrations_Min_Fields>;
  stddev?: Maybe<Registrations_Stddev_Fields>;
  stddev_pop?: Maybe<Registrations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Registrations_Stddev_Samp_Fields>;
  sum?: Maybe<Registrations_Sum_Fields>;
  var_pop?: Maybe<Registrations_Var_Pop_Fields>;
  var_samp?: Maybe<Registrations_Var_Samp_Fields>;
  variance?: Maybe<Registrations_Variance_Fields>;
};


/** aggregate fields of "registrations" */
export type Registrations_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Registrations_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "registrations" */
export type Registrations_Aggregate_Order_By = {
  avg?: Maybe<Registrations_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Registrations_Max_Order_By>;
  min?: Maybe<Registrations_Min_Order_By>;
  stddev?: Maybe<Registrations_Stddev_Order_By>;
  stddev_pop?: Maybe<Registrations_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Registrations_Stddev_Samp_Order_By>;
  sum?: Maybe<Registrations_Sum_Order_By>;
  var_pop?: Maybe<Registrations_Var_Pop_Order_By>;
  var_samp?: Maybe<Registrations_Var_Samp_Order_By>;
  variance?: Maybe<Registrations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "registrations" */
export type Registrations_Arr_Rel_Insert_Input = {
  data: Array<Registrations_Insert_Input>;
  on_conflict?: Maybe<Registrations_On_Conflict>;
};

/** aggregate avg on columns */
export type Registrations_Avg_Fields = {
  __typename?: 'registrations_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  profile_id?: Maybe<Scalars['Float']>;
  registration_billing_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "registrations" */
export type Registrations_Avg_Order_By = {
  created_by?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  profile_id?: Maybe<Order_By>;
  registration_billing_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "registrations". All fields are combined with a logical 'AND'. */
export type Registrations_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Registrations_Bool_Exp>>>;
  _not?: Maybe<Registrations_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Registrations_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Int_Comparison_Exp>;
  creator?: Maybe<Users_Bool_Exp>;
  duration?: Maybe<Int_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  exam_type?: Maybe<Exam_Types_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  institution?: Maybe<Institutions_Bool_Exp>;
  institution_id?: Maybe<Int_Comparison_Exp>;
  level?: Maybe<String_Comparison_Exp>;
  profile_id?: Maybe<Int_Comparison_Exp>;
  registration_billing_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "registrations" */
export enum Registrations_Constraint {
  /** unique or primary key constraint */
  RegistrationsPkey = 'registrations_pkey'
}

/** input type for incrementing integer column in table "registrations" */
export type Registrations_Inc_Input = {
  created_by?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  profile_id?: Maybe<Scalars['Int']>;
  registration_billing_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "registrations" */
export type Registrations_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  creator?: Maybe<Users_Obj_Rel_Insert_Input>;
  duration?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  id?: Maybe<Scalars['Int']>;
  institution?: Maybe<Institutions_Obj_Rel_Insert_Input>;
  institution_id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['Int']>;
  registration_billing_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Registrations_Max_Fields = {
  __typename?: 'registrations_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['Int']>;
  registration_billing_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "registrations" */
export type Registrations_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
  profile_id?: Maybe<Order_By>;
  registration_billing_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Registrations_Min_Fields = {
  __typename?: 'registrations_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['Int']>;
  registration_billing_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "registrations" */
export type Registrations_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
  profile_id?: Maybe<Order_By>;
  registration_billing_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "registrations" */
export type Registrations_Mutation_Response = {
  __typename?: 'registrations_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Registrations>;
};

/** input type for inserting object relation for remote table "registrations" */
export type Registrations_Obj_Rel_Insert_Input = {
  data: Registrations_Insert_Input;
  on_conflict?: Maybe<Registrations_On_Conflict>;
};

/** on conflict condition type for table "registrations" */
export type Registrations_On_Conflict = {
  constraint: Registrations_Constraint;
  update_columns: Array<Registrations_Update_Column>;
  where?: Maybe<Registrations_Bool_Exp>;
};

/** ordering options when selecting data from "registrations" */
export type Registrations_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  creator?: Maybe<Users_Order_By>;
  duration?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  exam_type?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution?: Maybe<Institutions_Order_By>;
  institution_id?: Maybe<Order_By>;
  level?: Maybe<Order_By>;
  profile_id?: Maybe<Order_By>;
  registration_billing_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "registrations" */
export type Registrations_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "registrations" */
export enum Registrations_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Duration = 'duration',
  /** column name */
  Email = 'email',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  Id = 'id',
  /** column name */
  InstitutionId = 'institution_id',
  /** column name */
  Level = 'level',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  RegistrationBillingId = 'registration_billing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "registrations" */
export type Registrations_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  exam_type?: Maybe<Scalars['exam_types']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['Int']>;
  registration_billing_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Registrations_Stddev_Fields = {
  __typename?: 'registrations_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  profile_id?: Maybe<Scalars['Float']>;
  registration_billing_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "registrations" */
export type Registrations_Stddev_Order_By = {
  created_by?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  profile_id?: Maybe<Order_By>;
  registration_billing_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Registrations_Stddev_Pop_Fields = {
  __typename?: 'registrations_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  profile_id?: Maybe<Scalars['Float']>;
  registration_billing_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "registrations" */
export type Registrations_Stddev_Pop_Order_By = {
  created_by?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  profile_id?: Maybe<Order_By>;
  registration_billing_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Registrations_Stddev_Samp_Fields = {
  __typename?: 'registrations_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  profile_id?: Maybe<Scalars['Float']>;
  registration_billing_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "registrations" */
export type Registrations_Stddev_Samp_Order_By = {
  created_by?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  profile_id?: Maybe<Order_By>;
  registration_billing_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Registrations_Sum_Fields = {
  __typename?: 'registrations_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  profile_id?: Maybe<Scalars['Int']>;
  registration_billing_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "registrations" */
export type Registrations_Sum_Order_By = {
  created_by?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  profile_id?: Maybe<Order_By>;
  registration_billing_id?: Maybe<Order_By>;
};

/** update columns of table "registrations" */
export enum Registrations_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Duration = 'duration',
  /** column name */
  Email = 'email',
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  Id = 'id',
  /** column name */
  InstitutionId = 'institution_id',
  /** column name */
  Level = 'level',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  RegistrationBillingId = 'registration_billing_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Registrations_Var_Pop_Fields = {
  __typename?: 'registrations_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  profile_id?: Maybe<Scalars['Float']>;
  registration_billing_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "registrations" */
export type Registrations_Var_Pop_Order_By = {
  created_by?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  profile_id?: Maybe<Order_By>;
  registration_billing_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Registrations_Var_Samp_Fields = {
  __typename?: 'registrations_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  profile_id?: Maybe<Scalars['Float']>;
  registration_billing_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "registrations" */
export type Registrations_Var_Samp_Order_By = {
  created_by?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  profile_id?: Maybe<Order_By>;
  registration_billing_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Registrations_Variance_Fields = {
  __typename?: 'registrations_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  profile_id?: Maybe<Scalars['Float']>;
  registration_billing_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "registrations" */
export type Registrations_Variance_Order_By = {
  created_by?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  profile_id?: Maybe<Order_By>;
  registration_billing_id?: Maybe<Order_By>;
};

/** columns and relationships of "result_plan_association" */
export type Result_Plan_Association = {
  __typename?: 'result_plan_association';
  /** An object relationship */
  plan: Plans;
  plan_id: Scalars['Int'];
  /** An object relationship */
  result: Results;
  result_id: Scalars['Int'];
};

/** aggregated selection of "result_plan_association" */
export type Result_Plan_Association_Aggregate = {
  __typename?: 'result_plan_association_aggregate';
  aggregate?: Maybe<Result_Plan_Association_Aggregate_Fields>;
  nodes: Array<Result_Plan_Association>;
};

/** aggregate fields of "result_plan_association" */
export type Result_Plan_Association_Aggregate_Fields = {
  __typename?: 'result_plan_association_aggregate_fields';
  avg?: Maybe<Result_Plan_Association_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Result_Plan_Association_Max_Fields>;
  min?: Maybe<Result_Plan_Association_Min_Fields>;
  stddev?: Maybe<Result_Plan_Association_Stddev_Fields>;
  stddev_pop?: Maybe<Result_Plan_Association_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Result_Plan_Association_Stddev_Samp_Fields>;
  sum?: Maybe<Result_Plan_Association_Sum_Fields>;
  var_pop?: Maybe<Result_Plan_Association_Var_Pop_Fields>;
  var_samp?: Maybe<Result_Plan_Association_Var_Samp_Fields>;
  variance?: Maybe<Result_Plan_Association_Variance_Fields>;
};


/** aggregate fields of "result_plan_association" */
export type Result_Plan_Association_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Result_Plan_Association_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "result_plan_association" */
export type Result_Plan_Association_Aggregate_Order_By = {
  avg?: Maybe<Result_Plan_Association_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Result_Plan_Association_Max_Order_By>;
  min?: Maybe<Result_Plan_Association_Min_Order_By>;
  stddev?: Maybe<Result_Plan_Association_Stddev_Order_By>;
  stddev_pop?: Maybe<Result_Plan_Association_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Result_Plan_Association_Stddev_Samp_Order_By>;
  sum?: Maybe<Result_Plan_Association_Sum_Order_By>;
  var_pop?: Maybe<Result_Plan_Association_Var_Pop_Order_By>;
  var_samp?: Maybe<Result_Plan_Association_Var_Samp_Order_By>;
  variance?: Maybe<Result_Plan_Association_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "result_plan_association" */
export type Result_Plan_Association_Arr_Rel_Insert_Input = {
  data: Array<Result_Plan_Association_Insert_Input>;
  on_conflict?: Maybe<Result_Plan_Association_On_Conflict>;
};

/** aggregate avg on columns */
export type Result_Plan_Association_Avg_Fields = {
  __typename?: 'result_plan_association_avg_fields';
  plan_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "result_plan_association" */
export type Result_Plan_Association_Avg_Order_By = {
  plan_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "result_plan_association". All fields are combined with a logical 'AND'. */
export type Result_Plan_Association_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Result_Plan_Association_Bool_Exp>>>;
  _not?: Maybe<Result_Plan_Association_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Result_Plan_Association_Bool_Exp>>>;
  plan?: Maybe<Plans_Bool_Exp>;
  plan_id?: Maybe<Int_Comparison_Exp>;
  result?: Maybe<Results_Bool_Exp>;
  result_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "result_plan_association" */
export enum Result_Plan_Association_Constraint {
  /** unique or primary key constraint */
  ResultPlanAssociationPkey = 'result_plan_association_pkey'
}

/** input type for incrementing integer column in table "result_plan_association" */
export type Result_Plan_Association_Inc_Input = {
  plan_id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "result_plan_association" */
export type Result_Plan_Association_Insert_Input = {
  plan?: Maybe<Plans_Obj_Rel_Insert_Input>;
  plan_id?: Maybe<Scalars['Int']>;
  result?: Maybe<Results_Obj_Rel_Insert_Input>;
  result_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Result_Plan_Association_Max_Fields = {
  __typename?: 'result_plan_association_max_fields';
  plan_id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "result_plan_association" */
export type Result_Plan_Association_Max_Order_By = {
  plan_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Result_Plan_Association_Min_Fields = {
  __typename?: 'result_plan_association_min_fields';
  plan_id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "result_plan_association" */
export type Result_Plan_Association_Min_Order_By = {
  plan_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "result_plan_association" */
export type Result_Plan_Association_Mutation_Response = {
  __typename?: 'result_plan_association_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Result_Plan_Association>;
};

/** input type for inserting object relation for remote table "result_plan_association" */
export type Result_Plan_Association_Obj_Rel_Insert_Input = {
  data: Result_Plan_Association_Insert_Input;
  on_conflict?: Maybe<Result_Plan_Association_On_Conflict>;
};

/** on conflict condition type for table "result_plan_association" */
export type Result_Plan_Association_On_Conflict = {
  constraint: Result_Plan_Association_Constraint;
  update_columns: Array<Result_Plan_Association_Update_Column>;
  where?: Maybe<Result_Plan_Association_Bool_Exp>;
};

/** ordering options when selecting data from "result_plan_association" */
export type Result_Plan_Association_Order_By = {
  plan?: Maybe<Plans_Order_By>;
  plan_id?: Maybe<Order_By>;
  result?: Maybe<Results_Order_By>;
  result_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "result_plan_association" */
export type Result_Plan_Association_Pk_Columns_Input = {
  plan_id: Scalars['Int'];
  result_id: Scalars['Int'];
};

/** select columns of table "result_plan_association" */
export enum Result_Plan_Association_Select_Column {
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  ResultId = 'result_id'
}

/** input type for updating data in table "result_plan_association" */
export type Result_Plan_Association_Set_Input = {
  plan_id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Result_Plan_Association_Stddev_Fields = {
  __typename?: 'result_plan_association_stddev_fields';
  plan_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "result_plan_association" */
export type Result_Plan_Association_Stddev_Order_By = {
  plan_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Result_Plan_Association_Stddev_Pop_Fields = {
  __typename?: 'result_plan_association_stddev_pop_fields';
  plan_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "result_plan_association" */
export type Result_Plan_Association_Stddev_Pop_Order_By = {
  plan_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Result_Plan_Association_Stddev_Samp_Fields = {
  __typename?: 'result_plan_association_stddev_samp_fields';
  plan_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "result_plan_association" */
export type Result_Plan_Association_Stddev_Samp_Order_By = {
  plan_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Result_Plan_Association_Sum_Fields = {
  __typename?: 'result_plan_association_sum_fields';
  plan_id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "result_plan_association" */
export type Result_Plan_Association_Sum_Order_By = {
  plan_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
};

/** update columns of table "result_plan_association" */
export enum Result_Plan_Association_Update_Column {
  /** column name */
  PlanId = 'plan_id',
  /** column name */
  ResultId = 'result_id'
}

/** aggregate var_pop on columns */
export type Result_Plan_Association_Var_Pop_Fields = {
  __typename?: 'result_plan_association_var_pop_fields';
  plan_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "result_plan_association" */
export type Result_Plan_Association_Var_Pop_Order_By = {
  plan_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Result_Plan_Association_Var_Samp_Fields = {
  __typename?: 'result_plan_association_var_samp_fields';
  plan_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "result_plan_association" */
export type Result_Plan_Association_Var_Samp_Order_By = {
  plan_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Result_Plan_Association_Variance_Fields = {
  __typename?: 'result_plan_association_variance_fields';
  plan_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "result_plan_association" */
export type Result_Plan_Association_Variance_Order_By = {
  plan_id?: Maybe<Order_By>;
  result_id?: Maybe<Order_By>;
};

/** columns and relationships of "results" */
export type Results = {
  __typename?: 'results';
  /** An array relationship */
  answers: Array<Answers>;
  /** An aggregated array relationship */
  answers_aggregate: Answers_Aggregate;
  created_at: Scalars['timestamp'];
  /** An object relationship */
  exam: Exams;
  exam_id: Scalars['Int'];
  id: Scalars['Int'];
  listening_score?: Maybe<Scalars['float8']>;
  oral_score?: Maybe<Scalars['float8']>;
  reading_score?: Maybe<Scalars['float8']>;
  /** An array relationship */
  result_plan_associations: Array<Result_Plan_Association>;
  /** An aggregated array relationship */
  result_plan_associations_aggregate: Result_Plan_Association_Aggregate;
  score?: Maybe<Scalars['float8']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
  writing_score?: Maybe<Scalars['float8']>;
};


/** columns and relationships of "results" */
export type ResultsAnswersArgs = {
  distinct_on?: Maybe<Array<Answers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Order_By>>;
  where?: Maybe<Answers_Bool_Exp>;
};


/** columns and relationships of "results" */
export type ResultsAnswers_AggregateArgs = {
  distinct_on?: Maybe<Array<Answers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Order_By>>;
  where?: Maybe<Answers_Bool_Exp>;
};


/** columns and relationships of "results" */
export type ResultsResult_Plan_AssociationsArgs = {
  distinct_on?: Maybe<Array<Result_Plan_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Result_Plan_Association_Order_By>>;
  where?: Maybe<Result_Plan_Association_Bool_Exp>;
};


/** columns and relationships of "results" */
export type ResultsResult_Plan_Associations_AggregateArgs = {
  distinct_on?: Maybe<Array<Result_Plan_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Result_Plan_Association_Order_By>>;
  where?: Maybe<Result_Plan_Association_Bool_Exp>;
};

/** aggregated selection of "results" */
export type Results_Aggregate = {
  __typename?: 'results_aggregate';
  aggregate?: Maybe<Results_Aggregate_Fields>;
  nodes: Array<Results>;
};

/** aggregate fields of "results" */
export type Results_Aggregate_Fields = {
  __typename?: 'results_aggregate_fields';
  avg?: Maybe<Results_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Results_Max_Fields>;
  min?: Maybe<Results_Min_Fields>;
  stddev?: Maybe<Results_Stddev_Fields>;
  stddev_pop?: Maybe<Results_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Results_Stddev_Samp_Fields>;
  sum?: Maybe<Results_Sum_Fields>;
  var_pop?: Maybe<Results_Var_Pop_Fields>;
  var_samp?: Maybe<Results_Var_Samp_Fields>;
  variance?: Maybe<Results_Variance_Fields>;
};


/** aggregate fields of "results" */
export type Results_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Results_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "results" */
export type Results_Aggregate_Order_By = {
  avg?: Maybe<Results_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Results_Max_Order_By>;
  min?: Maybe<Results_Min_Order_By>;
  stddev?: Maybe<Results_Stddev_Order_By>;
  stddev_pop?: Maybe<Results_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Results_Stddev_Samp_Order_By>;
  sum?: Maybe<Results_Sum_Order_By>;
  var_pop?: Maybe<Results_Var_Pop_Order_By>;
  var_samp?: Maybe<Results_Var_Samp_Order_By>;
  variance?: Maybe<Results_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "results" */
export type Results_Arr_Rel_Insert_Input = {
  data: Array<Results_Insert_Input>;
  on_conflict?: Maybe<Results_On_Conflict>;
};

/** aggregate avg on columns */
export type Results_Avg_Fields = {
  __typename?: 'results_avg_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listening_score?: Maybe<Scalars['Float']>;
  oral_score?: Maybe<Scalars['Float']>;
  reading_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  writing_score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "results" */
export type Results_Avg_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  listening_score?: Maybe<Order_By>;
  oral_score?: Maybe<Order_By>;
  reading_score?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  writing_score?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "results". All fields are combined with a logical 'AND'. */
export type Results_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Results_Bool_Exp>>>;
  _not?: Maybe<Results_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Results_Bool_Exp>>>;
  answers?: Maybe<Answers_Bool_Exp>;
  created_at?: Maybe<Timestamp_Comparison_Exp>;
  exam?: Maybe<Exams_Bool_Exp>;
  exam_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  listening_score?: Maybe<Float8_Comparison_Exp>;
  oral_score?: Maybe<Float8_Comparison_Exp>;
  reading_score?: Maybe<Float8_Comparison_Exp>;
  result_plan_associations?: Maybe<Result_Plan_Association_Bool_Exp>;
  score?: Maybe<Float8_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Int_Comparison_Exp>;
  writing_score?: Maybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "results" */
export enum Results_Constraint {
  /** unique or primary key constraint */
  ResultsPkey = 'results_pkey'
}

/** input type for incrementing integer column in table "results" */
export type Results_Inc_Input = {
  exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  listening_score?: Maybe<Scalars['float8']>;
  oral_score?: Maybe<Scalars['float8']>;
  reading_score?: Maybe<Scalars['float8']>;
  score?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
  writing_score?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "results" */
export type Results_Insert_Input = {
  answers?: Maybe<Answers_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamp']>;
  exam?: Maybe<Exams_Obj_Rel_Insert_Input>;
  exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  listening_score?: Maybe<Scalars['float8']>;
  oral_score?: Maybe<Scalars['float8']>;
  reading_score?: Maybe<Scalars['float8']>;
  result_plan_associations?: Maybe<Result_Plan_Association_Arr_Rel_Insert_Input>;
  score?: Maybe<Scalars['float8']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['Int']>;
  writing_score?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Results_Max_Fields = {
  __typename?: 'results_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  listening_score?: Maybe<Scalars['float8']>;
  oral_score?: Maybe<Scalars['float8']>;
  reading_score?: Maybe<Scalars['float8']>;
  score?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
  writing_score?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "results" */
export type Results_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  listening_score?: Maybe<Order_By>;
  oral_score?: Maybe<Order_By>;
  reading_score?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  writing_score?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Results_Min_Fields = {
  __typename?: 'results_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  listening_score?: Maybe<Scalars['float8']>;
  oral_score?: Maybe<Scalars['float8']>;
  reading_score?: Maybe<Scalars['float8']>;
  score?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
  writing_score?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "results" */
export type Results_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  listening_score?: Maybe<Order_By>;
  oral_score?: Maybe<Order_By>;
  reading_score?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  writing_score?: Maybe<Order_By>;
};

/** response of any mutation on the table "results" */
export type Results_Mutation_Response = {
  __typename?: 'results_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Results>;
};

/** input type for inserting object relation for remote table "results" */
export type Results_Obj_Rel_Insert_Input = {
  data: Results_Insert_Input;
  on_conflict?: Maybe<Results_On_Conflict>;
};

/** on conflict condition type for table "results" */
export type Results_On_Conflict = {
  constraint: Results_Constraint;
  update_columns: Array<Results_Update_Column>;
  where?: Maybe<Results_Bool_Exp>;
};

/** ordering options when selecting data from "results" */
export type Results_Order_By = {
  answers_aggregate?: Maybe<Answers_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  exam?: Maybe<Exams_Order_By>;
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  listening_score?: Maybe<Order_By>;
  oral_score?: Maybe<Order_By>;
  reading_score?: Maybe<Order_By>;
  result_plan_associations_aggregate?: Maybe<Result_Plan_Association_Aggregate_Order_By>;
  score?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
  writing_score?: Maybe<Order_By>;
};

/** primary key columns input for table: "results" */
export type Results_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "results" */
export enum Results_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExamId = 'exam_id',
  /** column name */
  Id = 'id',
  /** column name */
  ListeningScore = 'listening_score',
  /** column name */
  OralScore = 'oral_score',
  /** column name */
  ReadingScore = 'reading_score',
  /** column name */
  Score = 'score',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WritingScore = 'writing_score'
}

/** input type for updating data in table "results" */
export type Results_Set_Input = {
  created_at?: Maybe<Scalars['timestamp']>;
  exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  listening_score?: Maybe<Scalars['float8']>;
  oral_score?: Maybe<Scalars['float8']>;
  reading_score?: Maybe<Scalars['float8']>;
  score?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
  writing_score?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Results_Stddev_Fields = {
  __typename?: 'results_stddev_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listening_score?: Maybe<Scalars['Float']>;
  oral_score?: Maybe<Scalars['Float']>;
  reading_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  writing_score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "results" */
export type Results_Stddev_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  listening_score?: Maybe<Order_By>;
  oral_score?: Maybe<Order_By>;
  reading_score?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  writing_score?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Results_Stddev_Pop_Fields = {
  __typename?: 'results_stddev_pop_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listening_score?: Maybe<Scalars['Float']>;
  oral_score?: Maybe<Scalars['Float']>;
  reading_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  writing_score?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "results" */
export type Results_Stddev_Pop_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  listening_score?: Maybe<Order_By>;
  oral_score?: Maybe<Order_By>;
  reading_score?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  writing_score?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Results_Stddev_Samp_Fields = {
  __typename?: 'results_stddev_samp_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listening_score?: Maybe<Scalars['Float']>;
  oral_score?: Maybe<Scalars['Float']>;
  reading_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  writing_score?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "results" */
export type Results_Stddev_Samp_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  listening_score?: Maybe<Order_By>;
  oral_score?: Maybe<Order_By>;
  reading_score?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  writing_score?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Results_Sum_Fields = {
  __typename?: 'results_sum_fields';
  exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  listening_score?: Maybe<Scalars['float8']>;
  oral_score?: Maybe<Scalars['float8']>;
  reading_score?: Maybe<Scalars['float8']>;
  score?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
  writing_score?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "results" */
export type Results_Sum_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  listening_score?: Maybe<Order_By>;
  oral_score?: Maybe<Order_By>;
  reading_score?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  writing_score?: Maybe<Order_By>;
};

/** update columns of table "results" */
export enum Results_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExamId = 'exam_id',
  /** column name */
  Id = 'id',
  /** column name */
  ListeningScore = 'listening_score',
  /** column name */
  OralScore = 'oral_score',
  /** column name */
  ReadingScore = 'reading_score',
  /** column name */
  Score = 'score',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WritingScore = 'writing_score'
}

/** aggregate var_pop on columns */
export type Results_Var_Pop_Fields = {
  __typename?: 'results_var_pop_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listening_score?: Maybe<Scalars['Float']>;
  oral_score?: Maybe<Scalars['Float']>;
  reading_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  writing_score?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "results" */
export type Results_Var_Pop_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  listening_score?: Maybe<Order_By>;
  oral_score?: Maybe<Order_By>;
  reading_score?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  writing_score?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Results_Var_Samp_Fields = {
  __typename?: 'results_var_samp_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listening_score?: Maybe<Scalars['Float']>;
  oral_score?: Maybe<Scalars['Float']>;
  reading_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  writing_score?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "results" */
export type Results_Var_Samp_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  listening_score?: Maybe<Order_By>;
  oral_score?: Maybe<Order_By>;
  reading_score?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  writing_score?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Results_Variance_Fields = {
  __typename?: 'results_variance_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  listening_score?: Maybe<Scalars['Float']>;
  oral_score?: Maybe<Scalars['Float']>;
  reading_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  writing_score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "results" */
export type Results_Variance_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  listening_score?: Maybe<Order_By>;
  oral_score?: Maybe<Order_By>;
  reading_score?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  writing_score?: Maybe<Order_By>;
};

/** columns and relationships of "scores" */
export type Scores = {
  __typename?: 'scores';
  id: Scalars['Int'];
  known_date?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  lesson: Lessons;
  lesson_id: Scalars['Int'];
  trial_count: Scalars['Int'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
  value: Scalars['Int'];
};

/** aggregated selection of "scores" */
export type Scores_Aggregate = {
  __typename?: 'scores_aggregate';
  aggregate?: Maybe<Scores_Aggregate_Fields>;
  nodes: Array<Scores>;
};

/** aggregate fields of "scores" */
export type Scores_Aggregate_Fields = {
  __typename?: 'scores_aggregate_fields';
  avg?: Maybe<Scores_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Scores_Max_Fields>;
  min?: Maybe<Scores_Min_Fields>;
  stddev?: Maybe<Scores_Stddev_Fields>;
  stddev_pop?: Maybe<Scores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scores_Stddev_Samp_Fields>;
  sum?: Maybe<Scores_Sum_Fields>;
  var_pop?: Maybe<Scores_Var_Pop_Fields>;
  var_samp?: Maybe<Scores_Var_Samp_Fields>;
  variance?: Maybe<Scores_Variance_Fields>;
};


/** aggregate fields of "scores" */
export type Scores_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Scores_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "scores" */
export type Scores_Aggregate_Order_By = {
  avg?: Maybe<Scores_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Scores_Max_Order_By>;
  min?: Maybe<Scores_Min_Order_By>;
  stddev?: Maybe<Scores_Stddev_Order_By>;
  stddev_pop?: Maybe<Scores_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Scores_Stddev_Samp_Order_By>;
  sum?: Maybe<Scores_Sum_Order_By>;
  var_pop?: Maybe<Scores_Var_Pop_Order_By>;
  var_samp?: Maybe<Scores_Var_Samp_Order_By>;
  variance?: Maybe<Scores_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "scores" */
export type Scores_Arr_Rel_Insert_Input = {
  data: Array<Scores_Insert_Input>;
  on_conflict?: Maybe<Scores_On_Conflict>;
};

/** aggregate avg on columns */
export type Scores_Avg_Fields = {
  __typename?: 'scores_avg_fields';
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  trial_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "scores" */
export type Scores_Avg_Order_By = {
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  trial_count?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "scores". All fields are combined with a logical 'AND'. */
export type Scores_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Scores_Bool_Exp>>>;
  _not?: Maybe<Scores_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Scores_Bool_Exp>>>;
  id?: Maybe<Int_Comparison_Exp>;
  known_date?: Maybe<Timestamp_Comparison_Exp>;
  lesson?: Maybe<Lessons_Bool_Exp>;
  lesson_id?: Maybe<Int_Comparison_Exp>;
  trial_count?: Maybe<Int_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Int_Comparison_Exp>;
  value?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "scores" */
export enum Scores_Constraint {
  /** unique or primary key constraint */
  ScoresPkey = 'scores_pkey'
}

/** input type for incrementing integer column in table "scores" */
export type Scores_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  lesson_id?: Maybe<Scalars['Int']>;
  trial_count?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "scores" */
export type Scores_Insert_Input = {
  id?: Maybe<Scalars['Int']>;
  known_date?: Maybe<Scalars['timestamp']>;
  lesson?: Maybe<Lessons_Obj_Rel_Insert_Input>;
  lesson_id?: Maybe<Scalars['Int']>;
  trial_count?: Maybe<Scalars['Int']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Scores_Max_Fields = {
  __typename?: 'scores_max_fields';
  id?: Maybe<Scalars['Int']>;
  known_date?: Maybe<Scalars['timestamp']>;
  lesson_id?: Maybe<Scalars['Int']>;
  trial_count?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "scores" */
export type Scores_Max_Order_By = {
  id?: Maybe<Order_By>;
  known_date?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  trial_count?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Scores_Min_Fields = {
  __typename?: 'scores_min_fields';
  id?: Maybe<Scalars['Int']>;
  known_date?: Maybe<Scalars['timestamp']>;
  lesson_id?: Maybe<Scalars['Int']>;
  trial_count?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "scores" */
export type Scores_Min_Order_By = {
  id?: Maybe<Order_By>;
  known_date?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  trial_count?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "scores" */
export type Scores_Mutation_Response = {
  __typename?: 'scores_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Scores>;
};

/** input type for inserting object relation for remote table "scores" */
export type Scores_Obj_Rel_Insert_Input = {
  data: Scores_Insert_Input;
  on_conflict?: Maybe<Scores_On_Conflict>;
};

/** on conflict condition type for table "scores" */
export type Scores_On_Conflict = {
  constraint: Scores_Constraint;
  update_columns: Array<Scores_Update_Column>;
  where?: Maybe<Scores_Bool_Exp>;
};

/** ordering options when selecting data from "scores" */
export type Scores_Order_By = {
  id?: Maybe<Order_By>;
  known_date?: Maybe<Order_By>;
  lesson?: Maybe<Lessons_Order_By>;
  lesson_id?: Maybe<Order_By>;
  trial_count?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "scores" */
export type Scores_Pk_Columns_Input = {
  lesson_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "scores" */
export enum Scores_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  KnownDate = 'known_date',
  /** column name */
  LessonId = 'lesson_id',
  /** column name */
  TrialCount = 'trial_count',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "scores" */
export type Scores_Set_Input = {
  id?: Maybe<Scalars['Int']>;
  known_date?: Maybe<Scalars['timestamp']>;
  lesson_id?: Maybe<Scalars['Int']>;
  trial_count?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Scores_Stddev_Fields = {
  __typename?: 'scores_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  trial_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "scores" */
export type Scores_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  trial_count?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Scores_Stddev_Pop_Fields = {
  __typename?: 'scores_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  trial_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "scores" */
export type Scores_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  trial_count?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Scores_Stddev_Samp_Fields = {
  __typename?: 'scores_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  trial_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "scores" */
export type Scores_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  trial_count?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Scores_Sum_Fields = {
  __typename?: 'scores_sum_fields';
  id?: Maybe<Scalars['Int']>;
  lesson_id?: Maybe<Scalars['Int']>;
  trial_count?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "scores" */
export type Scores_Sum_Order_By = {
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  trial_count?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** update columns of table "scores" */
export enum Scores_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  KnownDate = 'known_date',
  /** column name */
  LessonId = 'lesson_id',
  /** column name */
  TrialCount = 'trial_count',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** aggregate var_pop on columns */
export type Scores_Var_Pop_Fields = {
  __typename?: 'scores_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  trial_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "scores" */
export type Scores_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  trial_count?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Scores_Var_Samp_Fields = {
  __typename?: 'scores_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  trial_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "scores" */
export type Scores_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  trial_count?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Scores_Variance_Fields = {
  __typename?: 'scores_variance_fields';
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  trial_count?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "scores" */
export type Scores_Variance_Order_By = {
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  trial_count?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** columns and relationships of "spheres" */
export type Spheres = {
  __typename?: 'spheres';
  exam_type: Scalars['exam_types'];
  id: Scalars['Int'];
  /** An object relationship */
  institution: Institutions;
  institution_id: Scalars['Int'];
  is_global: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  profile_sphere_associations: Array<Profile_Sphere_Association>;
  /** An aggregated array relationship */
  profile_sphere_associations_aggregate: Profile_Sphere_Association_Aggregate;
  /** An object relationship */
  teacher?: Maybe<Profiles>;
  teacher_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "spheres" */
export type SpheresProfile_Sphere_AssociationsArgs = {
  distinct_on?: Maybe<Array<Profile_Sphere_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_Sphere_Association_Order_By>>;
  where?: Maybe<Profile_Sphere_Association_Bool_Exp>;
};


/** columns and relationships of "spheres" */
export type SpheresProfile_Sphere_Associations_AggregateArgs = {
  distinct_on?: Maybe<Array<Profile_Sphere_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_Sphere_Association_Order_By>>;
  where?: Maybe<Profile_Sphere_Association_Bool_Exp>;
};

/** aggregated selection of "spheres" */
export type Spheres_Aggregate = {
  __typename?: 'spheres_aggregate';
  aggregate?: Maybe<Spheres_Aggregate_Fields>;
  nodes: Array<Spheres>;
};

/** aggregate fields of "spheres" */
export type Spheres_Aggregate_Fields = {
  __typename?: 'spheres_aggregate_fields';
  avg?: Maybe<Spheres_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Spheres_Max_Fields>;
  min?: Maybe<Spheres_Min_Fields>;
  stddev?: Maybe<Spheres_Stddev_Fields>;
  stddev_pop?: Maybe<Spheres_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spheres_Stddev_Samp_Fields>;
  sum?: Maybe<Spheres_Sum_Fields>;
  var_pop?: Maybe<Spheres_Var_Pop_Fields>;
  var_samp?: Maybe<Spheres_Var_Samp_Fields>;
  variance?: Maybe<Spheres_Variance_Fields>;
};


/** aggregate fields of "spheres" */
export type Spheres_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Spheres_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "spheres" */
export type Spheres_Aggregate_Order_By = {
  avg?: Maybe<Spheres_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Spheres_Max_Order_By>;
  min?: Maybe<Spheres_Min_Order_By>;
  stddev?: Maybe<Spheres_Stddev_Order_By>;
  stddev_pop?: Maybe<Spheres_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Spheres_Stddev_Samp_Order_By>;
  sum?: Maybe<Spheres_Sum_Order_By>;
  var_pop?: Maybe<Spheres_Var_Pop_Order_By>;
  var_samp?: Maybe<Spheres_Var_Samp_Order_By>;
  variance?: Maybe<Spheres_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spheres" */
export type Spheres_Arr_Rel_Insert_Input = {
  data: Array<Spheres_Insert_Input>;
  on_conflict?: Maybe<Spheres_On_Conflict>;
};

/** aggregate avg on columns */
export type Spheres_Avg_Fields = {
  __typename?: 'spheres_avg_fields';
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "spheres" */
export type Spheres_Avg_Order_By = {
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spheres". All fields are combined with a logical 'AND'. */
export type Spheres_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Spheres_Bool_Exp>>>;
  _not?: Maybe<Spheres_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Spheres_Bool_Exp>>>;
  exam_type?: Maybe<Exam_Types_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  institution?: Maybe<Institutions_Bool_Exp>;
  institution_id?: Maybe<Int_Comparison_Exp>;
  is_global?: Maybe<Boolean_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  profile_sphere_associations?: Maybe<Profile_Sphere_Association_Bool_Exp>;
  teacher?: Maybe<Profiles_Bool_Exp>;
  teacher_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "spheres" */
export enum Spheres_Constraint {
  /** unique or primary key constraint */
  SpheresPkey = 'spheres_pkey'
}

/** input type for incrementing integer column in table "spheres" */
export type Spheres_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  teacher_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "spheres" */
export type Spheres_Insert_Input = {
  exam_type?: Maybe<Scalars['exam_types']>;
  id?: Maybe<Scalars['Int']>;
  institution?: Maybe<Institutions_Obj_Rel_Insert_Input>;
  institution_id?: Maybe<Scalars['Int']>;
  is_global?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  profile_sphere_associations?: Maybe<Profile_Sphere_Association_Arr_Rel_Insert_Input>;
  teacher?: Maybe<Profiles_Obj_Rel_Insert_Input>;
  teacher_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Spheres_Max_Fields = {
  __typename?: 'spheres_max_fields';
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "spheres" */
export type Spheres_Max_Order_By = {
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Spheres_Min_Fields = {
  __typename?: 'spheres_min_fields';
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "spheres" */
export type Spheres_Min_Order_By = {
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "spheres" */
export type Spheres_Mutation_Response = {
  __typename?: 'spheres_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Spheres>;
};

/** input type for inserting object relation for remote table "spheres" */
export type Spheres_Obj_Rel_Insert_Input = {
  data: Spheres_Insert_Input;
  on_conflict?: Maybe<Spheres_On_Conflict>;
};

/** on conflict condition type for table "spheres" */
export type Spheres_On_Conflict = {
  constraint: Spheres_Constraint;
  update_columns: Array<Spheres_Update_Column>;
  where?: Maybe<Spheres_Bool_Exp>;
};

/** ordering options when selecting data from "spheres" */
export type Spheres_Order_By = {
  exam_type?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution?: Maybe<Institutions_Order_By>;
  institution_id?: Maybe<Order_By>;
  is_global?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  profile_sphere_associations_aggregate?: Maybe<Profile_Sphere_Association_Aggregate_Order_By>;
  teacher?: Maybe<Profiles_Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "spheres" */
export type Spheres_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "spheres" */
export enum Spheres_Select_Column {
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  Id = 'id',
  /** column name */
  InstitutionId = 'institution_id',
  /** column name */
  IsGlobal = 'is_global',
  /** column name */
  Name = 'name',
  /** column name */
  TeacherId = 'teacher_id'
}

/** input type for updating data in table "spheres" */
export type Spheres_Set_Input = {
  exam_type?: Maybe<Scalars['exam_types']>;
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  is_global?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Spheres_Stddev_Fields = {
  __typename?: 'spheres_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "spheres" */
export type Spheres_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spheres_Stddev_Pop_Fields = {
  __typename?: 'spheres_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "spheres" */
export type Spheres_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spheres_Stddev_Samp_Fields = {
  __typename?: 'spheres_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "spheres" */
export type Spheres_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Spheres_Sum_Fields = {
  __typename?: 'spheres_sum_fields';
  id?: Maybe<Scalars['Int']>;
  institution_id?: Maybe<Scalars['Int']>;
  teacher_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "spheres" */
export type Spheres_Sum_Order_By = {
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** update columns of table "spheres" */
export enum Spheres_Update_Column {
  /** column name */
  ExamType = 'exam_type',
  /** column name */
  Id = 'id',
  /** column name */
  InstitutionId = 'institution_id',
  /** column name */
  IsGlobal = 'is_global',
  /** column name */
  Name = 'name',
  /** column name */
  TeacherId = 'teacher_id'
}

/** aggregate var_pop on columns */
export type Spheres_Var_Pop_Fields = {
  __typename?: 'spheres_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "spheres" */
export type Spheres_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spheres_Var_Samp_Fields = {
  __typename?: 'spheres_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "spheres" */
export type Spheres_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Spheres_Variance_Fields = {
  __typename?: 'spheres_variance_fields';
  id?: Maybe<Scalars['Float']>;
  institution_id?: Maybe<Scalars['Float']>;
  teacher_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "spheres" */
export type Spheres_Variance_Order_By = {
  id?: Maybe<Order_By>;
  institution_id?: Maybe<Order_By>;
  teacher_id?: Maybe<Order_By>;
};

/** subscription root */
export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "activation_codes" */
  activation_codes: Array<Activation_Codes>;
  /** fetch aggregated fields from the table: "activation_codes" */
  activation_codes_aggregate: Activation_Codes_Aggregate;
  /** fetch data from the table: "activation_codes" using primary key columns */
  activation_codes_by_pk?: Maybe<Activation_Codes>;
  /** fetch data from the table: "answers" */
  answers: Array<Answers>;
  /** fetch aggregated fields from the table: "answers" */
  answers_aggregate: Answers_Aggregate;
  /** fetch data from the table: "answers" using primary key columns */
  answers_by_pk?: Maybe<Answers>;
  /** fetch data from the table: "answers_choice_association" */
  answers_choice_association: Array<Answers_Choice_Association>;
  /** fetch aggregated fields from the table: "answers_choice_association" */
  answers_choice_association_aggregate: Answers_Choice_Association_Aggregate;
  /** fetch data from the table: "bills" */
  bills: Array<Bills>;
  /** fetch aggregated fields from the table: "bills" */
  bills_aggregate: Bills_Aggregate;
  /** fetch data from the table: "bills" using primary key columns */
  bills_by_pk?: Maybe<Bills>;
  /** fetch data from the table: "bright_assessment" */
  bright_assessment: Array<Bright_Assessment>;
  /** fetch aggregated fields from the table: "bright_assessment" */
  bright_assessment_aggregate: Bright_Assessment_Aggregate;
  /** fetch data from the table: "bright_assessment" using primary key columns */
  bright_assessment_by_pk?: Maybe<Bright_Assessment>;
  /** fetch data from the table: "bright_assessments" */
  bright_assessments: Array<Bright_Assessments>;
  /** fetch aggregated fields from the table: "bright_assessments" */
  bright_assessments_aggregate: Bright_Assessments_Aggregate;
  /** fetch data from the table: "bright_assessments" using primary key columns */
  bright_assessments_by_pk?: Maybe<Bright_Assessments>;
  /** fetch data from the table: "bright_branch" */
  bright_branch: Array<Bright_Branch>;
  /** fetch aggregated fields from the table: "bright_branch" */
  bright_branch_aggregate: Bright_Branch_Aggregate;
  /** fetch data from the table: "bright_branch" using primary key columns */
  bright_branch_by_pk?: Maybe<Bright_Branch>;
  /** fetch data from the table: "bright_candidate" */
  bright_candidate: Array<Bright_Candidate>;
  /** fetch aggregated fields from the table: "bright_candidate" */
  bright_candidate_aggregate: Bright_Candidate_Aggregate;
  /** fetch data from the table: "bright_candidate" using primary key columns */
  bright_candidate_by_pk?: Maybe<Bright_Candidate>;
  /** fetch data from the table: "bright_manager" */
  bright_manager: Array<Bright_Manager>;
  /** fetch aggregated fields from the table: "bright_manager" */
  bright_manager_aggregate: Bright_Manager_Aggregate;
  /** fetch data from the table: "bright_manager" using primary key columns */
  bright_manager_by_pk?: Maybe<Bright_Manager>;
  /** fetch data from the table: "categories" */
  categories: Array<Categories>;
  /** fetch aggregated fields from the table: "categories" */
  categories_aggregate: Categories_Aggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>;
  /** fetch data from the table: "choices" */
  choices: Array<Choices>;
  /** fetch aggregated fields from the table: "choices" */
  choices_aggregate: Choices_Aggregate;
  /** fetch data from the table: "choices" using primary key columns */
  choices_by_pk?: Maybe<Choices>;
  /** fetch data from the table: "credits_log" */
  credits_log: Array<Credits_Log>;
  /** fetch aggregated fields from the table: "credits_log" */
  credits_log_aggregate: Credits_Log_Aggregate;
  /** fetch data from the table: "credits_log" using primary key columns */
  credits_log_by_pk?: Maybe<Credits_Log>;
  /** fetch data from the table: "discount_codes" */
  discount_codes: Array<Discount_Codes>;
  /** fetch aggregated fields from the table: "discount_codes" */
  discount_codes_aggregate: Discount_Codes_Aggregate;
  /** fetch data from the table: "discount_codes" using primary key columns */
  discount_codes_by_pk?: Maybe<Discount_Codes>;
  /** fetch data from the table: "estimated_scores" */
  estimated_scores: Array<Estimated_Scores>;
  /** fetch aggregated fields from the table: "estimated_scores" */
  estimated_scores_aggregate: Estimated_Scores_Aggregate;
  /** fetch data from the table: "estimated_scores" using primary key columns */
  estimated_scores_by_pk?: Maybe<Estimated_Scores>;
  /** fetch data from the table: "exams" */
  exams: Array<Exams>;
  /** fetch aggregated fields from the table: "exams" */
  exams_aggregate: Exams_Aggregate;
  /** fetch data from the table: "exams" using primary key columns */
  exams_by_pk?: Maybe<Exams>;
  /** fetch data from the table: "feedbacks" */
  feedbacks: Array<Feedbacks>;
  /** fetch aggregated fields from the table: "feedbacks" */
  feedbacks_aggregate: Feedbacks_Aggregate;
  /** fetch data from the table: "feedbacks" using primary key columns */
  feedbacks_by_pk?: Maybe<Feedbacks>;
  /** fetch data from the table: "institutions" */
  institutions: Array<Institutions>;
  /** fetch aggregated fields from the table: "institutions" */
  institutions_aggregate: Institutions_Aggregate;
  /** fetch data from the table: "institutions" using primary key columns */
  institutions_by_pk?: Maybe<Institutions>;
  /** fetch data from the table: "lessons" */
  lessons: Array<Lessons>;
  /** fetch aggregated fields from the table: "lessons" */
  lessons_aggregate: Lessons_Aggregate;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: Maybe<Lessons>;
  /** fetch data from the table: "plans" */
  plans: Array<Plans>;
  /** fetch aggregated fields from the table: "plans" */
  plans_aggregate: Plans_Aggregate;
  /** fetch data from the table: "plans" using primary key columns */
  plans_by_pk?: Maybe<Plans>;
  /** fetch data from the table: "profile_sphere_association" */
  profile_sphere_association: Array<Profile_Sphere_Association>;
  /** fetch aggregated fields from the table: "profile_sphere_association" */
  profile_sphere_association_aggregate: Profile_Sphere_Association_Aggregate;
  /** fetch data from the table: "profiles" */
  profiles: Array<Profiles>;
  /** fetch aggregated fields from the table: "profiles" */
  profiles_aggregate: Profiles_Aggregate;
  /** fetch data from the table: "profiles" using primary key columns */
  profiles_by_pk?: Maybe<Profiles>;
  /** fetch data from the table: "question_lesson_association" */
  question_lesson_association: Array<Question_Lesson_Association>;
  /** fetch aggregated fields from the table: "question_lesson_association" */
  question_lesson_association_aggregate: Question_Lesson_Association_Aggregate;
  /** fetch data from the table: "question_lesson_association" using primary key columns */
  question_lesson_association_by_pk?: Maybe<Question_Lesson_Association>;
  /** fetch data from the table: "questions" */
  questions: Array<Questions>;
  /** fetch aggregated fields from the table: "questions" */
  questions_aggregate: Questions_Aggregate;
  /** fetch data from the table: "questions" using primary key columns */
  questions_by_pk?: Maybe<Questions>;
  /** fetch data from the table: "registration_billings" */
  registration_billings: Array<Registration_Billings>;
  /** fetch aggregated fields from the table: "registration_billings" */
  registration_billings_aggregate: Registration_Billings_Aggregate;
  /** fetch data from the table: "registration_billings" using primary key columns */
  registration_billings_by_pk?: Maybe<Registration_Billings>;
  /** fetch data from the table: "registrations" */
  registrations: Array<Registrations>;
  /** fetch aggregated fields from the table: "registrations" */
  registrations_aggregate: Registrations_Aggregate;
  /** fetch data from the table: "registrations" using primary key columns */
  registrations_by_pk?: Maybe<Registrations>;
  /** fetch data from the table: "result_plan_association" */
  result_plan_association: Array<Result_Plan_Association>;
  /** fetch aggregated fields from the table: "result_plan_association" */
  result_plan_association_aggregate: Result_Plan_Association_Aggregate;
  /** fetch data from the table: "result_plan_association" using primary key columns */
  result_plan_association_by_pk?: Maybe<Result_Plan_Association>;
  /** fetch data from the table: "results" */
  results: Array<Results>;
  /** fetch aggregated fields from the table: "results" */
  results_aggregate: Results_Aggregate;
  /** fetch data from the table: "results" using primary key columns */
  results_by_pk?: Maybe<Results>;
  /** fetch data from the table: "scores" */
  scores: Array<Scores>;
  /** fetch aggregated fields from the table: "scores" */
  scores_aggregate: Scores_Aggregate;
  /** fetch data from the table: "scores" using primary key columns */
  scores_by_pk?: Maybe<Scores>;
  /** fetch data from the table: "spheres" */
  spheres: Array<Spheres>;
  /** fetch aggregated fields from the table: "spheres" */
  spheres_aggregate: Spheres_Aggregate;
  /** fetch data from the table: "spheres" using primary key columns */
  spheres_by_pk?: Maybe<Spheres>;
  /** fetch data from the table: "supports" */
  supports: Array<Supports>;
  /** fetch aggregated fields from the table: "supports" */
  supports_aggregate: Supports_Aggregate;
  /** fetch data from the table: "supports" using primary key columns */
  supports_by_pk?: Maybe<Supports>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


/** subscription root */
export type Subscription_RootActivation_CodesArgs = {
  distinct_on?: Maybe<Array<Activation_Codes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Activation_Codes_Order_By>>;
  where?: Maybe<Activation_Codes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootActivation_Codes_AggregateArgs = {
  distinct_on?: Maybe<Array<Activation_Codes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Activation_Codes_Order_By>>;
  where?: Maybe<Activation_Codes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootActivation_Codes_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootAnswersArgs = {
  distinct_on?: Maybe<Array<Answers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Order_By>>;
  where?: Maybe<Answers_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAnswers_AggregateArgs = {
  distinct_on?: Maybe<Array<Answers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Order_By>>;
  where?: Maybe<Answers_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAnswers_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootAnswers_Choice_AssociationArgs = {
  distinct_on?: Maybe<Array<Answers_Choice_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Choice_Association_Order_By>>;
  where?: Maybe<Answers_Choice_Association_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAnswers_Choice_Association_AggregateArgs = {
  distinct_on?: Maybe<Array<Answers_Choice_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Answers_Choice_Association_Order_By>>;
  where?: Maybe<Answers_Choice_Association_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBillsArgs = {
  distinct_on?: Maybe<Array<Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bills_Order_By>>;
  where?: Maybe<Bills_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBills_AggregateArgs = {
  distinct_on?: Maybe<Array<Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bills_Order_By>>;
  where?: Maybe<Bills_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBills_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootBright_AssessmentArgs = {
  distinct_on?: Maybe<Array<Bright_Assessment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Assessment_Order_By>>;
  where?: Maybe<Bright_Assessment_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBright_Assessment_AggregateArgs = {
  distinct_on?: Maybe<Array<Bright_Assessment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Assessment_Order_By>>;
  where?: Maybe<Bright_Assessment_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBright_Assessment_By_PkArgs = {
  bright_assessment_id: Scalars['Int'];
  tester_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootBright_AssessmentsArgs = {
  distinct_on?: Maybe<Array<Bright_Assessments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Assessments_Order_By>>;
  where?: Maybe<Bright_Assessments_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBright_Assessments_AggregateArgs = {
  distinct_on?: Maybe<Array<Bright_Assessments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Assessments_Order_By>>;
  where?: Maybe<Bright_Assessments_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBright_Assessments_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootBright_BranchArgs = {
  distinct_on?: Maybe<Array<Bright_Branch_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Branch_Order_By>>;
  where?: Maybe<Bright_Branch_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBright_Branch_AggregateArgs = {
  distinct_on?: Maybe<Array<Bright_Branch_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Branch_Order_By>>;
  where?: Maybe<Bright_Branch_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBright_Branch_By_PkArgs = {
  institution_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootBright_CandidateArgs = {
  distinct_on?: Maybe<Array<Bright_Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Candidate_Order_By>>;
  where?: Maybe<Bright_Candidate_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBright_Candidate_AggregateArgs = {
  distinct_on?: Maybe<Array<Bright_Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Candidate_Order_By>>;
  where?: Maybe<Bright_Candidate_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBright_Candidate_By_PkArgs = {
  candidate_id: Scalars['Int'];
  manager_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootBright_ManagerArgs = {
  distinct_on?: Maybe<Array<Bright_Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Manager_Order_By>>;
  where?: Maybe<Bright_Manager_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBright_Manager_AggregateArgs = {
  distinct_on?: Maybe<Array<Bright_Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bright_Manager_Order_By>>;
  where?: Maybe<Bright_Manager_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBright_Manager_By_PkArgs = {
  manager_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootCategoriesArgs = {
  distinct_on?: Maybe<Array<Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Categories_Order_By>>;
  where?: Maybe<Categories_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCategories_AggregateArgs = {
  distinct_on?: Maybe<Array<Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Categories_Order_By>>;
  where?: Maybe<Categories_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCategories_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootChoicesArgs = {
  distinct_on?: Maybe<Array<Choices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Choices_Order_By>>;
  where?: Maybe<Choices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootChoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Choices_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Choices_Order_By>>;
  where?: Maybe<Choices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootChoices_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootCredits_LogArgs = {
  distinct_on?: Maybe<Array<Credits_Log_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credits_Log_Order_By>>;
  where?: Maybe<Credits_Log_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCredits_Log_AggregateArgs = {
  distinct_on?: Maybe<Array<Credits_Log_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Credits_Log_Order_By>>;
  where?: Maybe<Credits_Log_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCredits_Log_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootDiscount_CodesArgs = {
  distinct_on?: Maybe<Array<Discount_Codes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Codes_Order_By>>;
  where?: Maybe<Discount_Codes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDiscount_Codes_AggregateArgs = {
  distinct_on?: Maybe<Array<Discount_Codes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Discount_Codes_Order_By>>;
  where?: Maybe<Discount_Codes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDiscount_Codes_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootEstimated_ScoresArgs = {
  distinct_on?: Maybe<Array<Estimated_Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Estimated_Scores_Order_By>>;
  where?: Maybe<Estimated_Scores_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEstimated_Scores_AggregateArgs = {
  distinct_on?: Maybe<Array<Estimated_Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Estimated_Scores_Order_By>>;
  where?: Maybe<Estimated_Scores_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEstimated_Scores_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootExamsArgs = {
  distinct_on?: Maybe<Array<Exams_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Exams_Order_By>>;
  where?: Maybe<Exams_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootExams_AggregateArgs = {
  distinct_on?: Maybe<Array<Exams_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Exams_Order_By>>;
  where?: Maybe<Exams_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootExams_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootFeedbacksArgs = {
  distinct_on?: Maybe<Array<Feedbacks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Feedbacks_Order_By>>;
  where?: Maybe<Feedbacks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFeedbacks_AggregateArgs = {
  distinct_on?: Maybe<Array<Feedbacks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Feedbacks_Order_By>>;
  where?: Maybe<Feedbacks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFeedbacks_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootInstitutionsArgs = {
  distinct_on?: Maybe<Array<Institutions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Institutions_Order_By>>;
  where?: Maybe<Institutions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootInstitutions_AggregateArgs = {
  distinct_on?: Maybe<Array<Institutions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Institutions_Order_By>>;
  where?: Maybe<Institutions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootInstitutions_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootLessonsArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLessons_AggregateArgs = {
  distinct_on?: Maybe<Array<Lessons_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lessons_Order_By>>;
  where?: Maybe<Lessons_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLessons_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootPlansArgs = {
  distinct_on?: Maybe<Array<Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plans_Order_By>>;
  where?: Maybe<Plans_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPlans_AggregateArgs = {
  distinct_on?: Maybe<Array<Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Plans_Order_By>>;
  where?: Maybe<Plans_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPlans_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootProfile_Sphere_AssociationArgs = {
  distinct_on?: Maybe<Array<Profile_Sphere_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_Sphere_Association_Order_By>>;
  where?: Maybe<Profile_Sphere_Association_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootProfile_Sphere_Association_AggregateArgs = {
  distinct_on?: Maybe<Array<Profile_Sphere_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_Sphere_Association_Order_By>>;
  where?: Maybe<Profile_Sphere_Association_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootProfilesArgs = {
  distinct_on?: Maybe<Array<Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profiles_Order_By>>;
  where?: Maybe<Profiles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootProfiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profiles_Order_By>>;
  where?: Maybe<Profiles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootProfiles_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootQuestion_Lesson_AssociationArgs = {
  distinct_on?: Maybe<Array<Question_Lesson_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Question_Lesson_Association_Order_By>>;
  where?: Maybe<Question_Lesson_Association_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Lesson_Association_AggregateArgs = {
  distinct_on?: Maybe<Array<Question_Lesson_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Question_Lesson_Association_Order_By>>;
  where?: Maybe<Question_Lesson_Association_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestion_Lesson_Association_By_PkArgs = {
  lesson_id: Scalars['Int'];
  question_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootQuestionsArgs = {
  distinct_on?: Maybe<Array<Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Questions_Order_By>>;
  where?: Maybe<Questions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestions_AggregateArgs = {
  distinct_on?: Maybe<Array<Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Questions_Order_By>>;
  where?: Maybe<Questions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootQuestions_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootRegistration_BillingsArgs = {
  distinct_on?: Maybe<Array<Registration_Billings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registration_Billings_Order_By>>;
  where?: Maybe<Registration_Billings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRegistration_Billings_AggregateArgs = {
  distinct_on?: Maybe<Array<Registration_Billings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registration_Billings_Order_By>>;
  where?: Maybe<Registration_Billings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRegistration_Billings_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootRegistrationsArgs = {
  distinct_on?: Maybe<Array<Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registrations_Order_By>>;
  where?: Maybe<Registrations_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRegistrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Registrations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Registrations_Order_By>>;
  where?: Maybe<Registrations_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRegistrations_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootResult_Plan_AssociationArgs = {
  distinct_on?: Maybe<Array<Result_Plan_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Result_Plan_Association_Order_By>>;
  where?: Maybe<Result_Plan_Association_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootResult_Plan_Association_AggregateArgs = {
  distinct_on?: Maybe<Array<Result_Plan_Association_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Result_Plan_Association_Order_By>>;
  where?: Maybe<Result_Plan_Association_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootResult_Plan_Association_By_PkArgs = {
  plan_id: Scalars['Int'];
  result_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootResultsArgs = {
  distinct_on?: Maybe<Array<Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Results_Order_By>>;
  where?: Maybe<Results_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootResults_AggregateArgs = {
  distinct_on?: Maybe<Array<Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Results_Order_By>>;
  where?: Maybe<Results_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootResults_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootScoresArgs = {
  distinct_on?: Maybe<Array<Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scores_Order_By>>;
  where?: Maybe<Scores_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootScores_AggregateArgs = {
  distinct_on?: Maybe<Array<Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scores_Order_By>>;
  where?: Maybe<Scores_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootScores_By_PkArgs = {
  lesson_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootSpheresArgs = {
  distinct_on?: Maybe<Array<Spheres_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Spheres_Order_By>>;
  where?: Maybe<Spheres_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSpheres_AggregateArgs = {
  distinct_on?: Maybe<Array<Spheres_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Spheres_Order_By>>;
  where?: Maybe<Spheres_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSpheres_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootSupportsArgs = {
  distinct_on?: Maybe<Array<Supports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Supports_Order_By>>;
  where?: Maybe<Supports_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSupports_AggregateArgs = {
  distinct_on?: Maybe<Array<Supports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Supports_Order_By>>;
  where?: Maybe<Supports_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSupports_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['Int'];
};

/** columns and relationships of "supports" */
export type Supports = {
  __typename?: 'supports';
  /** An object relationship */
  exam?: Maybe<Exams>;
  exam_audio?: Maybe<Scalars['String']>;
  exam_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  lesson_id?: Maybe<Scalars['Int']>;
  part?: Maybe<Scalars['Int']>;
  /** An array relationship */
  questions: Array<Questions>;
  /** An aggregated array relationship */
  questions_aggregate: Questions_Aggregate;
  text?: Maybe<Scalars['String']>;
  training_audio?: Maybe<Scalars['String']>;
};


/** columns and relationships of "supports" */
export type SupportsQuestionsArgs = {
  distinct_on?: Maybe<Array<Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Questions_Order_By>>;
  where?: Maybe<Questions_Bool_Exp>;
};


/** columns and relationships of "supports" */
export type SupportsQuestions_AggregateArgs = {
  distinct_on?: Maybe<Array<Questions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Questions_Order_By>>;
  where?: Maybe<Questions_Bool_Exp>;
};

/** aggregated selection of "supports" */
export type Supports_Aggregate = {
  __typename?: 'supports_aggregate';
  aggregate?: Maybe<Supports_Aggregate_Fields>;
  nodes: Array<Supports>;
};

/** aggregate fields of "supports" */
export type Supports_Aggregate_Fields = {
  __typename?: 'supports_aggregate_fields';
  avg?: Maybe<Supports_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Supports_Max_Fields>;
  min?: Maybe<Supports_Min_Fields>;
  stddev?: Maybe<Supports_Stddev_Fields>;
  stddev_pop?: Maybe<Supports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supports_Stddev_Samp_Fields>;
  sum?: Maybe<Supports_Sum_Fields>;
  var_pop?: Maybe<Supports_Var_Pop_Fields>;
  var_samp?: Maybe<Supports_Var_Samp_Fields>;
  variance?: Maybe<Supports_Variance_Fields>;
};


/** aggregate fields of "supports" */
export type Supports_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Supports_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "supports" */
export type Supports_Aggregate_Order_By = {
  avg?: Maybe<Supports_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Supports_Max_Order_By>;
  min?: Maybe<Supports_Min_Order_By>;
  stddev?: Maybe<Supports_Stddev_Order_By>;
  stddev_pop?: Maybe<Supports_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Supports_Stddev_Samp_Order_By>;
  sum?: Maybe<Supports_Sum_Order_By>;
  var_pop?: Maybe<Supports_Var_Pop_Order_By>;
  var_samp?: Maybe<Supports_Var_Samp_Order_By>;
  variance?: Maybe<Supports_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supports" */
export type Supports_Arr_Rel_Insert_Input = {
  data: Array<Supports_Insert_Input>;
  on_conflict?: Maybe<Supports_On_Conflict>;
};

/** aggregate avg on columns */
export type Supports_Avg_Fields = {
  __typename?: 'supports_avg_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "supports" */
export type Supports_Avg_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supports". All fields are combined with a logical 'AND'. */
export type Supports_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Supports_Bool_Exp>>>;
  _not?: Maybe<Supports_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Supports_Bool_Exp>>>;
  exam?: Maybe<Exams_Bool_Exp>;
  exam_audio?: Maybe<String_Comparison_Exp>;
  exam_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  image?: Maybe<String_Comparison_Exp>;
  instructions?: Maybe<String_Comparison_Exp>;
  lesson_id?: Maybe<Int_Comparison_Exp>;
  part?: Maybe<Int_Comparison_Exp>;
  questions?: Maybe<Questions_Bool_Exp>;
  text?: Maybe<String_Comparison_Exp>;
  training_audio?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supports" */
export enum Supports_Constraint {
  /** unique or primary key constraint */
  SupportsPkey = 'supports_pkey'
}

/** input type for incrementing integer column in table "supports" */
export type Supports_Inc_Input = {
  exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lesson_id?: Maybe<Scalars['Int']>;
  part?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "supports" */
export type Supports_Insert_Input = {
  exam?: Maybe<Exams_Obj_Rel_Insert_Input>;
  exam_audio?: Maybe<Scalars['String']>;
  exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  lesson_id?: Maybe<Scalars['Int']>;
  part?: Maybe<Scalars['Int']>;
  questions?: Maybe<Questions_Arr_Rel_Insert_Input>;
  text?: Maybe<Scalars['String']>;
  training_audio?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Supports_Max_Fields = {
  __typename?: 'supports_max_fields';
  exam_audio?: Maybe<Scalars['String']>;
  exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  lesson_id?: Maybe<Scalars['Int']>;
  part?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  training_audio?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "supports" */
export type Supports_Max_Order_By = {
  exam_audio?: Maybe<Order_By>;
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  image?: Maybe<Order_By>;
  instructions?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  training_audio?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Supports_Min_Fields = {
  __typename?: 'supports_min_fields';
  exam_audio?: Maybe<Scalars['String']>;
  exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  lesson_id?: Maybe<Scalars['Int']>;
  part?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  training_audio?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "supports" */
export type Supports_Min_Order_By = {
  exam_audio?: Maybe<Order_By>;
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  image?: Maybe<Order_By>;
  instructions?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  training_audio?: Maybe<Order_By>;
};

/** response of any mutation on the table "supports" */
export type Supports_Mutation_Response = {
  __typename?: 'supports_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Supports>;
};

/** input type for inserting object relation for remote table "supports" */
export type Supports_Obj_Rel_Insert_Input = {
  data: Supports_Insert_Input;
  on_conflict?: Maybe<Supports_On_Conflict>;
};

/** on conflict condition type for table "supports" */
export type Supports_On_Conflict = {
  constraint: Supports_Constraint;
  update_columns: Array<Supports_Update_Column>;
  where?: Maybe<Supports_Bool_Exp>;
};

/** ordering options when selecting data from "supports" */
export type Supports_Order_By = {
  exam?: Maybe<Exams_Order_By>;
  exam_audio?: Maybe<Order_By>;
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  image?: Maybe<Order_By>;
  instructions?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
  questions_aggregate?: Maybe<Questions_Aggregate_Order_By>;
  text?: Maybe<Order_By>;
  training_audio?: Maybe<Order_By>;
};

/** primary key columns input for table: "supports" */
export type Supports_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "supports" */
export enum Supports_Select_Column {
  /** column name */
  ExamAudio = 'exam_audio',
  /** column name */
  ExamId = 'exam_id',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Instructions = 'instructions',
  /** column name */
  LessonId = 'lesson_id',
  /** column name */
  Part = 'part',
  /** column name */
  Text = 'text',
  /** column name */
  TrainingAudio = 'training_audio'
}

/** input type for updating data in table "supports" */
export type Supports_Set_Input = {
  exam_audio?: Maybe<Scalars['String']>;
  exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  lesson_id?: Maybe<Scalars['Int']>;
  part?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  training_audio?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Supports_Stddev_Fields = {
  __typename?: 'supports_stddev_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "supports" */
export type Supports_Stddev_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supports_Stddev_Pop_Fields = {
  __typename?: 'supports_stddev_pop_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "supports" */
export type Supports_Stddev_Pop_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supports_Stddev_Samp_Fields = {
  __typename?: 'supports_stddev_samp_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "supports" */
export type Supports_Stddev_Samp_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Supports_Sum_Fields = {
  __typename?: 'supports_sum_fields';
  exam_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lesson_id?: Maybe<Scalars['Int']>;
  part?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "supports" */
export type Supports_Sum_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
};

/** update columns of table "supports" */
export enum Supports_Update_Column {
  /** column name */
  ExamAudio = 'exam_audio',
  /** column name */
  ExamId = 'exam_id',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Instructions = 'instructions',
  /** column name */
  LessonId = 'lesson_id',
  /** column name */
  Part = 'part',
  /** column name */
  Text = 'text',
  /** column name */
  TrainingAudio = 'training_audio'
}

/** aggregate var_pop on columns */
export type Supports_Var_Pop_Fields = {
  __typename?: 'supports_var_pop_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "supports" */
export type Supports_Var_Pop_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supports_Var_Samp_Fields = {
  __typename?: 'supports_var_samp_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "supports" */
export type Supports_Var_Samp_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Supports_Variance_Fields = {
  __typename?: 'supports_variance_fields';
  exam_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lesson_id?: Maybe<Scalars['Float']>;
  part?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "supports" */
export type Supports_Variance_Order_By = {
  exam_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lesson_id?: Maybe<Order_By>;
  part?: Maybe<Order_By>;
};


/** expression to compare columns of type timestamp. All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
};


/** expression to compare columns of type timestamptz. All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  address?: Maybe<Scalars['String']>;
  /** An array relationship */
  bills: Array<Bills>;
  /** An aggregated array relationship */
  bills_aggregate: Bills_Aggregate;
  birth_year?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** An array relationship */
  estimated_scores: Array<Estimated_Scores>;
  /** An aggregated array relationship */
  estimated_scores_aggregate: Estimated_Scores_Aggregate;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_generated_password: Scalars['Boolean'];
  is_student?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  password_hash?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  /** An array relationship */
  profiles: Array<Profiles>;
  /** An aggregated array relationship */
  profiles_aggregate: Profiles_Aggregate;
  referral?: Maybe<Scalars['Int']>;
  reset_password_code?: Maybe<Scalars['String']>;
  /** An array relationship */
  results: Array<Results>;
  /** An aggregated array relationship */
  results_aggregate: Results_Aggregate;
  /** An array relationship */
  scores: Array<Scores>;
  /** An aggregated array relationship */
  scores_aggregate: Scores_Aggregate;
  token_id: Scalars['Int'];
  username?: Maybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersBillsArgs = {
  distinct_on?: Maybe<Array<Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bills_Order_By>>;
  where?: Maybe<Bills_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBills_AggregateArgs = {
  distinct_on?: Maybe<Array<Bills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Bills_Order_By>>;
  where?: Maybe<Bills_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEstimated_ScoresArgs = {
  distinct_on?: Maybe<Array<Estimated_Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Estimated_Scores_Order_By>>;
  where?: Maybe<Estimated_Scores_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEstimated_Scores_AggregateArgs = {
  distinct_on?: Maybe<Array<Estimated_Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Estimated_Scores_Order_By>>;
  where?: Maybe<Estimated_Scores_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProfilesArgs = {
  distinct_on?: Maybe<Array<Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profiles_Order_By>>;
  where?: Maybe<Profiles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProfiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Profiles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profiles_Order_By>>;
  where?: Maybe<Profiles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersResultsArgs = {
  distinct_on?: Maybe<Array<Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Results_Order_By>>;
  where?: Maybe<Results_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersResults_AggregateArgs = {
  distinct_on?: Maybe<Array<Results_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Results_Order_By>>;
  where?: Maybe<Results_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersScoresArgs = {
  distinct_on?: Maybe<Array<Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scores_Order_By>>;
  where?: Maybe<Scores_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersScores_AggregateArgs = {
  distinct_on?: Maybe<Array<Scores_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Scores_Order_By>>;
  where?: Maybe<Scores_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: Maybe<Users_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Users_Max_Order_By>;
  min?: Maybe<Users_Min_Order_By>;
  stddev?: Maybe<Users_Stddev_Order_By>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Order_By>;
  sum?: Maybe<Users_Sum_Order_By>;
  var_pop?: Maybe<Users_Var_Pop_Order_By>;
  var_samp?: Maybe<Users_Var_Samp_Order_By>;
  variance?: Maybe<Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  birth_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  referral?: Maybe<Scalars['Float']>;
  token_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  birth_year?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  referral?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Users_Bool_Exp>>>;
  _not?: Maybe<Users_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Users_Bool_Exp>>>;
  address?: Maybe<String_Comparison_Exp>;
  bills?: Maybe<Bills_Bool_Exp>;
  birth_year?: Maybe<Int_Comparison_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  estimated_scores?: Maybe<Estimated_Scores_Bool_Exp>;
  first_name?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_generated_password?: Maybe<Boolean_Comparison_Exp>;
  is_student?: Maybe<Boolean_Comparison_Exp>;
  last_name?: Maybe<String_Comparison_Exp>;
  password_hash?: Maybe<String_Comparison_Exp>;
  postal_code?: Maybe<String_Comparison_Exp>;
  profiles?: Maybe<Profiles_Bool_Exp>;
  referral?: Maybe<Int_Comparison_Exp>;
  reset_password_code?: Maybe<String_Comparison_Exp>;
  results?: Maybe<Results_Bool_Exp>;
  scores?: Maybe<Scores_Bool_Exp>;
  token_id?: Maybe<Int_Comparison_Exp>;
  username?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint */
  UsersPkey = 'users_pkey',
  /** unique or primary key constraint */
  UsersUsernameKey = 'users_username_key'
}

/** input type for incrementing integer column in table "users" */
export type Users_Inc_Input = {
  birth_year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  referral?: Maybe<Scalars['Int']>;
  token_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  address?: Maybe<Scalars['String']>;
  bills?: Maybe<Bills_Arr_Rel_Insert_Input>;
  birth_year?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  estimated_scores?: Maybe<Estimated_Scores_Arr_Rel_Insert_Input>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_generated_password?: Maybe<Scalars['Boolean']>;
  is_student?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  password_hash?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  profiles?: Maybe<Profiles_Arr_Rel_Insert_Input>;
  referral?: Maybe<Scalars['Int']>;
  reset_password_code?: Maybe<Scalars['String']>;
  results?: Maybe<Results_Arr_Rel_Insert_Input>;
  scores?: Maybe<Scores_Arr_Rel_Insert_Input>;
  token_id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  address?: Maybe<Scalars['String']>;
  birth_year?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  password_hash?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  referral?: Maybe<Scalars['Int']>;
  reset_password_code?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  address?: Maybe<Order_By>;
  birth_year?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  password_hash?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  referral?: Maybe<Order_By>;
  reset_password_code?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
  username?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  address?: Maybe<Scalars['String']>;
  birth_year?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  password_hash?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  referral?: Maybe<Scalars['Int']>;
  reset_password_code?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  address?: Maybe<Order_By>;
  birth_year?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  password_hash?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  referral?: Maybe<Order_By>;
  reset_password_code?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
  username?: Maybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** on conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns: Array<Users_Update_Column>;
  where?: Maybe<Users_Bool_Exp>;
};

/** ordering options when selecting data from "users" */
export type Users_Order_By = {
  address?: Maybe<Order_By>;
  bills_aggregate?: Maybe<Bills_Aggregate_Order_By>;
  birth_year?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  estimated_scores_aggregate?: Maybe<Estimated_Scores_Aggregate_Order_By>;
  first_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_generated_password?: Maybe<Order_By>;
  is_student?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  password_hash?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  profiles_aggregate?: Maybe<Profiles_Aggregate_Order_By>;
  referral?: Maybe<Order_By>;
  reset_password_code?: Maybe<Order_By>;
  results_aggregate?: Maybe<Results_Aggregate_Order_By>;
  scores_aggregate?: Maybe<Scores_Aggregate_Order_By>;
  token_id?: Maybe<Order_By>;
  username?: Maybe<Order_By>;
};

/** primary key columns input for table: "users" */
export type Users_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  BirthYear = 'birth_year',
  /** column name */
  City = 'city',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsGeneratedPassword = 'is_generated_password',
  /** column name */
  IsStudent = 'is_student',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Referral = 'referral',
  /** column name */
  ResetPasswordCode = 'reset_password_code',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  address?: Maybe<Scalars['String']>;
  birth_year?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_generated_password?: Maybe<Scalars['Boolean']>;
  is_student?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  password_hash?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  referral?: Maybe<Scalars['Int']>;
  reset_password_code?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  birth_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  referral?: Maybe<Scalars['Float']>;
  token_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  birth_year?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  referral?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  birth_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  referral?: Maybe<Scalars['Float']>;
  token_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  birth_year?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  referral?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  birth_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  referral?: Maybe<Scalars['Float']>;
  token_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  birth_year?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  referral?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  birth_year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  referral?: Maybe<Scalars['Int']>;
  token_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  birth_year?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  referral?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  BirthYear = 'birth_year',
  /** column name */
  City = 'city',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsGeneratedPassword = 'is_generated_password',
  /** column name */
  IsStudent = 'is_student',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Referral = 'referral',
  /** column name */
  ResetPasswordCode = 'reset_password_code',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  Username = 'username'
}

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  birth_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  referral?: Maybe<Scalars['Float']>;
  token_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  birth_year?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  referral?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  birth_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  referral?: Maybe<Scalars['Float']>;
  token_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  birth_year?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  referral?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  birth_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  referral?: Maybe<Scalars['Float']>;
  token_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  birth_year?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  referral?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
};

export type GetAllInstitutionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInstitutionsQuery = (
  { __typename?: 'query_root' }
  & { institutions: Array<(
    { __typename?: 'institutions' }
    & Pick<Institutions, 'name' | 'id' | 'credits' | 'logo' | 'exams' | 'slug' | 'credit_duration'>
    & { credits_logs: Array<(
      { __typename?: 'credits_log' }
      & Pick<Credits_Log, 'billed_at' | 'created_at' | 'created_by' | 'credits' | 'id' | 'info' | 'institution_id'>
      & { institution: (
        { __typename?: 'institutions' }
        & Pick<Institutions, 'id' | 'name' | 'credits'>
      ), profile: (
        { __typename?: 'profiles' }
        & { user: (
          { __typename?: 'users' }
          & Pick<Users, 'email'>
        ) }
      ) }
    )> }
  )> }
);

export type GetAllInstitutionsByExamQueryVariables = Exact<{
  exam: Scalars['String'];
}>;


export type GetAllInstitutionsByExamQuery = (
  { __typename?: 'query_root' }
  & { institutions: Array<(
    { __typename?: 'institutions' }
    & Pick<Institutions, 'name' | 'id' | 'credits' | 'logo' | 'exams' | 'slug' | 'is_root_institution' | 'parent_institution_id' | 'credit_duration'>
    & { parent_institution?: Maybe<(
      { __typename?: 'institutions' }
      & Pick<Institutions, 'name'>
    )>, credits_logs: Array<(
      { __typename?: 'credits_log' }
      & Pick<Credits_Log, 'billed_at' | 'created_at' | 'created_by' | 'credits' | 'id' | 'info' | 'institution_id'>
      & { institution: (
        { __typename?: 'institutions' }
        & Pick<Institutions, 'id' | 'name' | 'credits'>
      ), profile: (
        { __typename?: 'profiles' }
        & { user: (
          { __typename?: 'users' }
          & Pick<Users, 'email'>
        ) }
      ) }
    )>, subInstitutions: Array<(
      { __typename?: 'institutions' }
      & Pick<Institutions, 'id'>
    )> }
  )> }
);

export type GetRegistrationBillingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegistrationBillingsQuery = (
  { __typename?: 'query_root' }
  & { registration_billings: Array<(
    { __typename?: 'registration_billings' }
    & Pick<Registration_Billings, 'created_at' | 'created_by' | 'id' | 'info' | 'institution_id' | 'updated_at'>
    & { institution: (
      { __typename?: 'institutions' }
      & Pick<Institutions, 'name'>
    ), profile: (
      { __typename?: 'profiles' }
      & { user: (
        { __typename?: 'users' }
        & Pick<Users, 'email'>
      ) }
    ), registrations_aggregate: (
      { __typename?: 'registrations_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'registrations_aggregate_fields' }
        & Pick<Registrations_Aggregate_Fields, 'count'>
      )> }
    ) }
  )> }
);

export type GetRegistrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegistrationsQuery = (
  { __typename?: 'query_root' }
  & { registrations: Array<(
    { __typename?: 'registrations' }
    & Pick<Registrations, 'level' | 'registration_billing_id' | 'institution_id'>
    & { institution: (
      { __typename?: 'institutions' }
      & Pick<Institutions, 'parent_institution_id'>
    ) }
  )> }
);

export type UpdateRegistrationByRegistrationBillingIdMutationVariables = Exact<{
  registrationBillingId: Scalars['Int'];
  registrationsIds: Array<Scalars['Int']>;
}>;


export type UpdateRegistrationByRegistrationBillingIdMutation = (
  { __typename?: 'mutation_root' }
  & { update_registrations?: Maybe<(
    { __typename?: 'registrations_mutation_response' }
    & Pick<Registrations_Mutation_Response, 'affected_rows'>
  )> }
);

export type GetAnswersQueryVariables = Exact<{
  exam: Scalars['exam_types'];
  supportParts: Array<Scalars['Int']>;
  institutionId: Scalars['Int'];
  profileIds: Array<Scalars['Int']>;
}>;


export type GetAnswersQuery = (
  { __typename?: 'query_root' }
  & { answers: Array<(
    { __typename?: 'answers' }
    & Pick<Answers, 'extra_value' | 'id' | 'feedback_by' | 'feedback_at' | 'feedback_score' | 'feedback' | 'result_id' | 'is_mock' | 'created_at'>
    & { result?: Maybe<(
      { __typename?: 'results' }
      & Pick<Results, 'listening_score' | 'oral_score' | 'writing_score' | 'reading_score'>
    )>, user: (
      { __typename?: 'users' }
      & Pick<Users, 'first_name' | 'last_name' | 'email'>
    ), question: (
      { __typename?: 'questions' }
      & Pick<Questions, 'value'>
      & { support: (
        { __typename?: 'supports' }
        & Pick<Supports, 'part' | 'id'>
        & { exam?: Maybe<(
          { __typename?: 'exams' }
          & Pick<Exams, 'level'>
        )> }
      ) }
    ) }
  )> }
);

export type GetAnswersByProfileIdQueryVariables = Exact<{
  exam: Scalars['exam_types'];
  supportParts: Array<Scalars['Int']>;
  profileId: Scalars['Int'];
}>;


export type GetAnswersByProfileIdQuery = (
  { __typename?: 'query_root' }
  & { answers: Array<(
    { __typename?: 'answers' }
    & Pick<Answers, 'extra_value' | 'id' | 'is_mock' | 'result_id' | 'feedback_by' | 'feedback_at' | 'feedback_score' | 'feedback' | 'created_at'>
    & { question: (
      { __typename?: 'questions' }
      & Pick<Questions, 'value'>
      & { support: (
        { __typename?: 'supports' }
        & Pick<Supports, 'part' | 'id'>
        & { exam?: Maybe<(
          { __typename?: 'exams' }
          & Pick<Exams, 'level'>
        )> }
      ) }
    ) }
  )> }
);

export type GetLightAnswersByResultIdQueryVariables = Exact<{
  resultId: Scalars['Int'];
}>;


export type GetLightAnswersByResultIdQuery = (
  { __typename?: 'query_root' }
  & { answers: Array<(
    { __typename?: 'answers' }
    & Pick<Answers, 'feedback_score' | 'part' | 'id'>
  )> }
);

export type GetUserWithProfilesByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type GetUserWithProfilesByUsernameQuery = (
  { __typename?: 'query_root' }
  & { users: Array<(
    { __typename?: 'users' }
    & Pick<Users, 'address' | 'birth_year' | 'city' | 'email' | 'first_name' | 'id' | 'is_student' | 'last_name' | 'password_hash' | 'postal_code'>
    & { profiles: Array<(
      { __typename?: 'profiles' }
      & Pick<Profiles, 'institution_id' | 'is_teacher' | 'is_manager' | 'exam_type' | 'id' | 'user_id' | 'expiration_date' | 'is_admin'>
    )> }
  )> }
);

export type Get_Bright_Assessment_By_PkQueryVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type Get_Bright_Assessment_By_PkQuery = (
  { __typename?: 'query_root' }
  & { bright_assessment: Array<(
    { __typename?: 'bright_assessment' }
    & Pick<Bright_Assessment, 'assessments_id' | 'bright_assessment_id' | 'id' | 'tester_id'>
    & { bright_assessment: (
      { __typename?: 'bright_assessments' }
      & Pick<Bright_Assessments, 'createdDate' | 'endDate' | 'id' | 'institutionId' | 'openedDate' | 'teacherId' | 'title'>
    ) }
  )> }
);

export type Get_Bright_Assessments_And_Teacher_IdQueryVariables = Exact<{
  teacherId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type Get_Bright_Assessments_And_Teacher_IdQuery = (
  { __typename?: 'query_root' }
  & { bright_assessments: Array<(
    { __typename?: 'bright_assessments' }
    & Pick<Bright_Assessments, 'teacherId' | 'openedDate' | 'institutionId' | 'id' | 'title' | 'endDate'>
    & { bright_assessments: Array<(
      { __typename?: 'bright_assessment' }
      & Pick<Bright_Assessment, 'id' | 'assessments_id' | 'bright_assessment_id'>
      & { profile: (
        { __typename?: 'profiles' }
        & Pick<Profiles, 'user_id' | 'time_spent' | 'objective' | 'last_time_spent_update' | 'is_teacher' | 'is_manager' | 'institution_id' | 'id' | 'expiration_date' | 'exam_type' | 'current_exam_id'>
        & { user: (
          { __typename?: 'users' }
          & Pick<Users, 'email' | 'first_name' | 'last_name' | 'username'>
        ) }
      ) }
    )> }
  )> }
);

export type GetFullProfilesByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetFullProfilesByIdQuery = (
  { __typename?: 'query_root' }
  & { profiles_by_pk?: Maybe<(
    { __typename?: 'profiles' }
    & Pick<Profiles, 'current_exam_id' | 'exam_type' | 'expiration_date' | 'id' | 'is_manager' | 'is_teacher' | 'last_time_spent_update' | 'objective' | 'time_spent'>
    & { institution?: Maybe<(
      { __typename?: 'institutions' }
      & Pick<Institutions, 'id' | 'logo' | 'name'>
      & { bright_branch?: Maybe<(
        { __typename?: 'bright_branch' }
        & Pick<Bright_Branch, 'bright_branch_id'>
      )> }
    )>, user: (
      { __typename?: 'users' }
      & Pick<Users, 'first_name' | 'last_name' | 'email'>
    ), bright_candidates: Array<(
      { __typename?: 'bright_candidate' }
      & Pick<Bright_Candidate, 'bright_candidate_id' | 'manager_id'>
    )>, bright_manager?: Maybe<(
      { __typename?: 'bright_manager' }
      & Pick<Bright_Manager, 'bright_manager_id'>
    )> }
  )> }
);

export type InsertBrightBranchMutationVariables = Exact<{
  brightBranchId: Scalars['Int'];
  institutionId: Scalars['Int'];
}>;


export type InsertBrightBranchMutation = (
  { __typename?: 'mutation_root' }
  & { insert_bright_branch?: Maybe<(
    { __typename?: 'bright_branch_mutation_response' }
    & { returning: Array<(
      { __typename?: 'bright_branch' }
      & Pick<Bright_Branch, 'institution_id' | 'bright_branch_id'>
    )> }
  )> }
);

export type InsertBrightCandidateMutationVariables = Exact<{
  brightCandidateId: Scalars['Int'];
  candidateId: Scalars['Int'];
  managerId: Scalars['Int'];
}>;


export type InsertBrightCandidateMutation = (
  { __typename?: 'mutation_root' }
  & { insert_bright_candidate?: Maybe<(
    { __typename?: 'bright_candidate_mutation_response' }
    & { returning: Array<(
      { __typename?: 'bright_candidate' }
      & Pick<Bright_Candidate, 'bright_candidate_id' | 'candidate_id' | 'manager_id'>
    )> }
  )> }
);

export type InsertBrightManagerMutationVariables = Exact<{
  brightManagerId: Scalars['Int'];
  managerId: Scalars['Int'];
}>;


export type InsertBrightManagerMutation = (
  { __typename?: 'mutation_root' }
  & { insert_bright_manager?: Maybe<(
    { __typename?: 'bright_manager_mutation_response' }
    & { returning: Array<(
      { __typename?: 'bright_manager' }
      & Pick<Bright_Manager, 'bright_manager_id' | 'manager_id'>
    )> }
  )> }
);

export type Update_Bright_AssessmentMutationVariables = Exact<{
  id: Scalars['Int'];
  assessment_id: Scalars['Int'];
}>;


export type Update_Bright_AssessmentMutation = (
  { __typename?: 'mutation_root' }
  & { update_bright_assessment?: Maybe<(
    { __typename?: 'bright_assessment_mutation_response' }
    & { returning: Array<(
      { __typename?: 'bright_assessment' }
      & Pick<Bright_Assessment, 'assessments_id' | 'bright_assessment_id' | 'id' | 'tester_id'>
    )> }
  )> }
);

export type GetActivationCodeByCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetActivationCodeByCodeQuery = (
  { __typename?: 'query_root' }
  & { activation_codes: Array<(
    { __typename?: 'activation_codes' }
    & Pick<Activation_Codes, 'activated_by' | 'activation_date' | 'code' | 'extra_days' | 'id' | 'type'>
  )> }
);

export type GetCouponsByProfileIdQueryVariables = Exact<{
  profileId: Scalars['Int'];
}>;


export type GetCouponsByProfileIdQuery = (
  { __typename: 'query_root' }
  & { activation_codes: Array<(
    { __typename?: 'activation_codes' }
    & Pick<Activation_Codes, 'activation_date' | 'activated_by' | 'code' | 'id' | 'type'>
  )> }
);

export type InsertCouponByProfileIdMutationVariables = Exact<{
  profileId: Scalars['Int'];
  activationDate: Scalars['timestamp'];
  promoCode: Scalars['String'];
  type: Scalars['String'];
}>;


export type InsertCouponByProfileIdMutation = (
  { __typename: 'mutation_root' }
  & { insert_activation_codes?: Maybe<(
    { __typename?: 'activation_codes_mutation_response' }
    & { returning: Array<(
      { __typename?: 'activation_codes' }
      & Pick<Activation_Codes, 'activated_by' | 'activation_date' | 'code' | 'id' | 'type'>
    )> }
  )> }
);

export type UpdateActivationCodesByIdMutationVariables = Exact<{
  id: Scalars['Int'];
  object: Activation_Codes_Set_Input;
}>;


export type UpdateActivationCodesByIdMutation = (
  { __typename: 'mutation_root' }
  & { update_activation_codes?: Maybe<(
    { __typename?: 'activation_codes_mutation_response' }
    & Pick<Activation_Codes_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename?: 'activation_codes' }
      & Pick<Activation_Codes, 'activated_by' | 'activation_date' | 'code' | 'extra_days' | 'id' | 'type'>
    )> }
  )> }
);

export type GetCreditsLogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditsLogQuery = (
  { __typename?: 'query_root' }
  & { credits_log: Array<(
    { __typename?: 'credits_log' }
    & Pick<Credits_Log, 'billed_at' | 'created_at' | 'created_by' | 'credits' | 'id' | 'info' | 'institution_id'>
    & { institution: (
      { __typename?: 'institutions' }
      & Pick<Institutions, 'name'>
    ), profile: (
      { __typename?: 'profiles' }
      & { user: (
        { __typename?: 'users' }
        & Pick<Users, 'email'>
      ) }
    ) }
  )> }
);

export type GetInstitutionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstitutionsQuery = (
  { __typename?: 'query_root' }
  & { institutions: Array<(
    { __typename?: 'institutions' }
    & Pick<Institutions, 'credits' | 'id' | 'logo' | 'name' | 'slug' | 'credit_duration'>
  )> }
);

export type GetSubInstitutionsByPkQueryVariables = Exact<{
  institutionPk: Scalars['Int'];
}>;


export type GetSubInstitutionsByPkQuery = (
  { __typename?: 'query_root' }
  & { institutions_by_pk?: Maybe<(
    { __typename?: 'institutions' }
    & { subInstitutions: Array<(
      { __typename?: 'institutions' }
      & Pick<Institutions, 'name' | 'id' | 'credits' | 'logo' | 'slug' | 'credit_duration'>
      & { registrations: Array<(
        { __typename?: 'registrations' }
        & Pick<Registrations, 'id' | 'created_by' | 'email' | 'created_at' | 'duration' | 'level'>
        & { creator?: Maybe<(
          { __typename?: 'users' }
          & Pick<Users, 'email'>
        )> }
      )> }
    )> }
  )> }
);

export type GetProfileByProfileIdQueryVariables = Exact<{
  profileId: Scalars['Int'];
}>;


export type GetProfileByProfileIdQuery = (
  { __typename: 'query_root' }
  & { profiles: Array<(
    { __typename?: 'profiles' }
    & Pick<Profiles, 'expiration_date' | 'last_time_spent_update' | 'objective' | 'id' | 'time_spent' | 'institution_id' | 'exam_type' | 'is_manager' | 'is_teacher'>
    & { user: (
      { __typename?: 'users' }
      & Pick<Users, 'address' | 'birth_year' | 'city' | 'email' | 'first_name' | 'id' | 'is_student' | 'last_name'>
      & { profiles: Array<(
        { __typename?: 'profiles' }
        & Pick<Profiles, 'expiration_date'>
      )> }
    ), estimated_scores: Array<(
      { __typename?: 'estimated_scores' }
      & Pick<Estimated_Scores, 'score' | 'created_at' | 'exam_type'>
    )>, answers_aggregate: (
      { __typename?: 'answers_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'answers_aggregate_fields' }
        & Pick<Answers_Aggregate_Fields, 'count'>
      )> }
    ), activation_codes: Array<(
      { __typename?: 'activation_codes' }
      & Pick<Activation_Codes, 'activated_by' | 'activation_date' | 'code' | 'id' | 'type'>
    )>, bills: Array<(
      { __typename?: 'bills' }
      & Pick<Bills, 'days' | 'date'>
    )> }
  )> }
);

export type GetSpheresFromProfileIdQueryVariables = Exact<{
  profileId: Scalars['Int'];
}>;


export type GetSpheresFromProfileIdQuery = (
  { __typename?: 'query_root' }
  & { profile_sphere_association: Array<(
    { __typename?: 'profile_sphere_association' }
    & { sphere?: Maybe<(
      { __typename?: 'spheres' }
      & Pick<Spheres, 'name' | 'is_global' | 'teacher_id'>
    )> }
  )> }
);

export type Update_ProfilesForExpirationDateMutationVariables = Exact<{
  id: Scalars['Int'];
  expirationDate: Scalars['timestamp'];
}>;


export type Update_ProfilesForExpirationDateMutation = (
  { __typename: 'mutation_root' }
  & { update_profiles?: Maybe<(
    { __typename?: 'profiles_mutation_response' }
    & { returning: Array<(
      { __typename?: 'profiles' }
      & Pick<Profiles, 'id' | 'expiration_date'>
    )> }
  )> }
);

export type GetAnswersFromResultsByPkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetAnswersFromResultsByPkQuery = (
  { __typename?: 'query_root' }
  & { results_by_pk?: Maybe<(
    { __typename?: 'results' }
    & Pick<Results, 'listening_score' | 'reading_score' | 'score'>
    & { answers: Array<(
      { __typename?: 'answers' }
      & Pick<Answers, 'created_at' | 'exam_type' | 'extra_value' | 'is_correct' | 'is_mock' | 'question_id' | 'part'>
    )> }
  )> }
);

export type GetStudentsProfileByInstitudionIdQueryVariables = Exact<{
  institutionId: Scalars['Int'];
  examType: Scalars['exam_types'];
}>;


export type GetStudentsProfileByInstitudionIdQuery = (
  { __typename: 'query_root' }
  & { profiles: Array<(
    { __typename?: 'profiles' }
    & Pick<Profiles, 'expiration_date' | 'last_time_spent_update' | 'objective' | 'time_spent' | 'level'>
    & { user: (
      { __typename?: 'users' }
      & Pick<Users, 'address' | 'birth_year' | 'city' | 'email' | 'first_name' | 'id' | 'is_student' | 'last_name'>
      & { profiles: Array<(
        { __typename?: 'profiles' }
        & Pick<Profiles, 'expiration_date' | 'last_time_spent_update'>
      )> }
    ), estimated_scores: Array<(
      { __typename?: 'estimated_scores' }
      & Pick<Estimated_Scores, 'score' | 'created_at' | 'exam_type'>
    )>, manual_estimated_scores: Array<(
      { __typename?: 'estimated_scores' }
      & Pick<Estimated_Scores, 'score' | 'created_at' | 'exam_type'>
    )>, answers_aggregate: (
      { __typename?: 'answers_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'answers_aggregate_fields' }
        & Pick<Answers_Aggregate_Fields, 'count'>
      )> }
    ) }
  )> }
);

export type GetStudentsProfileByInstitudionIdAndSphereQueryVariables = Exact<{
  institutionId: Scalars['Int'];
  examType: Scalars['exam_types'];
  sphereId: Scalars['Int'];
}>;


export type GetStudentsProfileByInstitudionIdAndSphereQuery = (
  { __typename: 'query_root' }
  & { profiles: Array<(
    { __typename?: 'profiles' }
    & Pick<Profiles, 'expiration_date' | 'last_time_spent_update' | 'objective' | 'time_spent' | 'level'>
    & { user: (
      { __typename?: 'users' }
      & Pick<Users, 'address' | 'birth_year' | 'city' | 'email' | 'first_name' | 'id' | 'is_student' | 'last_name'>
      & { profiles: Array<(
        { __typename?: 'profiles' }
        & Pick<Profiles, 'expiration_date' | 'last_time_spent_update'>
      )> }
    ), estimated_scores: Array<(
      { __typename?: 'estimated_scores' }
      & Pick<Estimated_Scores, 'score' | 'created_at' | 'exam_type'>
    )>, manual_estimated_scores: Array<(
      { __typename?: 'estimated_scores' }
      & Pick<Estimated_Scores, 'score' | 'created_at' | 'exam_type'>
    )>, answers_aggregate: (
      { __typename?: 'answers_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'answers_aggregate_fields' }
        & Pick<Answers_Aggregate_Fields, 'count'>
      )> }
    ) }
  )> }
);

export type GetStudentProfileByInstitudionIdAndProfileIdQueryVariables = Exact<{
  institutionId: Scalars['Int'];
  profileId: Scalars['Int'];
  examType: Scalars['exam_types'];
}>;


export type GetStudentProfileByInstitudionIdAndProfileIdQuery = (
  { __typename: 'query_root' }
  & { profiles: Array<(
    { __typename?: 'profiles' }
    & Pick<Profiles, 'expiration_date' | 'last_time_spent_update' | 'objective' | 'time_spent'>
    & { user: (
      { __typename?: 'users' }
      & Pick<Users, 'address' | 'birth_year' | 'city' | 'email' | 'first_name' | 'id' | 'is_student' | 'last_name'>
      & { profiles: Array<(
        { __typename?: 'profiles' }
        & Pick<Profiles, 'expiration_date' | 'last_time_spent_update'>
      )>, scores: Array<(
        { __typename?: 'scores' }
        & Pick<Scores, 'id' | 'known_date'>
        & { lesson: (
          { __typename?: 'lessons' }
          & Pick<Lessons, 'title'>
        ) }
      )> }
    ), estimated_scores: Array<(
      { __typename?: 'estimated_scores' }
      & Pick<Estimated_Scores, 'score' | 'created_at' | 'exam_type'>
    )>, manual_estimated_scores: Array<(
      { __typename?: 'estimated_scores' }
      & Pick<Estimated_Scores, 'score' | 'created_at' | 'exam_type'>
    )>, answers_aggregate: (
      { __typename?: 'answers_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'answers_aggregate_fields' }
        & Pick<Answers_Aggregate_Fields, 'count'>
      )> }
    ), institution?: Maybe<(
      { __typename?: 'institutions' }
      & Pick<Institutions, 'logo'>
    )>, answers: Array<(
      { __typename?: 'answers' }
      & Pick<Answers, 'created_at'>
    )> }
  )> }
);

export type GetSupportByPkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetSupportByPkQuery = (
  { __typename?: 'query_root' }
  & { supports_by_pk?: Maybe<(
    { __typename?: 'supports' }
    & Pick<Supports, 'exam_audio' | 'exam_id' | 'id' | 'image' | 'instructions' | 'part' | 'text' | 'training_audio'>
    & { exam?: Maybe<(
      { __typename?: 'exams' }
      & Pick<Exams, 'level'>
    )>, questions: Array<(
      { __typename?: 'questions' }
      & Pick<Questions, 'correction' | 'id' | 'text' | 'value'>
      & { choices: Array<(
        { __typename?: 'choices' }
        & Pick<Choices, 'id' | 'image' | 'is_correct' | 'question_id' | 'text'>
      )> }
    )> }
  )> }
);



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> = LegacyStitchingResolver<TResult, TParent, TContext, TArgs> | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  String: ResolverTypeWrapper<Scalars['String']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Boolean_comparison_exp: Boolean_Comparison_Exp;
  Float_comparison_exp: Float_Comparison_Exp;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Int_comparison_exp: Int_Comparison_Exp;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  String_comparison_exp: String_Comparison_Exp;
  activation_codes: ResolverTypeWrapper<Activation_Codes>;
  activation_codes_aggregate: ResolverTypeWrapper<Activation_Codes_Aggregate>;
  activation_codes_aggregate_fields: ResolverTypeWrapper<Activation_Codes_Aggregate_Fields>;
  activation_codes_aggregate_order_by: Activation_Codes_Aggregate_Order_By;
  activation_codes_arr_rel_insert_input: Activation_Codes_Arr_Rel_Insert_Input;
  activation_codes_avg_fields: ResolverTypeWrapper<Activation_Codes_Avg_Fields>;
  activation_codes_avg_order_by: Activation_Codes_Avg_Order_By;
  activation_codes_bool_exp: Activation_Codes_Bool_Exp;
  activation_codes_constraint: Activation_Codes_Constraint;
  activation_codes_inc_input: Activation_Codes_Inc_Input;
  activation_codes_insert_input: Activation_Codes_Insert_Input;
  activation_codes_max_fields: ResolverTypeWrapper<Activation_Codes_Max_Fields>;
  activation_codes_max_order_by: Activation_Codes_Max_Order_By;
  activation_codes_min_fields: ResolverTypeWrapper<Activation_Codes_Min_Fields>;
  activation_codes_min_order_by: Activation_Codes_Min_Order_By;
  activation_codes_mutation_response: ResolverTypeWrapper<Activation_Codes_Mutation_Response>;
  activation_codes_obj_rel_insert_input: Activation_Codes_Obj_Rel_Insert_Input;
  activation_codes_on_conflict: Activation_Codes_On_Conflict;
  activation_codes_order_by: Activation_Codes_Order_By;
  activation_codes_pk_columns_input: Activation_Codes_Pk_Columns_Input;
  activation_codes_select_column: Activation_Codes_Select_Column;
  activation_codes_set_input: Activation_Codes_Set_Input;
  activation_codes_stddev_fields: ResolverTypeWrapper<Activation_Codes_Stddev_Fields>;
  activation_codes_stddev_order_by: Activation_Codes_Stddev_Order_By;
  activation_codes_stddev_pop_fields: ResolverTypeWrapper<Activation_Codes_Stddev_Pop_Fields>;
  activation_codes_stddev_pop_order_by: Activation_Codes_Stddev_Pop_Order_By;
  activation_codes_stddev_samp_fields: ResolverTypeWrapper<Activation_Codes_Stddev_Samp_Fields>;
  activation_codes_stddev_samp_order_by: Activation_Codes_Stddev_Samp_Order_By;
  activation_codes_sum_fields: ResolverTypeWrapper<Activation_Codes_Sum_Fields>;
  activation_codes_sum_order_by: Activation_Codes_Sum_Order_By;
  activation_codes_update_column: Activation_Codes_Update_Column;
  activation_codes_var_pop_fields: ResolverTypeWrapper<Activation_Codes_Var_Pop_Fields>;
  activation_codes_var_pop_order_by: Activation_Codes_Var_Pop_Order_By;
  activation_codes_var_samp_fields: ResolverTypeWrapper<Activation_Codes_Var_Samp_Fields>;
  activation_codes_var_samp_order_by: Activation_Codes_Var_Samp_Order_By;
  activation_codes_variance_fields: ResolverTypeWrapper<Activation_Codes_Variance_Fields>;
  activation_codes_variance_order_by: Activation_Codes_Variance_Order_By;
  answers: ResolverTypeWrapper<Answers>;
  answers_aggregate: ResolverTypeWrapper<Answers_Aggregate>;
  answers_aggregate_fields: ResolverTypeWrapper<Answers_Aggregate_Fields>;
  answers_aggregate_order_by: Answers_Aggregate_Order_By;
  answers_arr_rel_insert_input: Answers_Arr_Rel_Insert_Input;
  answers_avg_fields: ResolverTypeWrapper<Answers_Avg_Fields>;
  answers_avg_order_by: Answers_Avg_Order_By;
  answers_bool_exp: Answers_Bool_Exp;
  answers_choice_association: ResolverTypeWrapper<Answers_Choice_Association>;
  answers_choice_association_aggregate: ResolverTypeWrapper<Answers_Choice_Association_Aggregate>;
  answers_choice_association_aggregate_fields: ResolverTypeWrapper<Answers_Choice_Association_Aggregate_Fields>;
  answers_choice_association_aggregate_order_by: Answers_Choice_Association_Aggregate_Order_By;
  answers_choice_association_arr_rel_insert_input: Answers_Choice_Association_Arr_Rel_Insert_Input;
  answers_choice_association_avg_fields: ResolverTypeWrapper<Answers_Choice_Association_Avg_Fields>;
  answers_choice_association_avg_order_by: Answers_Choice_Association_Avg_Order_By;
  answers_choice_association_bool_exp: Answers_Choice_Association_Bool_Exp;
  answers_choice_association_inc_input: Answers_Choice_Association_Inc_Input;
  answers_choice_association_insert_input: Answers_Choice_Association_Insert_Input;
  answers_choice_association_max_fields: ResolverTypeWrapper<Answers_Choice_Association_Max_Fields>;
  answers_choice_association_max_order_by: Answers_Choice_Association_Max_Order_By;
  answers_choice_association_min_fields: ResolverTypeWrapper<Answers_Choice_Association_Min_Fields>;
  answers_choice_association_min_order_by: Answers_Choice_Association_Min_Order_By;
  answers_choice_association_mutation_response: ResolverTypeWrapper<Answers_Choice_Association_Mutation_Response>;
  answers_choice_association_obj_rel_insert_input: Answers_Choice_Association_Obj_Rel_Insert_Input;
  answers_choice_association_order_by: Answers_Choice_Association_Order_By;
  answers_choice_association_select_column: Answers_Choice_Association_Select_Column;
  answers_choice_association_set_input: Answers_Choice_Association_Set_Input;
  answers_choice_association_stddev_fields: ResolverTypeWrapper<Answers_Choice_Association_Stddev_Fields>;
  answers_choice_association_stddev_order_by: Answers_Choice_Association_Stddev_Order_By;
  answers_choice_association_stddev_pop_fields: ResolverTypeWrapper<Answers_Choice_Association_Stddev_Pop_Fields>;
  answers_choice_association_stddev_pop_order_by: Answers_Choice_Association_Stddev_Pop_Order_By;
  answers_choice_association_stddev_samp_fields: ResolverTypeWrapper<Answers_Choice_Association_Stddev_Samp_Fields>;
  answers_choice_association_stddev_samp_order_by: Answers_Choice_Association_Stddev_Samp_Order_By;
  answers_choice_association_sum_fields: ResolverTypeWrapper<Answers_Choice_Association_Sum_Fields>;
  answers_choice_association_sum_order_by: Answers_Choice_Association_Sum_Order_By;
  answers_choice_association_var_pop_fields: ResolverTypeWrapper<Answers_Choice_Association_Var_Pop_Fields>;
  answers_choice_association_var_pop_order_by: Answers_Choice_Association_Var_Pop_Order_By;
  answers_choice_association_var_samp_fields: ResolverTypeWrapper<Answers_Choice_Association_Var_Samp_Fields>;
  answers_choice_association_var_samp_order_by: Answers_Choice_Association_Var_Samp_Order_By;
  answers_choice_association_variance_fields: ResolverTypeWrapper<Answers_Choice_Association_Variance_Fields>;
  answers_choice_association_variance_order_by: Answers_Choice_Association_Variance_Order_By;
  answers_constraint: Answers_Constraint;
  answers_inc_input: Answers_Inc_Input;
  answers_insert_input: Answers_Insert_Input;
  answers_max_fields: ResolverTypeWrapper<Answers_Max_Fields>;
  answers_max_order_by: Answers_Max_Order_By;
  answers_min_fields: ResolverTypeWrapper<Answers_Min_Fields>;
  answers_min_order_by: Answers_Min_Order_By;
  answers_mutation_response: ResolverTypeWrapper<Answers_Mutation_Response>;
  answers_obj_rel_insert_input: Answers_Obj_Rel_Insert_Input;
  answers_on_conflict: Answers_On_Conflict;
  answers_order_by: Answers_Order_By;
  answers_pk_columns_input: Answers_Pk_Columns_Input;
  answers_select_column: Answers_Select_Column;
  answers_set_input: Answers_Set_Input;
  answers_stddev_fields: ResolverTypeWrapper<Answers_Stddev_Fields>;
  answers_stddev_order_by: Answers_Stddev_Order_By;
  answers_stddev_pop_fields: ResolverTypeWrapper<Answers_Stddev_Pop_Fields>;
  answers_stddev_pop_order_by: Answers_Stddev_Pop_Order_By;
  answers_stddev_samp_fields: ResolverTypeWrapper<Answers_Stddev_Samp_Fields>;
  answers_stddev_samp_order_by: Answers_Stddev_Samp_Order_By;
  answers_sum_fields: ResolverTypeWrapper<Answers_Sum_Fields>;
  answers_sum_order_by: Answers_Sum_Order_By;
  answers_update_column: Answers_Update_Column;
  answers_var_pop_fields: ResolverTypeWrapper<Answers_Var_Pop_Fields>;
  answers_var_pop_order_by: Answers_Var_Pop_Order_By;
  answers_var_samp_fields: ResolverTypeWrapper<Answers_Var_Samp_Fields>;
  answers_var_samp_order_by: Answers_Var_Samp_Order_By;
  answers_variance_fields: ResolverTypeWrapper<Answers_Variance_Fields>;
  answers_variance_order_by: Answers_Variance_Order_By;
  bills: ResolverTypeWrapper<Bills>;
  bills_aggregate: ResolverTypeWrapper<Bills_Aggregate>;
  bills_aggregate_fields: ResolverTypeWrapper<Bills_Aggregate_Fields>;
  bills_aggregate_order_by: Bills_Aggregate_Order_By;
  bills_arr_rel_insert_input: Bills_Arr_Rel_Insert_Input;
  bills_avg_fields: ResolverTypeWrapper<Bills_Avg_Fields>;
  bills_avg_order_by: Bills_Avg_Order_By;
  bills_bool_exp: Bills_Bool_Exp;
  bills_constraint: Bills_Constraint;
  bills_inc_input: Bills_Inc_Input;
  bills_insert_input: Bills_Insert_Input;
  bills_max_fields: ResolverTypeWrapper<Bills_Max_Fields>;
  bills_max_order_by: Bills_Max_Order_By;
  bills_min_fields: ResolverTypeWrapper<Bills_Min_Fields>;
  bills_min_order_by: Bills_Min_Order_By;
  bills_mutation_response: ResolverTypeWrapper<Bills_Mutation_Response>;
  bills_obj_rel_insert_input: Bills_Obj_Rel_Insert_Input;
  bills_on_conflict: Bills_On_Conflict;
  bills_order_by: Bills_Order_By;
  bills_pk_columns_input: Bills_Pk_Columns_Input;
  bills_select_column: Bills_Select_Column;
  bills_set_input: Bills_Set_Input;
  bills_stddev_fields: ResolverTypeWrapper<Bills_Stddev_Fields>;
  bills_stddev_order_by: Bills_Stddev_Order_By;
  bills_stddev_pop_fields: ResolverTypeWrapper<Bills_Stddev_Pop_Fields>;
  bills_stddev_pop_order_by: Bills_Stddev_Pop_Order_By;
  bills_stddev_samp_fields: ResolverTypeWrapper<Bills_Stddev_Samp_Fields>;
  bills_stddev_samp_order_by: Bills_Stddev_Samp_Order_By;
  bills_sum_fields: ResolverTypeWrapper<Bills_Sum_Fields>;
  bills_sum_order_by: Bills_Sum_Order_By;
  bills_update_column: Bills_Update_Column;
  bills_var_pop_fields: ResolverTypeWrapper<Bills_Var_Pop_Fields>;
  bills_var_pop_order_by: Bills_Var_Pop_Order_By;
  bills_var_samp_fields: ResolverTypeWrapper<Bills_Var_Samp_Fields>;
  bills_var_samp_order_by: Bills_Var_Samp_Order_By;
  bills_variance_fields: ResolverTypeWrapper<Bills_Variance_Fields>;
  bills_variance_order_by: Bills_Variance_Order_By;
  bright_assessment: ResolverTypeWrapper<Bright_Assessment>;
  bright_assessment_aggregate: ResolverTypeWrapper<Bright_Assessment_Aggregate>;
  bright_assessment_aggregate_fields: ResolverTypeWrapper<Bright_Assessment_Aggregate_Fields>;
  bright_assessment_aggregate_order_by: Bright_Assessment_Aggregate_Order_By;
  bright_assessment_arr_rel_insert_input: Bright_Assessment_Arr_Rel_Insert_Input;
  bright_assessment_avg_fields: ResolverTypeWrapper<Bright_Assessment_Avg_Fields>;
  bright_assessment_avg_order_by: Bright_Assessment_Avg_Order_By;
  bright_assessment_bool_exp: Bright_Assessment_Bool_Exp;
  bright_assessment_constraint: Bright_Assessment_Constraint;
  bright_assessment_inc_input: Bright_Assessment_Inc_Input;
  bright_assessment_insert_input: Bright_Assessment_Insert_Input;
  bright_assessment_max_fields: ResolverTypeWrapper<Bright_Assessment_Max_Fields>;
  bright_assessment_max_order_by: Bright_Assessment_Max_Order_By;
  bright_assessment_min_fields: ResolverTypeWrapper<Bright_Assessment_Min_Fields>;
  bright_assessment_min_order_by: Bright_Assessment_Min_Order_By;
  bright_assessment_mutation_response: ResolverTypeWrapper<Bright_Assessment_Mutation_Response>;
  bright_assessment_obj_rel_insert_input: Bright_Assessment_Obj_Rel_Insert_Input;
  bright_assessment_on_conflict: Bright_Assessment_On_Conflict;
  bright_assessment_order_by: Bright_Assessment_Order_By;
  bright_assessment_pk_columns_input: Bright_Assessment_Pk_Columns_Input;
  bright_assessment_select_column: Bright_Assessment_Select_Column;
  bright_assessment_set_input: Bright_Assessment_Set_Input;
  bright_assessment_stddev_fields: ResolverTypeWrapper<Bright_Assessment_Stddev_Fields>;
  bright_assessment_stddev_order_by: Bright_Assessment_Stddev_Order_By;
  bright_assessment_stddev_pop_fields: ResolverTypeWrapper<Bright_Assessment_Stddev_Pop_Fields>;
  bright_assessment_stddev_pop_order_by: Bright_Assessment_Stddev_Pop_Order_By;
  bright_assessment_stddev_samp_fields: ResolverTypeWrapper<Bright_Assessment_Stddev_Samp_Fields>;
  bright_assessment_stddev_samp_order_by: Bright_Assessment_Stddev_Samp_Order_By;
  bright_assessment_sum_fields: ResolverTypeWrapper<Bright_Assessment_Sum_Fields>;
  bright_assessment_sum_order_by: Bright_Assessment_Sum_Order_By;
  bright_assessment_update_column: Bright_Assessment_Update_Column;
  bright_assessment_var_pop_fields: ResolverTypeWrapper<Bright_Assessment_Var_Pop_Fields>;
  bright_assessment_var_pop_order_by: Bright_Assessment_Var_Pop_Order_By;
  bright_assessment_var_samp_fields: ResolverTypeWrapper<Bright_Assessment_Var_Samp_Fields>;
  bright_assessment_var_samp_order_by: Bright_Assessment_Var_Samp_Order_By;
  bright_assessment_variance_fields: ResolverTypeWrapper<Bright_Assessment_Variance_Fields>;
  bright_assessment_variance_order_by: Bright_Assessment_Variance_Order_By;
  bright_assessments: ResolverTypeWrapper<Bright_Assessments>;
  bright_assessments_aggregate: ResolverTypeWrapper<Bright_Assessments_Aggregate>;
  bright_assessments_aggregate_fields: ResolverTypeWrapper<Bright_Assessments_Aggregate_Fields>;
  bright_assessments_aggregate_order_by: Bright_Assessments_Aggregate_Order_By;
  bright_assessments_arr_rel_insert_input: Bright_Assessments_Arr_Rel_Insert_Input;
  bright_assessments_avg_fields: ResolverTypeWrapper<Bright_Assessments_Avg_Fields>;
  bright_assessments_avg_order_by: Bright_Assessments_Avg_Order_By;
  bright_assessments_bool_exp: Bright_Assessments_Bool_Exp;
  bright_assessments_constraint: Bright_Assessments_Constraint;
  bright_assessments_inc_input: Bright_Assessments_Inc_Input;
  bright_assessments_insert_input: Bright_Assessments_Insert_Input;
  bright_assessments_max_fields: ResolverTypeWrapper<Bright_Assessments_Max_Fields>;
  bright_assessments_max_order_by: Bright_Assessments_Max_Order_By;
  bright_assessments_min_fields: ResolverTypeWrapper<Bright_Assessments_Min_Fields>;
  bright_assessments_min_order_by: Bright_Assessments_Min_Order_By;
  bright_assessments_mutation_response: ResolverTypeWrapper<Bright_Assessments_Mutation_Response>;
  bright_assessments_obj_rel_insert_input: Bright_Assessments_Obj_Rel_Insert_Input;
  bright_assessments_on_conflict: Bright_Assessments_On_Conflict;
  bright_assessments_order_by: Bright_Assessments_Order_By;
  bright_assessments_pk_columns_input: Bright_Assessments_Pk_Columns_Input;
  bright_assessments_select_column: Bright_Assessments_Select_Column;
  bright_assessments_set_input: Bright_Assessments_Set_Input;
  bright_assessments_stddev_fields: ResolverTypeWrapper<Bright_Assessments_Stddev_Fields>;
  bright_assessments_stddev_order_by: Bright_Assessments_Stddev_Order_By;
  bright_assessments_stddev_pop_fields: ResolverTypeWrapper<Bright_Assessments_Stddev_Pop_Fields>;
  bright_assessments_stddev_pop_order_by: Bright_Assessments_Stddev_Pop_Order_By;
  bright_assessments_stddev_samp_fields: ResolverTypeWrapper<Bright_Assessments_Stddev_Samp_Fields>;
  bright_assessments_stddev_samp_order_by: Bright_Assessments_Stddev_Samp_Order_By;
  bright_assessments_sum_fields: ResolverTypeWrapper<Bright_Assessments_Sum_Fields>;
  bright_assessments_sum_order_by: Bright_Assessments_Sum_Order_By;
  bright_assessments_update_column: Bright_Assessments_Update_Column;
  bright_assessments_var_pop_fields: ResolverTypeWrapper<Bright_Assessments_Var_Pop_Fields>;
  bright_assessments_var_pop_order_by: Bright_Assessments_Var_Pop_Order_By;
  bright_assessments_var_samp_fields: ResolverTypeWrapper<Bright_Assessments_Var_Samp_Fields>;
  bright_assessments_var_samp_order_by: Bright_Assessments_Var_Samp_Order_By;
  bright_assessments_variance_fields: ResolverTypeWrapper<Bright_Assessments_Variance_Fields>;
  bright_assessments_variance_order_by: Bright_Assessments_Variance_Order_By;
  bright_branch: ResolverTypeWrapper<Bright_Branch>;
  bright_branch_aggregate: ResolverTypeWrapper<Bright_Branch_Aggregate>;
  bright_branch_aggregate_fields: ResolverTypeWrapper<Bright_Branch_Aggregate_Fields>;
  bright_branch_aggregate_order_by: Bright_Branch_Aggregate_Order_By;
  bright_branch_arr_rel_insert_input: Bright_Branch_Arr_Rel_Insert_Input;
  bright_branch_avg_fields: ResolverTypeWrapper<Bright_Branch_Avg_Fields>;
  bright_branch_avg_order_by: Bright_Branch_Avg_Order_By;
  bright_branch_bool_exp: Bright_Branch_Bool_Exp;
  bright_branch_constraint: Bright_Branch_Constraint;
  bright_branch_inc_input: Bright_Branch_Inc_Input;
  bright_branch_insert_input: Bright_Branch_Insert_Input;
  bright_branch_max_fields: ResolverTypeWrapper<Bright_Branch_Max_Fields>;
  bright_branch_max_order_by: Bright_Branch_Max_Order_By;
  bright_branch_min_fields: ResolverTypeWrapper<Bright_Branch_Min_Fields>;
  bright_branch_min_order_by: Bright_Branch_Min_Order_By;
  bright_branch_mutation_response: ResolverTypeWrapper<Bright_Branch_Mutation_Response>;
  bright_branch_obj_rel_insert_input: Bright_Branch_Obj_Rel_Insert_Input;
  bright_branch_on_conflict: Bright_Branch_On_Conflict;
  bright_branch_order_by: Bright_Branch_Order_By;
  bright_branch_pk_columns_input: Bright_Branch_Pk_Columns_Input;
  bright_branch_select_column: Bright_Branch_Select_Column;
  bright_branch_set_input: Bright_Branch_Set_Input;
  bright_branch_stddev_fields: ResolverTypeWrapper<Bright_Branch_Stddev_Fields>;
  bright_branch_stddev_order_by: Bright_Branch_Stddev_Order_By;
  bright_branch_stddev_pop_fields: ResolverTypeWrapper<Bright_Branch_Stddev_Pop_Fields>;
  bright_branch_stddev_pop_order_by: Bright_Branch_Stddev_Pop_Order_By;
  bright_branch_stddev_samp_fields: ResolverTypeWrapper<Bright_Branch_Stddev_Samp_Fields>;
  bright_branch_stddev_samp_order_by: Bright_Branch_Stddev_Samp_Order_By;
  bright_branch_sum_fields: ResolverTypeWrapper<Bright_Branch_Sum_Fields>;
  bright_branch_sum_order_by: Bright_Branch_Sum_Order_By;
  bright_branch_update_column: Bright_Branch_Update_Column;
  bright_branch_var_pop_fields: ResolverTypeWrapper<Bright_Branch_Var_Pop_Fields>;
  bright_branch_var_pop_order_by: Bright_Branch_Var_Pop_Order_By;
  bright_branch_var_samp_fields: ResolverTypeWrapper<Bright_Branch_Var_Samp_Fields>;
  bright_branch_var_samp_order_by: Bright_Branch_Var_Samp_Order_By;
  bright_branch_variance_fields: ResolverTypeWrapper<Bright_Branch_Variance_Fields>;
  bright_branch_variance_order_by: Bright_Branch_Variance_Order_By;
  bright_candidate: ResolverTypeWrapper<Bright_Candidate>;
  bright_candidate_aggregate: ResolverTypeWrapper<Bright_Candidate_Aggregate>;
  bright_candidate_aggregate_fields: ResolverTypeWrapper<Bright_Candidate_Aggregate_Fields>;
  bright_candidate_aggregate_order_by: Bright_Candidate_Aggregate_Order_By;
  bright_candidate_arr_rel_insert_input: Bright_Candidate_Arr_Rel_Insert_Input;
  bright_candidate_avg_fields: ResolverTypeWrapper<Bright_Candidate_Avg_Fields>;
  bright_candidate_avg_order_by: Bright_Candidate_Avg_Order_By;
  bright_candidate_bool_exp: Bright_Candidate_Bool_Exp;
  bright_candidate_constraint: Bright_Candidate_Constraint;
  bright_candidate_inc_input: Bright_Candidate_Inc_Input;
  bright_candidate_insert_input: Bright_Candidate_Insert_Input;
  bright_candidate_max_fields: ResolverTypeWrapper<Bright_Candidate_Max_Fields>;
  bright_candidate_max_order_by: Bright_Candidate_Max_Order_By;
  bright_candidate_min_fields: ResolverTypeWrapper<Bright_Candidate_Min_Fields>;
  bright_candidate_min_order_by: Bright_Candidate_Min_Order_By;
  bright_candidate_mutation_response: ResolverTypeWrapper<Bright_Candidate_Mutation_Response>;
  bright_candidate_obj_rel_insert_input: Bright_Candidate_Obj_Rel_Insert_Input;
  bright_candidate_on_conflict: Bright_Candidate_On_Conflict;
  bright_candidate_order_by: Bright_Candidate_Order_By;
  bright_candidate_pk_columns_input: Bright_Candidate_Pk_Columns_Input;
  bright_candidate_select_column: Bright_Candidate_Select_Column;
  bright_candidate_set_input: Bright_Candidate_Set_Input;
  bright_candidate_stddev_fields: ResolverTypeWrapper<Bright_Candidate_Stddev_Fields>;
  bright_candidate_stddev_order_by: Bright_Candidate_Stddev_Order_By;
  bright_candidate_stddev_pop_fields: ResolverTypeWrapper<Bright_Candidate_Stddev_Pop_Fields>;
  bright_candidate_stddev_pop_order_by: Bright_Candidate_Stddev_Pop_Order_By;
  bright_candidate_stddev_samp_fields: ResolverTypeWrapper<Bright_Candidate_Stddev_Samp_Fields>;
  bright_candidate_stddev_samp_order_by: Bright_Candidate_Stddev_Samp_Order_By;
  bright_candidate_sum_fields: ResolverTypeWrapper<Bright_Candidate_Sum_Fields>;
  bright_candidate_sum_order_by: Bright_Candidate_Sum_Order_By;
  bright_candidate_update_column: Bright_Candidate_Update_Column;
  bright_candidate_var_pop_fields: ResolverTypeWrapper<Bright_Candidate_Var_Pop_Fields>;
  bright_candidate_var_pop_order_by: Bright_Candidate_Var_Pop_Order_By;
  bright_candidate_var_samp_fields: ResolverTypeWrapper<Bright_Candidate_Var_Samp_Fields>;
  bright_candidate_var_samp_order_by: Bright_Candidate_Var_Samp_Order_By;
  bright_candidate_variance_fields: ResolverTypeWrapper<Bright_Candidate_Variance_Fields>;
  bright_candidate_variance_order_by: Bright_Candidate_Variance_Order_By;
  bright_manager: ResolverTypeWrapper<Bright_Manager>;
  bright_manager_aggregate: ResolverTypeWrapper<Bright_Manager_Aggregate>;
  bright_manager_aggregate_fields: ResolverTypeWrapper<Bright_Manager_Aggregate_Fields>;
  bright_manager_aggregate_order_by: Bright_Manager_Aggregate_Order_By;
  bright_manager_arr_rel_insert_input: Bright_Manager_Arr_Rel_Insert_Input;
  bright_manager_avg_fields: ResolverTypeWrapper<Bright_Manager_Avg_Fields>;
  bright_manager_avg_order_by: Bright_Manager_Avg_Order_By;
  bright_manager_bool_exp: Bright_Manager_Bool_Exp;
  bright_manager_constraint: Bright_Manager_Constraint;
  bright_manager_inc_input: Bright_Manager_Inc_Input;
  bright_manager_insert_input: Bright_Manager_Insert_Input;
  bright_manager_max_fields: ResolverTypeWrapper<Bright_Manager_Max_Fields>;
  bright_manager_max_order_by: Bright_Manager_Max_Order_By;
  bright_manager_min_fields: ResolverTypeWrapper<Bright_Manager_Min_Fields>;
  bright_manager_min_order_by: Bright_Manager_Min_Order_By;
  bright_manager_mutation_response: ResolverTypeWrapper<Bright_Manager_Mutation_Response>;
  bright_manager_obj_rel_insert_input: Bright_Manager_Obj_Rel_Insert_Input;
  bright_manager_on_conflict: Bright_Manager_On_Conflict;
  bright_manager_order_by: Bright_Manager_Order_By;
  bright_manager_pk_columns_input: Bright_Manager_Pk_Columns_Input;
  bright_manager_select_column: Bright_Manager_Select_Column;
  bright_manager_set_input: Bright_Manager_Set_Input;
  bright_manager_stddev_fields: ResolverTypeWrapper<Bright_Manager_Stddev_Fields>;
  bright_manager_stddev_order_by: Bright_Manager_Stddev_Order_By;
  bright_manager_stddev_pop_fields: ResolverTypeWrapper<Bright_Manager_Stddev_Pop_Fields>;
  bright_manager_stddev_pop_order_by: Bright_Manager_Stddev_Pop_Order_By;
  bright_manager_stddev_samp_fields: ResolverTypeWrapper<Bright_Manager_Stddev_Samp_Fields>;
  bright_manager_stddev_samp_order_by: Bright_Manager_Stddev_Samp_Order_By;
  bright_manager_sum_fields: ResolverTypeWrapper<Bright_Manager_Sum_Fields>;
  bright_manager_sum_order_by: Bright_Manager_Sum_Order_By;
  bright_manager_update_column: Bright_Manager_Update_Column;
  bright_manager_var_pop_fields: ResolverTypeWrapper<Bright_Manager_Var_Pop_Fields>;
  bright_manager_var_pop_order_by: Bright_Manager_Var_Pop_Order_By;
  bright_manager_var_samp_fields: ResolverTypeWrapper<Bright_Manager_Var_Samp_Fields>;
  bright_manager_var_samp_order_by: Bright_Manager_Var_Samp_Order_By;
  bright_manager_variance_fields: ResolverTypeWrapper<Bright_Manager_Variance_Fields>;
  bright_manager_variance_order_by: Bright_Manager_Variance_Order_By;
  categories: ResolverTypeWrapper<Categories>;
  categories_aggregate: ResolverTypeWrapper<Categories_Aggregate>;
  categories_aggregate_fields: ResolverTypeWrapper<Categories_Aggregate_Fields>;
  categories_aggregate_order_by: Categories_Aggregate_Order_By;
  categories_arr_rel_insert_input: Categories_Arr_Rel_Insert_Input;
  categories_avg_fields: ResolverTypeWrapper<Categories_Avg_Fields>;
  categories_avg_order_by: Categories_Avg_Order_By;
  categories_bool_exp: Categories_Bool_Exp;
  categories_constraint: Categories_Constraint;
  categories_inc_input: Categories_Inc_Input;
  categories_insert_input: Categories_Insert_Input;
  categories_max_fields: ResolverTypeWrapper<Categories_Max_Fields>;
  categories_max_order_by: Categories_Max_Order_By;
  categories_min_fields: ResolverTypeWrapper<Categories_Min_Fields>;
  categories_min_order_by: Categories_Min_Order_By;
  categories_mutation_response: ResolverTypeWrapper<Categories_Mutation_Response>;
  categories_obj_rel_insert_input: Categories_Obj_Rel_Insert_Input;
  categories_on_conflict: Categories_On_Conflict;
  categories_order_by: Categories_Order_By;
  categories_pk_columns_input: Categories_Pk_Columns_Input;
  categories_select_column: Categories_Select_Column;
  categories_set_input: Categories_Set_Input;
  categories_stddev_fields: ResolverTypeWrapper<Categories_Stddev_Fields>;
  categories_stddev_order_by: Categories_Stddev_Order_By;
  categories_stddev_pop_fields: ResolverTypeWrapper<Categories_Stddev_Pop_Fields>;
  categories_stddev_pop_order_by: Categories_Stddev_Pop_Order_By;
  categories_stddev_samp_fields: ResolverTypeWrapper<Categories_Stddev_Samp_Fields>;
  categories_stddev_samp_order_by: Categories_Stddev_Samp_Order_By;
  categories_sum_fields: ResolverTypeWrapper<Categories_Sum_Fields>;
  categories_sum_order_by: Categories_Sum_Order_By;
  categories_update_column: Categories_Update_Column;
  categories_var_pop_fields: ResolverTypeWrapper<Categories_Var_Pop_Fields>;
  categories_var_pop_order_by: Categories_Var_Pop_Order_By;
  categories_var_samp_fields: ResolverTypeWrapper<Categories_Var_Samp_Fields>;
  categories_var_samp_order_by: Categories_Var_Samp_Order_By;
  categories_variance_fields: ResolverTypeWrapper<Categories_Variance_Fields>;
  categories_variance_order_by: Categories_Variance_Order_By;
  choices: ResolverTypeWrapper<Choices>;
  choices_aggregate: ResolverTypeWrapper<Choices_Aggregate>;
  choices_aggregate_fields: ResolverTypeWrapper<Choices_Aggregate_Fields>;
  choices_aggregate_order_by: Choices_Aggregate_Order_By;
  choices_arr_rel_insert_input: Choices_Arr_Rel_Insert_Input;
  choices_avg_fields: ResolverTypeWrapper<Choices_Avg_Fields>;
  choices_avg_order_by: Choices_Avg_Order_By;
  choices_bool_exp: Choices_Bool_Exp;
  choices_constraint: Choices_Constraint;
  choices_inc_input: Choices_Inc_Input;
  choices_insert_input: Choices_Insert_Input;
  choices_max_fields: ResolverTypeWrapper<Choices_Max_Fields>;
  choices_max_order_by: Choices_Max_Order_By;
  choices_min_fields: ResolverTypeWrapper<Choices_Min_Fields>;
  choices_min_order_by: Choices_Min_Order_By;
  choices_mutation_response: ResolverTypeWrapper<Choices_Mutation_Response>;
  choices_obj_rel_insert_input: Choices_Obj_Rel_Insert_Input;
  choices_on_conflict: Choices_On_Conflict;
  choices_order_by: Choices_Order_By;
  choices_pk_columns_input: Choices_Pk_Columns_Input;
  choices_select_column: Choices_Select_Column;
  choices_set_input: Choices_Set_Input;
  choices_stddev_fields: ResolverTypeWrapper<Choices_Stddev_Fields>;
  choices_stddev_order_by: Choices_Stddev_Order_By;
  choices_stddev_pop_fields: ResolverTypeWrapper<Choices_Stddev_Pop_Fields>;
  choices_stddev_pop_order_by: Choices_Stddev_Pop_Order_By;
  choices_stddev_samp_fields: ResolverTypeWrapper<Choices_Stddev_Samp_Fields>;
  choices_stddev_samp_order_by: Choices_Stddev_Samp_Order_By;
  choices_sum_fields: ResolverTypeWrapper<Choices_Sum_Fields>;
  choices_sum_order_by: Choices_Sum_Order_By;
  choices_update_column: Choices_Update_Column;
  choices_var_pop_fields: ResolverTypeWrapper<Choices_Var_Pop_Fields>;
  choices_var_pop_order_by: Choices_Var_Pop_Order_By;
  choices_var_samp_fields: ResolverTypeWrapper<Choices_Var_Samp_Fields>;
  choices_var_samp_order_by: Choices_Var_Samp_Order_By;
  choices_variance_fields: ResolverTypeWrapper<Choices_Variance_Fields>;
  choices_variance_order_by: Choices_Variance_Order_By;
  credits_log: ResolverTypeWrapper<Credits_Log>;
  credits_log_aggregate: ResolverTypeWrapper<Credits_Log_Aggregate>;
  credits_log_aggregate_fields: ResolverTypeWrapper<Credits_Log_Aggregate_Fields>;
  credits_log_aggregate_order_by: Credits_Log_Aggregate_Order_By;
  credits_log_arr_rel_insert_input: Credits_Log_Arr_Rel_Insert_Input;
  credits_log_avg_fields: ResolverTypeWrapper<Credits_Log_Avg_Fields>;
  credits_log_avg_order_by: Credits_Log_Avg_Order_By;
  credits_log_bool_exp: Credits_Log_Bool_Exp;
  credits_log_constraint: Credits_Log_Constraint;
  credits_log_inc_input: Credits_Log_Inc_Input;
  credits_log_insert_input: Credits_Log_Insert_Input;
  credits_log_max_fields: ResolverTypeWrapper<Credits_Log_Max_Fields>;
  credits_log_max_order_by: Credits_Log_Max_Order_By;
  credits_log_min_fields: ResolverTypeWrapper<Credits_Log_Min_Fields>;
  credits_log_min_order_by: Credits_Log_Min_Order_By;
  credits_log_mutation_response: ResolverTypeWrapper<Credits_Log_Mutation_Response>;
  credits_log_obj_rel_insert_input: Credits_Log_Obj_Rel_Insert_Input;
  credits_log_on_conflict: Credits_Log_On_Conflict;
  credits_log_order_by: Credits_Log_Order_By;
  credits_log_pk_columns_input: Credits_Log_Pk_Columns_Input;
  credits_log_select_column: Credits_Log_Select_Column;
  credits_log_set_input: Credits_Log_Set_Input;
  credits_log_stddev_fields: ResolverTypeWrapper<Credits_Log_Stddev_Fields>;
  credits_log_stddev_order_by: Credits_Log_Stddev_Order_By;
  credits_log_stddev_pop_fields: ResolverTypeWrapper<Credits_Log_Stddev_Pop_Fields>;
  credits_log_stddev_pop_order_by: Credits_Log_Stddev_Pop_Order_By;
  credits_log_stddev_samp_fields: ResolverTypeWrapper<Credits_Log_Stddev_Samp_Fields>;
  credits_log_stddev_samp_order_by: Credits_Log_Stddev_Samp_Order_By;
  credits_log_sum_fields: ResolverTypeWrapper<Credits_Log_Sum_Fields>;
  credits_log_sum_order_by: Credits_Log_Sum_Order_By;
  credits_log_update_column: Credits_Log_Update_Column;
  credits_log_var_pop_fields: ResolverTypeWrapper<Credits_Log_Var_Pop_Fields>;
  credits_log_var_pop_order_by: Credits_Log_Var_Pop_Order_By;
  credits_log_var_samp_fields: ResolverTypeWrapper<Credits_Log_Var_Samp_Fields>;
  credits_log_var_samp_order_by: Credits_Log_Var_Samp_Order_By;
  credits_log_variance_fields: ResolverTypeWrapper<Credits_Log_Variance_Fields>;
  credits_log_variance_order_by: Credits_Log_Variance_Order_By;
  discount_codes: ResolverTypeWrapper<Discount_Codes>;
  discount_codes_aggregate: ResolverTypeWrapper<Discount_Codes_Aggregate>;
  discount_codes_aggregate_fields: ResolverTypeWrapper<Discount_Codes_Aggregate_Fields>;
  discount_codes_aggregate_order_by: Discount_Codes_Aggregate_Order_By;
  discount_codes_arr_rel_insert_input: Discount_Codes_Arr_Rel_Insert_Input;
  discount_codes_avg_fields: ResolverTypeWrapper<Discount_Codes_Avg_Fields>;
  discount_codes_avg_order_by: Discount_Codes_Avg_Order_By;
  discount_codes_bool_exp: Discount_Codes_Bool_Exp;
  discount_codes_constraint: Discount_Codes_Constraint;
  discount_codes_inc_input: Discount_Codes_Inc_Input;
  discount_codes_insert_input: Discount_Codes_Insert_Input;
  discount_codes_max_fields: ResolverTypeWrapper<Discount_Codes_Max_Fields>;
  discount_codes_max_order_by: Discount_Codes_Max_Order_By;
  discount_codes_min_fields: ResolverTypeWrapper<Discount_Codes_Min_Fields>;
  discount_codes_min_order_by: Discount_Codes_Min_Order_By;
  discount_codes_mutation_response: ResolverTypeWrapper<Discount_Codes_Mutation_Response>;
  discount_codes_obj_rel_insert_input: Discount_Codes_Obj_Rel_Insert_Input;
  discount_codes_on_conflict: Discount_Codes_On_Conflict;
  discount_codes_order_by: Discount_Codes_Order_By;
  discount_codes_pk_columns_input: Discount_Codes_Pk_Columns_Input;
  discount_codes_select_column: Discount_Codes_Select_Column;
  discount_codes_set_input: Discount_Codes_Set_Input;
  discount_codes_stddev_fields: ResolverTypeWrapper<Discount_Codes_Stddev_Fields>;
  discount_codes_stddev_order_by: Discount_Codes_Stddev_Order_By;
  discount_codes_stddev_pop_fields: ResolverTypeWrapper<Discount_Codes_Stddev_Pop_Fields>;
  discount_codes_stddev_pop_order_by: Discount_Codes_Stddev_Pop_Order_By;
  discount_codes_stddev_samp_fields: ResolverTypeWrapper<Discount_Codes_Stddev_Samp_Fields>;
  discount_codes_stddev_samp_order_by: Discount_Codes_Stddev_Samp_Order_By;
  discount_codes_sum_fields: ResolverTypeWrapper<Discount_Codes_Sum_Fields>;
  discount_codes_sum_order_by: Discount_Codes_Sum_Order_By;
  discount_codes_update_column: Discount_Codes_Update_Column;
  discount_codes_var_pop_fields: ResolverTypeWrapper<Discount_Codes_Var_Pop_Fields>;
  discount_codes_var_pop_order_by: Discount_Codes_Var_Pop_Order_By;
  discount_codes_var_samp_fields: ResolverTypeWrapper<Discount_Codes_Var_Samp_Fields>;
  discount_codes_var_samp_order_by: Discount_Codes_Var_Samp_Order_By;
  discount_codes_variance_fields: ResolverTypeWrapper<Discount_Codes_Variance_Fields>;
  discount_codes_variance_order_by: Discount_Codes_Variance_Order_By;
  estimated_scores: ResolverTypeWrapper<Estimated_Scores>;
  estimated_scores_aggregate: ResolverTypeWrapper<Estimated_Scores_Aggregate>;
  estimated_scores_aggregate_fields: ResolverTypeWrapper<Estimated_Scores_Aggregate_Fields>;
  estimated_scores_aggregate_order_by: Estimated_Scores_Aggregate_Order_By;
  estimated_scores_arr_rel_insert_input: Estimated_Scores_Arr_Rel_Insert_Input;
  estimated_scores_avg_fields: ResolverTypeWrapper<Estimated_Scores_Avg_Fields>;
  estimated_scores_avg_order_by: Estimated_Scores_Avg_Order_By;
  estimated_scores_bool_exp: Estimated_Scores_Bool_Exp;
  estimated_scores_constraint: Estimated_Scores_Constraint;
  estimated_scores_inc_input: Estimated_Scores_Inc_Input;
  estimated_scores_insert_input: Estimated_Scores_Insert_Input;
  estimated_scores_max_fields: ResolverTypeWrapper<Estimated_Scores_Max_Fields>;
  estimated_scores_max_order_by: Estimated_Scores_Max_Order_By;
  estimated_scores_min_fields: ResolverTypeWrapper<Estimated_Scores_Min_Fields>;
  estimated_scores_min_order_by: Estimated_Scores_Min_Order_By;
  estimated_scores_mutation_response: ResolverTypeWrapper<Estimated_Scores_Mutation_Response>;
  estimated_scores_obj_rel_insert_input: Estimated_Scores_Obj_Rel_Insert_Input;
  estimated_scores_on_conflict: Estimated_Scores_On_Conflict;
  estimated_scores_order_by: Estimated_Scores_Order_By;
  estimated_scores_pk_columns_input: Estimated_Scores_Pk_Columns_Input;
  estimated_scores_select_column: Estimated_Scores_Select_Column;
  estimated_scores_set_input: Estimated_Scores_Set_Input;
  estimated_scores_stddev_fields: ResolverTypeWrapper<Estimated_Scores_Stddev_Fields>;
  estimated_scores_stddev_order_by: Estimated_Scores_Stddev_Order_By;
  estimated_scores_stddev_pop_fields: ResolverTypeWrapper<Estimated_Scores_Stddev_Pop_Fields>;
  estimated_scores_stddev_pop_order_by: Estimated_Scores_Stddev_Pop_Order_By;
  estimated_scores_stddev_samp_fields: ResolverTypeWrapper<Estimated_Scores_Stddev_Samp_Fields>;
  estimated_scores_stddev_samp_order_by: Estimated_Scores_Stddev_Samp_Order_By;
  estimated_scores_sum_fields: ResolverTypeWrapper<Estimated_Scores_Sum_Fields>;
  estimated_scores_sum_order_by: Estimated_Scores_Sum_Order_By;
  estimated_scores_update_column: Estimated_Scores_Update_Column;
  estimated_scores_var_pop_fields: ResolverTypeWrapper<Estimated_Scores_Var_Pop_Fields>;
  estimated_scores_var_pop_order_by: Estimated_Scores_Var_Pop_Order_By;
  estimated_scores_var_samp_fields: ResolverTypeWrapper<Estimated_Scores_Var_Samp_Fields>;
  estimated_scores_var_samp_order_by: Estimated_Scores_Var_Samp_Order_By;
  estimated_scores_variance_fields: ResolverTypeWrapper<Estimated_Scores_Variance_Fields>;
  estimated_scores_variance_order_by: Estimated_Scores_Variance_Order_By;
  exam_types: ResolverTypeWrapper<Scalars['exam_types']>;
  exam_types_comparison_exp: Exam_Types_Comparison_Exp;
  exams: ResolverTypeWrapper<Exams>;
  exams_aggregate: ResolverTypeWrapper<Exams_Aggregate>;
  exams_aggregate_fields: ResolverTypeWrapper<Exams_Aggregate_Fields>;
  exams_aggregate_order_by: Exams_Aggregate_Order_By;
  exams_arr_rel_insert_input: Exams_Arr_Rel_Insert_Input;
  exams_avg_fields: ResolverTypeWrapper<Exams_Avg_Fields>;
  exams_avg_order_by: Exams_Avg_Order_By;
  exams_bool_exp: Exams_Bool_Exp;
  exams_constraint: Exams_Constraint;
  exams_inc_input: Exams_Inc_Input;
  exams_insert_input: Exams_Insert_Input;
  exams_max_fields: ResolverTypeWrapper<Exams_Max_Fields>;
  exams_max_order_by: Exams_Max_Order_By;
  exams_min_fields: ResolverTypeWrapper<Exams_Min_Fields>;
  exams_min_order_by: Exams_Min_Order_By;
  exams_mutation_response: ResolverTypeWrapper<Exams_Mutation_Response>;
  exams_obj_rel_insert_input: Exams_Obj_Rel_Insert_Input;
  exams_on_conflict: Exams_On_Conflict;
  exams_order_by: Exams_Order_By;
  exams_pk_columns_input: Exams_Pk_Columns_Input;
  exams_select_column: Exams_Select_Column;
  exams_set_input: Exams_Set_Input;
  exams_stddev_fields: ResolverTypeWrapper<Exams_Stddev_Fields>;
  exams_stddev_order_by: Exams_Stddev_Order_By;
  exams_stddev_pop_fields: ResolverTypeWrapper<Exams_Stddev_Pop_Fields>;
  exams_stddev_pop_order_by: Exams_Stddev_Pop_Order_By;
  exams_stddev_samp_fields: ResolverTypeWrapper<Exams_Stddev_Samp_Fields>;
  exams_stddev_samp_order_by: Exams_Stddev_Samp_Order_By;
  exams_sum_fields: ResolverTypeWrapper<Exams_Sum_Fields>;
  exams_sum_order_by: Exams_Sum_Order_By;
  exams_update_column: Exams_Update_Column;
  exams_var_pop_fields: ResolverTypeWrapper<Exams_Var_Pop_Fields>;
  exams_var_pop_order_by: Exams_Var_Pop_Order_By;
  exams_var_samp_fields: ResolverTypeWrapper<Exams_Var_Samp_Fields>;
  exams_var_samp_order_by: Exams_Var_Samp_Order_By;
  exams_variance_fields: ResolverTypeWrapper<Exams_Variance_Fields>;
  exams_variance_order_by: Exams_Variance_Order_By;
  feedbacks: ResolverTypeWrapper<Feedbacks>;
  feedbacks_aggregate: ResolverTypeWrapper<Feedbacks_Aggregate>;
  feedbacks_aggregate_fields: ResolverTypeWrapper<Feedbacks_Aggregate_Fields>;
  feedbacks_aggregate_order_by: Feedbacks_Aggregate_Order_By;
  feedbacks_append_input: Feedbacks_Append_Input;
  feedbacks_arr_rel_insert_input: Feedbacks_Arr_Rel_Insert_Input;
  feedbacks_avg_fields: ResolverTypeWrapper<Feedbacks_Avg_Fields>;
  feedbacks_avg_order_by: Feedbacks_Avg_Order_By;
  feedbacks_bool_exp: Feedbacks_Bool_Exp;
  feedbacks_constraint: Feedbacks_Constraint;
  feedbacks_delete_at_path_input: Feedbacks_Delete_At_Path_Input;
  feedbacks_delete_elem_input: Feedbacks_Delete_Elem_Input;
  feedbacks_delete_key_input: Feedbacks_Delete_Key_Input;
  feedbacks_inc_input: Feedbacks_Inc_Input;
  feedbacks_insert_input: Feedbacks_Insert_Input;
  feedbacks_max_fields: ResolverTypeWrapper<Feedbacks_Max_Fields>;
  feedbacks_max_order_by: Feedbacks_Max_Order_By;
  feedbacks_min_fields: ResolverTypeWrapper<Feedbacks_Min_Fields>;
  feedbacks_min_order_by: Feedbacks_Min_Order_By;
  feedbacks_mutation_response: ResolverTypeWrapper<Feedbacks_Mutation_Response>;
  feedbacks_obj_rel_insert_input: Feedbacks_Obj_Rel_Insert_Input;
  feedbacks_on_conflict: Feedbacks_On_Conflict;
  feedbacks_order_by: Feedbacks_Order_By;
  feedbacks_pk_columns_input: Feedbacks_Pk_Columns_Input;
  feedbacks_prepend_input: Feedbacks_Prepend_Input;
  feedbacks_select_column: Feedbacks_Select_Column;
  feedbacks_set_input: Feedbacks_Set_Input;
  feedbacks_stddev_fields: ResolverTypeWrapper<Feedbacks_Stddev_Fields>;
  feedbacks_stddev_order_by: Feedbacks_Stddev_Order_By;
  feedbacks_stddev_pop_fields: ResolverTypeWrapper<Feedbacks_Stddev_Pop_Fields>;
  feedbacks_stddev_pop_order_by: Feedbacks_Stddev_Pop_Order_By;
  feedbacks_stddev_samp_fields: ResolverTypeWrapper<Feedbacks_Stddev_Samp_Fields>;
  feedbacks_stddev_samp_order_by: Feedbacks_Stddev_Samp_Order_By;
  feedbacks_sum_fields: ResolverTypeWrapper<Feedbacks_Sum_Fields>;
  feedbacks_sum_order_by: Feedbacks_Sum_Order_By;
  feedbacks_update_column: Feedbacks_Update_Column;
  feedbacks_var_pop_fields: ResolverTypeWrapper<Feedbacks_Var_Pop_Fields>;
  feedbacks_var_pop_order_by: Feedbacks_Var_Pop_Order_By;
  feedbacks_var_samp_fields: ResolverTypeWrapper<Feedbacks_Var_Samp_Fields>;
  feedbacks_var_samp_order_by: Feedbacks_Var_Samp_Order_By;
  feedbacks_variance_fields: ResolverTypeWrapper<Feedbacks_Variance_Fields>;
  feedbacks_variance_order_by: Feedbacks_Variance_Order_By;
  float8: ResolverTypeWrapper<Scalars['float8']>;
  float8_comparison_exp: Float8_Comparison_Exp;
  institutions: ResolverTypeWrapper<Institutions>;
  institutions_aggregate: ResolverTypeWrapper<Institutions_Aggregate>;
  institutions_aggregate_fields: ResolverTypeWrapper<Institutions_Aggregate_Fields>;
  institutions_aggregate_order_by: Institutions_Aggregate_Order_By;
  institutions_append_input: Institutions_Append_Input;
  institutions_arr_rel_insert_input: Institutions_Arr_Rel_Insert_Input;
  institutions_avg_fields: ResolverTypeWrapper<Institutions_Avg_Fields>;
  institutions_avg_order_by: Institutions_Avg_Order_By;
  institutions_bool_exp: Institutions_Bool_Exp;
  institutions_constraint: Institutions_Constraint;
  institutions_delete_at_path_input: Institutions_Delete_At_Path_Input;
  institutions_delete_elem_input: Institutions_Delete_Elem_Input;
  institutions_delete_key_input: Institutions_Delete_Key_Input;
  institutions_inc_input: Institutions_Inc_Input;
  institutions_insert_input: Institutions_Insert_Input;
  institutions_max_fields: ResolverTypeWrapper<Institutions_Max_Fields>;
  institutions_max_order_by: Institutions_Max_Order_By;
  institutions_min_fields: ResolverTypeWrapper<Institutions_Min_Fields>;
  institutions_min_order_by: Institutions_Min_Order_By;
  institutions_mutation_response: ResolverTypeWrapper<Institutions_Mutation_Response>;
  institutions_obj_rel_insert_input: Institutions_Obj_Rel_Insert_Input;
  institutions_on_conflict: Institutions_On_Conflict;
  institutions_order_by: Institutions_Order_By;
  institutions_pk_columns_input: Institutions_Pk_Columns_Input;
  institutions_prepend_input: Institutions_Prepend_Input;
  institutions_select_column: Institutions_Select_Column;
  institutions_set_input: Institutions_Set_Input;
  institutions_stddev_fields: ResolverTypeWrapper<Institutions_Stddev_Fields>;
  institutions_stddev_order_by: Institutions_Stddev_Order_By;
  institutions_stddev_pop_fields: ResolverTypeWrapper<Institutions_Stddev_Pop_Fields>;
  institutions_stddev_pop_order_by: Institutions_Stddev_Pop_Order_By;
  institutions_stddev_samp_fields: ResolverTypeWrapper<Institutions_Stddev_Samp_Fields>;
  institutions_stddev_samp_order_by: Institutions_Stddev_Samp_Order_By;
  institutions_sum_fields: ResolverTypeWrapper<Institutions_Sum_Fields>;
  institutions_sum_order_by: Institutions_Sum_Order_By;
  institutions_update_column: Institutions_Update_Column;
  institutions_var_pop_fields: ResolverTypeWrapper<Institutions_Var_Pop_Fields>;
  institutions_var_pop_order_by: Institutions_Var_Pop_Order_By;
  institutions_var_samp_fields: ResolverTypeWrapper<Institutions_Var_Samp_Fields>;
  institutions_var_samp_order_by: Institutions_Var_Samp_Order_By;
  institutions_variance_fields: ResolverTypeWrapper<Institutions_Variance_Fields>;
  institutions_variance_order_by: Institutions_Variance_Order_By;
  jsonb: ResolverTypeWrapper<Scalars['jsonb']>;
  jsonb_comparison_exp: Jsonb_Comparison_Exp;
  lessons: ResolverTypeWrapper<Lessons>;
  lessons_aggregate: ResolverTypeWrapper<Lessons_Aggregate>;
  lessons_aggregate_fields: ResolverTypeWrapper<Lessons_Aggregate_Fields>;
  lessons_aggregate_order_by: Lessons_Aggregate_Order_By;
  lessons_arr_rel_insert_input: Lessons_Arr_Rel_Insert_Input;
  lessons_avg_fields: ResolverTypeWrapper<Lessons_Avg_Fields>;
  lessons_avg_order_by: Lessons_Avg_Order_By;
  lessons_bool_exp: Lessons_Bool_Exp;
  lessons_constraint: Lessons_Constraint;
  lessons_inc_input: Lessons_Inc_Input;
  lessons_insert_input: Lessons_Insert_Input;
  lessons_max_fields: ResolverTypeWrapper<Lessons_Max_Fields>;
  lessons_max_order_by: Lessons_Max_Order_By;
  lessons_min_fields: ResolverTypeWrapper<Lessons_Min_Fields>;
  lessons_min_order_by: Lessons_Min_Order_By;
  lessons_mutation_response: ResolverTypeWrapper<Lessons_Mutation_Response>;
  lessons_obj_rel_insert_input: Lessons_Obj_Rel_Insert_Input;
  lessons_on_conflict: Lessons_On_Conflict;
  lessons_order_by: Lessons_Order_By;
  lessons_pk_columns_input: Lessons_Pk_Columns_Input;
  lessons_select_column: Lessons_Select_Column;
  lessons_set_input: Lessons_Set_Input;
  lessons_stddev_fields: ResolverTypeWrapper<Lessons_Stddev_Fields>;
  lessons_stddev_order_by: Lessons_Stddev_Order_By;
  lessons_stddev_pop_fields: ResolverTypeWrapper<Lessons_Stddev_Pop_Fields>;
  lessons_stddev_pop_order_by: Lessons_Stddev_Pop_Order_By;
  lessons_stddev_samp_fields: ResolverTypeWrapper<Lessons_Stddev_Samp_Fields>;
  lessons_stddev_samp_order_by: Lessons_Stddev_Samp_Order_By;
  lessons_sum_fields: ResolverTypeWrapper<Lessons_Sum_Fields>;
  lessons_sum_order_by: Lessons_Sum_Order_By;
  lessons_update_column: Lessons_Update_Column;
  lessons_var_pop_fields: ResolverTypeWrapper<Lessons_Var_Pop_Fields>;
  lessons_var_pop_order_by: Lessons_Var_Pop_Order_By;
  lessons_var_samp_fields: ResolverTypeWrapper<Lessons_Var_Samp_Fields>;
  lessons_var_samp_order_by: Lessons_Var_Samp_Order_By;
  lessons_variance_fields: ResolverTypeWrapper<Lessons_Variance_Fields>;
  lessons_variance_order_by: Lessons_Variance_Order_By;
  mutation_root: ResolverTypeWrapper<{}>;
  numeric: ResolverTypeWrapper<Scalars['numeric']>;
  numeric_comparison_exp: Numeric_Comparison_Exp;
  order_by: Order_By;
  plans: ResolverTypeWrapper<Plans>;
  plans_aggregate: ResolverTypeWrapper<Plans_Aggregate>;
  plans_aggregate_fields: ResolverTypeWrapper<Plans_Aggregate_Fields>;
  plans_aggregate_order_by: Plans_Aggregate_Order_By;
  plans_arr_rel_insert_input: Plans_Arr_Rel_Insert_Input;
  plans_avg_fields: ResolverTypeWrapper<Plans_Avg_Fields>;
  plans_avg_order_by: Plans_Avg_Order_By;
  plans_bool_exp: Plans_Bool_Exp;
  plans_constraint: Plans_Constraint;
  plans_inc_input: Plans_Inc_Input;
  plans_insert_input: Plans_Insert_Input;
  plans_max_fields: ResolverTypeWrapper<Plans_Max_Fields>;
  plans_max_order_by: Plans_Max_Order_By;
  plans_min_fields: ResolverTypeWrapper<Plans_Min_Fields>;
  plans_min_order_by: Plans_Min_Order_By;
  plans_mutation_response: ResolverTypeWrapper<Plans_Mutation_Response>;
  plans_obj_rel_insert_input: Plans_Obj_Rel_Insert_Input;
  plans_on_conflict: Plans_On_Conflict;
  plans_order_by: Plans_Order_By;
  plans_pk_columns_input: Plans_Pk_Columns_Input;
  plans_select_column: Plans_Select_Column;
  plans_set_input: Plans_Set_Input;
  plans_stddev_fields: ResolverTypeWrapper<Plans_Stddev_Fields>;
  plans_stddev_order_by: Plans_Stddev_Order_By;
  plans_stddev_pop_fields: ResolverTypeWrapper<Plans_Stddev_Pop_Fields>;
  plans_stddev_pop_order_by: Plans_Stddev_Pop_Order_By;
  plans_stddev_samp_fields: ResolverTypeWrapper<Plans_Stddev_Samp_Fields>;
  plans_stddev_samp_order_by: Plans_Stddev_Samp_Order_By;
  plans_sum_fields: ResolverTypeWrapper<Plans_Sum_Fields>;
  plans_sum_order_by: Plans_Sum_Order_By;
  plans_update_column: Plans_Update_Column;
  plans_var_pop_fields: ResolverTypeWrapper<Plans_Var_Pop_Fields>;
  plans_var_pop_order_by: Plans_Var_Pop_Order_By;
  plans_var_samp_fields: ResolverTypeWrapper<Plans_Var_Samp_Fields>;
  plans_var_samp_order_by: Plans_Var_Samp_Order_By;
  plans_variance_fields: ResolverTypeWrapper<Plans_Variance_Fields>;
  plans_variance_order_by: Plans_Variance_Order_By;
  profile_sphere_association: ResolverTypeWrapper<Profile_Sphere_Association>;
  profile_sphere_association_aggregate: ResolverTypeWrapper<Profile_Sphere_Association_Aggregate>;
  profile_sphere_association_aggregate_fields: ResolverTypeWrapper<Profile_Sphere_Association_Aggregate_Fields>;
  profile_sphere_association_aggregate_order_by: Profile_Sphere_Association_Aggregate_Order_By;
  profile_sphere_association_arr_rel_insert_input: Profile_Sphere_Association_Arr_Rel_Insert_Input;
  profile_sphere_association_avg_fields: ResolverTypeWrapper<Profile_Sphere_Association_Avg_Fields>;
  profile_sphere_association_avg_order_by: Profile_Sphere_Association_Avg_Order_By;
  profile_sphere_association_bool_exp: Profile_Sphere_Association_Bool_Exp;
  profile_sphere_association_inc_input: Profile_Sphere_Association_Inc_Input;
  profile_sphere_association_insert_input: Profile_Sphere_Association_Insert_Input;
  profile_sphere_association_max_fields: ResolverTypeWrapper<Profile_Sphere_Association_Max_Fields>;
  profile_sphere_association_max_order_by: Profile_Sphere_Association_Max_Order_By;
  profile_sphere_association_min_fields: ResolverTypeWrapper<Profile_Sphere_Association_Min_Fields>;
  profile_sphere_association_min_order_by: Profile_Sphere_Association_Min_Order_By;
  profile_sphere_association_mutation_response: ResolverTypeWrapper<Profile_Sphere_Association_Mutation_Response>;
  profile_sphere_association_obj_rel_insert_input: Profile_Sphere_Association_Obj_Rel_Insert_Input;
  profile_sphere_association_order_by: Profile_Sphere_Association_Order_By;
  profile_sphere_association_select_column: Profile_Sphere_Association_Select_Column;
  profile_sphere_association_set_input: Profile_Sphere_Association_Set_Input;
  profile_sphere_association_stddev_fields: ResolverTypeWrapper<Profile_Sphere_Association_Stddev_Fields>;
  profile_sphere_association_stddev_order_by: Profile_Sphere_Association_Stddev_Order_By;
  profile_sphere_association_stddev_pop_fields: ResolverTypeWrapper<Profile_Sphere_Association_Stddev_Pop_Fields>;
  profile_sphere_association_stddev_pop_order_by: Profile_Sphere_Association_Stddev_Pop_Order_By;
  profile_sphere_association_stddev_samp_fields: ResolverTypeWrapper<Profile_Sphere_Association_Stddev_Samp_Fields>;
  profile_sphere_association_stddev_samp_order_by: Profile_Sphere_Association_Stddev_Samp_Order_By;
  profile_sphere_association_sum_fields: ResolverTypeWrapper<Profile_Sphere_Association_Sum_Fields>;
  profile_sphere_association_sum_order_by: Profile_Sphere_Association_Sum_Order_By;
  profile_sphere_association_var_pop_fields: ResolverTypeWrapper<Profile_Sphere_Association_Var_Pop_Fields>;
  profile_sphere_association_var_pop_order_by: Profile_Sphere_Association_Var_Pop_Order_By;
  profile_sphere_association_var_samp_fields: ResolverTypeWrapper<Profile_Sphere_Association_Var_Samp_Fields>;
  profile_sphere_association_var_samp_order_by: Profile_Sphere_Association_Var_Samp_Order_By;
  profile_sphere_association_variance_fields: ResolverTypeWrapper<Profile_Sphere_Association_Variance_Fields>;
  profile_sphere_association_variance_order_by: Profile_Sphere_Association_Variance_Order_By;
  profiles: ResolverTypeWrapper<Profiles>;
  profiles_aggregate: ResolverTypeWrapper<Profiles_Aggregate>;
  profiles_aggregate_fields: ResolverTypeWrapper<Profiles_Aggregate_Fields>;
  profiles_aggregate_order_by: Profiles_Aggregate_Order_By;
  profiles_arr_rel_insert_input: Profiles_Arr_Rel_Insert_Input;
  profiles_avg_fields: ResolverTypeWrapper<Profiles_Avg_Fields>;
  profiles_avg_order_by: Profiles_Avg_Order_By;
  profiles_bool_exp: Profiles_Bool_Exp;
  profiles_constraint: Profiles_Constraint;
  profiles_inc_input: Profiles_Inc_Input;
  profiles_insert_input: Profiles_Insert_Input;
  profiles_max_fields: ResolverTypeWrapper<Profiles_Max_Fields>;
  profiles_max_order_by: Profiles_Max_Order_By;
  profiles_min_fields: ResolverTypeWrapper<Profiles_Min_Fields>;
  profiles_min_order_by: Profiles_Min_Order_By;
  profiles_mutation_response: ResolverTypeWrapper<Profiles_Mutation_Response>;
  profiles_obj_rel_insert_input: Profiles_Obj_Rel_Insert_Input;
  profiles_on_conflict: Profiles_On_Conflict;
  profiles_order_by: Profiles_Order_By;
  profiles_pk_columns_input: Profiles_Pk_Columns_Input;
  profiles_select_column: Profiles_Select_Column;
  profiles_set_input: Profiles_Set_Input;
  profiles_stddev_fields: ResolverTypeWrapper<Profiles_Stddev_Fields>;
  profiles_stddev_order_by: Profiles_Stddev_Order_By;
  profiles_stddev_pop_fields: ResolverTypeWrapper<Profiles_Stddev_Pop_Fields>;
  profiles_stddev_pop_order_by: Profiles_Stddev_Pop_Order_By;
  profiles_stddev_samp_fields: ResolverTypeWrapper<Profiles_Stddev_Samp_Fields>;
  profiles_stddev_samp_order_by: Profiles_Stddev_Samp_Order_By;
  profiles_sum_fields: ResolverTypeWrapper<Profiles_Sum_Fields>;
  profiles_sum_order_by: Profiles_Sum_Order_By;
  profiles_update_column: Profiles_Update_Column;
  profiles_var_pop_fields: ResolverTypeWrapper<Profiles_Var_Pop_Fields>;
  profiles_var_pop_order_by: Profiles_Var_Pop_Order_By;
  profiles_var_samp_fields: ResolverTypeWrapper<Profiles_Var_Samp_Fields>;
  profiles_var_samp_order_by: Profiles_Var_Samp_Order_By;
  profiles_variance_fields: ResolverTypeWrapper<Profiles_Variance_Fields>;
  profiles_variance_order_by: Profiles_Variance_Order_By;
  query_root: ResolverTypeWrapper<{}>;
  question_lesson_association: ResolverTypeWrapper<Question_Lesson_Association>;
  question_lesson_association_aggregate: ResolverTypeWrapper<Question_Lesson_Association_Aggregate>;
  question_lesson_association_aggregate_fields: ResolverTypeWrapper<Question_Lesson_Association_Aggregate_Fields>;
  question_lesson_association_aggregate_order_by: Question_Lesson_Association_Aggregate_Order_By;
  question_lesson_association_arr_rel_insert_input: Question_Lesson_Association_Arr_Rel_Insert_Input;
  question_lesson_association_avg_fields: ResolverTypeWrapper<Question_Lesson_Association_Avg_Fields>;
  question_lesson_association_avg_order_by: Question_Lesson_Association_Avg_Order_By;
  question_lesson_association_bool_exp: Question_Lesson_Association_Bool_Exp;
  question_lesson_association_constraint: Question_Lesson_Association_Constraint;
  question_lesson_association_inc_input: Question_Lesson_Association_Inc_Input;
  question_lesson_association_insert_input: Question_Lesson_Association_Insert_Input;
  question_lesson_association_max_fields: ResolverTypeWrapper<Question_Lesson_Association_Max_Fields>;
  question_lesson_association_max_order_by: Question_Lesson_Association_Max_Order_By;
  question_lesson_association_min_fields: ResolverTypeWrapper<Question_Lesson_Association_Min_Fields>;
  question_lesson_association_min_order_by: Question_Lesson_Association_Min_Order_By;
  question_lesson_association_mutation_response: ResolverTypeWrapper<Question_Lesson_Association_Mutation_Response>;
  question_lesson_association_obj_rel_insert_input: Question_Lesson_Association_Obj_Rel_Insert_Input;
  question_lesson_association_on_conflict: Question_Lesson_Association_On_Conflict;
  question_lesson_association_order_by: Question_Lesson_Association_Order_By;
  question_lesson_association_pk_columns_input: Question_Lesson_Association_Pk_Columns_Input;
  question_lesson_association_select_column: Question_Lesson_Association_Select_Column;
  question_lesson_association_set_input: Question_Lesson_Association_Set_Input;
  question_lesson_association_stddev_fields: ResolverTypeWrapper<Question_Lesson_Association_Stddev_Fields>;
  question_lesson_association_stddev_order_by: Question_Lesson_Association_Stddev_Order_By;
  question_lesson_association_stddev_pop_fields: ResolverTypeWrapper<Question_Lesson_Association_Stddev_Pop_Fields>;
  question_lesson_association_stddev_pop_order_by: Question_Lesson_Association_Stddev_Pop_Order_By;
  question_lesson_association_stddev_samp_fields: ResolverTypeWrapper<Question_Lesson_Association_Stddev_Samp_Fields>;
  question_lesson_association_stddev_samp_order_by: Question_Lesson_Association_Stddev_Samp_Order_By;
  question_lesson_association_sum_fields: ResolverTypeWrapper<Question_Lesson_Association_Sum_Fields>;
  question_lesson_association_sum_order_by: Question_Lesson_Association_Sum_Order_By;
  question_lesson_association_update_column: Question_Lesson_Association_Update_Column;
  question_lesson_association_var_pop_fields: ResolverTypeWrapper<Question_Lesson_Association_Var_Pop_Fields>;
  question_lesson_association_var_pop_order_by: Question_Lesson_Association_Var_Pop_Order_By;
  question_lesson_association_var_samp_fields: ResolverTypeWrapper<Question_Lesson_Association_Var_Samp_Fields>;
  question_lesson_association_var_samp_order_by: Question_Lesson_Association_Var_Samp_Order_By;
  question_lesson_association_variance_fields: ResolverTypeWrapper<Question_Lesson_Association_Variance_Fields>;
  question_lesson_association_variance_order_by: Question_Lesson_Association_Variance_Order_By;
  questions: ResolverTypeWrapper<Questions>;
  questions_aggregate: ResolverTypeWrapper<Questions_Aggregate>;
  questions_aggregate_fields: ResolverTypeWrapper<Questions_Aggregate_Fields>;
  questions_aggregate_order_by: Questions_Aggregate_Order_By;
  questions_arr_rel_insert_input: Questions_Arr_Rel_Insert_Input;
  questions_avg_fields: ResolverTypeWrapper<Questions_Avg_Fields>;
  questions_avg_order_by: Questions_Avg_Order_By;
  questions_bool_exp: Questions_Bool_Exp;
  questions_constraint: Questions_Constraint;
  questions_inc_input: Questions_Inc_Input;
  questions_insert_input: Questions_Insert_Input;
  questions_max_fields: ResolverTypeWrapper<Questions_Max_Fields>;
  questions_max_order_by: Questions_Max_Order_By;
  questions_min_fields: ResolverTypeWrapper<Questions_Min_Fields>;
  questions_min_order_by: Questions_Min_Order_By;
  questions_mutation_response: ResolverTypeWrapper<Questions_Mutation_Response>;
  questions_obj_rel_insert_input: Questions_Obj_Rel_Insert_Input;
  questions_on_conflict: Questions_On_Conflict;
  questions_order_by: Questions_Order_By;
  questions_pk_columns_input: Questions_Pk_Columns_Input;
  questions_select_column: Questions_Select_Column;
  questions_set_input: Questions_Set_Input;
  questions_stddev_fields: ResolverTypeWrapper<Questions_Stddev_Fields>;
  questions_stddev_order_by: Questions_Stddev_Order_By;
  questions_stddev_pop_fields: ResolverTypeWrapper<Questions_Stddev_Pop_Fields>;
  questions_stddev_pop_order_by: Questions_Stddev_Pop_Order_By;
  questions_stddev_samp_fields: ResolverTypeWrapper<Questions_Stddev_Samp_Fields>;
  questions_stddev_samp_order_by: Questions_Stddev_Samp_Order_By;
  questions_sum_fields: ResolverTypeWrapper<Questions_Sum_Fields>;
  questions_sum_order_by: Questions_Sum_Order_By;
  questions_update_column: Questions_Update_Column;
  questions_var_pop_fields: ResolverTypeWrapper<Questions_Var_Pop_Fields>;
  questions_var_pop_order_by: Questions_Var_Pop_Order_By;
  questions_var_samp_fields: ResolverTypeWrapper<Questions_Var_Samp_Fields>;
  questions_var_samp_order_by: Questions_Var_Samp_Order_By;
  questions_variance_fields: ResolverTypeWrapper<Questions_Variance_Fields>;
  questions_variance_order_by: Questions_Variance_Order_By;
  registration_billings: ResolverTypeWrapper<Registration_Billings>;
  registration_billings_aggregate: ResolverTypeWrapper<Registration_Billings_Aggregate>;
  registration_billings_aggregate_fields: ResolverTypeWrapper<Registration_Billings_Aggregate_Fields>;
  registration_billings_aggregate_order_by: Registration_Billings_Aggregate_Order_By;
  registration_billings_arr_rel_insert_input: Registration_Billings_Arr_Rel_Insert_Input;
  registration_billings_avg_fields: ResolverTypeWrapper<Registration_Billings_Avg_Fields>;
  registration_billings_avg_order_by: Registration_Billings_Avg_Order_By;
  registration_billings_bool_exp: Registration_Billings_Bool_Exp;
  registration_billings_constraint: Registration_Billings_Constraint;
  registration_billings_inc_input: Registration_Billings_Inc_Input;
  registration_billings_insert_input: Registration_Billings_Insert_Input;
  registration_billings_max_fields: ResolverTypeWrapper<Registration_Billings_Max_Fields>;
  registration_billings_max_order_by: Registration_Billings_Max_Order_By;
  registration_billings_min_fields: ResolverTypeWrapper<Registration_Billings_Min_Fields>;
  registration_billings_min_order_by: Registration_Billings_Min_Order_By;
  registration_billings_mutation_response: ResolverTypeWrapper<Registration_Billings_Mutation_Response>;
  registration_billings_obj_rel_insert_input: Registration_Billings_Obj_Rel_Insert_Input;
  registration_billings_on_conflict: Registration_Billings_On_Conflict;
  registration_billings_order_by: Registration_Billings_Order_By;
  registration_billings_pk_columns_input: Registration_Billings_Pk_Columns_Input;
  registration_billings_select_column: Registration_Billings_Select_Column;
  registration_billings_set_input: Registration_Billings_Set_Input;
  registration_billings_stddev_fields: ResolverTypeWrapper<Registration_Billings_Stddev_Fields>;
  registration_billings_stddev_order_by: Registration_Billings_Stddev_Order_By;
  registration_billings_stddev_pop_fields: ResolverTypeWrapper<Registration_Billings_Stddev_Pop_Fields>;
  registration_billings_stddev_pop_order_by: Registration_Billings_Stddev_Pop_Order_By;
  registration_billings_stddev_samp_fields: ResolverTypeWrapper<Registration_Billings_Stddev_Samp_Fields>;
  registration_billings_stddev_samp_order_by: Registration_Billings_Stddev_Samp_Order_By;
  registration_billings_sum_fields: ResolverTypeWrapper<Registration_Billings_Sum_Fields>;
  registration_billings_sum_order_by: Registration_Billings_Sum_Order_By;
  registration_billings_update_column: Registration_Billings_Update_Column;
  registration_billings_var_pop_fields: ResolverTypeWrapper<Registration_Billings_Var_Pop_Fields>;
  registration_billings_var_pop_order_by: Registration_Billings_Var_Pop_Order_By;
  registration_billings_var_samp_fields: ResolverTypeWrapper<Registration_Billings_Var_Samp_Fields>;
  registration_billings_var_samp_order_by: Registration_Billings_Var_Samp_Order_By;
  registration_billings_variance_fields: ResolverTypeWrapper<Registration_Billings_Variance_Fields>;
  registration_billings_variance_order_by: Registration_Billings_Variance_Order_By;
  registrations: ResolverTypeWrapper<Registrations>;
  registrations_aggregate: ResolverTypeWrapper<Registrations_Aggregate>;
  registrations_aggregate_fields: ResolverTypeWrapper<Registrations_Aggregate_Fields>;
  registrations_aggregate_order_by: Registrations_Aggregate_Order_By;
  registrations_arr_rel_insert_input: Registrations_Arr_Rel_Insert_Input;
  registrations_avg_fields: ResolverTypeWrapper<Registrations_Avg_Fields>;
  registrations_avg_order_by: Registrations_Avg_Order_By;
  registrations_bool_exp: Registrations_Bool_Exp;
  registrations_constraint: Registrations_Constraint;
  registrations_inc_input: Registrations_Inc_Input;
  registrations_insert_input: Registrations_Insert_Input;
  registrations_max_fields: ResolverTypeWrapper<Registrations_Max_Fields>;
  registrations_max_order_by: Registrations_Max_Order_By;
  registrations_min_fields: ResolverTypeWrapper<Registrations_Min_Fields>;
  registrations_min_order_by: Registrations_Min_Order_By;
  registrations_mutation_response: ResolverTypeWrapper<Registrations_Mutation_Response>;
  registrations_obj_rel_insert_input: Registrations_Obj_Rel_Insert_Input;
  registrations_on_conflict: Registrations_On_Conflict;
  registrations_order_by: Registrations_Order_By;
  registrations_pk_columns_input: Registrations_Pk_Columns_Input;
  registrations_select_column: Registrations_Select_Column;
  registrations_set_input: Registrations_Set_Input;
  registrations_stddev_fields: ResolverTypeWrapper<Registrations_Stddev_Fields>;
  registrations_stddev_order_by: Registrations_Stddev_Order_By;
  registrations_stddev_pop_fields: ResolverTypeWrapper<Registrations_Stddev_Pop_Fields>;
  registrations_stddev_pop_order_by: Registrations_Stddev_Pop_Order_By;
  registrations_stddev_samp_fields: ResolverTypeWrapper<Registrations_Stddev_Samp_Fields>;
  registrations_stddev_samp_order_by: Registrations_Stddev_Samp_Order_By;
  registrations_sum_fields: ResolverTypeWrapper<Registrations_Sum_Fields>;
  registrations_sum_order_by: Registrations_Sum_Order_By;
  registrations_update_column: Registrations_Update_Column;
  registrations_var_pop_fields: ResolverTypeWrapper<Registrations_Var_Pop_Fields>;
  registrations_var_pop_order_by: Registrations_Var_Pop_Order_By;
  registrations_var_samp_fields: ResolverTypeWrapper<Registrations_Var_Samp_Fields>;
  registrations_var_samp_order_by: Registrations_Var_Samp_Order_By;
  registrations_variance_fields: ResolverTypeWrapper<Registrations_Variance_Fields>;
  registrations_variance_order_by: Registrations_Variance_Order_By;
  result_plan_association: ResolverTypeWrapper<Result_Plan_Association>;
  result_plan_association_aggregate: ResolverTypeWrapper<Result_Plan_Association_Aggregate>;
  result_plan_association_aggregate_fields: ResolverTypeWrapper<Result_Plan_Association_Aggregate_Fields>;
  result_plan_association_aggregate_order_by: Result_Plan_Association_Aggregate_Order_By;
  result_plan_association_arr_rel_insert_input: Result_Plan_Association_Arr_Rel_Insert_Input;
  result_plan_association_avg_fields: ResolverTypeWrapper<Result_Plan_Association_Avg_Fields>;
  result_plan_association_avg_order_by: Result_Plan_Association_Avg_Order_By;
  result_plan_association_bool_exp: Result_Plan_Association_Bool_Exp;
  result_plan_association_constraint: Result_Plan_Association_Constraint;
  result_plan_association_inc_input: Result_Plan_Association_Inc_Input;
  result_plan_association_insert_input: Result_Plan_Association_Insert_Input;
  result_plan_association_max_fields: ResolverTypeWrapper<Result_Plan_Association_Max_Fields>;
  result_plan_association_max_order_by: Result_Plan_Association_Max_Order_By;
  result_plan_association_min_fields: ResolverTypeWrapper<Result_Plan_Association_Min_Fields>;
  result_plan_association_min_order_by: Result_Plan_Association_Min_Order_By;
  result_plan_association_mutation_response: ResolverTypeWrapper<Result_Plan_Association_Mutation_Response>;
  result_plan_association_obj_rel_insert_input: Result_Plan_Association_Obj_Rel_Insert_Input;
  result_plan_association_on_conflict: Result_Plan_Association_On_Conflict;
  result_plan_association_order_by: Result_Plan_Association_Order_By;
  result_plan_association_pk_columns_input: Result_Plan_Association_Pk_Columns_Input;
  result_plan_association_select_column: Result_Plan_Association_Select_Column;
  result_plan_association_set_input: Result_Plan_Association_Set_Input;
  result_plan_association_stddev_fields: ResolverTypeWrapper<Result_Plan_Association_Stddev_Fields>;
  result_plan_association_stddev_order_by: Result_Plan_Association_Stddev_Order_By;
  result_plan_association_stddev_pop_fields: ResolverTypeWrapper<Result_Plan_Association_Stddev_Pop_Fields>;
  result_plan_association_stddev_pop_order_by: Result_Plan_Association_Stddev_Pop_Order_By;
  result_plan_association_stddev_samp_fields: ResolverTypeWrapper<Result_Plan_Association_Stddev_Samp_Fields>;
  result_plan_association_stddev_samp_order_by: Result_Plan_Association_Stddev_Samp_Order_By;
  result_plan_association_sum_fields: ResolverTypeWrapper<Result_Plan_Association_Sum_Fields>;
  result_plan_association_sum_order_by: Result_Plan_Association_Sum_Order_By;
  result_plan_association_update_column: Result_Plan_Association_Update_Column;
  result_plan_association_var_pop_fields: ResolverTypeWrapper<Result_Plan_Association_Var_Pop_Fields>;
  result_plan_association_var_pop_order_by: Result_Plan_Association_Var_Pop_Order_By;
  result_plan_association_var_samp_fields: ResolverTypeWrapper<Result_Plan_Association_Var_Samp_Fields>;
  result_plan_association_var_samp_order_by: Result_Plan_Association_Var_Samp_Order_By;
  result_plan_association_variance_fields: ResolverTypeWrapper<Result_Plan_Association_Variance_Fields>;
  result_plan_association_variance_order_by: Result_Plan_Association_Variance_Order_By;
  results: ResolverTypeWrapper<Results>;
  results_aggregate: ResolverTypeWrapper<Results_Aggregate>;
  results_aggregate_fields: ResolverTypeWrapper<Results_Aggregate_Fields>;
  results_aggregate_order_by: Results_Aggregate_Order_By;
  results_arr_rel_insert_input: Results_Arr_Rel_Insert_Input;
  results_avg_fields: ResolverTypeWrapper<Results_Avg_Fields>;
  results_avg_order_by: Results_Avg_Order_By;
  results_bool_exp: Results_Bool_Exp;
  results_constraint: Results_Constraint;
  results_inc_input: Results_Inc_Input;
  results_insert_input: Results_Insert_Input;
  results_max_fields: ResolverTypeWrapper<Results_Max_Fields>;
  results_max_order_by: Results_Max_Order_By;
  results_min_fields: ResolverTypeWrapper<Results_Min_Fields>;
  results_min_order_by: Results_Min_Order_By;
  results_mutation_response: ResolverTypeWrapper<Results_Mutation_Response>;
  results_obj_rel_insert_input: Results_Obj_Rel_Insert_Input;
  results_on_conflict: Results_On_Conflict;
  results_order_by: Results_Order_By;
  results_pk_columns_input: Results_Pk_Columns_Input;
  results_select_column: Results_Select_Column;
  results_set_input: Results_Set_Input;
  results_stddev_fields: ResolverTypeWrapper<Results_Stddev_Fields>;
  results_stddev_order_by: Results_Stddev_Order_By;
  results_stddev_pop_fields: ResolverTypeWrapper<Results_Stddev_Pop_Fields>;
  results_stddev_pop_order_by: Results_Stddev_Pop_Order_By;
  results_stddev_samp_fields: ResolverTypeWrapper<Results_Stddev_Samp_Fields>;
  results_stddev_samp_order_by: Results_Stddev_Samp_Order_By;
  results_sum_fields: ResolverTypeWrapper<Results_Sum_Fields>;
  results_sum_order_by: Results_Sum_Order_By;
  results_update_column: Results_Update_Column;
  results_var_pop_fields: ResolverTypeWrapper<Results_Var_Pop_Fields>;
  results_var_pop_order_by: Results_Var_Pop_Order_By;
  results_var_samp_fields: ResolverTypeWrapper<Results_Var_Samp_Fields>;
  results_var_samp_order_by: Results_Var_Samp_Order_By;
  results_variance_fields: ResolverTypeWrapper<Results_Variance_Fields>;
  results_variance_order_by: Results_Variance_Order_By;
  scores: ResolverTypeWrapper<Scores>;
  scores_aggregate: ResolverTypeWrapper<Scores_Aggregate>;
  scores_aggregate_fields: ResolverTypeWrapper<Scores_Aggregate_Fields>;
  scores_aggregate_order_by: Scores_Aggregate_Order_By;
  scores_arr_rel_insert_input: Scores_Arr_Rel_Insert_Input;
  scores_avg_fields: ResolverTypeWrapper<Scores_Avg_Fields>;
  scores_avg_order_by: Scores_Avg_Order_By;
  scores_bool_exp: Scores_Bool_Exp;
  scores_constraint: Scores_Constraint;
  scores_inc_input: Scores_Inc_Input;
  scores_insert_input: Scores_Insert_Input;
  scores_max_fields: ResolverTypeWrapper<Scores_Max_Fields>;
  scores_max_order_by: Scores_Max_Order_By;
  scores_min_fields: ResolverTypeWrapper<Scores_Min_Fields>;
  scores_min_order_by: Scores_Min_Order_By;
  scores_mutation_response: ResolverTypeWrapper<Scores_Mutation_Response>;
  scores_obj_rel_insert_input: Scores_Obj_Rel_Insert_Input;
  scores_on_conflict: Scores_On_Conflict;
  scores_order_by: Scores_Order_By;
  scores_pk_columns_input: Scores_Pk_Columns_Input;
  scores_select_column: Scores_Select_Column;
  scores_set_input: Scores_Set_Input;
  scores_stddev_fields: ResolverTypeWrapper<Scores_Stddev_Fields>;
  scores_stddev_order_by: Scores_Stddev_Order_By;
  scores_stddev_pop_fields: ResolverTypeWrapper<Scores_Stddev_Pop_Fields>;
  scores_stddev_pop_order_by: Scores_Stddev_Pop_Order_By;
  scores_stddev_samp_fields: ResolverTypeWrapper<Scores_Stddev_Samp_Fields>;
  scores_stddev_samp_order_by: Scores_Stddev_Samp_Order_By;
  scores_sum_fields: ResolverTypeWrapper<Scores_Sum_Fields>;
  scores_sum_order_by: Scores_Sum_Order_By;
  scores_update_column: Scores_Update_Column;
  scores_var_pop_fields: ResolverTypeWrapper<Scores_Var_Pop_Fields>;
  scores_var_pop_order_by: Scores_Var_Pop_Order_By;
  scores_var_samp_fields: ResolverTypeWrapper<Scores_Var_Samp_Fields>;
  scores_var_samp_order_by: Scores_Var_Samp_Order_By;
  scores_variance_fields: ResolverTypeWrapper<Scores_Variance_Fields>;
  scores_variance_order_by: Scores_Variance_Order_By;
  spheres: ResolverTypeWrapper<Spheres>;
  spheres_aggregate: ResolverTypeWrapper<Spheres_Aggregate>;
  spheres_aggregate_fields: ResolverTypeWrapper<Spheres_Aggregate_Fields>;
  spheres_aggregate_order_by: Spheres_Aggregate_Order_By;
  spheres_arr_rel_insert_input: Spheres_Arr_Rel_Insert_Input;
  spheres_avg_fields: ResolverTypeWrapper<Spheres_Avg_Fields>;
  spheres_avg_order_by: Spheres_Avg_Order_By;
  spheres_bool_exp: Spheres_Bool_Exp;
  spheres_constraint: Spheres_Constraint;
  spheres_inc_input: Spheres_Inc_Input;
  spheres_insert_input: Spheres_Insert_Input;
  spheres_max_fields: ResolverTypeWrapper<Spheres_Max_Fields>;
  spheres_max_order_by: Spheres_Max_Order_By;
  spheres_min_fields: ResolverTypeWrapper<Spheres_Min_Fields>;
  spheres_min_order_by: Spheres_Min_Order_By;
  spheres_mutation_response: ResolverTypeWrapper<Spheres_Mutation_Response>;
  spheres_obj_rel_insert_input: Spheres_Obj_Rel_Insert_Input;
  spheres_on_conflict: Spheres_On_Conflict;
  spheres_order_by: Spheres_Order_By;
  spheres_pk_columns_input: Spheres_Pk_Columns_Input;
  spheres_select_column: Spheres_Select_Column;
  spheres_set_input: Spheres_Set_Input;
  spheres_stddev_fields: ResolverTypeWrapper<Spheres_Stddev_Fields>;
  spheres_stddev_order_by: Spheres_Stddev_Order_By;
  spheres_stddev_pop_fields: ResolverTypeWrapper<Spheres_Stddev_Pop_Fields>;
  spheres_stddev_pop_order_by: Spheres_Stddev_Pop_Order_By;
  spheres_stddev_samp_fields: ResolverTypeWrapper<Spheres_Stddev_Samp_Fields>;
  spheres_stddev_samp_order_by: Spheres_Stddev_Samp_Order_By;
  spheres_sum_fields: ResolverTypeWrapper<Spheres_Sum_Fields>;
  spheres_sum_order_by: Spheres_Sum_Order_By;
  spheres_update_column: Spheres_Update_Column;
  spheres_var_pop_fields: ResolverTypeWrapper<Spheres_Var_Pop_Fields>;
  spheres_var_pop_order_by: Spheres_Var_Pop_Order_By;
  spheres_var_samp_fields: ResolverTypeWrapper<Spheres_Var_Samp_Fields>;
  spheres_var_samp_order_by: Spheres_Var_Samp_Order_By;
  spheres_variance_fields: ResolverTypeWrapper<Spheres_Variance_Fields>;
  spheres_variance_order_by: Spheres_Variance_Order_By;
  subscription_root: ResolverTypeWrapper<{}>;
  supports: ResolverTypeWrapper<Supports>;
  supports_aggregate: ResolverTypeWrapper<Supports_Aggregate>;
  supports_aggregate_fields: ResolverTypeWrapper<Supports_Aggregate_Fields>;
  supports_aggregate_order_by: Supports_Aggregate_Order_By;
  supports_arr_rel_insert_input: Supports_Arr_Rel_Insert_Input;
  supports_avg_fields: ResolverTypeWrapper<Supports_Avg_Fields>;
  supports_avg_order_by: Supports_Avg_Order_By;
  supports_bool_exp: Supports_Bool_Exp;
  supports_constraint: Supports_Constraint;
  supports_inc_input: Supports_Inc_Input;
  supports_insert_input: Supports_Insert_Input;
  supports_max_fields: ResolverTypeWrapper<Supports_Max_Fields>;
  supports_max_order_by: Supports_Max_Order_By;
  supports_min_fields: ResolverTypeWrapper<Supports_Min_Fields>;
  supports_min_order_by: Supports_Min_Order_By;
  supports_mutation_response: ResolverTypeWrapper<Supports_Mutation_Response>;
  supports_obj_rel_insert_input: Supports_Obj_Rel_Insert_Input;
  supports_on_conflict: Supports_On_Conflict;
  supports_order_by: Supports_Order_By;
  supports_pk_columns_input: Supports_Pk_Columns_Input;
  supports_select_column: Supports_Select_Column;
  supports_set_input: Supports_Set_Input;
  supports_stddev_fields: ResolverTypeWrapper<Supports_Stddev_Fields>;
  supports_stddev_order_by: Supports_Stddev_Order_By;
  supports_stddev_pop_fields: ResolverTypeWrapper<Supports_Stddev_Pop_Fields>;
  supports_stddev_pop_order_by: Supports_Stddev_Pop_Order_By;
  supports_stddev_samp_fields: ResolverTypeWrapper<Supports_Stddev_Samp_Fields>;
  supports_stddev_samp_order_by: Supports_Stddev_Samp_Order_By;
  supports_sum_fields: ResolverTypeWrapper<Supports_Sum_Fields>;
  supports_sum_order_by: Supports_Sum_Order_By;
  supports_update_column: Supports_Update_Column;
  supports_var_pop_fields: ResolverTypeWrapper<Supports_Var_Pop_Fields>;
  supports_var_pop_order_by: Supports_Var_Pop_Order_By;
  supports_var_samp_fields: ResolverTypeWrapper<Supports_Var_Samp_Fields>;
  supports_var_samp_order_by: Supports_Var_Samp_Order_By;
  supports_variance_fields: ResolverTypeWrapper<Supports_Variance_Fields>;
  supports_variance_order_by: Supports_Variance_Order_By;
  timestamp: ResolverTypeWrapper<Scalars['timestamp']>;
  timestamp_comparison_exp: Timestamp_Comparison_Exp;
  timestamptz: ResolverTypeWrapper<Scalars['timestamptz']>;
  timestamptz_comparison_exp: Timestamptz_Comparison_Exp;
  users: ResolverTypeWrapper<Users>;
  users_aggregate: ResolverTypeWrapper<Users_Aggregate>;
  users_aggregate_fields: ResolverTypeWrapper<Users_Aggregate_Fields>;
  users_aggregate_order_by: Users_Aggregate_Order_By;
  users_arr_rel_insert_input: Users_Arr_Rel_Insert_Input;
  users_avg_fields: ResolverTypeWrapper<Users_Avg_Fields>;
  users_avg_order_by: Users_Avg_Order_By;
  users_bool_exp: Users_Bool_Exp;
  users_constraint: Users_Constraint;
  users_inc_input: Users_Inc_Input;
  users_insert_input: Users_Insert_Input;
  users_max_fields: ResolverTypeWrapper<Users_Max_Fields>;
  users_max_order_by: Users_Max_Order_By;
  users_min_fields: ResolverTypeWrapper<Users_Min_Fields>;
  users_min_order_by: Users_Min_Order_By;
  users_mutation_response: ResolverTypeWrapper<Users_Mutation_Response>;
  users_obj_rel_insert_input: Users_Obj_Rel_Insert_Input;
  users_on_conflict: Users_On_Conflict;
  users_order_by: Users_Order_By;
  users_pk_columns_input: Users_Pk_Columns_Input;
  users_select_column: Users_Select_Column;
  users_set_input: Users_Set_Input;
  users_stddev_fields: ResolverTypeWrapper<Users_Stddev_Fields>;
  users_stddev_order_by: Users_Stddev_Order_By;
  users_stddev_pop_fields: ResolverTypeWrapper<Users_Stddev_Pop_Fields>;
  users_stddev_pop_order_by: Users_Stddev_Pop_Order_By;
  users_stddev_samp_fields: ResolverTypeWrapper<Users_Stddev_Samp_Fields>;
  users_stddev_samp_order_by: Users_Stddev_Samp_Order_By;
  users_sum_fields: ResolverTypeWrapper<Users_Sum_Fields>;
  users_sum_order_by: Users_Sum_Order_By;
  users_update_column: Users_Update_Column;
  users_var_pop_fields: ResolverTypeWrapper<Users_Var_Pop_Fields>;
  users_var_pop_order_by: Users_Var_Pop_Order_By;
  users_var_samp_fields: ResolverTypeWrapper<Users_Var_Samp_Fields>;
  users_var_samp_order_by: Users_Var_Samp_Order_By;
  users_variance_fields: ResolverTypeWrapper<Users_Variance_Fields>;
  users_variance_order_by: Users_Variance_Order_By;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  String: Scalars['String'];
  Boolean: Scalars['Boolean'];
  Boolean_comparison_exp: Boolean_Comparison_Exp;
  Float_comparison_exp: Float_Comparison_Exp;
  Float: Scalars['Float'];
  Int_comparison_exp: Int_Comparison_Exp;
  Int: Scalars['Int'];
  String_comparison_exp: String_Comparison_Exp;
  activation_codes: Activation_Codes;
  activation_codes_aggregate: Activation_Codes_Aggregate;
  activation_codes_aggregate_fields: Activation_Codes_Aggregate_Fields;
  activation_codes_aggregate_order_by: Activation_Codes_Aggregate_Order_By;
  activation_codes_arr_rel_insert_input: Activation_Codes_Arr_Rel_Insert_Input;
  activation_codes_avg_fields: Activation_Codes_Avg_Fields;
  activation_codes_avg_order_by: Activation_Codes_Avg_Order_By;
  activation_codes_bool_exp: Activation_Codes_Bool_Exp;
  activation_codes_inc_input: Activation_Codes_Inc_Input;
  activation_codes_insert_input: Activation_Codes_Insert_Input;
  activation_codes_max_fields: Activation_Codes_Max_Fields;
  activation_codes_max_order_by: Activation_Codes_Max_Order_By;
  activation_codes_min_fields: Activation_Codes_Min_Fields;
  activation_codes_min_order_by: Activation_Codes_Min_Order_By;
  activation_codes_mutation_response: Activation_Codes_Mutation_Response;
  activation_codes_obj_rel_insert_input: Activation_Codes_Obj_Rel_Insert_Input;
  activation_codes_on_conflict: Activation_Codes_On_Conflict;
  activation_codes_order_by: Activation_Codes_Order_By;
  activation_codes_pk_columns_input: Activation_Codes_Pk_Columns_Input;
  activation_codes_set_input: Activation_Codes_Set_Input;
  activation_codes_stddev_fields: Activation_Codes_Stddev_Fields;
  activation_codes_stddev_order_by: Activation_Codes_Stddev_Order_By;
  activation_codes_stddev_pop_fields: Activation_Codes_Stddev_Pop_Fields;
  activation_codes_stddev_pop_order_by: Activation_Codes_Stddev_Pop_Order_By;
  activation_codes_stddev_samp_fields: Activation_Codes_Stddev_Samp_Fields;
  activation_codes_stddev_samp_order_by: Activation_Codes_Stddev_Samp_Order_By;
  activation_codes_sum_fields: Activation_Codes_Sum_Fields;
  activation_codes_sum_order_by: Activation_Codes_Sum_Order_By;
  activation_codes_var_pop_fields: Activation_Codes_Var_Pop_Fields;
  activation_codes_var_pop_order_by: Activation_Codes_Var_Pop_Order_By;
  activation_codes_var_samp_fields: Activation_Codes_Var_Samp_Fields;
  activation_codes_var_samp_order_by: Activation_Codes_Var_Samp_Order_By;
  activation_codes_variance_fields: Activation_Codes_Variance_Fields;
  activation_codes_variance_order_by: Activation_Codes_Variance_Order_By;
  answers: Answers;
  answers_aggregate: Answers_Aggregate;
  answers_aggregate_fields: Answers_Aggregate_Fields;
  answers_aggregate_order_by: Answers_Aggregate_Order_By;
  answers_arr_rel_insert_input: Answers_Arr_Rel_Insert_Input;
  answers_avg_fields: Answers_Avg_Fields;
  answers_avg_order_by: Answers_Avg_Order_By;
  answers_bool_exp: Answers_Bool_Exp;
  answers_choice_association: Answers_Choice_Association;
  answers_choice_association_aggregate: Answers_Choice_Association_Aggregate;
  answers_choice_association_aggregate_fields: Answers_Choice_Association_Aggregate_Fields;
  answers_choice_association_aggregate_order_by: Answers_Choice_Association_Aggregate_Order_By;
  answers_choice_association_arr_rel_insert_input: Answers_Choice_Association_Arr_Rel_Insert_Input;
  answers_choice_association_avg_fields: Answers_Choice_Association_Avg_Fields;
  answers_choice_association_avg_order_by: Answers_Choice_Association_Avg_Order_By;
  answers_choice_association_bool_exp: Answers_Choice_Association_Bool_Exp;
  answers_choice_association_inc_input: Answers_Choice_Association_Inc_Input;
  answers_choice_association_insert_input: Answers_Choice_Association_Insert_Input;
  answers_choice_association_max_fields: Answers_Choice_Association_Max_Fields;
  answers_choice_association_max_order_by: Answers_Choice_Association_Max_Order_By;
  answers_choice_association_min_fields: Answers_Choice_Association_Min_Fields;
  answers_choice_association_min_order_by: Answers_Choice_Association_Min_Order_By;
  answers_choice_association_mutation_response: Answers_Choice_Association_Mutation_Response;
  answers_choice_association_obj_rel_insert_input: Answers_Choice_Association_Obj_Rel_Insert_Input;
  answers_choice_association_order_by: Answers_Choice_Association_Order_By;
  answers_choice_association_set_input: Answers_Choice_Association_Set_Input;
  answers_choice_association_stddev_fields: Answers_Choice_Association_Stddev_Fields;
  answers_choice_association_stddev_order_by: Answers_Choice_Association_Stddev_Order_By;
  answers_choice_association_stddev_pop_fields: Answers_Choice_Association_Stddev_Pop_Fields;
  answers_choice_association_stddev_pop_order_by: Answers_Choice_Association_Stddev_Pop_Order_By;
  answers_choice_association_stddev_samp_fields: Answers_Choice_Association_Stddev_Samp_Fields;
  answers_choice_association_stddev_samp_order_by: Answers_Choice_Association_Stddev_Samp_Order_By;
  answers_choice_association_sum_fields: Answers_Choice_Association_Sum_Fields;
  answers_choice_association_sum_order_by: Answers_Choice_Association_Sum_Order_By;
  answers_choice_association_var_pop_fields: Answers_Choice_Association_Var_Pop_Fields;
  answers_choice_association_var_pop_order_by: Answers_Choice_Association_Var_Pop_Order_By;
  answers_choice_association_var_samp_fields: Answers_Choice_Association_Var_Samp_Fields;
  answers_choice_association_var_samp_order_by: Answers_Choice_Association_Var_Samp_Order_By;
  answers_choice_association_variance_fields: Answers_Choice_Association_Variance_Fields;
  answers_choice_association_variance_order_by: Answers_Choice_Association_Variance_Order_By;
  answers_inc_input: Answers_Inc_Input;
  answers_insert_input: Answers_Insert_Input;
  answers_max_fields: Answers_Max_Fields;
  answers_max_order_by: Answers_Max_Order_By;
  answers_min_fields: Answers_Min_Fields;
  answers_min_order_by: Answers_Min_Order_By;
  answers_mutation_response: Answers_Mutation_Response;
  answers_obj_rel_insert_input: Answers_Obj_Rel_Insert_Input;
  answers_on_conflict: Answers_On_Conflict;
  answers_order_by: Answers_Order_By;
  answers_pk_columns_input: Answers_Pk_Columns_Input;
  answers_set_input: Answers_Set_Input;
  answers_stddev_fields: Answers_Stddev_Fields;
  answers_stddev_order_by: Answers_Stddev_Order_By;
  answers_stddev_pop_fields: Answers_Stddev_Pop_Fields;
  answers_stddev_pop_order_by: Answers_Stddev_Pop_Order_By;
  answers_stddev_samp_fields: Answers_Stddev_Samp_Fields;
  answers_stddev_samp_order_by: Answers_Stddev_Samp_Order_By;
  answers_sum_fields: Answers_Sum_Fields;
  answers_sum_order_by: Answers_Sum_Order_By;
  answers_var_pop_fields: Answers_Var_Pop_Fields;
  answers_var_pop_order_by: Answers_Var_Pop_Order_By;
  answers_var_samp_fields: Answers_Var_Samp_Fields;
  answers_var_samp_order_by: Answers_Var_Samp_Order_By;
  answers_variance_fields: Answers_Variance_Fields;
  answers_variance_order_by: Answers_Variance_Order_By;
  bills: Bills;
  bills_aggregate: Bills_Aggregate;
  bills_aggregate_fields: Bills_Aggregate_Fields;
  bills_aggregate_order_by: Bills_Aggregate_Order_By;
  bills_arr_rel_insert_input: Bills_Arr_Rel_Insert_Input;
  bills_avg_fields: Bills_Avg_Fields;
  bills_avg_order_by: Bills_Avg_Order_By;
  bills_bool_exp: Bills_Bool_Exp;
  bills_inc_input: Bills_Inc_Input;
  bills_insert_input: Bills_Insert_Input;
  bills_max_fields: Bills_Max_Fields;
  bills_max_order_by: Bills_Max_Order_By;
  bills_min_fields: Bills_Min_Fields;
  bills_min_order_by: Bills_Min_Order_By;
  bills_mutation_response: Bills_Mutation_Response;
  bills_obj_rel_insert_input: Bills_Obj_Rel_Insert_Input;
  bills_on_conflict: Bills_On_Conflict;
  bills_order_by: Bills_Order_By;
  bills_pk_columns_input: Bills_Pk_Columns_Input;
  bills_set_input: Bills_Set_Input;
  bills_stddev_fields: Bills_Stddev_Fields;
  bills_stddev_order_by: Bills_Stddev_Order_By;
  bills_stddev_pop_fields: Bills_Stddev_Pop_Fields;
  bills_stddev_pop_order_by: Bills_Stddev_Pop_Order_By;
  bills_stddev_samp_fields: Bills_Stddev_Samp_Fields;
  bills_stddev_samp_order_by: Bills_Stddev_Samp_Order_By;
  bills_sum_fields: Bills_Sum_Fields;
  bills_sum_order_by: Bills_Sum_Order_By;
  bills_var_pop_fields: Bills_Var_Pop_Fields;
  bills_var_pop_order_by: Bills_Var_Pop_Order_By;
  bills_var_samp_fields: Bills_Var_Samp_Fields;
  bills_var_samp_order_by: Bills_Var_Samp_Order_By;
  bills_variance_fields: Bills_Variance_Fields;
  bills_variance_order_by: Bills_Variance_Order_By;
  bright_assessment: Bright_Assessment;
  bright_assessment_aggregate: Bright_Assessment_Aggregate;
  bright_assessment_aggregate_fields: Bright_Assessment_Aggregate_Fields;
  bright_assessment_aggregate_order_by: Bright_Assessment_Aggregate_Order_By;
  bright_assessment_arr_rel_insert_input: Bright_Assessment_Arr_Rel_Insert_Input;
  bright_assessment_avg_fields: Bright_Assessment_Avg_Fields;
  bright_assessment_avg_order_by: Bright_Assessment_Avg_Order_By;
  bright_assessment_bool_exp: Bright_Assessment_Bool_Exp;
  bright_assessment_inc_input: Bright_Assessment_Inc_Input;
  bright_assessment_insert_input: Bright_Assessment_Insert_Input;
  bright_assessment_max_fields: Bright_Assessment_Max_Fields;
  bright_assessment_max_order_by: Bright_Assessment_Max_Order_By;
  bright_assessment_min_fields: Bright_Assessment_Min_Fields;
  bright_assessment_min_order_by: Bright_Assessment_Min_Order_By;
  bright_assessment_mutation_response: Bright_Assessment_Mutation_Response;
  bright_assessment_obj_rel_insert_input: Bright_Assessment_Obj_Rel_Insert_Input;
  bright_assessment_on_conflict: Bright_Assessment_On_Conflict;
  bright_assessment_order_by: Bright_Assessment_Order_By;
  bright_assessment_pk_columns_input: Bright_Assessment_Pk_Columns_Input;
  bright_assessment_set_input: Bright_Assessment_Set_Input;
  bright_assessment_stddev_fields: Bright_Assessment_Stddev_Fields;
  bright_assessment_stddev_order_by: Bright_Assessment_Stddev_Order_By;
  bright_assessment_stddev_pop_fields: Bright_Assessment_Stddev_Pop_Fields;
  bright_assessment_stddev_pop_order_by: Bright_Assessment_Stddev_Pop_Order_By;
  bright_assessment_stddev_samp_fields: Bright_Assessment_Stddev_Samp_Fields;
  bright_assessment_stddev_samp_order_by: Bright_Assessment_Stddev_Samp_Order_By;
  bright_assessment_sum_fields: Bright_Assessment_Sum_Fields;
  bright_assessment_sum_order_by: Bright_Assessment_Sum_Order_By;
  bright_assessment_var_pop_fields: Bright_Assessment_Var_Pop_Fields;
  bright_assessment_var_pop_order_by: Bright_Assessment_Var_Pop_Order_By;
  bright_assessment_var_samp_fields: Bright_Assessment_Var_Samp_Fields;
  bright_assessment_var_samp_order_by: Bright_Assessment_Var_Samp_Order_By;
  bright_assessment_variance_fields: Bright_Assessment_Variance_Fields;
  bright_assessment_variance_order_by: Bright_Assessment_Variance_Order_By;
  bright_assessments: Bright_Assessments;
  bright_assessments_aggregate: Bright_Assessments_Aggregate;
  bright_assessments_aggregate_fields: Bright_Assessments_Aggregate_Fields;
  bright_assessments_aggregate_order_by: Bright_Assessments_Aggregate_Order_By;
  bright_assessments_arr_rel_insert_input: Bright_Assessments_Arr_Rel_Insert_Input;
  bright_assessments_avg_fields: Bright_Assessments_Avg_Fields;
  bright_assessments_avg_order_by: Bright_Assessments_Avg_Order_By;
  bright_assessments_bool_exp: Bright_Assessments_Bool_Exp;
  bright_assessments_inc_input: Bright_Assessments_Inc_Input;
  bright_assessments_insert_input: Bright_Assessments_Insert_Input;
  bright_assessments_max_fields: Bright_Assessments_Max_Fields;
  bright_assessments_max_order_by: Bright_Assessments_Max_Order_By;
  bright_assessments_min_fields: Bright_Assessments_Min_Fields;
  bright_assessments_min_order_by: Bright_Assessments_Min_Order_By;
  bright_assessments_mutation_response: Bright_Assessments_Mutation_Response;
  bright_assessments_obj_rel_insert_input: Bright_Assessments_Obj_Rel_Insert_Input;
  bright_assessments_on_conflict: Bright_Assessments_On_Conflict;
  bright_assessments_order_by: Bright_Assessments_Order_By;
  bright_assessments_pk_columns_input: Bright_Assessments_Pk_Columns_Input;
  bright_assessments_set_input: Bright_Assessments_Set_Input;
  bright_assessments_stddev_fields: Bright_Assessments_Stddev_Fields;
  bright_assessments_stddev_order_by: Bright_Assessments_Stddev_Order_By;
  bright_assessments_stddev_pop_fields: Bright_Assessments_Stddev_Pop_Fields;
  bright_assessments_stddev_pop_order_by: Bright_Assessments_Stddev_Pop_Order_By;
  bright_assessments_stddev_samp_fields: Bright_Assessments_Stddev_Samp_Fields;
  bright_assessments_stddev_samp_order_by: Bright_Assessments_Stddev_Samp_Order_By;
  bright_assessments_sum_fields: Bright_Assessments_Sum_Fields;
  bright_assessments_sum_order_by: Bright_Assessments_Sum_Order_By;
  bright_assessments_var_pop_fields: Bright_Assessments_Var_Pop_Fields;
  bright_assessments_var_pop_order_by: Bright_Assessments_Var_Pop_Order_By;
  bright_assessments_var_samp_fields: Bright_Assessments_Var_Samp_Fields;
  bright_assessments_var_samp_order_by: Bright_Assessments_Var_Samp_Order_By;
  bright_assessments_variance_fields: Bright_Assessments_Variance_Fields;
  bright_assessments_variance_order_by: Bright_Assessments_Variance_Order_By;
  bright_branch: Bright_Branch;
  bright_branch_aggregate: Bright_Branch_Aggregate;
  bright_branch_aggregate_fields: Bright_Branch_Aggregate_Fields;
  bright_branch_aggregate_order_by: Bright_Branch_Aggregate_Order_By;
  bright_branch_arr_rel_insert_input: Bright_Branch_Arr_Rel_Insert_Input;
  bright_branch_avg_fields: Bright_Branch_Avg_Fields;
  bright_branch_avg_order_by: Bright_Branch_Avg_Order_By;
  bright_branch_bool_exp: Bright_Branch_Bool_Exp;
  bright_branch_inc_input: Bright_Branch_Inc_Input;
  bright_branch_insert_input: Bright_Branch_Insert_Input;
  bright_branch_max_fields: Bright_Branch_Max_Fields;
  bright_branch_max_order_by: Bright_Branch_Max_Order_By;
  bright_branch_min_fields: Bright_Branch_Min_Fields;
  bright_branch_min_order_by: Bright_Branch_Min_Order_By;
  bright_branch_mutation_response: Bright_Branch_Mutation_Response;
  bright_branch_obj_rel_insert_input: Bright_Branch_Obj_Rel_Insert_Input;
  bright_branch_on_conflict: Bright_Branch_On_Conflict;
  bright_branch_order_by: Bright_Branch_Order_By;
  bright_branch_pk_columns_input: Bright_Branch_Pk_Columns_Input;
  bright_branch_set_input: Bright_Branch_Set_Input;
  bright_branch_stddev_fields: Bright_Branch_Stddev_Fields;
  bright_branch_stddev_order_by: Bright_Branch_Stddev_Order_By;
  bright_branch_stddev_pop_fields: Bright_Branch_Stddev_Pop_Fields;
  bright_branch_stddev_pop_order_by: Bright_Branch_Stddev_Pop_Order_By;
  bright_branch_stddev_samp_fields: Bright_Branch_Stddev_Samp_Fields;
  bright_branch_stddev_samp_order_by: Bright_Branch_Stddev_Samp_Order_By;
  bright_branch_sum_fields: Bright_Branch_Sum_Fields;
  bright_branch_sum_order_by: Bright_Branch_Sum_Order_By;
  bright_branch_var_pop_fields: Bright_Branch_Var_Pop_Fields;
  bright_branch_var_pop_order_by: Bright_Branch_Var_Pop_Order_By;
  bright_branch_var_samp_fields: Bright_Branch_Var_Samp_Fields;
  bright_branch_var_samp_order_by: Bright_Branch_Var_Samp_Order_By;
  bright_branch_variance_fields: Bright_Branch_Variance_Fields;
  bright_branch_variance_order_by: Bright_Branch_Variance_Order_By;
  bright_candidate: Bright_Candidate;
  bright_candidate_aggregate: Bright_Candidate_Aggregate;
  bright_candidate_aggregate_fields: Bright_Candidate_Aggregate_Fields;
  bright_candidate_aggregate_order_by: Bright_Candidate_Aggregate_Order_By;
  bright_candidate_arr_rel_insert_input: Bright_Candidate_Arr_Rel_Insert_Input;
  bright_candidate_avg_fields: Bright_Candidate_Avg_Fields;
  bright_candidate_avg_order_by: Bright_Candidate_Avg_Order_By;
  bright_candidate_bool_exp: Bright_Candidate_Bool_Exp;
  bright_candidate_inc_input: Bright_Candidate_Inc_Input;
  bright_candidate_insert_input: Bright_Candidate_Insert_Input;
  bright_candidate_max_fields: Bright_Candidate_Max_Fields;
  bright_candidate_max_order_by: Bright_Candidate_Max_Order_By;
  bright_candidate_min_fields: Bright_Candidate_Min_Fields;
  bright_candidate_min_order_by: Bright_Candidate_Min_Order_By;
  bright_candidate_mutation_response: Bright_Candidate_Mutation_Response;
  bright_candidate_obj_rel_insert_input: Bright_Candidate_Obj_Rel_Insert_Input;
  bright_candidate_on_conflict: Bright_Candidate_On_Conflict;
  bright_candidate_order_by: Bright_Candidate_Order_By;
  bright_candidate_pk_columns_input: Bright_Candidate_Pk_Columns_Input;
  bright_candidate_set_input: Bright_Candidate_Set_Input;
  bright_candidate_stddev_fields: Bright_Candidate_Stddev_Fields;
  bright_candidate_stddev_order_by: Bright_Candidate_Stddev_Order_By;
  bright_candidate_stddev_pop_fields: Bright_Candidate_Stddev_Pop_Fields;
  bright_candidate_stddev_pop_order_by: Bright_Candidate_Stddev_Pop_Order_By;
  bright_candidate_stddev_samp_fields: Bright_Candidate_Stddev_Samp_Fields;
  bright_candidate_stddev_samp_order_by: Bright_Candidate_Stddev_Samp_Order_By;
  bright_candidate_sum_fields: Bright_Candidate_Sum_Fields;
  bright_candidate_sum_order_by: Bright_Candidate_Sum_Order_By;
  bright_candidate_var_pop_fields: Bright_Candidate_Var_Pop_Fields;
  bright_candidate_var_pop_order_by: Bright_Candidate_Var_Pop_Order_By;
  bright_candidate_var_samp_fields: Bright_Candidate_Var_Samp_Fields;
  bright_candidate_var_samp_order_by: Bright_Candidate_Var_Samp_Order_By;
  bright_candidate_variance_fields: Bright_Candidate_Variance_Fields;
  bright_candidate_variance_order_by: Bright_Candidate_Variance_Order_By;
  bright_manager: Bright_Manager;
  bright_manager_aggregate: Bright_Manager_Aggregate;
  bright_manager_aggregate_fields: Bright_Manager_Aggregate_Fields;
  bright_manager_aggregate_order_by: Bright_Manager_Aggregate_Order_By;
  bright_manager_arr_rel_insert_input: Bright_Manager_Arr_Rel_Insert_Input;
  bright_manager_avg_fields: Bright_Manager_Avg_Fields;
  bright_manager_avg_order_by: Bright_Manager_Avg_Order_By;
  bright_manager_bool_exp: Bright_Manager_Bool_Exp;
  bright_manager_inc_input: Bright_Manager_Inc_Input;
  bright_manager_insert_input: Bright_Manager_Insert_Input;
  bright_manager_max_fields: Bright_Manager_Max_Fields;
  bright_manager_max_order_by: Bright_Manager_Max_Order_By;
  bright_manager_min_fields: Bright_Manager_Min_Fields;
  bright_manager_min_order_by: Bright_Manager_Min_Order_By;
  bright_manager_mutation_response: Bright_Manager_Mutation_Response;
  bright_manager_obj_rel_insert_input: Bright_Manager_Obj_Rel_Insert_Input;
  bright_manager_on_conflict: Bright_Manager_On_Conflict;
  bright_manager_order_by: Bright_Manager_Order_By;
  bright_manager_pk_columns_input: Bright_Manager_Pk_Columns_Input;
  bright_manager_set_input: Bright_Manager_Set_Input;
  bright_manager_stddev_fields: Bright_Manager_Stddev_Fields;
  bright_manager_stddev_order_by: Bright_Manager_Stddev_Order_By;
  bright_manager_stddev_pop_fields: Bright_Manager_Stddev_Pop_Fields;
  bright_manager_stddev_pop_order_by: Bright_Manager_Stddev_Pop_Order_By;
  bright_manager_stddev_samp_fields: Bright_Manager_Stddev_Samp_Fields;
  bright_manager_stddev_samp_order_by: Bright_Manager_Stddev_Samp_Order_By;
  bright_manager_sum_fields: Bright_Manager_Sum_Fields;
  bright_manager_sum_order_by: Bright_Manager_Sum_Order_By;
  bright_manager_var_pop_fields: Bright_Manager_Var_Pop_Fields;
  bright_manager_var_pop_order_by: Bright_Manager_Var_Pop_Order_By;
  bright_manager_var_samp_fields: Bright_Manager_Var_Samp_Fields;
  bright_manager_var_samp_order_by: Bright_Manager_Var_Samp_Order_By;
  bright_manager_variance_fields: Bright_Manager_Variance_Fields;
  bright_manager_variance_order_by: Bright_Manager_Variance_Order_By;
  categories: Categories;
  categories_aggregate: Categories_Aggregate;
  categories_aggregate_fields: Categories_Aggregate_Fields;
  categories_aggregate_order_by: Categories_Aggregate_Order_By;
  categories_arr_rel_insert_input: Categories_Arr_Rel_Insert_Input;
  categories_avg_fields: Categories_Avg_Fields;
  categories_avg_order_by: Categories_Avg_Order_By;
  categories_bool_exp: Categories_Bool_Exp;
  categories_inc_input: Categories_Inc_Input;
  categories_insert_input: Categories_Insert_Input;
  categories_max_fields: Categories_Max_Fields;
  categories_max_order_by: Categories_Max_Order_By;
  categories_min_fields: Categories_Min_Fields;
  categories_min_order_by: Categories_Min_Order_By;
  categories_mutation_response: Categories_Mutation_Response;
  categories_obj_rel_insert_input: Categories_Obj_Rel_Insert_Input;
  categories_on_conflict: Categories_On_Conflict;
  categories_order_by: Categories_Order_By;
  categories_pk_columns_input: Categories_Pk_Columns_Input;
  categories_set_input: Categories_Set_Input;
  categories_stddev_fields: Categories_Stddev_Fields;
  categories_stddev_order_by: Categories_Stddev_Order_By;
  categories_stddev_pop_fields: Categories_Stddev_Pop_Fields;
  categories_stddev_pop_order_by: Categories_Stddev_Pop_Order_By;
  categories_stddev_samp_fields: Categories_Stddev_Samp_Fields;
  categories_stddev_samp_order_by: Categories_Stddev_Samp_Order_By;
  categories_sum_fields: Categories_Sum_Fields;
  categories_sum_order_by: Categories_Sum_Order_By;
  categories_var_pop_fields: Categories_Var_Pop_Fields;
  categories_var_pop_order_by: Categories_Var_Pop_Order_By;
  categories_var_samp_fields: Categories_Var_Samp_Fields;
  categories_var_samp_order_by: Categories_Var_Samp_Order_By;
  categories_variance_fields: Categories_Variance_Fields;
  categories_variance_order_by: Categories_Variance_Order_By;
  choices: Choices;
  choices_aggregate: Choices_Aggregate;
  choices_aggregate_fields: Choices_Aggregate_Fields;
  choices_aggregate_order_by: Choices_Aggregate_Order_By;
  choices_arr_rel_insert_input: Choices_Arr_Rel_Insert_Input;
  choices_avg_fields: Choices_Avg_Fields;
  choices_avg_order_by: Choices_Avg_Order_By;
  choices_bool_exp: Choices_Bool_Exp;
  choices_inc_input: Choices_Inc_Input;
  choices_insert_input: Choices_Insert_Input;
  choices_max_fields: Choices_Max_Fields;
  choices_max_order_by: Choices_Max_Order_By;
  choices_min_fields: Choices_Min_Fields;
  choices_min_order_by: Choices_Min_Order_By;
  choices_mutation_response: Choices_Mutation_Response;
  choices_obj_rel_insert_input: Choices_Obj_Rel_Insert_Input;
  choices_on_conflict: Choices_On_Conflict;
  choices_order_by: Choices_Order_By;
  choices_pk_columns_input: Choices_Pk_Columns_Input;
  choices_set_input: Choices_Set_Input;
  choices_stddev_fields: Choices_Stddev_Fields;
  choices_stddev_order_by: Choices_Stddev_Order_By;
  choices_stddev_pop_fields: Choices_Stddev_Pop_Fields;
  choices_stddev_pop_order_by: Choices_Stddev_Pop_Order_By;
  choices_stddev_samp_fields: Choices_Stddev_Samp_Fields;
  choices_stddev_samp_order_by: Choices_Stddev_Samp_Order_By;
  choices_sum_fields: Choices_Sum_Fields;
  choices_sum_order_by: Choices_Sum_Order_By;
  choices_var_pop_fields: Choices_Var_Pop_Fields;
  choices_var_pop_order_by: Choices_Var_Pop_Order_By;
  choices_var_samp_fields: Choices_Var_Samp_Fields;
  choices_var_samp_order_by: Choices_Var_Samp_Order_By;
  choices_variance_fields: Choices_Variance_Fields;
  choices_variance_order_by: Choices_Variance_Order_By;
  credits_log: Credits_Log;
  credits_log_aggregate: Credits_Log_Aggregate;
  credits_log_aggregate_fields: Credits_Log_Aggregate_Fields;
  credits_log_aggregate_order_by: Credits_Log_Aggregate_Order_By;
  credits_log_arr_rel_insert_input: Credits_Log_Arr_Rel_Insert_Input;
  credits_log_avg_fields: Credits_Log_Avg_Fields;
  credits_log_avg_order_by: Credits_Log_Avg_Order_By;
  credits_log_bool_exp: Credits_Log_Bool_Exp;
  credits_log_inc_input: Credits_Log_Inc_Input;
  credits_log_insert_input: Credits_Log_Insert_Input;
  credits_log_max_fields: Credits_Log_Max_Fields;
  credits_log_max_order_by: Credits_Log_Max_Order_By;
  credits_log_min_fields: Credits_Log_Min_Fields;
  credits_log_min_order_by: Credits_Log_Min_Order_By;
  credits_log_mutation_response: Credits_Log_Mutation_Response;
  credits_log_obj_rel_insert_input: Credits_Log_Obj_Rel_Insert_Input;
  credits_log_on_conflict: Credits_Log_On_Conflict;
  credits_log_order_by: Credits_Log_Order_By;
  credits_log_pk_columns_input: Credits_Log_Pk_Columns_Input;
  credits_log_set_input: Credits_Log_Set_Input;
  credits_log_stddev_fields: Credits_Log_Stddev_Fields;
  credits_log_stddev_order_by: Credits_Log_Stddev_Order_By;
  credits_log_stddev_pop_fields: Credits_Log_Stddev_Pop_Fields;
  credits_log_stddev_pop_order_by: Credits_Log_Stddev_Pop_Order_By;
  credits_log_stddev_samp_fields: Credits_Log_Stddev_Samp_Fields;
  credits_log_stddev_samp_order_by: Credits_Log_Stddev_Samp_Order_By;
  credits_log_sum_fields: Credits_Log_Sum_Fields;
  credits_log_sum_order_by: Credits_Log_Sum_Order_By;
  credits_log_var_pop_fields: Credits_Log_Var_Pop_Fields;
  credits_log_var_pop_order_by: Credits_Log_Var_Pop_Order_By;
  credits_log_var_samp_fields: Credits_Log_Var_Samp_Fields;
  credits_log_var_samp_order_by: Credits_Log_Var_Samp_Order_By;
  credits_log_variance_fields: Credits_Log_Variance_Fields;
  credits_log_variance_order_by: Credits_Log_Variance_Order_By;
  discount_codes: Discount_Codes;
  discount_codes_aggregate: Discount_Codes_Aggregate;
  discount_codes_aggregate_fields: Discount_Codes_Aggregate_Fields;
  discount_codes_aggregate_order_by: Discount_Codes_Aggregate_Order_By;
  discount_codes_arr_rel_insert_input: Discount_Codes_Arr_Rel_Insert_Input;
  discount_codes_avg_fields: Discount_Codes_Avg_Fields;
  discount_codes_avg_order_by: Discount_Codes_Avg_Order_By;
  discount_codes_bool_exp: Discount_Codes_Bool_Exp;
  discount_codes_inc_input: Discount_Codes_Inc_Input;
  discount_codes_insert_input: Discount_Codes_Insert_Input;
  discount_codes_max_fields: Discount_Codes_Max_Fields;
  discount_codes_max_order_by: Discount_Codes_Max_Order_By;
  discount_codes_min_fields: Discount_Codes_Min_Fields;
  discount_codes_min_order_by: Discount_Codes_Min_Order_By;
  discount_codes_mutation_response: Discount_Codes_Mutation_Response;
  discount_codes_obj_rel_insert_input: Discount_Codes_Obj_Rel_Insert_Input;
  discount_codes_on_conflict: Discount_Codes_On_Conflict;
  discount_codes_order_by: Discount_Codes_Order_By;
  discount_codes_pk_columns_input: Discount_Codes_Pk_Columns_Input;
  discount_codes_set_input: Discount_Codes_Set_Input;
  discount_codes_stddev_fields: Discount_Codes_Stddev_Fields;
  discount_codes_stddev_order_by: Discount_Codes_Stddev_Order_By;
  discount_codes_stddev_pop_fields: Discount_Codes_Stddev_Pop_Fields;
  discount_codes_stddev_pop_order_by: Discount_Codes_Stddev_Pop_Order_By;
  discount_codes_stddev_samp_fields: Discount_Codes_Stddev_Samp_Fields;
  discount_codes_stddev_samp_order_by: Discount_Codes_Stddev_Samp_Order_By;
  discount_codes_sum_fields: Discount_Codes_Sum_Fields;
  discount_codes_sum_order_by: Discount_Codes_Sum_Order_By;
  discount_codes_var_pop_fields: Discount_Codes_Var_Pop_Fields;
  discount_codes_var_pop_order_by: Discount_Codes_Var_Pop_Order_By;
  discount_codes_var_samp_fields: Discount_Codes_Var_Samp_Fields;
  discount_codes_var_samp_order_by: Discount_Codes_Var_Samp_Order_By;
  discount_codes_variance_fields: Discount_Codes_Variance_Fields;
  discount_codes_variance_order_by: Discount_Codes_Variance_Order_By;
  estimated_scores: Estimated_Scores;
  estimated_scores_aggregate: Estimated_Scores_Aggregate;
  estimated_scores_aggregate_fields: Estimated_Scores_Aggregate_Fields;
  estimated_scores_aggregate_order_by: Estimated_Scores_Aggregate_Order_By;
  estimated_scores_arr_rel_insert_input: Estimated_Scores_Arr_Rel_Insert_Input;
  estimated_scores_avg_fields: Estimated_Scores_Avg_Fields;
  estimated_scores_avg_order_by: Estimated_Scores_Avg_Order_By;
  estimated_scores_bool_exp: Estimated_Scores_Bool_Exp;
  estimated_scores_inc_input: Estimated_Scores_Inc_Input;
  estimated_scores_insert_input: Estimated_Scores_Insert_Input;
  estimated_scores_max_fields: Estimated_Scores_Max_Fields;
  estimated_scores_max_order_by: Estimated_Scores_Max_Order_By;
  estimated_scores_min_fields: Estimated_Scores_Min_Fields;
  estimated_scores_min_order_by: Estimated_Scores_Min_Order_By;
  estimated_scores_mutation_response: Estimated_Scores_Mutation_Response;
  estimated_scores_obj_rel_insert_input: Estimated_Scores_Obj_Rel_Insert_Input;
  estimated_scores_on_conflict: Estimated_Scores_On_Conflict;
  estimated_scores_order_by: Estimated_Scores_Order_By;
  estimated_scores_pk_columns_input: Estimated_Scores_Pk_Columns_Input;
  estimated_scores_set_input: Estimated_Scores_Set_Input;
  estimated_scores_stddev_fields: Estimated_Scores_Stddev_Fields;
  estimated_scores_stddev_order_by: Estimated_Scores_Stddev_Order_By;
  estimated_scores_stddev_pop_fields: Estimated_Scores_Stddev_Pop_Fields;
  estimated_scores_stddev_pop_order_by: Estimated_Scores_Stddev_Pop_Order_By;
  estimated_scores_stddev_samp_fields: Estimated_Scores_Stddev_Samp_Fields;
  estimated_scores_stddev_samp_order_by: Estimated_Scores_Stddev_Samp_Order_By;
  estimated_scores_sum_fields: Estimated_Scores_Sum_Fields;
  estimated_scores_sum_order_by: Estimated_Scores_Sum_Order_By;
  estimated_scores_var_pop_fields: Estimated_Scores_Var_Pop_Fields;
  estimated_scores_var_pop_order_by: Estimated_Scores_Var_Pop_Order_By;
  estimated_scores_var_samp_fields: Estimated_Scores_Var_Samp_Fields;
  estimated_scores_var_samp_order_by: Estimated_Scores_Var_Samp_Order_By;
  estimated_scores_variance_fields: Estimated_Scores_Variance_Fields;
  estimated_scores_variance_order_by: Estimated_Scores_Variance_Order_By;
  exam_types: Scalars['exam_types'];
  exam_types_comparison_exp: Exam_Types_Comparison_Exp;
  exams: Exams;
  exams_aggregate: Exams_Aggregate;
  exams_aggregate_fields: Exams_Aggregate_Fields;
  exams_aggregate_order_by: Exams_Aggregate_Order_By;
  exams_arr_rel_insert_input: Exams_Arr_Rel_Insert_Input;
  exams_avg_fields: Exams_Avg_Fields;
  exams_avg_order_by: Exams_Avg_Order_By;
  exams_bool_exp: Exams_Bool_Exp;
  exams_inc_input: Exams_Inc_Input;
  exams_insert_input: Exams_Insert_Input;
  exams_max_fields: Exams_Max_Fields;
  exams_max_order_by: Exams_Max_Order_By;
  exams_min_fields: Exams_Min_Fields;
  exams_min_order_by: Exams_Min_Order_By;
  exams_mutation_response: Exams_Mutation_Response;
  exams_obj_rel_insert_input: Exams_Obj_Rel_Insert_Input;
  exams_on_conflict: Exams_On_Conflict;
  exams_order_by: Exams_Order_By;
  exams_pk_columns_input: Exams_Pk_Columns_Input;
  exams_set_input: Exams_Set_Input;
  exams_stddev_fields: Exams_Stddev_Fields;
  exams_stddev_order_by: Exams_Stddev_Order_By;
  exams_stddev_pop_fields: Exams_Stddev_Pop_Fields;
  exams_stddev_pop_order_by: Exams_Stddev_Pop_Order_By;
  exams_stddev_samp_fields: Exams_Stddev_Samp_Fields;
  exams_stddev_samp_order_by: Exams_Stddev_Samp_Order_By;
  exams_sum_fields: Exams_Sum_Fields;
  exams_sum_order_by: Exams_Sum_Order_By;
  exams_var_pop_fields: Exams_Var_Pop_Fields;
  exams_var_pop_order_by: Exams_Var_Pop_Order_By;
  exams_var_samp_fields: Exams_Var_Samp_Fields;
  exams_var_samp_order_by: Exams_Var_Samp_Order_By;
  exams_variance_fields: Exams_Variance_Fields;
  exams_variance_order_by: Exams_Variance_Order_By;
  feedbacks: Feedbacks;
  feedbacks_aggregate: Feedbacks_Aggregate;
  feedbacks_aggregate_fields: Feedbacks_Aggregate_Fields;
  feedbacks_aggregate_order_by: Feedbacks_Aggregate_Order_By;
  feedbacks_append_input: Feedbacks_Append_Input;
  feedbacks_arr_rel_insert_input: Feedbacks_Arr_Rel_Insert_Input;
  feedbacks_avg_fields: Feedbacks_Avg_Fields;
  feedbacks_avg_order_by: Feedbacks_Avg_Order_By;
  feedbacks_bool_exp: Feedbacks_Bool_Exp;
  feedbacks_delete_at_path_input: Feedbacks_Delete_At_Path_Input;
  feedbacks_delete_elem_input: Feedbacks_Delete_Elem_Input;
  feedbacks_delete_key_input: Feedbacks_Delete_Key_Input;
  feedbacks_inc_input: Feedbacks_Inc_Input;
  feedbacks_insert_input: Feedbacks_Insert_Input;
  feedbacks_max_fields: Feedbacks_Max_Fields;
  feedbacks_max_order_by: Feedbacks_Max_Order_By;
  feedbacks_min_fields: Feedbacks_Min_Fields;
  feedbacks_min_order_by: Feedbacks_Min_Order_By;
  feedbacks_mutation_response: Feedbacks_Mutation_Response;
  feedbacks_obj_rel_insert_input: Feedbacks_Obj_Rel_Insert_Input;
  feedbacks_on_conflict: Feedbacks_On_Conflict;
  feedbacks_order_by: Feedbacks_Order_By;
  feedbacks_pk_columns_input: Feedbacks_Pk_Columns_Input;
  feedbacks_prepend_input: Feedbacks_Prepend_Input;
  feedbacks_set_input: Feedbacks_Set_Input;
  feedbacks_stddev_fields: Feedbacks_Stddev_Fields;
  feedbacks_stddev_order_by: Feedbacks_Stddev_Order_By;
  feedbacks_stddev_pop_fields: Feedbacks_Stddev_Pop_Fields;
  feedbacks_stddev_pop_order_by: Feedbacks_Stddev_Pop_Order_By;
  feedbacks_stddev_samp_fields: Feedbacks_Stddev_Samp_Fields;
  feedbacks_stddev_samp_order_by: Feedbacks_Stddev_Samp_Order_By;
  feedbacks_sum_fields: Feedbacks_Sum_Fields;
  feedbacks_sum_order_by: Feedbacks_Sum_Order_By;
  feedbacks_var_pop_fields: Feedbacks_Var_Pop_Fields;
  feedbacks_var_pop_order_by: Feedbacks_Var_Pop_Order_By;
  feedbacks_var_samp_fields: Feedbacks_Var_Samp_Fields;
  feedbacks_var_samp_order_by: Feedbacks_Var_Samp_Order_By;
  feedbacks_variance_fields: Feedbacks_Variance_Fields;
  feedbacks_variance_order_by: Feedbacks_Variance_Order_By;
  float8: Scalars['float8'];
  float8_comparison_exp: Float8_Comparison_Exp;
  institutions: Institutions;
  institutions_aggregate: Institutions_Aggregate;
  institutions_aggregate_fields: Institutions_Aggregate_Fields;
  institutions_aggregate_order_by: Institutions_Aggregate_Order_By;
  institutions_append_input: Institutions_Append_Input;
  institutions_arr_rel_insert_input: Institutions_Arr_Rel_Insert_Input;
  institutions_avg_fields: Institutions_Avg_Fields;
  institutions_avg_order_by: Institutions_Avg_Order_By;
  institutions_bool_exp: Institutions_Bool_Exp;
  institutions_delete_at_path_input: Institutions_Delete_At_Path_Input;
  institutions_delete_elem_input: Institutions_Delete_Elem_Input;
  institutions_delete_key_input: Institutions_Delete_Key_Input;
  institutions_inc_input: Institutions_Inc_Input;
  institutions_insert_input: Institutions_Insert_Input;
  institutions_max_fields: Institutions_Max_Fields;
  institutions_max_order_by: Institutions_Max_Order_By;
  institutions_min_fields: Institutions_Min_Fields;
  institutions_min_order_by: Institutions_Min_Order_By;
  institutions_mutation_response: Institutions_Mutation_Response;
  institutions_obj_rel_insert_input: Institutions_Obj_Rel_Insert_Input;
  institutions_on_conflict: Institutions_On_Conflict;
  institutions_order_by: Institutions_Order_By;
  institutions_pk_columns_input: Institutions_Pk_Columns_Input;
  institutions_prepend_input: Institutions_Prepend_Input;
  institutions_set_input: Institutions_Set_Input;
  institutions_stddev_fields: Institutions_Stddev_Fields;
  institutions_stddev_order_by: Institutions_Stddev_Order_By;
  institutions_stddev_pop_fields: Institutions_Stddev_Pop_Fields;
  institutions_stddev_pop_order_by: Institutions_Stddev_Pop_Order_By;
  institutions_stddev_samp_fields: Institutions_Stddev_Samp_Fields;
  institutions_stddev_samp_order_by: Institutions_Stddev_Samp_Order_By;
  institutions_sum_fields: Institutions_Sum_Fields;
  institutions_sum_order_by: Institutions_Sum_Order_By;
  institutions_var_pop_fields: Institutions_Var_Pop_Fields;
  institutions_var_pop_order_by: Institutions_Var_Pop_Order_By;
  institutions_var_samp_fields: Institutions_Var_Samp_Fields;
  institutions_var_samp_order_by: Institutions_Var_Samp_Order_By;
  institutions_variance_fields: Institutions_Variance_Fields;
  institutions_variance_order_by: Institutions_Variance_Order_By;
  jsonb: Scalars['jsonb'];
  jsonb_comparison_exp: Jsonb_Comparison_Exp;
  lessons: Lessons;
  lessons_aggregate: Lessons_Aggregate;
  lessons_aggregate_fields: Lessons_Aggregate_Fields;
  lessons_aggregate_order_by: Lessons_Aggregate_Order_By;
  lessons_arr_rel_insert_input: Lessons_Arr_Rel_Insert_Input;
  lessons_avg_fields: Lessons_Avg_Fields;
  lessons_avg_order_by: Lessons_Avg_Order_By;
  lessons_bool_exp: Lessons_Bool_Exp;
  lessons_inc_input: Lessons_Inc_Input;
  lessons_insert_input: Lessons_Insert_Input;
  lessons_max_fields: Lessons_Max_Fields;
  lessons_max_order_by: Lessons_Max_Order_By;
  lessons_min_fields: Lessons_Min_Fields;
  lessons_min_order_by: Lessons_Min_Order_By;
  lessons_mutation_response: Lessons_Mutation_Response;
  lessons_obj_rel_insert_input: Lessons_Obj_Rel_Insert_Input;
  lessons_on_conflict: Lessons_On_Conflict;
  lessons_order_by: Lessons_Order_By;
  lessons_pk_columns_input: Lessons_Pk_Columns_Input;
  lessons_set_input: Lessons_Set_Input;
  lessons_stddev_fields: Lessons_Stddev_Fields;
  lessons_stddev_order_by: Lessons_Stddev_Order_By;
  lessons_stddev_pop_fields: Lessons_Stddev_Pop_Fields;
  lessons_stddev_pop_order_by: Lessons_Stddev_Pop_Order_By;
  lessons_stddev_samp_fields: Lessons_Stddev_Samp_Fields;
  lessons_stddev_samp_order_by: Lessons_Stddev_Samp_Order_By;
  lessons_sum_fields: Lessons_Sum_Fields;
  lessons_sum_order_by: Lessons_Sum_Order_By;
  lessons_var_pop_fields: Lessons_Var_Pop_Fields;
  lessons_var_pop_order_by: Lessons_Var_Pop_Order_By;
  lessons_var_samp_fields: Lessons_Var_Samp_Fields;
  lessons_var_samp_order_by: Lessons_Var_Samp_Order_By;
  lessons_variance_fields: Lessons_Variance_Fields;
  lessons_variance_order_by: Lessons_Variance_Order_By;
  mutation_root: {};
  numeric: Scalars['numeric'];
  numeric_comparison_exp: Numeric_Comparison_Exp;
  plans: Plans;
  plans_aggregate: Plans_Aggregate;
  plans_aggregate_fields: Plans_Aggregate_Fields;
  plans_aggregate_order_by: Plans_Aggregate_Order_By;
  plans_arr_rel_insert_input: Plans_Arr_Rel_Insert_Input;
  plans_avg_fields: Plans_Avg_Fields;
  plans_avg_order_by: Plans_Avg_Order_By;
  plans_bool_exp: Plans_Bool_Exp;
  plans_inc_input: Plans_Inc_Input;
  plans_insert_input: Plans_Insert_Input;
  plans_max_fields: Plans_Max_Fields;
  plans_max_order_by: Plans_Max_Order_By;
  plans_min_fields: Plans_Min_Fields;
  plans_min_order_by: Plans_Min_Order_By;
  plans_mutation_response: Plans_Mutation_Response;
  plans_obj_rel_insert_input: Plans_Obj_Rel_Insert_Input;
  plans_on_conflict: Plans_On_Conflict;
  plans_order_by: Plans_Order_By;
  plans_pk_columns_input: Plans_Pk_Columns_Input;
  plans_set_input: Plans_Set_Input;
  plans_stddev_fields: Plans_Stddev_Fields;
  plans_stddev_order_by: Plans_Stddev_Order_By;
  plans_stddev_pop_fields: Plans_Stddev_Pop_Fields;
  plans_stddev_pop_order_by: Plans_Stddev_Pop_Order_By;
  plans_stddev_samp_fields: Plans_Stddev_Samp_Fields;
  plans_stddev_samp_order_by: Plans_Stddev_Samp_Order_By;
  plans_sum_fields: Plans_Sum_Fields;
  plans_sum_order_by: Plans_Sum_Order_By;
  plans_var_pop_fields: Plans_Var_Pop_Fields;
  plans_var_pop_order_by: Plans_Var_Pop_Order_By;
  plans_var_samp_fields: Plans_Var_Samp_Fields;
  plans_var_samp_order_by: Plans_Var_Samp_Order_By;
  plans_variance_fields: Plans_Variance_Fields;
  plans_variance_order_by: Plans_Variance_Order_By;
  profile_sphere_association: Profile_Sphere_Association;
  profile_sphere_association_aggregate: Profile_Sphere_Association_Aggregate;
  profile_sphere_association_aggregate_fields: Profile_Sphere_Association_Aggregate_Fields;
  profile_sphere_association_aggregate_order_by: Profile_Sphere_Association_Aggregate_Order_By;
  profile_sphere_association_arr_rel_insert_input: Profile_Sphere_Association_Arr_Rel_Insert_Input;
  profile_sphere_association_avg_fields: Profile_Sphere_Association_Avg_Fields;
  profile_sphere_association_avg_order_by: Profile_Sphere_Association_Avg_Order_By;
  profile_sphere_association_bool_exp: Profile_Sphere_Association_Bool_Exp;
  profile_sphere_association_inc_input: Profile_Sphere_Association_Inc_Input;
  profile_sphere_association_insert_input: Profile_Sphere_Association_Insert_Input;
  profile_sphere_association_max_fields: Profile_Sphere_Association_Max_Fields;
  profile_sphere_association_max_order_by: Profile_Sphere_Association_Max_Order_By;
  profile_sphere_association_min_fields: Profile_Sphere_Association_Min_Fields;
  profile_sphere_association_min_order_by: Profile_Sphere_Association_Min_Order_By;
  profile_sphere_association_mutation_response: Profile_Sphere_Association_Mutation_Response;
  profile_sphere_association_obj_rel_insert_input: Profile_Sphere_Association_Obj_Rel_Insert_Input;
  profile_sphere_association_order_by: Profile_Sphere_Association_Order_By;
  profile_sphere_association_set_input: Profile_Sphere_Association_Set_Input;
  profile_sphere_association_stddev_fields: Profile_Sphere_Association_Stddev_Fields;
  profile_sphere_association_stddev_order_by: Profile_Sphere_Association_Stddev_Order_By;
  profile_sphere_association_stddev_pop_fields: Profile_Sphere_Association_Stddev_Pop_Fields;
  profile_sphere_association_stddev_pop_order_by: Profile_Sphere_Association_Stddev_Pop_Order_By;
  profile_sphere_association_stddev_samp_fields: Profile_Sphere_Association_Stddev_Samp_Fields;
  profile_sphere_association_stddev_samp_order_by: Profile_Sphere_Association_Stddev_Samp_Order_By;
  profile_sphere_association_sum_fields: Profile_Sphere_Association_Sum_Fields;
  profile_sphere_association_sum_order_by: Profile_Sphere_Association_Sum_Order_By;
  profile_sphere_association_var_pop_fields: Profile_Sphere_Association_Var_Pop_Fields;
  profile_sphere_association_var_pop_order_by: Profile_Sphere_Association_Var_Pop_Order_By;
  profile_sphere_association_var_samp_fields: Profile_Sphere_Association_Var_Samp_Fields;
  profile_sphere_association_var_samp_order_by: Profile_Sphere_Association_Var_Samp_Order_By;
  profile_sphere_association_variance_fields: Profile_Sphere_Association_Variance_Fields;
  profile_sphere_association_variance_order_by: Profile_Sphere_Association_Variance_Order_By;
  profiles: Profiles;
  profiles_aggregate: Profiles_Aggregate;
  profiles_aggregate_fields: Profiles_Aggregate_Fields;
  profiles_aggregate_order_by: Profiles_Aggregate_Order_By;
  profiles_arr_rel_insert_input: Profiles_Arr_Rel_Insert_Input;
  profiles_avg_fields: Profiles_Avg_Fields;
  profiles_avg_order_by: Profiles_Avg_Order_By;
  profiles_bool_exp: Profiles_Bool_Exp;
  profiles_inc_input: Profiles_Inc_Input;
  profiles_insert_input: Profiles_Insert_Input;
  profiles_max_fields: Profiles_Max_Fields;
  profiles_max_order_by: Profiles_Max_Order_By;
  profiles_min_fields: Profiles_Min_Fields;
  profiles_min_order_by: Profiles_Min_Order_By;
  profiles_mutation_response: Profiles_Mutation_Response;
  profiles_obj_rel_insert_input: Profiles_Obj_Rel_Insert_Input;
  profiles_on_conflict: Profiles_On_Conflict;
  profiles_order_by: Profiles_Order_By;
  profiles_pk_columns_input: Profiles_Pk_Columns_Input;
  profiles_set_input: Profiles_Set_Input;
  profiles_stddev_fields: Profiles_Stddev_Fields;
  profiles_stddev_order_by: Profiles_Stddev_Order_By;
  profiles_stddev_pop_fields: Profiles_Stddev_Pop_Fields;
  profiles_stddev_pop_order_by: Profiles_Stddev_Pop_Order_By;
  profiles_stddev_samp_fields: Profiles_Stddev_Samp_Fields;
  profiles_stddev_samp_order_by: Profiles_Stddev_Samp_Order_By;
  profiles_sum_fields: Profiles_Sum_Fields;
  profiles_sum_order_by: Profiles_Sum_Order_By;
  profiles_var_pop_fields: Profiles_Var_Pop_Fields;
  profiles_var_pop_order_by: Profiles_Var_Pop_Order_By;
  profiles_var_samp_fields: Profiles_Var_Samp_Fields;
  profiles_var_samp_order_by: Profiles_Var_Samp_Order_By;
  profiles_variance_fields: Profiles_Variance_Fields;
  profiles_variance_order_by: Profiles_Variance_Order_By;
  query_root: {};
  question_lesson_association: Question_Lesson_Association;
  question_lesson_association_aggregate: Question_Lesson_Association_Aggregate;
  question_lesson_association_aggregate_fields: Question_Lesson_Association_Aggregate_Fields;
  question_lesson_association_aggregate_order_by: Question_Lesson_Association_Aggregate_Order_By;
  question_lesson_association_arr_rel_insert_input: Question_Lesson_Association_Arr_Rel_Insert_Input;
  question_lesson_association_avg_fields: Question_Lesson_Association_Avg_Fields;
  question_lesson_association_avg_order_by: Question_Lesson_Association_Avg_Order_By;
  question_lesson_association_bool_exp: Question_Lesson_Association_Bool_Exp;
  question_lesson_association_inc_input: Question_Lesson_Association_Inc_Input;
  question_lesson_association_insert_input: Question_Lesson_Association_Insert_Input;
  question_lesson_association_max_fields: Question_Lesson_Association_Max_Fields;
  question_lesson_association_max_order_by: Question_Lesson_Association_Max_Order_By;
  question_lesson_association_min_fields: Question_Lesson_Association_Min_Fields;
  question_lesson_association_min_order_by: Question_Lesson_Association_Min_Order_By;
  question_lesson_association_mutation_response: Question_Lesson_Association_Mutation_Response;
  question_lesson_association_obj_rel_insert_input: Question_Lesson_Association_Obj_Rel_Insert_Input;
  question_lesson_association_on_conflict: Question_Lesson_Association_On_Conflict;
  question_lesson_association_order_by: Question_Lesson_Association_Order_By;
  question_lesson_association_pk_columns_input: Question_Lesson_Association_Pk_Columns_Input;
  question_lesson_association_set_input: Question_Lesson_Association_Set_Input;
  question_lesson_association_stddev_fields: Question_Lesson_Association_Stddev_Fields;
  question_lesson_association_stddev_order_by: Question_Lesson_Association_Stddev_Order_By;
  question_lesson_association_stddev_pop_fields: Question_Lesson_Association_Stddev_Pop_Fields;
  question_lesson_association_stddev_pop_order_by: Question_Lesson_Association_Stddev_Pop_Order_By;
  question_lesson_association_stddev_samp_fields: Question_Lesson_Association_Stddev_Samp_Fields;
  question_lesson_association_stddev_samp_order_by: Question_Lesson_Association_Stddev_Samp_Order_By;
  question_lesson_association_sum_fields: Question_Lesson_Association_Sum_Fields;
  question_lesson_association_sum_order_by: Question_Lesson_Association_Sum_Order_By;
  question_lesson_association_var_pop_fields: Question_Lesson_Association_Var_Pop_Fields;
  question_lesson_association_var_pop_order_by: Question_Lesson_Association_Var_Pop_Order_By;
  question_lesson_association_var_samp_fields: Question_Lesson_Association_Var_Samp_Fields;
  question_lesson_association_var_samp_order_by: Question_Lesson_Association_Var_Samp_Order_By;
  question_lesson_association_variance_fields: Question_Lesson_Association_Variance_Fields;
  question_lesson_association_variance_order_by: Question_Lesson_Association_Variance_Order_By;
  questions: Questions;
  questions_aggregate: Questions_Aggregate;
  questions_aggregate_fields: Questions_Aggregate_Fields;
  questions_aggregate_order_by: Questions_Aggregate_Order_By;
  questions_arr_rel_insert_input: Questions_Arr_Rel_Insert_Input;
  questions_avg_fields: Questions_Avg_Fields;
  questions_avg_order_by: Questions_Avg_Order_By;
  questions_bool_exp: Questions_Bool_Exp;
  questions_inc_input: Questions_Inc_Input;
  questions_insert_input: Questions_Insert_Input;
  questions_max_fields: Questions_Max_Fields;
  questions_max_order_by: Questions_Max_Order_By;
  questions_min_fields: Questions_Min_Fields;
  questions_min_order_by: Questions_Min_Order_By;
  questions_mutation_response: Questions_Mutation_Response;
  questions_obj_rel_insert_input: Questions_Obj_Rel_Insert_Input;
  questions_on_conflict: Questions_On_Conflict;
  questions_order_by: Questions_Order_By;
  questions_pk_columns_input: Questions_Pk_Columns_Input;
  questions_set_input: Questions_Set_Input;
  questions_stddev_fields: Questions_Stddev_Fields;
  questions_stddev_order_by: Questions_Stddev_Order_By;
  questions_stddev_pop_fields: Questions_Stddev_Pop_Fields;
  questions_stddev_pop_order_by: Questions_Stddev_Pop_Order_By;
  questions_stddev_samp_fields: Questions_Stddev_Samp_Fields;
  questions_stddev_samp_order_by: Questions_Stddev_Samp_Order_By;
  questions_sum_fields: Questions_Sum_Fields;
  questions_sum_order_by: Questions_Sum_Order_By;
  questions_var_pop_fields: Questions_Var_Pop_Fields;
  questions_var_pop_order_by: Questions_Var_Pop_Order_By;
  questions_var_samp_fields: Questions_Var_Samp_Fields;
  questions_var_samp_order_by: Questions_Var_Samp_Order_By;
  questions_variance_fields: Questions_Variance_Fields;
  questions_variance_order_by: Questions_Variance_Order_By;
  registration_billings: Registration_Billings;
  registration_billings_aggregate: Registration_Billings_Aggregate;
  registration_billings_aggregate_fields: Registration_Billings_Aggregate_Fields;
  registration_billings_aggregate_order_by: Registration_Billings_Aggregate_Order_By;
  registration_billings_arr_rel_insert_input: Registration_Billings_Arr_Rel_Insert_Input;
  registration_billings_avg_fields: Registration_Billings_Avg_Fields;
  registration_billings_avg_order_by: Registration_Billings_Avg_Order_By;
  registration_billings_bool_exp: Registration_Billings_Bool_Exp;
  registration_billings_inc_input: Registration_Billings_Inc_Input;
  registration_billings_insert_input: Registration_Billings_Insert_Input;
  registration_billings_max_fields: Registration_Billings_Max_Fields;
  registration_billings_max_order_by: Registration_Billings_Max_Order_By;
  registration_billings_min_fields: Registration_Billings_Min_Fields;
  registration_billings_min_order_by: Registration_Billings_Min_Order_By;
  registration_billings_mutation_response: Registration_Billings_Mutation_Response;
  registration_billings_obj_rel_insert_input: Registration_Billings_Obj_Rel_Insert_Input;
  registration_billings_on_conflict: Registration_Billings_On_Conflict;
  registration_billings_order_by: Registration_Billings_Order_By;
  registration_billings_pk_columns_input: Registration_Billings_Pk_Columns_Input;
  registration_billings_set_input: Registration_Billings_Set_Input;
  registration_billings_stddev_fields: Registration_Billings_Stddev_Fields;
  registration_billings_stddev_order_by: Registration_Billings_Stddev_Order_By;
  registration_billings_stddev_pop_fields: Registration_Billings_Stddev_Pop_Fields;
  registration_billings_stddev_pop_order_by: Registration_Billings_Stddev_Pop_Order_By;
  registration_billings_stddev_samp_fields: Registration_Billings_Stddev_Samp_Fields;
  registration_billings_stddev_samp_order_by: Registration_Billings_Stddev_Samp_Order_By;
  registration_billings_sum_fields: Registration_Billings_Sum_Fields;
  registration_billings_sum_order_by: Registration_Billings_Sum_Order_By;
  registration_billings_var_pop_fields: Registration_Billings_Var_Pop_Fields;
  registration_billings_var_pop_order_by: Registration_Billings_Var_Pop_Order_By;
  registration_billings_var_samp_fields: Registration_Billings_Var_Samp_Fields;
  registration_billings_var_samp_order_by: Registration_Billings_Var_Samp_Order_By;
  registration_billings_variance_fields: Registration_Billings_Variance_Fields;
  registration_billings_variance_order_by: Registration_Billings_Variance_Order_By;
  registrations: Registrations;
  registrations_aggregate: Registrations_Aggregate;
  registrations_aggregate_fields: Registrations_Aggregate_Fields;
  registrations_aggregate_order_by: Registrations_Aggregate_Order_By;
  registrations_arr_rel_insert_input: Registrations_Arr_Rel_Insert_Input;
  registrations_avg_fields: Registrations_Avg_Fields;
  registrations_avg_order_by: Registrations_Avg_Order_By;
  registrations_bool_exp: Registrations_Bool_Exp;
  registrations_inc_input: Registrations_Inc_Input;
  registrations_insert_input: Registrations_Insert_Input;
  registrations_max_fields: Registrations_Max_Fields;
  registrations_max_order_by: Registrations_Max_Order_By;
  registrations_min_fields: Registrations_Min_Fields;
  registrations_min_order_by: Registrations_Min_Order_By;
  registrations_mutation_response: Registrations_Mutation_Response;
  registrations_obj_rel_insert_input: Registrations_Obj_Rel_Insert_Input;
  registrations_on_conflict: Registrations_On_Conflict;
  registrations_order_by: Registrations_Order_By;
  registrations_pk_columns_input: Registrations_Pk_Columns_Input;
  registrations_set_input: Registrations_Set_Input;
  registrations_stddev_fields: Registrations_Stddev_Fields;
  registrations_stddev_order_by: Registrations_Stddev_Order_By;
  registrations_stddev_pop_fields: Registrations_Stddev_Pop_Fields;
  registrations_stddev_pop_order_by: Registrations_Stddev_Pop_Order_By;
  registrations_stddev_samp_fields: Registrations_Stddev_Samp_Fields;
  registrations_stddev_samp_order_by: Registrations_Stddev_Samp_Order_By;
  registrations_sum_fields: Registrations_Sum_Fields;
  registrations_sum_order_by: Registrations_Sum_Order_By;
  registrations_var_pop_fields: Registrations_Var_Pop_Fields;
  registrations_var_pop_order_by: Registrations_Var_Pop_Order_By;
  registrations_var_samp_fields: Registrations_Var_Samp_Fields;
  registrations_var_samp_order_by: Registrations_Var_Samp_Order_By;
  registrations_variance_fields: Registrations_Variance_Fields;
  registrations_variance_order_by: Registrations_Variance_Order_By;
  result_plan_association: Result_Plan_Association;
  result_plan_association_aggregate: Result_Plan_Association_Aggregate;
  result_plan_association_aggregate_fields: Result_Plan_Association_Aggregate_Fields;
  result_plan_association_aggregate_order_by: Result_Plan_Association_Aggregate_Order_By;
  result_plan_association_arr_rel_insert_input: Result_Plan_Association_Arr_Rel_Insert_Input;
  result_plan_association_avg_fields: Result_Plan_Association_Avg_Fields;
  result_plan_association_avg_order_by: Result_Plan_Association_Avg_Order_By;
  result_plan_association_bool_exp: Result_Plan_Association_Bool_Exp;
  result_plan_association_inc_input: Result_Plan_Association_Inc_Input;
  result_plan_association_insert_input: Result_Plan_Association_Insert_Input;
  result_plan_association_max_fields: Result_Plan_Association_Max_Fields;
  result_plan_association_max_order_by: Result_Plan_Association_Max_Order_By;
  result_plan_association_min_fields: Result_Plan_Association_Min_Fields;
  result_plan_association_min_order_by: Result_Plan_Association_Min_Order_By;
  result_plan_association_mutation_response: Result_Plan_Association_Mutation_Response;
  result_plan_association_obj_rel_insert_input: Result_Plan_Association_Obj_Rel_Insert_Input;
  result_plan_association_on_conflict: Result_Plan_Association_On_Conflict;
  result_plan_association_order_by: Result_Plan_Association_Order_By;
  result_plan_association_pk_columns_input: Result_Plan_Association_Pk_Columns_Input;
  result_plan_association_set_input: Result_Plan_Association_Set_Input;
  result_plan_association_stddev_fields: Result_Plan_Association_Stddev_Fields;
  result_plan_association_stddev_order_by: Result_Plan_Association_Stddev_Order_By;
  result_plan_association_stddev_pop_fields: Result_Plan_Association_Stddev_Pop_Fields;
  result_plan_association_stddev_pop_order_by: Result_Plan_Association_Stddev_Pop_Order_By;
  result_plan_association_stddev_samp_fields: Result_Plan_Association_Stddev_Samp_Fields;
  result_plan_association_stddev_samp_order_by: Result_Plan_Association_Stddev_Samp_Order_By;
  result_plan_association_sum_fields: Result_Plan_Association_Sum_Fields;
  result_plan_association_sum_order_by: Result_Plan_Association_Sum_Order_By;
  result_plan_association_var_pop_fields: Result_Plan_Association_Var_Pop_Fields;
  result_plan_association_var_pop_order_by: Result_Plan_Association_Var_Pop_Order_By;
  result_plan_association_var_samp_fields: Result_Plan_Association_Var_Samp_Fields;
  result_plan_association_var_samp_order_by: Result_Plan_Association_Var_Samp_Order_By;
  result_plan_association_variance_fields: Result_Plan_Association_Variance_Fields;
  result_plan_association_variance_order_by: Result_Plan_Association_Variance_Order_By;
  results: Results;
  results_aggregate: Results_Aggregate;
  results_aggregate_fields: Results_Aggregate_Fields;
  results_aggregate_order_by: Results_Aggregate_Order_By;
  results_arr_rel_insert_input: Results_Arr_Rel_Insert_Input;
  results_avg_fields: Results_Avg_Fields;
  results_avg_order_by: Results_Avg_Order_By;
  results_bool_exp: Results_Bool_Exp;
  results_inc_input: Results_Inc_Input;
  results_insert_input: Results_Insert_Input;
  results_max_fields: Results_Max_Fields;
  results_max_order_by: Results_Max_Order_By;
  results_min_fields: Results_Min_Fields;
  results_min_order_by: Results_Min_Order_By;
  results_mutation_response: Results_Mutation_Response;
  results_obj_rel_insert_input: Results_Obj_Rel_Insert_Input;
  results_on_conflict: Results_On_Conflict;
  results_order_by: Results_Order_By;
  results_pk_columns_input: Results_Pk_Columns_Input;
  results_set_input: Results_Set_Input;
  results_stddev_fields: Results_Stddev_Fields;
  results_stddev_order_by: Results_Stddev_Order_By;
  results_stddev_pop_fields: Results_Stddev_Pop_Fields;
  results_stddev_pop_order_by: Results_Stddev_Pop_Order_By;
  results_stddev_samp_fields: Results_Stddev_Samp_Fields;
  results_stddev_samp_order_by: Results_Stddev_Samp_Order_By;
  results_sum_fields: Results_Sum_Fields;
  results_sum_order_by: Results_Sum_Order_By;
  results_var_pop_fields: Results_Var_Pop_Fields;
  results_var_pop_order_by: Results_Var_Pop_Order_By;
  results_var_samp_fields: Results_Var_Samp_Fields;
  results_var_samp_order_by: Results_Var_Samp_Order_By;
  results_variance_fields: Results_Variance_Fields;
  results_variance_order_by: Results_Variance_Order_By;
  scores: Scores;
  scores_aggregate: Scores_Aggregate;
  scores_aggregate_fields: Scores_Aggregate_Fields;
  scores_aggregate_order_by: Scores_Aggregate_Order_By;
  scores_arr_rel_insert_input: Scores_Arr_Rel_Insert_Input;
  scores_avg_fields: Scores_Avg_Fields;
  scores_avg_order_by: Scores_Avg_Order_By;
  scores_bool_exp: Scores_Bool_Exp;
  scores_inc_input: Scores_Inc_Input;
  scores_insert_input: Scores_Insert_Input;
  scores_max_fields: Scores_Max_Fields;
  scores_max_order_by: Scores_Max_Order_By;
  scores_min_fields: Scores_Min_Fields;
  scores_min_order_by: Scores_Min_Order_By;
  scores_mutation_response: Scores_Mutation_Response;
  scores_obj_rel_insert_input: Scores_Obj_Rel_Insert_Input;
  scores_on_conflict: Scores_On_Conflict;
  scores_order_by: Scores_Order_By;
  scores_pk_columns_input: Scores_Pk_Columns_Input;
  scores_set_input: Scores_Set_Input;
  scores_stddev_fields: Scores_Stddev_Fields;
  scores_stddev_order_by: Scores_Stddev_Order_By;
  scores_stddev_pop_fields: Scores_Stddev_Pop_Fields;
  scores_stddev_pop_order_by: Scores_Stddev_Pop_Order_By;
  scores_stddev_samp_fields: Scores_Stddev_Samp_Fields;
  scores_stddev_samp_order_by: Scores_Stddev_Samp_Order_By;
  scores_sum_fields: Scores_Sum_Fields;
  scores_sum_order_by: Scores_Sum_Order_By;
  scores_var_pop_fields: Scores_Var_Pop_Fields;
  scores_var_pop_order_by: Scores_Var_Pop_Order_By;
  scores_var_samp_fields: Scores_Var_Samp_Fields;
  scores_var_samp_order_by: Scores_Var_Samp_Order_By;
  scores_variance_fields: Scores_Variance_Fields;
  scores_variance_order_by: Scores_Variance_Order_By;
  spheres: Spheres;
  spheres_aggregate: Spheres_Aggregate;
  spheres_aggregate_fields: Spheres_Aggregate_Fields;
  spheres_aggregate_order_by: Spheres_Aggregate_Order_By;
  spheres_arr_rel_insert_input: Spheres_Arr_Rel_Insert_Input;
  spheres_avg_fields: Spheres_Avg_Fields;
  spheres_avg_order_by: Spheres_Avg_Order_By;
  spheres_bool_exp: Spheres_Bool_Exp;
  spheres_inc_input: Spheres_Inc_Input;
  spheres_insert_input: Spheres_Insert_Input;
  spheres_max_fields: Spheres_Max_Fields;
  spheres_max_order_by: Spheres_Max_Order_By;
  spheres_min_fields: Spheres_Min_Fields;
  spheres_min_order_by: Spheres_Min_Order_By;
  spheres_mutation_response: Spheres_Mutation_Response;
  spheres_obj_rel_insert_input: Spheres_Obj_Rel_Insert_Input;
  spheres_on_conflict: Spheres_On_Conflict;
  spheres_order_by: Spheres_Order_By;
  spheres_pk_columns_input: Spheres_Pk_Columns_Input;
  spheres_set_input: Spheres_Set_Input;
  spheres_stddev_fields: Spheres_Stddev_Fields;
  spheres_stddev_order_by: Spheres_Stddev_Order_By;
  spheres_stddev_pop_fields: Spheres_Stddev_Pop_Fields;
  spheres_stddev_pop_order_by: Spheres_Stddev_Pop_Order_By;
  spheres_stddev_samp_fields: Spheres_Stddev_Samp_Fields;
  spheres_stddev_samp_order_by: Spheres_Stddev_Samp_Order_By;
  spheres_sum_fields: Spheres_Sum_Fields;
  spheres_sum_order_by: Spheres_Sum_Order_By;
  spheres_var_pop_fields: Spheres_Var_Pop_Fields;
  spheres_var_pop_order_by: Spheres_Var_Pop_Order_By;
  spheres_var_samp_fields: Spheres_Var_Samp_Fields;
  spheres_var_samp_order_by: Spheres_Var_Samp_Order_By;
  spheres_variance_fields: Spheres_Variance_Fields;
  spheres_variance_order_by: Spheres_Variance_Order_By;
  subscription_root: {};
  supports: Supports;
  supports_aggregate: Supports_Aggregate;
  supports_aggregate_fields: Supports_Aggregate_Fields;
  supports_aggregate_order_by: Supports_Aggregate_Order_By;
  supports_arr_rel_insert_input: Supports_Arr_Rel_Insert_Input;
  supports_avg_fields: Supports_Avg_Fields;
  supports_avg_order_by: Supports_Avg_Order_By;
  supports_bool_exp: Supports_Bool_Exp;
  supports_inc_input: Supports_Inc_Input;
  supports_insert_input: Supports_Insert_Input;
  supports_max_fields: Supports_Max_Fields;
  supports_max_order_by: Supports_Max_Order_By;
  supports_min_fields: Supports_Min_Fields;
  supports_min_order_by: Supports_Min_Order_By;
  supports_mutation_response: Supports_Mutation_Response;
  supports_obj_rel_insert_input: Supports_Obj_Rel_Insert_Input;
  supports_on_conflict: Supports_On_Conflict;
  supports_order_by: Supports_Order_By;
  supports_pk_columns_input: Supports_Pk_Columns_Input;
  supports_set_input: Supports_Set_Input;
  supports_stddev_fields: Supports_Stddev_Fields;
  supports_stddev_order_by: Supports_Stddev_Order_By;
  supports_stddev_pop_fields: Supports_Stddev_Pop_Fields;
  supports_stddev_pop_order_by: Supports_Stddev_Pop_Order_By;
  supports_stddev_samp_fields: Supports_Stddev_Samp_Fields;
  supports_stddev_samp_order_by: Supports_Stddev_Samp_Order_By;
  supports_sum_fields: Supports_Sum_Fields;
  supports_sum_order_by: Supports_Sum_Order_By;
  supports_var_pop_fields: Supports_Var_Pop_Fields;
  supports_var_pop_order_by: Supports_Var_Pop_Order_By;
  supports_var_samp_fields: Supports_Var_Samp_Fields;
  supports_var_samp_order_by: Supports_Var_Samp_Order_By;
  supports_variance_fields: Supports_Variance_Fields;
  supports_variance_order_by: Supports_Variance_Order_By;
  timestamp: Scalars['timestamp'];
  timestamp_comparison_exp: Timestamp_Comparison_Exp;
  timestamptz: Scalars['timestamptz'];
  timestamptz_comparison_exp: Timestamptz_Comparison_Exp;
  users: Users;
  users_aggregate: Users_Aggregate;
  users_aggregate_fields: Users_Aggregate_Fields;
  users_aggregate_order_by: Users_Aggregate_Order_By;
  users_arr_rel_insert_input: Users_Arr_Rel_Insert_Input;
  users_avg_fields: Users_Avg_Fields;
  users_avg_order_by: Users_Avg_Order_By;
  users_bool_exp: Users_Bool_Exp;
  users_inc_input: Users_Inc_Input;
  users_insert_input: Users_Insert_Input;
  users_max_fields: Users_Max_Fields;
  users_max_order_by: Users_Max_Order_By;
  users_min_fields: Users_Min_Fields;
  users_min_order_by: Users_Min_Order_By;
  users_mutation_response: Users_Mutation_Response;
  users_obj_rel_insert_input: Users_Obj_Rel_Insert_Input;
  users_on_conflict: Users_On_Conflict;
  users_order_by: Users_Order_By;
  users_pk_columns_input: Users_Pk_Columns_Input;
  users_set_input: Users_Set_Input;
  users_stddev_fields: Users_Stddev_Fields;
  users_stddev_order_by: Users_Stddev_Order_By;
  users_stddev_pop_fields: Users_Stddev_Pop_Fields;
  users_stddev_pop_order_by: Users_Stddev_Pop_Order_By;
  users_stddev_samp_fields: Users_Stddev_Samp_Fields;
  users_stddev_samp_order_by: Users_Stddev_Samp_Order_By;
  users_sum_fields: Users_Sum_Fields;
  users_sum_order_by: Users_Sum_Order_By;
  users_var_pop_fields: Users_Var_Pop_Fields;
  users_var_pop_order_by: Users_Var_Pop_Order_By;
  users_var_samp_fields: Users_Var_Samp_Fields;
  users_var_samp_order_by: Users_Var_Samp_Order_By;
  users_variance_fields: Users_Variance_Fields;
  users_variance_order_by: Users_Variance_Order_By;
};

export type NgModuleDirectiveArgs = {   module: Scalars['String']; };

export type NgModuleDirectiveResolver<Result, Parent, ContextType = any, Args = NgModuleDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type NamedClientDirectiveArgs = {   name: Scalars['String']; };

export type NamedClientDirectiveResolver<Result, Parent, ContextType = any, Args = NamedClientDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Activation_CodesResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes'] = ResolversParentTypes['activation_codes']> = {
  activated_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  activation_date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  extra_days?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profile?: Resolver<Maybe<ResolversTypes['profiles']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_aggregate'] = ResolversParentTypes['activation_codes_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['activation_codes_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['activation_codes']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_aggregate_fields'] = ResolversParentTypes['activation_codes_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['activation_codes_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Activation_Codes_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['activation_codes_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['activation_codes_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['activation_codes_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['activation_codes_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['activation_codes_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['activation_codes_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['activation_codes_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['activation_codes_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['activation_codes_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_avg_fields'] = ResolversParentTypes['activation_codes_avg_fields']> = {
  activated_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  extra_days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_max_fields'] = ResolversParentTypes['activation_codes_max_fields']> = {
  activated_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  activation_date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extra_days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_min_fields'] = ResolversParentTypes['activation_codes_min_fields']> = {
  activated_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  activation_date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extra_days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_mutation_response'] = ResolversParentTypes['activation_codes_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['activation_codes']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_stddev_fields'] = ResolversParentTypes['activation_codes_stddev_fields']> = {
  activated_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  extra_days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_stddev_pop_fields'] = ResolversParentTypes['activation_codes_stddev_pop_fields']> = {
  activated_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  extra_days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_stddev_samp_fields'] = ResolversParentTypes['activation_codes_stddev_samp_fields']> = {
  activated_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  extra_days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_sum_fields'] = ResolversParentTypes['activation_codes_sum_fields']> = {
  activated_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  extra_days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_var_pop_fields'] = ResolversParentTypes['activation_codes_var_pop_fields']> = {
  activated_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  extra_days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_var_samp_fields'] = ResolversParentTypes['activation_codes_var_samp_fields']> = {
  activated_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  extra_days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Activation_Codes_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activation_codes_variance_fields'] = ResolversParentTypes['activation_codes_variance_fields']> = {
  activated_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  extra_days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnswersResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers'] = ResolversParentTypes['answers']> = {
  answers_choice_associations?: Resolver<Array<ResolversTypes['answers_choice_association']>, ParentType, ContextType, RequireFields<AnswersAnswers_Choice_AssociationsArgs, never>>;
  answers_choice_associations_aggregate?: Resolver<ResolversTypes['answers_choice_association_aggregate'], ParentType, ContextType, RequireFields<AnswersAnswers_Choice_Associations_AggregateArgs, never>>;
  created_at?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  exam_type?: Resolver<ResolversTypes['exam_types'], ParentType, ContextType>;
  extra_value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feedbackAuthor?: Resolver<Maybe<ResolversTypes['profiles']>, ParentType, ContextType>;
  feedback_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  feedback_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  feedback_score?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  is_correct?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  is_mock?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  need_feedback?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  part?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profile?: Resolver<Maybe<ResolversTypes['profiles']>, ParentType, ContextType>;
  question?: Resolver<ResolversTypes['questions'], ParentType, ContextType>;
  question_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['results']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['users'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_aggregate'] = ResolversParentTypes['answers_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['answers_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['answers']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_aggregate_fields'] = ResolversParentTypes['answers_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['answers_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Answers_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['answers_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['answers_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['answers_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['answers_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['answers_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['answers_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['answers_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['answers_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['answers_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_avg_fields'] = ResolversParentTypes['answers_avg_fields']> = {
  feedback_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feedback_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_AssociationResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association'] = ResolversParentTypes['answers_choice_association']> = {
  answer?: Resolver<Maybe<ResolversTypes['answers']>, ParentType, ContextType>;
  answer_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  choice?: Resolver<Maybe<ResolversTypes['choices']>, ParentType, ContextType>;
  choice_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_aggregate'] = ResolversParentTypes['answers_choice_association_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['answers_choice_association_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['answers_choice_association']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_aggregate_fields'] = ResolversParentTypes['answers_choice_association_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['answers_choice_association_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Answers_Choice_Association_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['answers_choice_association_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['answers_choice_association_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['answers_choice_association_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['answers_choice_association_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['answers_choice_association_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['answers_choice_association_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['answers_choice_association_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['answers_choice_association_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['answers_choice_association_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_avg_fields'] = ResolversParentTypes['answers_choice_association_avg_fields']> = {
  answer_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  choice_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_max_fields'] = ResolversParentTypes['answers_choice_association_max_fields']> = {
  answer_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  choice_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_min_fields'] = ResolversParentTypes['answers_choice_association_min_fields']> = {
  answer_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  choice_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_mutation_response'] = ResolversParentTypes['answers_choice_association_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['answers_choice_association']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_stddev_fields'] = ResolversParentTypes['answers_choice_association_stddev_fields']> = {
  answer_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  choice_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_stddev_pop_fields'] = ResolversParentTypes['answers_choice_association_stddev_pop_fields']> = {
  answer_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  choice_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_stddev_samp_fields'] = ResolversParentTypes['answers_choice_association_stddev_samp_fields']> = {
  answer_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  choice_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_sum_fields'] = ResolversParentTypes['answers_choice_association_sum_fields']> = {
  answer_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  choice_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_var_pop_fields'] = ResolversParentTypes['answers_choice_association_var_pop_fields']> = {
  answer_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  choice_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_var_samp_fields'] = ResolversParentTypes['answers_choice_association_var_samp_fields']> = {
  answer_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  choice_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Choice_Association_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_choice_association_variance_fields'] = ResolversParentTypes['answers_choice_association_variance_fields']> = {
  answer_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  choice_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_max_fields'] = ResolversParentTypes['answers_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  extra_value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feedback_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  feedback_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  feedback_score?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_min_fields'] = ResolversParentTypes['answers_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  extra_value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feedback_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  feedback_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  feedback_score?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_mutation_response'] = ResolversParentTypes['answers_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['answers']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_stddev_fields'] = ResolversParentTypes['answers_stddev_fields']> = {
  feedback_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feedback_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_stddev_pop_fields'] = ResolversParentTypes['answers_stddev_pop_fields']> = {
  feedback_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feedback_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_stddev_samp_fields'] = ResolversParentTypes['answers_stddev_samp_fields']> = {
  feedback_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feedback_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_sum_fields'] = ResolversParentTypes['answers_sum_fields']> = {
  feedback_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  feedback_score?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_var_pop_fields'] = ResolversParentTypes['answers_var_pop_fields']> = {
  feedback_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feedback_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_var_samp_fields'] = ResolversParentTypes['answers_var_samp_fields']> = {
  feedback_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feedback_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Answers_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['answers_variance_fields'] = ResolversParentTypes['answers_variance_fields']> = {
  feedback_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feedback_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills'] = ResolversParentTypes['bills']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  days?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discount_fix?: Resolver<ResolversTypes['float8'], ParentType, ContextType>;
  discount_per?: Resolver<ResolversTypes['float8'], ParentType, ContextType>;
  exam_type?: Resolver<ResolversTypes['exam_types'], ParentType, ContextType>;
  first_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  last_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postal_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pretax_price?: Resolver<ResolversTypes['float8'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_aggregate'] = ResolversParentTypes['bills_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['bills_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['bills']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_aggregate_fields'] = ResolversParentTypes['bills_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['bills_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Bills_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['bills_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['bills_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['bills_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['bills_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['bills_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['bills_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['bills_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['bills_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['bills_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_avg_fields'] = ResolversParentTypes['bills_avg_fields']> = {
  days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pretax_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_max_fields'] = ResolversParentTypes['bills_max_fields']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discount_fix?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  first_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  last_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pretax_price?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_min_fields'] = ResolversParentTypes['bills_min_fields']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discount_fix?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  first_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  last_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pretax_price?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_mutation_response'] = ResolversParentTypes['bills_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['bills']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_stddev_fields'] = ResolversParentTypes['bills_stddev_fields']> = {
  days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pretax_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_stddev_pop_fields'] = ResolversParentTypes['bills_stddev_pop_fields']> = {
  days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pretax_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_stddev_samp_fields'] = ResolversParentTypes['bills_stddev_samp_fields']> = {
  days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pretax_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_sum_fields'] = ResolversParentTypes['bills_sum_fields']> = {
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discount_fix?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pretax_price?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_var_pop_fields'] = ResolversParentTypes['bills_var_pop_fields']> = {
  days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pretax_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_var_samp_fields'] = ResolversParentTypes['bills_var_samp_fields']> = {
  days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pretax_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bills_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bills_variance_fields'] = ResolversParentTypes['bills_variance_fields']> = {
  days?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pretax_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_AssessmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment'] = ResolversParentTypes['bright_assessment']> = {
  assessments_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bright_assessment?: Resolver<ResolversTypes['bright_assessments'], ParentType, ContextType>;
  bright_assessment_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['profiles'], ParentType, ContextType>;
  tester_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_aggregate'] = ResolversParentTypes['bright_assessment_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['bright_assessment_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['bright_assessment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_aggregate_fields'] = ResolversParentTypes['bright_assessment_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['bright_assessment_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Bright_Assessment_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['bright_assessment_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['bright_assessment_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['bright_assessment_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['bright_assessment_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['bright_assessment_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['bright_assessment_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['bright_assessment_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['bright_assessment_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['bright_assessment_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_avg_fields'] = ResolversParentTypes['bright_assessment_avg_fields']> = {
  assessments_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bright_assessment_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tester_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_max_fields'] = ResolversParentTypes['bright_assessment_max_fields']> = {
  assessments_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bright_assessment_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tester_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_min_fields'] = ResolversParentTypes['bright_assessment_min_fields']> = {
  assessments_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bright_assessment_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tester_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_mutation_response'] = ResolversParentTypes['bright_assessment_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['bright_assessment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_stddev_fields'] = ResolversParentTypes['bright_assessment_stddev_fields']> = {
  assessments_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bright_assessment_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tester_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_stddev_pop_fields'] = ResolversParentTypes['bright_assessment_stddev_pop_fields']> = {
  assessments_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bright_assessment_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tester_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_stddev_samp_fields'] = ResolversParentTypes['bright_assessment_stddev_samp_fields']> = {
  assessments_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bright_assessment_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tester_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_sum_fields'] = ResolversParentTypes['bright_assessment_sum_fields']> = {
  assessments_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bright_assessment_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tester_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_var_pop_fields'] = ResolversParentTypes['bright_assessment_var_pop_fields']> = {
  assessments_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bright_assessment_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tester_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_var_samp_fields'] = ResolversParentTypes['bright_assessment_var_samp_fields']> = {
  assessments_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bright_assessment_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tester_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessment_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessment_variance_fields'] = ResolversParentTypes['bright_assessment_variance_fields']> = {
  assessments_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bright_assessment_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tester_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_AssessmentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments'] = ResolversParentTypes['bright_assessments']> = {
  bright_assessments?: Resolver<Array<ResolversTypes['bright_assessment']>, ParentType, ContextType, RequireFields<Bright_AssessmentsBright_AssessmentsArgs, never>>;
  bright_assessments_aggregate?: Resolver<ResolversTypes['bright_assessment_aggregate'], ParentType, ContextType, RequireFields<Bright_AssessmentsBright_Assessments_AggregateArgs, never>>;
  createdDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  institutionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  openedDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  teacherId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_aggregate'] = ResolversParentTypes['bright_assessments_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['bright_assessments_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['bright_assessments']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_aggregate_fields'] = ResolversParentTypes['bright_assessments_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['bright_assessments_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Bright_Assessments_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['bright_assessments_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['bright_assessments_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['bright_assessments_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['bright_assessments_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['bright_assessments_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['bright_assessments_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['bright_assessments_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['bright_assessments_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['bright_assessments_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_avg_fields'] = ResolversParentTypes['bright_assessments_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacherId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_max_fields'] = ResolversParentTypes['bright_assessments_max_fields']> = {
  createdDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  openedDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  teacherId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_min_fields'] = ResolversParentTypes['bright_assessments_min_fields']> = {
  createdDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  openedDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  teacherId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_mutation_response'] = ResolversParentTypes['bright_assessments_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['bright_assessments']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_stddev_fields'] = ResolversParentTypes['bright_assessments_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacherId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_stddev_pop_fields'] = ResolversParentTypes['bright_assessments_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacherId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_stddev_samp_fields'] = ResolversParentTypes['bright_assessments_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacherId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_sum_fields'] = ResolversParentTypes['bright_assessments_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  teacherId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_var_pop_fields'] = ResolversParentTypes['bright_assessments_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacherId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_var_samp_fields'] = ResolversParentTypes['bright_assessments_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacherId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Assessments_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_assessments_variance_fields'] = ResolversParentTypes['bright_assessments_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacherId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_BranchResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch'] = ResolversParentTypes['bright_branch']> = {
  bright_branch_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  institution_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_aggregate'] = ResolversParentTypes['bright_branch_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['bright_branch_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['bright_branch']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_aggregate_fields'] = ResolversParentTypes['bright_branch_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['bright_branch_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Bright_Branch_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['bright_branch_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['bright_branch_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['bright_branch_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['bright_branch_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['bright_branch_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['bright_branch_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['bright_branch_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['bright_branch_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['bright_branch_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_avg_fields'] = ResolversParentTypes['bright_branch_avg_fields']> = {
  bright_branch_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_max_fields'] = ResolversParentTypes['bright_branch_max_fields']> = {
  bright_branch_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_min_fields'] = ResolversParentTypes['bright_branch_min_fields']> = {
  bright_branch_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_mutation_response'] = ResolversParentTypes['bright_branch_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['bright_branch']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_stddev_fields'] = ResolversParentTypes['bright_branch_stddev_fields']> = {
  bright_branch_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_stddev_pop_fields'] = ResolversParentTypes['bright_branch_stddev_pop_fields']> = {
  bright_branch_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_stddev_samp_fields'] = ResolversParentTypes['bright_branch_stddev_samp_fields']> = {
  bright_branch_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_sum_fields'] = ResolversParentTypes['bright_branch_sum_fields']> = {
  bright_branch_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_var_pop_fields'] = ResolversParentTypes['bright_branch_var_pop_fields']> = {
  bright_branch_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_var_samp_fields'] = ResolversParentTypes['bright_branch_var_samp_fields']> = {
  bright_branch_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Branch_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_branch_variance_fields'] = ResolversParentTypes['bright_branch_variance_fields']> = {
  bright_branch_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_CandidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate'] = ResolversParentTypes['bright_candidate']> = {
  bright_candidate_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  candidate_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  manager_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_aggregate'] = ResolversParentTypes['bright_candidate_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['bright_candidate_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['bright_candidate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_aggregate_fields'] = ResolversParentTypes['bright_candidate_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['bright_candidate_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Bright_Candidate_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['bright_candidate_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['bright_candidate_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['bright_candidate_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['bright_candidate_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['bright_candidate_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['bright_candidate_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['bright_candidate_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['bright_candidate_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['bright_candidate_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_avg_fields'] = ResolversParentTypes['bright_candidate_avg_fields']> = {
  bright_candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_max_fields'] = ResolversParentTypes['bright_candidate_max_fields']> = {
  bright_candidate_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  candidate_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_min_fields'] = ResolversParentTypes['bright_candidate_min_fields']> = {
  bright_candidate_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  candidate_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_mutation_response'] = ResolversParentTypes['bright_candidate_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['bright_candidate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_stddev_fields'] = ResolversParentTypes['bright_candidate_stddev_fields']> = {
  bright_candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_stddev_pop_fields'] = ResolversParentTypes['bright_candidate_stddev_pop_fields']> = {
  bright_candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_stddev_samp_fields'] = ResolversParentTypes['bright_candidate_stddev_samp_fields']> = {
  bright_candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_sum_fields'] = ResolversParentTypes['bright_candidate_sum_fields']> = {
  bright_candidate_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  candidate_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_var_pop_fields'] = ResolversParentTypes['bright_candidate_var_pop_fields']> = {
  bright_candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_var_samp_fields'] = ResolversParentTypes['bright_candidate_var_samp_fields']> = {
  bright_candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Candidate_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_candidate_variance_fields'] = ResolversParentTypes['bright_candidate_variance_fields']> = {
  bright_candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  candidate_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_ManagerResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager'] = ResolversParentTypes['bright_manager']> = {
  bright_manager_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  manager_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['profiles'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_aggregate'] = ResolversParentTypes['bright_manager_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['bright_manager_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['bright_manager']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_aggregate_fields'] = ResolversParentTypes['bright_manager_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['bright_manager_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Bright_Manager_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['bright_manager_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['bright_manager_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['bright_manager_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['bright_manager_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['bright_manager_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['bright_manager_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['bright_manager_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['bright_manager_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['bright_manager_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_avg_fields'] = ResolversParentTypes['bright_manager_avg_fields']> = {
  bright_manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_max_fields'] = ResolversParentTypes['bright_manager_max_fields']> = {
  bright_manager_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_min_fields'] = ResolversParentTypes['bright_manager_min_fields']> = {
  bright_manager_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_mutation_response'] = ResolversParentTypes['bright_manager_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['bright_manager']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_stddev_fields'] = ResolversParentTypes['bright_manager_stddev_fields']> = {
  bright_manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_stddev_pop_fields'] = ResolversParentTypes['bright_manager_stddev_pop_fields']> = {
  bright_manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_stddev_samp_fields'] = ResolversParentTypes['bright_manager_stddev_samp_fields']> = {
  bright_manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_sum_fields'] = ResolversParentTypes['bright_manager_sum_fields']> = {
  bright_manager_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_var_pop_fields'] = ResolversParentTypes['bright_manager_var_pop_fields']> = {
  bright_manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_var_samp_fields'] = ResolversParentTypes['bright_manager_var_samp_fields']> = {
  bright_manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Bright_Manager_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['bright_manager_variance_fields'] = ResolversParentTypes['bright_manager_variance_fields']> = {
  bright_manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories'] = ResolversParentTypes['categories']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lessons?: Resolver<Array<ResolversTypes['lessons']>, ParentType, ContextType, RequireFields<CategoriesLessonsArgs, never>>;
  lessons_aggregate?: Resolver<ResolversTypes['lessons_aggregate'], ParentType, ContextType, RequireFields<CategoriesLessons_AggregateArgs, never>>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_aggregate'] = ResolversParentTypes['categories_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['categories_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['categories']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_aggregate_fields'] = ResolversParentTypes['categories_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['categories_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Categories_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['categories_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['categories_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['categories_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['categories_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['categories_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['categories_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['categories_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['categories_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['categories_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_avg_fields'] = ResolversParentTypes['categories_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_max_fields'] = ResolversParentTypes['categories_max_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_min_fields'] = ResolversParentTypes['categories_min_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_mutation_response'] = ResolversParentTypes['categories_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['categories']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_stddev_fields'] = ResolversParentTypes['categories_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_stddev_pop_fields'] = ResolversParentTypes['categories_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_stddev_samp_fields'] = ResolversParentTypes['categories_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_sum_fields'] = ResolversParentTypes['categories_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_var_pop_fields'] = ResolversParentTypes['categories_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_var_samp_fields'] = ResolversParentTypes['categories_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Categories_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['categories_variance_fields'] = ResolversParentTypes['categories_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChoicesResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices'] = ResolversParentTypes['choices']> = {
  answers_choice_associations?: Resolver<Array<ResolversTypes['answers_choice_association']>, ParentType, ContextType, RequireFields<ChoicesAnswers_Choice_AssociationsArgs, never>>;
  answers_choice_associations_aggregate?: Resolver<ResolversTypes['answers_choice_association_aggregate'], ParentType, ContextType, RequireFields<ChoicesAnswers_Choice_Associations_AggregateArgs, never>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_correct?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  question?: Resolver<ResolversTypes['questions'], ParentType, ContextType>;
  question_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_aggregate'] = ResolversParentTypes['choices_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['choices_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['choices']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_aggregate_fields'] = ResolversParentTypes['choices_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['choices_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Choices_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['choices_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['choices_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['choices_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['choices_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['choices_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['choices_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['choices_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['choices_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['choices_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_avg_fields'] = ResolversParentTypes['choices_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_max_fields'] = ResolversParentTypes['choices_max_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_min_fields'] = ResolversParentTypes['choices_min_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_mutation_response'] = ResolversParentTypes['choices_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['choices']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_stddev_fields'] = ResolversParentTypes['choices_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_stddev_pop_fields'] = ResolversParentTypes['choices_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_stddev_samp_fields'] = ResolversParentTypes['choices_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_sum_fields'] = ResolversParentTypes['choices_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_var_pop_fields'] = ResolversParentTypes['choices_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_var_samp_fields'] = ResolversParentTypes['choices_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Choices_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['choices_variance_fields'] = ResolversParentTypes['choices_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_LogResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log'] = ResolversParentTypes['credits_log']> = {
  billed_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  created_by?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  credits?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  institution?: Resolver<ResolversTypes['institutions'], ParentType, ContextType>;
  institution_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['profiles'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_aggregate'] = ResolversParentTypes['credits_log_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['credits_log_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['credits_log']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_aggregate_fields'] = ResolversParentTypes['credits_log_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['credits_log_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Credits_Log_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['credits_log_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['credits_log_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['credits_log_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['credits_log_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['credits_log_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['credits_log_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['credits_log_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['credits_log_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['credits_log_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_avg_fields'] = ResolversParentTypes['credits_log_avg_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_max_fields'] = ResolversParentTypes['credits_log_max_fields']> = {
  billed_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_min_fields'] = ResolversParentTypes['credits_log_min_fields']> = {
  billed_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_mutation_response'] = ResolversParentTypes['credits_log_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['credits_log']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_stddev_fields'] = ResolversParentTypes['credits_log_stddev_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_stddev_pop_fields'] = ResolversParentTypes['credits_log_stddev_pop_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_stddev_samp_fields'] = ResolversParentTypes['credits_log_stddev_samp_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_sum_fields'] = ResolversParentTypes['credits_log_sum_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_var_pop_fields'] = ResolversParentTypes['credits_log_var_pop_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_var_samp_fields'] = ResolversParentTypes['credits_log_var_samp_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Credits_Log_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['credits_log_variance_fields'] = ResolversParentTypes['credits_log_variance_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_CodesResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes'] = ResolversParentTypes['discount_codes']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount_fix?: Resolver<ResolversTypes['float8'], ParentType, ContextType>;
  discount_per?: Resolver<ResolversTypes['float8'], ParentType, ContextType>;
  exam_type?: Resolver<ResolversTypes['exam_types'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  valid_until?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_aggregate'] = ResolversParentTypes['discount_codes_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['discount_codes_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['discount_codes']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_aggregate_fields'] = ResolversParentTypes['discount_codes_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['discount_codes_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Discount_Codes_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['discount_codes_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['discount_codes_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['discount_codes_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['discount_codes_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['discount_codes_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['discount_codes_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['discount_codes_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['discount_codes_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['discount_codes_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_avg_fields'] = ResolversParentTypes['discount_codes_avg_fields']> = {
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_max_fields'] = ResolversParentTypes['discount_codes_max_fields']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_fix?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  valid_until?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_min_fields'] = ResolversParentTypes['discount_codes_min_fields']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_fix?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  valid_until?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_mutation_response'] = ResolversParentTypes['discount_codes_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['discount_codes']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_stddev_fields'] = ResolversParentTypes['discount_codes_stddev_fields']> = {
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_stddev_pop_fields'] = ResolversParentTypes['discount_codes_stddev_pop_fields']> = {
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_stddev_samp_fields'] = ResolversParentTypes['discount_codes_stddev_samp_fields']> = {
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_sum_fields'] = ResolversParentTypes['discount_codes_sum_fields']> = {
  discount_fix?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_var_pop_fields'] = ResolversParentTypes['discount_codes_var_pop_fields']> = {
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_var_samp_fields'] = ResolversParentTypes['discount_codes_var_samp_fields']> = {
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Discount_Codes_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['discount_codes_variance_fields'] = ResolversParentTypes['discount_codes_variance_fields']> = {
  discount_fix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discount_per?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_ScoresResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores'] = ResolversParentTypes['estimated_scores']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  exam_type?: Resolver<ResolversTypes['exam_types'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profile?: Resolver<Maybe<ResolversTypes['profiles']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_aggregate'] = ResolversParentTypes['estimated_scores_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['estimated_scores_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['estimated_scores']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_aggregate_fields'] = ResolversParentTypes['estimated_scores_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['estimated_scores_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Estimated_Scores_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['estimated_scores_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['estimated_scores_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['estimated_scores_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['estimated_scores_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['estimated_scores_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['estimated_scores_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['estimated_scores_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['estimated_scores_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['estimated_scores_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_avg_fields'] = ResolversParentTypes['estimated_scores_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_max_fields'] = ResolversParentTypes['estimated_scores_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_min_fields'] = ResolversParentTypes['estimated_scores_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_mutation_response'] = ResolversParentTypes['estimated_scores_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['estimated_scores']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_stddev_fields'] = ResolversParentTypes['estimated_scores_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_stddev_pop_fields'] = ResolversParentTypes['estimated_scores_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_stddev_samp_fields'] = ResolversParentTypes['estimated_scores_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_sum_fields'] = ResolversParentTypes['estimated_scores_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_var_pop_fields'] = ResolversParentTypes['estimated_scores_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_var_samp_fields'] = ResolversParentTypes['estimated_scores_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Estimated_Scores_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['estimated_scores_variance_fields'] = ResolversParentTypes['estimated_scores_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface Exam_TypesScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['exam_types'], any> {
  name: 'exam_types';
}

export type ExamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams'] = ResolversParentTypes['exams']> = {
  exam_type?: Resolver<ResolversTypes['exam_types'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  is_active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  is_exercises?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supports?: Resolver<Array<ResolversTypes['supports']>, ParentType, ContextType, RequireFields<ExamsSupportsArgs, never>>;
  supports_aggregate?: Resolver<ResolversTypes['supports_aggregate'], ParentType, ContextType, RequireFields<ExamsSupports_AggregateArgs, never>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_aggregate'] = ResolversParentTypes['exams_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['exams_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['exams']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_aggregate_fields'] = ResolversParentTypes['exams_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['exams_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Exams_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['exams_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['exams_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['exams_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['exams_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['exams_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['exams_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['exams_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['exams_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['exams_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_avg_fields'] = ResolversParentTypes['exams_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_max_fields'] = ResolversParentTypes['exams_max_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_min_fields'] = ResolversParentTypes['exams_min_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_mutation_response'] = ResolversParentTypes['exams_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['exams']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_stddev_fields'] = ResolversParentTypes['exams_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_stddev_pop_fields'] = ResolversParentTypes['exams_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_stddev_samp_fields'] = ResolversParentTypes['exams_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_sum_fields'] = ResolversParentTypes['exams_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_var_pop_fields'] = ResolversParentTypes['exams_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_var_samp_fields'] = ResolversParentTypes['exams_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Exams_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['exams_variance_fields'] = ResolversParentTypes['exams_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeedbacksResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks'] = ResolversParentTypes['feedbacks']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  information?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  support?: Resolver<ResolversTypes['supports'], ParentType, ContextType>;
  supportCopy?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, RequireFields<FeedbacksSupportCopyArgs, never>>;
  supportId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_aggregate'] = ResolversParentTypes['feedbacks_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['feedbacks_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['feedbacks']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_aggregate_fields'] = ResolversParentTypes['feedbacks_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['feedbacks_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Feedbacks_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['feedbacks_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['feedbacks_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['feedbacks_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['feedbacks_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['feedbacks_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['feedbacks_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['feedbacks_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['feedbacks_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['feedbacks_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_avg_fields'] = ResolversParentTypes['feedbacks_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supportId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_max_fields'] = ResolversParentTypes['feedbacks_max_fields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  information?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supportId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_min_fields'] = ResolversParentTypes['feedbacks_min_fields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  information?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supportId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_mutation_response'] = ResolversParentTypes['feedbacks_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['feedbacks']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_stddev_fields'] = ResolversParentTypes['feedbacks_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supportId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_stddev_pop_fields'] = ResolversParentTypes['feedbacks_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supportId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_stddev_samp_fields'] = ResolversParentTypes['feedbacks_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supportId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_sum_fields'] = ResolversParentTypes['feedbacks_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  supportId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_var_pop_fields'] = ResolversParentTypes['feedbacks_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supportId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_var_samp_fields'] = ResolversParentTypes['feedbacks_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supportId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Feedbacks_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['feedbacks_variance_fields'] = ResolversParentTypes['feedbacks_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supportId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface Float8ScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['float8'], any> {
  name: 'float8';
}

export type InstitutionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions'] = ResolversParentTypes['institutions']> = {
  bright_branch?: Resolver<Maybe<ResolversTypes['bright_branch']>, ParentType, ContextType>;
  credit_duration?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  credits?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  credits_logs?: Resolver<Array<ResolversTypes['credits_log']>, ParentType, ContextType, RequireFields<InstitutionsCredits_LogsArgs, never>>;
  credits_logs_aggregate?: Resolver<ResolversTypes['credits_log_aggregate'], ParentType, ContextType, RequireFields<InstitutionsCredits_Logs_AggregateArgs, never>>;
  exams?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, RequireFields<InstitutionsExamsArgs, never>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  is_root_institution?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  multi_credits?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, RequireFields<InstitutionsMulti_CreditsArgs, never>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nb_of_exclusive_mock_exams?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  parent_institution?: Resolver<Maybe<ResolversTypes['institutions']>, ParentType, ContextType>;
  parent_institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profiles?: Resolver<Array<ResolversTypes['profiles']>, ParentType, ContextType, RequireFields<InstitutionsProfilesArgs, never>>;
  profiles_aggregate?: Resolver<ResolversTypes['profiles_aggregate'], ParentType, ContextType, RequireFields<InstitutionsProfiles_AggregateArgs, never>>;
  registration_billings?: Resolver<Array<ResolversTypes['registration_billings']>, ParentType, ContextType, RequireFields<InstitutionsRegistration_BillingsArgs, never>>;
  registration_billings_aggregate?: Resolver<ResolversTypes['registration_billings_aggregate'], ParentType, ContextType, RequireFields<InstitutionsRegistration_Billings_AggregateArgs, never>>;
  registrations?: Resolver<Array<ResolversTypes['registrations']>, ParentType, ContextType, RequireFields<InstitutionsRegistrationsArgs, never>>;
  registrations_aggregate?: Resolver<ResolversTypes['registrations_aggregate'], ParentType, ContextType, RequireFields<InstitutionsRegistrations_AggregateArgs, never>>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subInstitutions?: Resolver<Array<ResolversTypes['institutions']>, ParentType, ContextType, RequireFields<InstitutionsSubInstitutionsArgs, never>>;
  subInstitutions_aggregate?: Resolver<ResolversTypes['institutions_aggregate'], ParentType, ContextType, RequireFields<InstitutionsSubInstitutions_AggregateArgs, never>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_aggregate'] = ResolversParentTypes['institutions_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['institutions_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['institutions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_aggregate_fields'] = ResolversParentTypes['institutions_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['institutions_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Institutions_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['institutions_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['institutions_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['institutions_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['institutions_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['institutions_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['institutions_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['institutions_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['institutions_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['institutions_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_avg_fields'] = ResolversParentTypes['institutions_avg_fields']> = {
  credit_duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nb_of_exclusive_mock_exams?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  parent_institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_max_fields'] = ResolversParentTypes['institutions_max_fields']> = {
  credit_duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nb_of_exclusive_mock_exams?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  parent_institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_min_fields'] = ResolversParentTypes['institutions_min_fields']> = {
  credit_duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nb_of_exclusive_mock_exams?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  parent_institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_mutation_response'] = ResolversParentTypes['institutions_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['institutions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_stddev_fields'] = ResolversParentTypes['institutions_stddev_fields']> = {
  credit_duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nb_of_exclusive_mock_exams?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  parent_institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_stddev_pop_fields'] = ResolversParentTypes['institutions_stddev_pop_fields']> = {
  credit_duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nb_of_exclusive_mock_exams?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  parent_institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_stddev_samp_fields'] = ResolversParentTypes['institutions_stddev_samp_fields']> = {
  credit_duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nb_of_exclusive_mock_exams?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  parent_institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_sum_fields'] = ResolversParentTypes['institutions_sum_fields']> = {
  credit_duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nb_of_exclusive_mock_exams?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  parent_institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_var_pop_fields'] = ResolversParentTypes['institutions_var_pop_fields']> = {
  credit_duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nb_of_exclusive_mock_exams?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  parent_institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_var_samp_fields'] = ResolversParentTypes['institutions_var_samp_fields']> = {
  credit_duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nb_of_exclusive_mock_exams?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  parent_institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Institutions_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['institutions_variance_fields'] = ResolversParentTypes['institutions_variance_fields']> = {
  credit_duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nb_of_exclusive_mock_exams?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  parent_institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonbScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['jsonb'], any> {
  name: 'jsonb';
}

export type LessonsResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons'] = ResolversParentTypes['lessons']> = {
  category?: Resolver<ResolversTypes['categories'], ParentType, ContextType>;
  category_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exam_type?: Resolver<ResolversTypes['exam_types'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  question_lesson_associations?: Resolver<Array<ResolversTypes['question_lesson_association']>, ParentType, ContextType, RequireFields<LessonsQuestion_Lesson_AssociationsArgs, never>>;
  question_lesson_associations_aggregate?: Resolver<ResolversTypes['question_lesson_association_aggregate'], ParentType, ContextType, RequireFields<LessonsQuestion_Lesson_Associations_AggregateArgs, never>>;
  scores?: Resolver<Array<ResolversTypes['scores']>, ParentType, ContextType, RequireFields<LessonsScoresArgs, never>>;
  scores_aggregate?: Resolver<ResolversTypes['scores_aggregate'], ParentType, ContextType, RequireFields<LessonsScores_AggregateArgs, never>>;
  supports?: Resolver<Array<ResolversTypes['supports']>, ParentType, ContextType, RequireFields<LessonsSupportsArgs, never>>;
  supports_aggregate?: Resolver<ResolversTypes['supports_aggregate'], ParentType, ContextType, RequireFields<LessonsSupports_AggregateArgs, never>>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_aggregate'] = ResolversParentTypes['lessons_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['lessons_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['lessons']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_aggregate_fields'] = ResolversParentTypes['lessons_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['lessons_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Lessons_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['lessons_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['lessons_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['lessons_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['lessons_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['lessons_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['lessons_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['lessons_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['lessons_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['lessons_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_avg_fields'] = ResolversParentTypes['lessons_avg_fields']> = {
  category_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_max_fields'] = ResolversParentTypes['lessons_max_fields']> = {
  category_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_min_fields'] = ResolversParentTypes['lessons_min_fields']> = {
  category_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_mutation_response'] = ResolversParentTypes['lessons_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['lessons']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_stddev_fields'] = ResolversParentTypes['lessons_stddev_fields']> = {
  category_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_stddev_pop_fields'] = ResolversParentTypes['lessons_stddev_pop_fields']> = {
  category_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_stddev_samp_fields'] = ResolversParentTypes['lessons_stddev_samp_fields']> = {
  category_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_sum_fields'] = ResolversParentTypes['lessons_sum_fields']> = {
  category_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_var_pop_fields'] = ResolversParentTypes['lessons_var_pop_fields']> = {
  category_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_var_samp_fields'] = ResolversParentTypes['lessons_var_samp_fields']> = {
  category_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Lessons_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['lessons_variance_fields'] = ResolversParentTypes['lessons_variance_fields']> = {
  category_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Mutation_RootResolvers<ContextType = any, ParentType extends ResolversParentTypes['mutation_root'] = ResolversParentTypes['mutation_root']> = {
  delete_activation_codes?: Resolver<Maybe<ResolversTypes['activation_codes_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Activation_CodesArgs, 'where'>>;
  delete_activation_codes_by_pk?: Resolver<Maybe<ResolversTypes['activation_codes']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Activation_Codes_By_PkArgs, 'id'>>;
  delete_answers?: Resolver<Maybe<ResolversTypes['answers_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_AnswersArgs, 'where'>>;
  delete_answers_by_pk?: Resolver<Maybe<ResolversTypes['answers']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Answers_By_PkArgs, 'id'>>;
  delete_answers_choice_association?: Resolver<Maybe<ResolversTypes['answers_choice_association_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Answers_Choice_AssociationArgs, 'where'>>;
  delete_bills?: Resolver<Maybe<ResolversTypes['bills_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_BillsArgs, 'where'>>;
  delete_bills_by_pk?: Resolver<Maybe<ResolversTypes['bills']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Bills_By_PkArgs, 'id'>>;
  delete_bright_assessment?: Resolver<Maybe<ResolversTypes['bright_assessment_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Bright_AssessmentArgs, 'where'>>;
  delete_bright_assessment_by_pk?: Resolver<Maybe<ResolversTypes['bright_assessment']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Bright_Assessment_By_PkArgs, 'bright_assessment_id' | 'tester_id'>>;
  delete_bright_assessments?: Resolver<Maybe<ResolversTypes['bright_assessments_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Bright_AssessmentsArgs, 'where'>>;
  delete_bright_assessments_by_pk?: Resolver<Maybe<ResolversTypes['bright_assessments']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Bright_Assessments_By_PkArgs, 'id'>>;
  delete_bright_branch?: Resolver<Maybe<ResolversTypes['bright_branch_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Bright_BranchArgs, 'where'>>;
  delete_bright_branch_by_pk?: Resolver<Maybe<ResolversTypes['bright_branch']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Bright_Branch_By_PkArgs, 'institution_id'>>;
  delete_bright_candidate?: Resolver<Maybe<ResolversTypes['bright_candidate_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Bright_CandidateArgs, 'where'>>;
  delete_bright_candidate_by_pk?: Resolver<Maybe<ResolversTypes['bright_candidate']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Bright_Candidate_By_PkArgs, 'candidate_id' | 'manager_id'>>;
  delete_bright_manager?: Resolver<Maybe<ResolversTypes['bright_manager_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Bright_ManagerArgs, 'where'>>;
  delete_bright_manager_by_pk?: Resolver<Maybe<ResolversTypes['bright_manager']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Bright_Manager_By_PkArgs, 'manager_id'>>;
  delete_categories?: Resolver<Maybe<ResolversTypes['categories_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_CategoriesArgs, 'where'>>;
  delete_categories_by_pk?: Resolver<Maybe<ResolversTypes['categories']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Categories_By_PkArgs, 'id'>>;
  delete_choices?: Resolver<Maybe<ResolversTypes['choices_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ChoicesArgs, 'where'>>;
  delete_choices_by_pk?: Resolver<Maybe<ResolversTypes['choices']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Choices_By_PkArgs, 'id'>>;
  delete_credits_log?: Resolver<Maybe<ResolversTypes['credits_log_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Credits_LogArgs, 'where'>>;
  delete_credits_log_by_pk?: Resolver<Maybe<ResolversTypes['credits_log']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Credits_Log_By_PkArgs, 'id'>>;
  delete_discount_codes?: Resolver<Maybe<ResolversTypes['discount_codes_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Discount_CodesArgs, 'where'>>;
  delete_discount_codes_by_pk?: Resolver<Maybe<ResolversTypes['discount_codes']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Discount_Codes_By_PkArgs, 'id'>>;
  delete_estimated_scores?: Resolver<Maybe<ResolversTypes['estimated_scores_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Estimated_ScoresArgs, 'where'>>;
  delete_estimated_scores_by_pk?: Resolver<Maybe<ResolversTypes['estimated_scores']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Estimated_Scores_By_PkArgs, 'id'>>;
  delete_exams?: Resolver<Maybe<ResolversTypes['exams_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ExamsArgs, 'where'>>;
  delete_exams_by_pk?: Resolver<Maybe<ResolversTypes['exams']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Exams_By_PkArgs, 'id'>>;
  delete_feedbacks?: Resolver<Maybe<ResolversTypes['feedbacks_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_FeedbacksArgs, 'where'>>;
  delete_feedbacks_by_pk?: Resolver<Maybe<ResolversTypes['feedbacks']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Feedbacks_By_PkArgs, 'id'>>;
  delete_institutions?: Resolver<Maybe<ResolversTypes['institutions_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_InstitutionsArgs, 'where'>>;
  delete_institutions_by_pk?: Resolver<Maybe<ResolversTypes['institutions']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Institutions_By_PkArgs, 'id'>>;
  delete_lessons?: Resolver<Maybe<ResolversTypes['lessons_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_LessonsArgs, 'where'>>;
  delete_lessons_by_pk?: Resolver<Maybe<ResolversTypes['lessons']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Lessons_By_PkArgs, 'id'>>;
  delete_plans?: Resolver<Maybe<ResolversTypes['plans_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_PlansArgs, 'where'>>;
  delete_plans_by_pk?: Resolver<Maybe<ResolversTypes['plans']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Plans_By_PkArgs, 'id'>>;
  delete_profile_sphere_association?: Resolver<Maybe<ResolversTypes['profile_sphere_association_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Profile_Sphere_AssociationArgs, 'where'>>;
  delete_profiles?: Resolver<Maybe<ResolversTypes['profiles_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ProfilesArgs, 'where'>>;
  delete_profiles_by_pk?: Resolver<Maybe<ResolversTypes['profiles']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Profiles_By_PkArgs, 'id'>>;
  delete_question_lesson_association?: Resolver<Maybe<ResolversTypes['question_lesson_association_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Question_Lesson_AssociationArgs, 'where'>>;
  delete_question_lesson_association_by_pk?: Resolver<Maybe<ResolversTypes['question_lesson_association']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Question_Lesson_Association_By_PkArgs, 'lesson_id' | 'question_id'>>;
  delete_questions?: Resolver<Maybe<ResolversTypes['questions_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_QuestionsArgs, 'where'>>;
  delete_questions_by_pk?: Resolver<Maybe<ResolversTypes['questions']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Questions_By_PkArgs, 'id'>>;
  delete_registration_billings?: Resolver<Maybe<ResolversTypes['registration_billings_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Registration_BillingsArgs, 'where'>>;
  delete_registration_billings_by_pk?: Resolver<Maybe<ResolversTypes['registration_billings']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Registration_Billings_By_PkArgs, 'id'>>;
  delete_registrations?: Resolver<Maybe<ResolversTypes['registrations_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_RegistrationsArgs, 'where'>>;
  delete_registrations_by_pk?: Resolver<Maybe<ResolversTypes['registrations']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Registrations_By_PkArgs, 'id'>>;
  delete_result_plan_association?: Resolver<Maybe<ResolversTypes['result_plan_association_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Result_Plan_AssociationArgs, 'where'>>;
  delete_result_plan_association_by_pk?: Resolver<Maybe<ResolversTypes['result_plan_association']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Result_Plan_Association_By_PkArgs, 'plan_id' | 'result_id'>>;
  delete_results?: Resolver<Maybe<ResolversTypes['results_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ResultsArgs, 'where'>>;
  delete_results_by_pk?: Resolver<Maybe<ResolversTypes['results']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Results_By_PkArgs, 'id'>>;
  delete_scores?: Resolver<Maybe<ResolversTypes['scores_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ScoresArgs, 'where'>>;
  delete_scores_by_pk?: Resolver<Maybe<ResolversTypes['scores']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Scores_By_PkArgs, 'lesson_id' | 'user_id'>>;
  delete_spheres?: Resolver<Maybe<ResolversTypes['spheres_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_SpheresArgs, 'where'>>;
  delete_spheres_by_pk?: Resolver<Maybe<ResolversTypes['spheres']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Spheres_By_PkArgs, 'id'>>;
  delete_supports?: Resolver<Maybe<ResolversTypes['supports_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_SupportsArgs, 'where'>>;
  delete_supports_by_pk?: Resolver<Maybe<ResolversTypes['supports']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Supports_By_PkArgs, 'id'>>;
  delete_users?: Resolver<Maybe<ResolversTypes['users_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_UsersArgs, 'where'>>;
  delete_users_by_pk?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Users_By_PkArgs, 'id'>>;
  insert_activation_codes?: Resolver<Maybe<ResolversTypes['activation_codes_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Activation_CodesArgs, 'objects'>>;
  insert_activation_codes_one?: Resolver<Maybe<ResolversTypes['activation_codes']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Activation_Codes_OneArgs, 'object'>>;
  insert_answers?: Resolver<Maybe<ResolversTypes['answers_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_AnswersArgs, 'objects'>>;
  insert_answers_choice_association?: Resolver<Maybe<ResolversTypes['answers_choice_association_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Answers_Choice_AssociationArgs, 'objects'>>;
  insert_answers_choice_association_one?: Resolver<Maybe<ResolversTypes['answers_choice_association']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Answers_Choice_Association_OneArgs, 'object'>>;
  insert_answers_one?: Resolver<Maybe<ResolversTypes['answers']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Answers_OneArgs, 'object'>>;
  insert_bills?: Resolver<Maybe<ResolversTypes['bills_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_BillsArgs, 'objects'>>;
  insert_bills_one?: Resolver<Maybe<ResolversTypes['bills']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Bills_OneArgs, 'object'>>;
  insert_bright_assessment?: Resolver<Maybe<ResolversTypes['bright_assessment_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Bright_AssessmentArgs, 'objects'>>;
  insert_bright_assessment_one?: Resolver<Maybe<ResolversTypes['bright_assessment']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Bright_Assessment_OneArgs, 'object'>>;
  insert_bright_assessments?: Resolver<Maybe<ResolversTypes['bright_assessments_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Bright_AssessmentsArgs, 'objects'>>;
  insert_bright_assessments_one?: Resolver<Maybe<ResolversTypes['bright_assessments']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Bright_Assessments_OneArgs, 'object'>>;
  insert_bright_branch?: Resolver<Maybe<ResolversTypes['bright_branch_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Bright_BranchArgs, 'objects'>>;
  insert_bright_branch_one?: Resolver<Maybe<ResolversTypes['bright_branch']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Bright_Branch_OneArgs, 'object'>>;
  insert_bright_candidate?: Resolver<Maybe<ResolversTypes['bright_candidate_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Bright_CandidateArgs, 'objects'>>;
  insert_bright_candidate_one?: Resolver<Maybe<ResolversTypes['bright_candidate']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Bright_Candidate_OneArgs, 'object'>>;
  insert_bright_manager?: Resolver<Maybe<ResolversTypes['bright_manager_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Bright_ManagerArgs, 'objects'>>;
  insert_bright_manager_one?: Resolver<Maybe<ResolversTypes['bright_manager']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Bright_Manager_OneArgs, 'object'>>;
  insert_categories?: Resolver<Maybe<ResolversTypes['categories_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_CategoriesArgs, 'objects'>>;
  insert_categories_one?: Resolver<Maybe<ResolversTypes['categories']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Categories_OneArgs, 'object'>>;
  insert_choices?: Resolver<Maybe<ResolversTypes['choices_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ChoicesArgs, 'objects'>>;
  insert_choices_one?: Resolver<Maybe<ResolversTypes['choices']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Choices_OneArgs, 'object'>>;
  insert_credits_log?: Resolver<Maybe<ResolversTypes['credits_log_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Credits_LogArgs, 'objects'>>;
  insert_credits_log_one?: Resolver<Maybe<ResolversTypes['credits_log']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Credits_Log_OneArgs, 'object'>>;
  insert_discount_codes?: Resolver<Maybe<ResolversTypes['discount_codes_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Discount_CodesArgs, 'objects'>>;
  insert_discount_codes_one?: Resolver<Maybe<ResolversTypes['discount_codes']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Discount_Codes_OneArgs, 'object'>>;
  insert_estimated_scores?: Resolver<Maybe<ResolversTypes['estimated_scores_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Estimated_ScoresArgs, 'objects'>>;
  insert_estimated_scores_one?: Resolver<Maybe<ResolversTypes['estimated_scores']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Estimated_Scores_OneArgs, 'object'>>;
  insert_exams?: Resolver<Maybe<ResolversTypes['exams_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ExamsArgs, 'objects'>>;
  insert_exams_one?: Resolver<Maybe<ResolversTypes['exams']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Exams_OneArgs, 'object'>>;
  insert_feedbacks?: Resolver<Maybe<ResolversTypes['feedbacks_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_FeedbacksArgs, 'objects'>>;
  insert_feedbacks_one?: Resolver<Maybe<ResolversTypes['feedbacks']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Feedbacks_OneArgs, 'object'>>;
  insert_institutions?: Resolver<Maybe<ResolversTypes['institutions_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_InstitutionsArgs, 'objects'>>;
  insert_institutions_one?: Resolver<Maybe<ResolversTypes['institutions']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Institutions_OneArgs, 'object'>>;
  insert_lessons?: Resolver<Maybe<ResolversTypes['lessons_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_LessonsArgs, 'objects'>>;
  insert_lessons_one?: Resolver<Maybe<ResolversTypes['lessons']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Lessons_OneArgs, 'object'>>;
  insert_plans?: Resolver<Maybe<ResolversTypes['plans_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_PlansArgs, 'objects'>>;
  insert_plans_one?: Resolver<Maybe<ResolversTypes['plans']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Plans_OneArgs, 'object'>>;
  insert_profile_sphere_association?: Resolver<Maybe<ResolversTypes['profile_sphere_association_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Profile_Sphere_AssociationArgs, 'objects'>>;
  insert_profile_sphere_association_one?: Resolver<Maybe<ResolversTypes['profile_sphere_association']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Profile_Sphere_Association_OneArgs, 'object'>>;
  insert_profiles?: Resolver<Maybe<ResolversTypes['profiles_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ProfilesArgs, 'objects'>>;
  insert_profiles_one?: Resolver<Maybe<ResolversTypes['profiles']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Profiles_OneArgs, 'object'>>;
  insert_question_lesson_association?: Resolver<Maybe<ResolversTypes['question_lesson_association_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Question_Lesson_AssociationArgs, 'objects'>>;
  insert_question_lesson_association_one?: Resolver<Maybe<ResolversTypes['question_lesson_association']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Question_Lesson_Association_OneArgs, 'object'>>;
  insert_questions?: Resolver<Maybe<ResolversTypes['questions_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_QuestionsArgs, 'objects'>>;
  insert_questions_one?: Resolver<Maybe<ResolversTypes['questions']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Questions_OneArgs, 'object'>>;
  insert_registration_billings?: Resolver<Maybe<ResolversTypes['registration_billings_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Registration_BillingsArgs, 'objects'>>;
  insert_registration_billings_one?: Resolver<Maybe<ResolversTypes['registration_billings']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Registration_Billings_OneArgs, 'object'>>;
  insert_registrations?: Resolver<Maybe<ResolversTypes['registrations_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_RegistrationsArgs, 'objects'>>;
  insert_registrations_one?: Resolver<Maybe<ResolversTypes['registrations']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Registrations_OneArgs, 'object'>>;
  insert_result_plan_association?: Resolver<Maybe<ResolversTypes['result_plan_association_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Result_Plan_AssociationArgs, 'objects'>>;
  insert_result_plan_association_one?: Resolver<Maybe<ResolversTypes['result_plan_association']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Result_Plan_Association_OneArgs, 'object'>>;
  insert_results?: Resolver<Maybe<ResolversTypes['results_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ResultsArgs, 'objects'>>;
  insert_results_one?: Resolver<Maybe<ResolversTypes['results']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Results_OneArgs, 'object'>>;
  insert_scores?: Resolver<Maybe<ResolversTypes['scores_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ScoresArgs, 'objects'>>;
  insert_scores_one?: Resolver<Maybe<ResolversTypes['scores']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Scores_OneArgs, 'object'>>;
  insert_spheres?: Resolver<Maybe<ResolversTypes['spheres_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_SpheresArgs, 'objects'>>;
  insert_spheres_one?: Resolver<Maybe<ResolversTypes['spheres']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Spheres_OneArgs, 'object'>>;
  insert_supports?: Resolver<Maybe<ResolversTypes['supports_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_SupportsArgs, 'objects'>>;
  insert_supports_one?: Resolver<Maybe<ResolversTypes['supports']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Supports_OneArgs, 'object'>>;
  insert_users?: Resolver<Maybe<ResolversTypes['users_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_UsersArgs, 'objects'>>;
  insert_users_one?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Users_OneArgs, 'object'>>;
  update_activation_codes?: Resolver<Maybe<ResolversTypes['activation_codes_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Activation_CodesArgs, 'where'>>;
  update_activation_codes_by_pk?: Resolver<Maybe<ResolversTypes['activation_codes']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Activation_Codes_By_PkArgs, 'pk_columns'>>;
  update_answers?: Resolver<Maybe<ResolversTypes['answers_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_AnswersArgs, 'where'>>;
  update_answers_by_pk?: Resolver<Maybe<ResolversTypes['answers']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Answers_By_PkArgs, 'pk_columns'>>;
  update_answers_choice_association?: Resolver<Maybe<ResolversTypes['answers_choice_association_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Answers_Choice_AssociationArgs, 'where'>>;
  update_bills?: Resolver<Maybe<ResolversTypes['bills_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_BillsArgs, 'where'>>;
  update_bills_by_pk?: Resolver<Maybe<ResolversTypes['bills']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Bills_By_PkArgs, 'pk_columns'>>;
  update_bright_assessment?: Resolver<Maybe<ResolversTypes['bright_assessment_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Bright_AssessmentArgs, 'where'>>;
  update_bright_assessment_by_pk?: Resolver<Maybe<ResolversTypes['bright_assessment']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Bright_Assessment_By_PkArgs, 'pk_columns'>>;
  update_bright_assessments?: Resolver<Maybe<ResolversTypes['bright_assessments_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Bright_AssessmentsArgs, 'where'>>;
  update_bright_assessments_by_pk?: Resolver<Maybe<ResolversTypes['bright_assessments']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Bright_Assessments_By_PkArgs, 'pk_columns'>>;
  update_bright_branch?: Resolver<Maybe<ResolversTypes['bright_branch_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Bright_BranchArgs, 'where'>>;
  update_bright_branch_by_pk?: Resolver<Maybe<ResolversTypes['bright_branch']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Bright_Branch_By_PkArgs, 'pk_columns'>>;
  update_bright_candidate?: Resolver<Maybe<ResolversTypes['bright_candidate_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Bright_CandidateArgs, 'where'>>;
  update_bright_candidate_by_pk?: Resolver<Maybe<ResolversTypes['bright_candidate']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Bright_Candidate_By_PkArgs, 'pk_columns'>>;
  update_bright_manager?: Resolver<Maybe<ResolversTypes['bright_manager_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Bright_ManagerArgs, 'where'>>;
  update_bright_manager_by_pk?: Resolver<Maybe<ResolversTypes['bright_manager']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Bright_Manager_By_PkArgs, 'pk_columns'>>;
  update_categories?: Resolver<Maybe<ResolversTypes['categories_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_CategoriesArgs, 'where'>>;
  update_categories_by_pk?: Resolver<Maybe<ResolversTypes['categories']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Categories_By_PkArgs, 'pk_columns'>>;
  update_choices?: Resolver<Maybe<ResolversTypes['choices_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ChoicesArgs, 'where'>>;
  update_choices_by_pk?: Resolver<Maybe<ResolversTypes['choices']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Choices_By_PkArgs, 'pk_columns'>>;
  update_credits_log?: Resolver<Maybe<ResolversTypes['credits_log_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Credits_LogArgs, 'where'>>;
  update_credits_log_by_pk?: Resolver<Maybe<ResolversTypes['credits_log']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Credits_Log_By_PkArgs, 'pk_columns'>>;
  update_discount_codes?: Resolver<Maybe<ResolversTypes['discount_codes_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Discount_CodesArgs, 'where'>>;
  update_discount_codes_by_pk?: Resolver<Maybe<ResolversTypes['discount_codes']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Discount_Codes_By_PkArgs, 'pk_columns'>>;
  update_estimated_scores?: Resolver<Maybe<ResolversTypes['estimated_scores_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Estimated_ScoresArgs, 'where'>>;
  update_estimated_scores_by_pk?: Resolver<Maybe<ResolversTypes['estimated_scores']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Estimated_Scores_By_PkArgs, 'pk_columns'>>;
  update_exams?: Resolver<Maybe<ResolversTypes['exams_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ExamsArgs, 'where'>>;
  update_exams_by_pk?: Resolver<Maybe<ResolversTypes['exams']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Exams_By_PkArgs, 'pk_columns'>>;
  update_feedbacks?: Resolver<Maybe<ResolversTypes['feedbacks_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_FeedbacksArgs, 'where'>>;
  update_feedbacks_by_pk?: Resolver<Maybe<ResolversTypes['feedbacks']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Feedbacks_By_PkArgs, 'pk_columns'>>;
  update_institutions?: Resolver<Maybe<ResolversTypes['institutions_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_InstitutionsArgs, 'where'>>;
  update_institutions_by_pk?: Resolver<Maybe<ResolversTypes['institutions']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Institutions_By_PkArgs, 'pk_columns'>>;
  update_lessons?: Resolver<Maybe<ResolversTypes['lessons_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_LessonsArgs, 'where'>>;
  update_lessons_by_pk?: Resolver<Maybe<ResolversTypes['lessons']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Lessons_By_PkArgs, 'pk_columns'>>;
  update_plans?: Resolver<Maybe<ResolversTypes['plans_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_PlansArgs, 'where'>>;
  update_plans_by_pk?: Resolver<Maybe<ResolversTypes['plans']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Plans_By_PkArgs, 'pk_columns'>>;
  update_profile_sphere_association?: Resolver<Maybe<ResolversTypes['profile_sphere_association_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Profile_Sphere_AssociationArgs, 'where'>>;
  update_profiles?: Resolver<Maybe<ResolversTypes['profiles_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ProfilesArgs, 'where'>>;
  update_profiles_by_pk?: Resolver<Maybe<ResolversTypes['profiles']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Profiles_By_PkArgs, 'pk_columns'>>;
  update_question_lesson_association?: Resolver<Maybe<ResolversTypes['question_lesson_association_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Question_Lesson_AssociationArgs, 'where'>>;
  update_question_lesson_association_by_pk?: Resolver<Maybe<ResolversTypes['question_lesson_association']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Question_Lesson_Association_By_PkArgs, 'pk_columns'>>;
  update_questions?: Resolver<Maybe<ResolversTypes['questions_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_QuestionsArgs, 'where'>>;
  update_questions_by_pk?: Resolver<Maybe<ResolversTypes['questions']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Questions_By_PkArgs, 'pk_columns'>>;
  update_registration_billings?: Resolver<Maybe<ResolversTypes['registration_billings_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Registration_BillingsArgs, 'where'>>;
  update_registration_billings_by_pk?: Resolver<Maybe<ResolversTypes['registration_billings']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Registration_Billings_By_PkArgs, 'pk_columns'>>;
  update_registrations?: Resolver<Maybe<ResolversTypes['registrations_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_RegistrationsArgs, 'where'>>;
  update_registrations_by_pk?: Resolver<Maybe<ResolversTypes['registrations']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Registrations_By_PkArgs, 'pk_columns'>>;
  update_result_plan_association?: Resolver<Maybe<ResolversTypes['result_plan_association_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Result_Plan_AssociationArgs, 'where'>>;
  update_result_plan_association_by_pk?: Resolver<Maybe<ResolversTypes['result_plan_association']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Result_Plan_Association_By_PkArgs, 'pk_columns'>>;
  update_results?: Resolver<Maybe<ResolversTypes['results_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ResultsArgs, 'where'>>;
  update_results_by_pk?: Resolver<Maybe<ResolversTypes['results']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Results_By_PkArgs, 'pk_columns'>>;
  update_scores?: Resolver<Maybe<ResolversTypes['scores_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ScoresArgs, 'where'>>;
  update_scores_by_pk?: Resolver<Maybe<ResolversTypes['scores']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Scores_By_PkArgs, 'pk_columns'>>;
  update_spheres?: Resolver<Maybe<ResolversTypes['spheres_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SpheresArgs, 'where'>>;
  update_spheres_by_pk?: Resolver<Maybe<ResolversTypes['spheres']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Spheres_By_PkArgs, 'pk_columns'>>;
  update_supports?: Resolver<Maybe<ResolversTypes['supports_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SupportsArgs, 'where'>>;
  update_supports_by_pk?: Resolver<Maybe<ResolversTypes['supports']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Supports_By_PkArgs, 'pk_columns'>>;
  update_users?: Resolver<Maybe<ResolversTypes['users_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_UsersArgs, 'where'>>;
  update_users_by_pk?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Users_By_PkArgs, 'pk_columns'>>;
};

export interface NumericScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['numeric'], any> {
  name: 'numeric';
}

export type PlansResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans'] = ResolversParentTypes['plans']> = {
  begin_date?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  end_date?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sphere?: Resolver<ResolversTypes['spheres'], ParentType, ContextType>;
  sphere_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  task_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  teacher?: Resolver<ResolversTypes['profiles'], ParentType, ContextType>;
  teacher_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_aggregate'] = ResolversParentTypes['plans_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['plans_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['plans']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_aggregate_fields'] = ResolversParentTypes['plans_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['plans_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Plans_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['plans_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['plans_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['plans_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['plans_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['plans_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['plans_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['plans_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['plans_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['plans_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_avg_fields'] = ResolversParentTypes['plans_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_max_fields'] = ResolversParentTypes['plans_max_fields']> = {
  begin_date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  task_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_min_fields'] = ResolversParentTypes['plans_min_fields']> = {
  begin_date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  task_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_mutation_response'] = ResolversParentTypes['plans_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['plans']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_stddev_fields'] = ResolversParentTypes['plans_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_stddev_pop_fields'] = ResolversParentTypes['plans_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_stddev_samp_fields'] = ResolversParentTypes['plans_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_sum_fields'] = ResolversParentTypes['plans_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_var_pop_fields'] = ResolversParentTypes['plans_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_var_samp_fields'] = ResolversParentTypes['plans_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Plans_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['plans_variance_fields'] = ResolversParentTypes['plans_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_AssociationResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association'] = ResolversParentTypes['profile_sphere_association']> = {
  profile?: Resolver<Maybe<ResolversTypes['profiles']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sphere?: Resolver<Maybe<ResolversTypes['spheres']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_aggregate'] = ResolversParentTypes['profile_sphere_association_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['profile_sphere_association_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['profile_sphere_association']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_aggregate_fields'] = ResolversParentTypes['profile_sphere_association_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['profile_sphere_association_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Profile_Sphere_Association_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['profile_sphere_association_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['profile_sphere_association_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['profile_sphere_association_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['profile_sphere_association_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['profile_sphere_association_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['profile_sphere_association_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['profile_sphere_association_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['profile_sphere_association_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['profile_sphere_association_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_avg_fields'] = ResolversParentTypes['profile_sphere_association_avg_fields']> = {
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_max_fields'] = ResolversParentTypes['profile_sphere_association_max_fields']> = {
  profile_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_min_fields'] = ResolversParentTypes['profile_sphere_association_min_fields']> = {
  profile_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_mutation_response'] = ResolversParentTypes['profile_sphere_association_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['profile_sphere_association']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_stddev_fields'] = ResolversParentTypes['profile_sphere_association_stddev_fields']> = {
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_stddev_pop_fields'] = ResolversParentTypes['profile_sphere_association_stddev_pop_fields']> = {
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_stddev_samp_fields'] = ResolversParentTypes['profile_sphere_association_stddev_samp_fields']> = {
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_sum_fields'] = ResolversParentTypes['profile_sphere_association_sum_fields']> = {
  profile_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_var_pop_fields'] = ResolversParentTypes['profile_sphere_association_var_pop_fields']> = {
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_var_samp_fields'] = ResolversParentTypes['profile_sphere_association_var_samp_fields']> = {
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profile_Sphere_Association_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profile_sphere_association_variance_fields'] = ResolversParentTypes['profile_sphere_association_variance_fields']> = {
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sphere_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfilesResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles'] = ResolversParentTypes['profiles']> = {
  activation_codes?: Resolver<Array<ResolversTypes['activation_codes']>, ParentType, ContextType, RequireFields<ProfilesActivation_CodesArgs, never>>;
  activation_codes_aggregate?: Resolver<ResolversTypes['activation_codes_aggregate'], ParentType, ContextType, RequireFields<ProfilesActivation_Codes_AggregateArgs, never>>;
  answers?: Resolver<Array<ResolversTypes['answers']>, ParentType, ContextType, RequireFields<ProfilesAnswersArgs, never>>;
  answers_aggregate?: Resolver<ResolversTypes['answers_aggregate'], ParentType, ContextType, RequireFields<ProfilesAnswers_AggregateArgs, never>>;
  bills?: Resolver<Array<ResolversTypes['bills']>, ParentType, ContextType, RequireFields<ProfilesBillsArgs, never>>;
  bills_aggregate?: Resolver<ResolversTypes['bills_aggregate'], ParentType, ContextType, RequireFields<ProfilesBills_AggregateArgs, never>>;
  bright_candidates?: Resolver<Array<ResolversTypes['bright_candidate']>, ParentType, ContextType, RequireFields<ProfilesBright_CandidatesArgs, never>>;
  bright_candidates_aggregate?: Resolver<ResolversTypes['bright_candidate_aggregate'], ParentType, ContextType, RequireFields<ProfilesBright_Candidates_AggregateArgs, never>>;
  bright_manager?: Resolver<Maybe<ResolversTypes['bright_manager']>, ParentType, ContextType>;
  current_exam_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  estimated_scores?: Resolver<Array<ResolversTypes['estimated_scores']>, ParentType, ContextType, RequireFields<ProfilesEstimated_ScoresArgs, never>>;
  estimated_scores_aggregate?: Resolver<ResolversTypes['estimated_scores_aggregate'], ParentType, ContextType, RequireFields<ProfilesEstimated_Scores_AggregateArgs, never>>;
  exam_type?: Resolver<ResolversTypes['exam_types'], ParentType, ContextType>;
  expiration_date?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  feedbacks?: Resolver<Array<ResolversTypes['answers']>, ParentType, ContextType, RequireFields<ProfilesFeedbacksArgs, never>>;
  feedbacks_aggregate?: Resolver<ResolversTypes['answers_aggregate'], ParentType, ContextType, RequireFields<ProfilesFeedbacks_AggregateArgs, never>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['institutions']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_admin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  is_guest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  is_manager?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  is_teacher?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  last_time_spent_update?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objective?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profile_sphere_associations?: Resolver<Array<ResolversTypes['profile_sphere_association']>, ParentType, ContextType, RequireFields<ProfilesProfile_Sphere_AssociationsArgs, never>>;
  profile_sphere_associations_aggregate?: Resolver<ResolversTypes['profile_sphere_association_aggregate'], ParentType, ContextType, RequireFields<ProfilesProfile_Sphere_Associations_AggregateArgs, never>>;
  time_spent?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['users'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_aggregate'] = ResolversParentTypes['profiles_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['profiles_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['profiles']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_aggregate_fields'] = ResolversParentTypes['profiles_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['profiles_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Profiles_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['profiles_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['profiles_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['profiles_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['profiles_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['profiles_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['profiles_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['profiles_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['profiles_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['profiles_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_avg_fields'] = ResolversParentTypes['profiles_avg_fields']> = {
  current_exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  time_spent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_max_fields'] = ResolversParentTypes['profiles_max_fields']> = {
  current_exam_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  expiration_date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  last_time_spent_update?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objective?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  time_spent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_min_fields'] = ResolversParentTypes['profiles_min_fields']> = {
  current_exam_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  expiration_date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  last_time_spent_update?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objective?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  time_spent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_mutation_response'] = ResolversParentTypes['profiles_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['profiles']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_stddev_fields'] = ResolversParentTypes['profiles_stddev_fields']> = {
  current_exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  time_spent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_stddev_pop_fields'] = ResolversParentTypes['profiles_stddev_pop_fields']> = {
  current_exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  time_spent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_stddev_samp_fields'] = ResolversParentTypes['profiles_stddev_samp_fields']> = {
  current_exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  time_spent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_sum_fields'] = ResolversParentTypes['profiles_sum_fields']> = {
  current_exam_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objective?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  time_spent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_var_pop_fields'] = ResolversParentTypes['profiles_var_pop_fields']> = {
  current_exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  time_spent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_var_samp_fields'] = ResolversParentTypes['profiles_var_samp_fields']> = {
  current_exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  time_spent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Profiles_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['profiles_variance_fields'] = ResolversParentTypes['profiles_variance_fields']> = {
  current_exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  time_spent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Query_RootResolvers<ContextType = any, ParentType extends ResolversParentTypes['query_root'] = ResolversParentTypes['query_root']> = {
  activation_codes?: Resolver<Array<ResolversTypes['activation_codes']>, ParentType, ContextType, RequireFields<Query_RootActivation_CodesArgs, never>>;
  activation_codes_aggregate?: Resolver<ResolversTypes['activation_codes_aggregate'], ParentType, ContextType, RequireFields<Query_RootActivation_Codes_AggregateArgs, never>>;
  activation_codes_by_pk?: Resolver<Maybe<ResolversTypes['activation_codes']>, ParentType, ContextType, RequireFields<Query_RootActivation_Codes_By_PkArgs, 'id'>>;
  answers?: Resolver<Array<ResolversTypes['answers']>, ParentType, ContextType, RequireFields<Query_RootAnswersArgs, never>>;
  answers_aggregate?: Resolver<ResolversTypes['answers_aggregate'], ParentType, ContextType, RequireFields<Query_RootAnswers_AggregateArgs, never>>;
  answers_by_pk?: Resolver<Maybe<ResolversTypes['answers']>, ParentType, ContextType, RequireFields<Query_RootAnswers_By_PkArgs, 'id'>>;
  answers_choice_association?: Resolver<Array<ResolversTypes['answers_choice_association']>, ParentType, ContextType, RequireFields<Query_RootAnswers_Choice_AssociationArgs, never>>;
  answers_choice_association_aggregate?: Resolver<ResolversTypes['answers_choice_association_aggregate'], ParentType, ContextType, RequireFields<Query_RootAnswers_Choice_Association_AggregateArgs, never>>;
  bills?: Resolver<Array<ResolversTypes['bills']>, ParentType, ContextType, RequireFields<Query_RootBillsArgs, never>>;
  bills_aggregate?: Resolver<ResolversTypes['bills_aggregate'], ParentType, ContextType, RequireFields<Query_RootBills_AggregateArgs, never>>;
  bills_by_pk?: Resolver<Maybe<ResolversTypes['bills']>, ParentType, ContextType, RequireFields<Query_RootBills_By_PkArgs, 'id'>>;
  bright_assessment?: Resolver<Array<ResolversTypes['bright_assessment']>, ParentType, ContextType, RequireFields<Query_RootBright_AssessmentArgs, never>>;
  bright_assessment_aggregate?: Resolver<ResolversTypes['bright_assessment_aggregate'], ParentType, ContextType, RequireFields<Query_RootBright_Assessment_AggregateArgs, never>>;
  bright_assessment_by_pk?: Resolver<Maybe<ResolversTypes['bright_assessment']>, ParentType, ContextType, RequireFields<Query_RootBright_Assessment_By_PkArgs, 'bright_assessment_id' | 'tester_id'>>;
  bright_assessments?: Resolver<Array<ResolversTypes['bright_assessments']>, ParentType, ContextType, RequireFields<Query_RootBright_AssessmentsArgs, never>>;
  bright_assessments_aggregate?: Resolver<ResolversTypes['bright_assessments_aggregate'], ParentType, ContextType, RequireFields<Query_RootBright_Assessments_AggregateArgs, never>>;
  bright_assessments_by_pk?: Resolver<Maybe<ResolversTypes['bright_assessments']>, ParentType, ContextType, RequireFields<Query_RootBright_Assessments_By_PkArgs, 'id'>>;
  bright_branch?: Resolver<Array<ResolversTypes['bright_branch']>, ParentType, ContextType, RequireFields<Query_RootBright_BranchArgs, never>>;
  bright_branch_aggregate?: Resolver<ResolversTypes['bright_branch_aggregate'], ParentType, ContextType, RequireFields<Query_RootBright_Branch_AggregateArgs, never>>;
  bright_branch_by_pk?: Resolver<Maybe<ResolversTypes['bright_branch']>, ParentType, ContextType, RequireFields<Query_RootBright_Branch_By_PkArgs, 'institution_id'>>;
  bright_candidate?: Resolver<Array<ResolversTypes['bright_candidate']>, ParentType, ContextType, RequireFields<Query_RootBright_CandidateArgs, never>>;
  bright_candidate_aggregate?: Resolver<ResolversTypes['bright_candidate_aggregate'], ParentType, ContextType, RequireFields<Query_RootBright_Candidate_AggregateArgs, never>>;
  bright_candidate_by_pk?: Resolver<Maybe<ResolversTypes['bright_candidate']>, ParentType, ContextType, RequireFields<Query_RootBright_Candidate_By_PkArgs, 'candidate_id' | 'manager_id'>>;
  bright_manager?: Resolver<Array<ResolversTypes['bright_manager']>, ParentType, ContextType, RequireFields<Query_RootBright_ManagerArgs, never>>;
  bright_manager_aggregate?: Resolver<ResolversTypes['bright_manager_aggregate'], ParentType, ContextType, RequireFields<Query_RootBright_Manager_AggregateArgs, never>>;
  bright_manager_by_pk?: Resolver<Maybe<ResolversTypes['bright_manager']>, ParentType, ContextType, RequireFields<Query_RootBright_Manager_By_PkArgs, 'manager_id'>>;
  categories?: Resolver<Array<ResolversTypes['categories']>, ParentType, ContextType, RequireFields<Query_RootCategoriesArgs, never>>;
  categories_aggregate?: Resolver<ResolversTypes['categories_aggregate'], ParentType, ContextType, RequireFields<Query_RootCategories_AggregateArgs, never>>;
  categories_by_pk?: Resolver<Maybe<ResolversTypes['categories']>, ParentType, ContextType, RequireFields<Query_RootCategories_By_PkArgs, 'id'>>;
  choices?: Resolver<Array<ResolversTypes['choices']>, ParentType, ContextType, RequireFields<Query_RootChoicesArgs, never>>;
  choices_aggregate?: Resolver<ResolversTypes['choices_aggregate'], ParentType, ContextType, RequireFields<Query_RootChoices_AggregateArgs, never>>;
  choices_by_pk?: Resolver<Maybe<ResolversTypes['choices']>, ParentType, ContextType, RequireFields<Query_RootChoices_By_PkArgs, 'id'>>;
  credits_log?: Resolver<Array<ResolversTypes['credits_log']>, ParentType, ContextType, RequireFields<Query_RootCredits_LogArgs, never>>;
  credits_log_aggregate?: Resolver<ResolversTypes['credits_log_aggregate'], ParentType, ContextType, RequireFields<Query_RootCredits_Log_AggregateArgs, never>>;
  credits_log_by_pk?: Resolver<Maybe<ResolversTypes['credits_log']>, ParentType, ContextType, RequireFields<Query_RootCredits_Log_By_PkArgs, 'id'>>;
  discount_codes?: Resolver<Array<ResolversTypes['discount_codes']>, ParentType, ContextType, RequireFields<Query_RootDiscount_CodesArgs, never>>;
  discount_codes_aggregate?: Resolver<ResolversTypes['discount_codes_aggregate'], ParentType, ContextType, RequireFields<Query_RootDiscount_Codes_AggregateArgs, never>>;
  discount_codes_by_pk?: Resolver<Maybe<ResolversTypes['discount_codes']>, ParentType, ContextType, RequireFields<Query_RootDiscount_Codes_By_PkArgs, 'id'>>;
  estimated_scores?: Resolver<Array<ResolversTypes['estimated_scores']>, ParentType, ContextType, RequireFields<Query_RootEstimated_ScoresArgs, never>>;
  estimated_scores_aggregate?: Resolver<ResolversTypes['estimated_scores_aggregate'], ParentType, ContextType, RequireFields<Query_RootEstimated_Scores_AggregateArgs, never>>;
  estimated_scores_by_pk?: Resolver<Maybe<ResolversTypes['estimated_scores']>, ParentType, ContextType, RequireFields<Query_RootEstimated_Scores_By_PkArgs, 'id'>>;
  exams?: Resolver<Array<ResolversTypes['exams']>, ParentType, ContextType, RequireFields<Query_RootExamsArgs, never>>;
  exams_aggregate?: Resolver<ResolversTypes['exams_aggregate'], ParentType, ContextType, RequireFields<Query_RootExams_AggregateArgs, never>>;
  exams_by_pk?: Resolver<Maybe<ResolversTypes['exams']>, ParentType, ContextType, RequireFields<Query_RootExams_By_PkArgs, 'id'>>;
  feedbacks?: Resolver<Array<ResolversTypes['feedbacks']>, ParentType, ContextType, RequireFields<Query_RootFeedbacksArgs, never>>;
  feedbacks_aggregate?: Resolver<ResolversTypes['feedbacks_aggregate'], ParentType, ContextType, RequireFields<Query_RootFeedbacks_AggregateArgs, never>>;
  feedbacks_by_pk?: Resolver<Maybe<ResolversTypes['feedbacks']>, ParentType, ContextType, RequireFields<Query_RootFeedbacks_By_PkArgs, 'id'>>;
  institutions?: Resolver<Array<ResolversTypes['institutions']>, ParentType, ContextType, RequireFields<Query_RootInstitutionsArgs, never>>;
  institutions_aggregate?: Resolver<ResolversTypes['institutions_aggregate'], ParentType, ContextType, RequireFields<Query_RootInstitutions_AggregateArgs, never>>;
  institutions_by_pk?: Resolver<Maybe<ResolversTypes['institutions']>, ParentType, ContextType, RequireFields<Query_RootInstitutions_By_PkArgs, 'id'>>;
  lessons?: Resolver<Array<ResolversTypes['lessons']>, ParentType, ContextType, RequireFields<Query_RootLessonsArgs, never>>;
  lessons_aggregate?: Resolver<ResolversTypes['lessons_aggregate'], ParentType, ContextType, RequireFields<Query_RootLessons_AggregateArgs, never>>;
  lessons_by_pk?: Resolver<Maybe<ResolversTypes['lessons']>, ParentType, ContextType, RequireFields<Query_RootLessons_By_PkArgs, 'id'>>;
  plans?: Resolver<Array<ResolversTypes['plans']>, ParentType, ContextType, RequireFields<Query_RootPlansArgs, never>>;
  plans_aggregate?: Resolver<ResolversTypes['plans_aggregate'], ParentType, ContextType, RequireFields<Query_RootPlans_AggregateArgs, never>>;
  plans_by_pk?: Resolver<Maybe<ResolversTypes['plans']>, ParentType, ContextType, RequireFields<Query_RootPlans_By_PkArgs, 'id'>>;
  profile_sphere_association?: Resolver<Array<ResolversTypes['profile_sphere_association']>, ParentType, ContextType, RequireFields<Query_RootProfile_Sphere_AssociationArgs, never>>;
  profile_sphere_association_aggregate?: Resolver<ResolversTypes['profile_sphere_association_aggregate'], ParentType, ContextType, RequireFields<Query_RootProfile_Sphere_Association_AggregateArgs, never>>;
  profiles?: Resolver<Array<ResolversTypes['profiles']>, ParentType, ContextType, RequireFields<Query_RootProfilesArgs, never>>;
  profiles_aggregate?: Resolver<ResolversTypes['profiles_aggregate'], ParentType, ContextType, RequireFields<Query_RootProfiles_AggregateArgs, never>>;
  profiles_by_pk?: Resolver<Maybe<ResolversTypes['profiles']>, ParentType, ContextType, RequireFields<Query_RootProfiles_By_PkArgs, 'id'>>;
  question_lesson_association?: Resolver<Array<ResolversTypes['question_lesson_association']>, ParentType, ContextType, RequireFields<Query_RootQuestion_Lesson_AssociationArgs, never>>;
  question_lesson_association_aggregate?: Resolver<ResolversTypes['question_lesson_association_aggregate'], ParentType, ContextType, RequireFields<Query_RootQuestion_Lesson_Association_AggregateArgs, never>>;
  question_lesson_association_by_pk?: Resolver<Maybe<ResolversTypes['question_lesson_association']>, ParentType, ContextType, RequireFields<Query_RootQuestion_Lesson_Association_By_PkArgs, 'lesson_id' | 'question_id'>>;
  questions?: Resolver<Array<ResolversTypes['questions']>, ParentType, ContextType, RequireFields<Query_RootQuestionsArgs, never>>;
  questions_aggregate?: Resolver<ResolversTypes['questions_aggregate'], ParentType, ContextType, RequireFields<Query_RootQuestions_AggregateArgs, never>>;
  questions_by_pk?: Resolver<Maybe<ResolversTypes['questions']>, ParentType, ContextType, RequireFields<Query_RootQuestions_By_PkArgs, 'id'>>;
  registration_billings?: Resolver<Array<ResolversTypes['registration_billings']>, ParentType, ContextType, RequireFields<Query_RootRegistration_BillingsArgs, never>>;
  registration_billings_aggregate?: Resolver<ResolversTypes['registration_billings_aggregate'], ParentType, ContextType, RequireFields<Query_RootRegistration_Billings_AggregateArgs, never>>;
  registration_billings_by_pk?: Resolver<Maybe<ResolversTypes['registration_billings']>, ParentType, ContextType, RequireFields<Query_RootRegistration_Billings_By_PkArgs, 'id'>>;
  registrations?: Resolver<Array<ResolversTypes['registrations']>, ParentType, ContextType, RequireFields<Query_RootRegistrationsArgs, never>>;
  registrations_aggregate?: Resolver<ResolversTypes['registrations_aggregate'], ParentType, ContextType, RequireFields<Query_RootRegistrations_AggregateArgs, never>>;
  registrations_by_pk?: Resolver<Maybe<ResolversTypes['registrations']>, ParentType, ContextType, RequireFields<Query_RootRegistrations_By_PkArgs, 'id'>>;
  result_plan_association?: Resolver<Array<ResolversTypes['result_plan_association']>, ParentType, ContextType, RequireFields<Query_RootResult_Plan_AssociationArgs, never>>;
  result_plan_association_aggregate?: Resolver<ResolversTypes['result_plan_association_aggregate'], ParentType, ContextType, RequireFields<Query_RootResult_Plan_Association_AggregateArgs, never>>;
  result_plan_association_by_pk?: Resolver<Maybe<ResolversTypes['result_plan_association']>, ParentType, ContextType, RequireFields<Query_RootResult_Plan_Association_By_PkArgs, 'plan_id' | 'result_id'>>;
  results?: Resolver<Array<ResolversTypes['results']>, ParentType, ContextType, RequireFields<Query_RootResultsArgs, never>>;
  results_aggregate?: Resolver<ResolversTypes['results_aggregate'], ParentType, ContextType, RequireFields<Query_RootResults_AggregateArgs, never>>;
  results_by_pk?: Resolver<Maybe<ResolversTypes['results']>, ParentType, ContextType, RequireFields<Query_RootResults_By_PkArgs, 'id'>>;
  scores?: Resolver<Array<ResolversTypes['scores']>, ParentType, ContextType, RequireFields<Query_RootScoresArgs, never>>;
  scores_aggregate?: Resolver<ResolversTypes['scores_aggregate'], ParentType, ContextType, RequireFields<Query_RootScores_AggregateArgs, never>>;
  scores_by_pk?: Resolver<Maybe<ResolversTypes['scores']>, ParentType, ContextType, RequireFields<Query_RootScores_By_PkArgs, 'lesson_id' | 'user_id'>>;
  spheres?: Resolver<Array<ResolversTypes['spheres']>, ParentType, ContextType, RequireFields<Query_RootSpheresArgs, never>>;
  spheres_aggregate?: Resolver<ResolversTypes['spheres_aggregate'], ParentType, ContextType, RequireFields<Query_RootSpheres_AggregateArgs, never>>;
  spheres_by_pk?: Resolver<Maybe<ResolversTypes['spheres']>, ParentType, ContextType, RequireFields<Query_RootSpheres_By_PkArgs, 'id'>>;
  supports?: Resolver<Array<ResolversTypes['supports']>, ParentType, ContextType, RequireFields<Query_RootSupportsArgs, never>>;
  supports_aggregate?: Resolver<ResolversTypes['supports_aggregate'], ParentType, ContextType, RequireFields<Query_RootSupports_AggregateArgs, never>>;
  supports_by_pk?: Resolver<Maybe<ResolversTypes['supports']>, ParentType, ContextType, RequireFields<Query_RootSupports_By_PkArgs, 'id'>>;
  users?: Resolver<Array<ResolversTypes['users']>, ParentType, ContextType, RequireFields<Query_RootUsersArgs, never>>;
  users_aggregate?: Resolver<ResolversTypes['users_aggregate'], ParentType, ContextType, RequireFields<Query_RootUsers_AggregateArgs, never>>;
  users_by_pk?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType, RequireFields<Query_RootUsers_By_PkArgs, 'id'>>;
};

export type Question_Lesson_AssociationResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association'] = ResolversParentTypes['question_lesson_association']> = {
  lesson?: Resolver<ResolversTypes['lessons'], ParentType, ContextType>;
  lesson_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  question?: Resolver<ResolversTypes['questions'], ParentType, ContextType>;
  question_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_aggregate'] = ResolversParentTypes['question_lesson_association_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['question_lesson_association_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['question_lesson_association']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_aggregate_fields'] = ResolversParentTypes['question_lesson_association_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['question_lesson_association_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Question_Lesson_Association_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['question_lesson_association_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['question_lesson_association_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['question_lesson_association_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['question_lesson_association_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['question_lesson_association_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['question_lesson_association_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['question_lesson_association_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['question_lesson_association_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['question_lesson_association_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_avg_fields'] = ResolversParentTypes['question_lesson_association_avg_fields']> = {
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_max_fields'] = ResolversParentTypes['question_lesson_association_max_fields']> = {
  lesson_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_min_fields'] = ResolversParentTypes['question_lesson_association_min_fields']> = {
  lesson_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_mutation_response'] = ResolversParentTypes['question_lesson_association_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['question_lesson_association']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_stddev_fields'] = ResolversParentTypes['question_lesson_association_stddev_fields']> = {
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_stddev_pop_fields'] = ResolversParentTypes['question_lesson_association_stddev_pop_fields']> = {
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_stddev_samp_fields'] = ResolversParentTypes['question_lesson_association_stddev_samp_fields']> = {
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_sum_fields'] = ResolversParentTypes['question_lesson_association_sum_fields']> = {
  lesson_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_var_pop_fields'] = ResolversParentTypes['question_lesson_association_var_pop_fields']> = {
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_var_samp_fields'] = ResolversParentTypes['question_lesson_association_var_samp_fields']> = {
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Question_Lesson_Association_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['question_lesson_association_variance_fields'] = ResolversParentTypes['question_lesson_association_variance_fields']> = {
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions'] = ResolversParentTypes['questions']> = {
  answers?: Resolver<Array<ResolversTypes['answers']>, ParentType, ContextType, RequireFields<QuestionsAnswersArgs, never>>;
  answers_aggregate?: Resolver<ResolversTypes['answers_aggregate'], ParentType, ContextType, RequireFields<QuestionsAnswers_AggregateArgs, never>>;
  choices?: Resolver<Array<ResolversTypes['choices']>, ParentType, ContextType, RequireFields<QuestionsChoicesArgs, never>>;
  choices_aggregate?: Resolver<ResolversTypes['choices_aggregate'], ParentType, ContextType, RequireFields<QuestionsChoices_AggregateArgs, never>>;
  correction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  question_lesson_associations?: Resolver<Array<ResolversTypes['question_lesson_association']>, ParentType, ContextType, RequireFields<QuestionsQuestion_Lesson_AssociationsArgs, never>>;
  question_lesson_associations_aggregate?: Resolver<ResolversTypes['question_lesson_association_aggregate'], ParentType, ContextType, RequireFields<QuestionsQuestion_Lesson_Associations_AggregateArgs, never>>;
  support?: Resolver<ResolversTypes['supports'], ParentType, ContextType>;
  support_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_aggregate'] = ResolversParentTypes['questions_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['questions_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['questions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_aggregate_fields'] = ResolversParentTypes['questions_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['questions_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Questions_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['questions_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['questions_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['questions_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['questions_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['questions_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['questions_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['questions_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['questions_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['questions_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_avg_fields'] = ResolversParentTypes['questions_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  support_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_max_fields'] = ResolversParentTypes['questions_max_fields']> = {
  correction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  support_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_min_fields'] = ResolversParentTypes['questions_min_fields']> = {
  correction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  support_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_mutation_response'] = ResolversParentTypes['questions_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['questions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_stddev_fields'] = ResolversParentTypes['questions_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  support_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_stddev_pop_fields'] = ResolversParentTypes['questions_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  support_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_stddev_samp_fields'] = ResolversParentTypes['questions_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  support_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_sum_fields'] = ResolversParentTypes['questions_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  support_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_var_pop_fields'] = ResolversParentTypes['questions_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  support_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_var_samp_fields'] = ResolversParentTypes['questions_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  support_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Questions_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['questions_variance_fields'] = ResolversParentTypes['questions_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  support_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_BillingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings'] = ResolversParentTypes['registration_billings']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  created_by?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  institution?: Resolver<ResolversTypes['institutions'], ParentType, ContextType>;
  institution_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['profiles'], ParentType, ContextType>;
  registrations?: Resolver<Array<ResolversTypes['registrations']>, ParentType, ContextType, RequireFields<Registration_BillingsRegistrationsArgs, never>>;
  registrations_aggregate?: Resolver<ResolversTypes['registrations_aggregate'], ParentType, ContextType, RequireFields<Registration_BillingsRegistrations_AggregateArgs, never>>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_aggregate'] = ResolversParentTypes['registration_billings_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['registration_billings_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['registration_billings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_aggregate_fields'] = ResolversParentTypes['registration_billings_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['registration_billings_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Registration_Billings_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['registration_billings_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['registration_billings_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['registration_billings_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['registration_billings_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['registration_billings_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['registration_billings_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['registration_billings_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['registration_billings_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['registration_billings_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_avg_fields'] = ResolversParentTypes['registration_billings_avg_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_max_fields'] = ResolversParentTypes['registration_billings_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_min_fields'] = ResolversParentTypes['registration_billings_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_mutation_response'] = ResolversParentTypes['registration_billings_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['registration_billings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_stddev_fields'] = ResolversParentTypes['registration_billings_stddev_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_stddev_pop_fields'] = ResolversParentTypes['registration_billings_stddev_pop_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_stddev_samp_fields'] = ResolversParentTypes['registration_billings_stddev_samp_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_sum_fields'] = ResolversParentTypes['registration_billings_sum_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_var_pop_fields'] = ResolversParentTypes['registration_billings_var_pop_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_var_samp_fields'] = ResolversParentTypes['registration_billings_var_samp_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registration_Billings_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registration_billings_variance_fields'] = ResolversParentTypes['registration_billings_variance_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistrationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations'] = ResolversParentTypes['registrations']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exam_type?: Resolver<ResolversTypes['exam_types'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  institution?: Resolver<ResolversTypes['institutions'], ParentType, ContextType>;
  institution_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  registration_billing_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_aggregate'] = ResolversParentTypes['registrations_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['registrations_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['registrations']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_aggregate_fields'] = ResolversParentTypes['registrations_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['registrations_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Registrations_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['registrations_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['registrations_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['registrations_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['registrations_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['registrations_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['registrations_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['registrations_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['registrations_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['registrations_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_avg_fields'] = ResolversParentTypes['registrations_avg_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  registration_billing_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_max_fields'] = ResolversParentTypes['registrations_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  registration_billing_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_min_fields'] = ResolversParentTypes['registrations_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  registration_billing_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_mutation_response'] = ResolversParentTypes['registrations_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['registrations']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_stddev_fields'] = ResolversParentTypes['registrations_stddev_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  registration_billing_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_stddev_pop_fields'] = ResolversParentTypes['registrations_stddev_pop_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  registration_billing_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_stddev_samp_fields'] = ResolversParentTypes['registrations_stddev_samp_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  registration_billing_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_sum_fields'] = ResolversParentTypes['registrations_sum_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  registration_billing_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_var_pop_fields'] = ResolversParentTypes['registrations_var_pop_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  registration_billing_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_var_samp_fields'] = ResolversParentTypes['registrations_var_samp_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  registration_billing_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Registrations_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['registrations_variance_fields'] = ResolversParentTypes['registrations_variance_fields']> = {
  created_by?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  registration_billing_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_AssociationResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association'] = ResolversParentTypes['result_plan_association']> = {
  plan?: Resolver<ResolversTypes['plans'], ParentType, ContextType>;
  plan_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  result?: Resolver<ResolversTypes['results'], ParentType, ContextType>;
  result_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_aggregate'] = ResolversParentTypes['result_plan_association_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['result_plan_association_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['result_plan_association']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_aggregate_fields'] = ResolversParentTypes['result_plan_association_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['result_plan_association_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Result_Plan_Association_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['result_plan_association_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['result_plan_association_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['result_plan_association_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['result_plan_association_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['result_plan_association_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['result_plan_association_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['result_plan_association_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['result_plan_association_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['result_plan_association_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_avg_fields'] = ResolversParentTypes['result_plan_association_avg_fields']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_max_fields'] = ResolversParentTypes['result_plan_association_max_fields']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_min_fields'] = ResolversParentTypes['result_plan_association_min_fields']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_mutation_response'] = ResolversParentTypes['result_plan_association_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['result_plan_association']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_stddev_fields'] = ResolversParentTypes['result_plan_association_stddev_fields']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_stddev_pop_fields'] = ResolversParentTypes['result_plan_association_stddev_pop_fields']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_stddev_samp_fields'] = ResolversParentTypes['result_plan_association_stddev_samp_fields']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_sum_fields'] = ResolversParentTypes['result_plan_association_sum_fields']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_var_pop_fields'] = ResolversParentTypes['result_plan_association_var_pop_fields']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_var_samp_fields'] = ResolversParentTypes['result_plan_association_var_samp_fields']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Result_Plan_Association_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['result_plan_association_variance_fields'] = ResolversParentTypes['result_plan_association_variance_fields']> = {
  plan_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  result_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['results'] = ResolversParentTypes['results']> = {
  answers?: Resolver<Array<ResolversTypes['answers']>, ParentType, ContextType, RequireFields<ResultsAnswersArgs, never>>;
  answers_aggregate?: Resolver<ResolversTypes['answers_aggregate'], ParentType, ContextType, RequireFields<ResultsAnswers_AggregateArgs, never>>;
  created_at?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  exam?: Resolver<ResolversTypes['exams'], ParentType, ContextType>;
  exam_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  listening_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  oral_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  reading_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  result_plan_associations?: Resolver<Array<ResolversTypes['result_plan_association']>, ParentType, ContextType, RequireFields<ResultsResult_Plan_AssociationsArgs, never>>;
  result_plan_associations_aggregate?: Resolver<ResolversTypes['result_plan_association_aggregate'], ParentType, ContextType, RequireFields<ResultsResult_Plan_Associations_AggregateArgs, never>>;
  score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['users'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  writing_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_aggregate'] = ResolversParentTypes['results_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['results_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['results']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_aggregate_fields'] = ResolversParentTypes['results_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['results_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Results_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['results_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['results_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['results_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['results_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['results_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['results_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['results_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['results_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['results_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_avg_fields'] = ResolversParentTypes['results_avg_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  listening_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  oral_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reading_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writing_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_max_fields'] = ResolversParentTypes['results_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  exam_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  listening_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  oral_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  reading_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  writing_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_min_fields'] = ResolversParentTypes['results_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  exam_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  listening_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  oral_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  reading_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  writing_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_mutation_response'] = ResolversParentTypes['results_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['results']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_stddev_fields'] = ResolversParentTypes['results_stddev_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  listening_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  oral_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reading_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writing_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_stddev_pop_fields'] = ResolversParentTypes['results_stddev_pop_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  listening_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  oral_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reading_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writing_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_stddev_samp_fields'] = ResolversParentTypes['results_stddev_samp_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  listening_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  oral_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reading_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writing_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_sum_fields'] = ResolversParentTypes['results_sum_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  listening_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  oral_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  reading_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  writing_score?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_var_pop_fields'] = ResolversParentTypes['results_var_pop_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  listening_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  oral_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reading_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writing_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_var_samp_fields'] = ResolversParentTypes['results_var_samp_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  listening_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  oral_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reading_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writing_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Results_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['results_variance_fields'] = ResolversParentTypes['results_variance_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  listening_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  oral_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reading_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writing_score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoresResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores'] = ResolversParentTypes['scores']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  known_date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  lesson?: Resolver<ResolversTypes['lessons'], ParentType, ContextType>;
  lesson_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  trial_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['users'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_aggregate'] = ResolversParentTypes['scores_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['scores_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['scores']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_aggregate_fields'] = ResolversParentTypes['scores_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['scores_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Scores_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['scores_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['scores_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['scores_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['scores_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['scores_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['scores_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['scores_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['scores_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['scores_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_avg_fields'] = ResolversParentTypes['scores_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  trial_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_max_fields'] = ResolversParentTypes['scores_max_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  known_date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trial_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_min_fields'] = ResolversParentTypes['scores_min_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  known_date?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trial_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_mutation_response'] = ResolversParentTypes['scores_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['scores']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_stddev_fields'] = ResolversParentTypes['scores_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  trial_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_stddev_pop_fields'] = ResolversParentTypes['scores_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  trial_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_stddev_samp_fields'] = ResolversParentTypes['scores_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  trial_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_sum_fields'] = ResolversParentTypes['scores_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trial_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_var_pop_fields'] = ResolversParentTypes['scores_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  trial_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_var_samp_fields'] = ResolversParentTypes['scores_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  trial_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Scores_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['scores_variance_fields'] = ResolversParentTypes['scores_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  trial_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SpheresResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres'] = ResolversParentTypes['spheres']> = {
  exam_type?: Resolver<ResolversTypes['exam_types'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  institution?: Resolver<ResolversTypes['institutions'], ParentType, ContextType>;
  institution_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  is_global?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profile_sphere_associations?: Resolver<Array<ResolversTypes['profile_sphere_association']>, ParentType, ContextType, RequireFields<SpheresProfile_Sphere_AssociationsArgs, never>>;
  profile_sphere_associations_aggregate?: Resolver<ResolversTypes['profile_sphere_association_aggregate'], ParentType, ContextType, RequireFields<SpheresProfile_Sphere_Associations_AggregateArgs, never>>;
  teacher?: Resolver<Maybe<ResolversTypes['profiles']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_aggregate'] = ResolversParentTypes['spheres_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['spheres_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['spheres']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_aggregate_fields'] = ResolversParentTypes['spheres_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['spheres_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Spheres_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['spheres_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['spheres_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['spheres_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['spheres_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['spheres_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['spheres_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['spheres_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['spheres_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['spheres_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_avg_fields'] = ResolversParentTypes['spheres_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_max_fields'] = ResolversParentTypes['spheres_max_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_min_fields'] = ResolversParentTypes['spheres_min_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_mutation_response'] = ResolversParentTypes['spheres_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['spheres']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_stddev_fields'] = ResolversParentTypes['spheres_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_stddev_pop_fields'] = ResolversParentTypes['spheres_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_stddev_samp_fields'] = ResolversParentTypes['spheres_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_sum_fields'] = ResolversParentTypes['spheres_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_var_pop_fields'] = ResolversParentTypes['spheres_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_var_samp_fields'] = ResolversParentTypes['spheres_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Spheres_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['spheres_variance_fields'] = ResolversParentTypes['spheres_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  institution_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  teacher_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_RootResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_root'] = ResolversParentTypes['subscription_root']> = {
  activation_codes?: SubscriptionResolver<Array<ResolversTypes['activation_codes']>, "activation_codes", ParentType, ContextType, RequireFields<Subscription_RootActivation_CodesArgs, never>>;
  activation_codes_aggregate?: SubscriptionResolver<ResolversTypes['activation_codes_aggregate'], "activation_codes_aggregate", ParentType, ContextType, RequireFields<Subscription_RootActivation_Codes_AggregateArgs, never>>;
  activation_codes_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['activation_codes']>, "activation_codes_by_pk", ParentType, ContextType, RequireFields<Subscription_RootActivation_Codes_By_PkArgs, 'id'>>;
  answers?: SubscriptionResolver<Array<ResolversTypes['answers']>, "answers", ParentType, ContextType, RequireFields<Subscription_RootAnswersArgs, never>>;
  answers_aggregate?: SubscriptionResolver<ResolversTypes['answers_aggregate'], "answers_aggregate", ParentType, ContextType, RequireFields<Subscription_RootAnswers_AggregateArgs, never>>;
  answers_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['answers']>, "answers_by_pk", ParentType, ContextType, RequireFields<Subscription_RootAnswers_By_PkArgs, 'id'>>;
  answers_choice_association?: SubscriptionResolver<Array<ResolversTypes['answers_choice_association']>, "answers_choice_association", ParentType, ContextType, RequireFields<Subscription_RootAnswers_Choice_AssociationArgs, never>>;
  answers_choice_association_aggregate?: SubscriptionResolver<ResolversTypes['answers_choice_association_aggregate'], "answers_choice_association_aggregate", ParentType, ContextType, RequireFields<Subscription_RootAnswers_Choice_Association_AggregateArgs, never>>;
  bills?: SubscriptionResolver<Array<ResolversTypes['bills']>, "bills", ParentType, ContextType, RequireFields<Subscription_RootBillsArgs, never>>;
  bills_aggregate?: SubscriptionResolver<ResolversTypes['bills_aggregate'], "bills_aggregate", ParentType, ContextType, RequireFields<Subscription_RootBills_AggregateArgs, never>>;
  bills_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['bills']>, "bills_by_pk", ParentType, ContextType, RequireFields<Subscription_RootBills_By_PkArgs, 'id'>>;
  bright_assessment?: SubscriptionResolver<Array<ResolversTypes['bright_assessment']>, "bright_assessment", ParentType, ContextType, RequireFields<Subscription_RootBright_AssessmentArgs, never>>;
  bright_assessment_aggregate?: SubscriptionResolver<ResolversTypes['bright_assessment_aggregate'], "bright_assessment_aggregate", ParentType, ContextType, RequireFields<Subscription_RootBright_Assessment_AggregateArgs, never>>;
  bright_assessment_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['bright_assessment']>, "bright_assessment_by_pk", ParentType, ContextType, RequireFields<Subscription_RootBright_Assessment_By_PkArgs, 'bright_assessment_id' | 'tester_id'>>;
  bright_assessments?: SubscriptionResolver<Array<ResolversTypes['bright_assessments']>, "bright_assessments", ParentType, ContextType, RequireFields<Subscription_RootBright_AssessmentsArgs, never>>;
  bright_assessments_aggregate?: SubscriptionResolver<ResolversTypes['bright_assessments_aggregate'], "bright_assessments_aggregate", ParentType, ContextType, RequireFields<Subscription_RootBright_Assessments_AggregateArgs, never>>;
  bright_assessments_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['bright_assessments']>, "bright_assessments_by_pk", ParentType, ContextType, RequireFields<Subscription_RootBright_Assessments_By_PkArgs, 'id'>>;
  bright_branch?: SubscriptionResolver<Array<ResolversTypes['bright_branch']>, "bright_branch", ParentType, ContextType, RequireFields<Subscription_RootBright_BranchArgs, never>>;
  bright_branch_aggregate?: SubscriptionResolver<ResolversTypes['bright_branch_aggregate'], "bright_branch_aggregate", ParentType, ContextType, RequireFields<Subscription_RootBright_Branch_AggregateArgs, never>>;
  bright_branch_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['bright_branch']>, "bright_branch_by_pk", ParentType, ContextType, RequireFields<Subscription_RootBright_Branch_By_PkArgs, 'institution_id'>>;
  bright_candidate?: SubscriptionResolver<Array<ResolversTypes['bright_candidate']>, "bright_candidate", ParentType, ContextType, RequireFields<Subscription_RootBright_CandidateArgs, never>>;
  bright_candidate_aggregate?: SubscriptionResolver<ResolversTypes['bright_candidate_aggregate'], "bright_candidate_aggregate", ParentType, ContextType, RequireFields<Subscription_RootBright_Candidate_AggregateArgs, never>>;
  bright_candidate_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['bright_candidate']>, "bright_candidate_by_pk", ParentType, ContextType, RequireFields<Subscription_RootBright_Candidate_By_PkArgs, 'candidate_id' | 'manager_id'>>;
  bright_manager?: SubscriptionResolver<Array<ResolversTypes['bright_manager']>, "bright_manager", ParentType, ContextType, RequireFields<Subscription_RootBright_ManagerArgs, never>>;
  bright_manager_aggregate?: SubscriptionResolver<ResolversTypes['bright_manager_aggregate'], "bright_manager_aggregate", ParentType, ContextType, RequireFields<Subscription_RootBright_Manager_AggregateArgs, never>>;
  bright_manager_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['bright_manager']>, "bright_manager_by_pk", ParentType, ContextType, RequireFields<Subscription_RootBright_Manager_By_PkArgs, 'manager_id'>>;
  categories?: SubscriptionResolver<Array<ResolversTypes['categories']>, "categories", ParentType, ContextType, RequireFields<Subscription_RootCategoriesArgs, never>>;
  categories_aggregate?: SubscriptionResolver<ResolversTypes['categories_aggregate'], "categories_aggregate", ParentType, ContextType, RequireFields<Subscription_RootCategories_AggregateArgs, never>>;
  categories_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['categories']>, "categories_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCategories_By_PkArgs, 'id'>>;
  choices?: SubscriptionResolver<Array<ResolversTypes['choices']>, "choices", ParentType, ContextType, RequireFields<Subscription_RootChoicesArgs, never>>;
  choices_aggregate?: SubscriptionResolver<ResolversTypes['choices_aggregate'], "choices_aggregate", ParentType, ContextType, RequireFields<Subscription_RootChoices_AggregateArgs, never>>;
  choices_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['choices']>, "choices_by_pk", ParentType, ContextType, RequireFields<Subscription_RootChoices_By_PkArgs, 'id'>>;
  credits_log?: SubscriptionResolver<Array<ResolversTypes['credits_log']>, "credits_log", ParentType, ContextType, RequireFields<Subscription_RootCredits_LogArgs, never>>;
  credits_log_aggregate?: SubscriptionResolver<ResolversTypes['credits_log_aggregate'], "credits_log_aggregate", ParentType, ContextType, RequireFields<Subscription_RootCredits_Log_AggregateArgs, never>>;
  credits_log_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['credits_log']>, "credits_log_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCredits_Log_By_PkArgs, 'id'>>;
  discount_codes?: SubscriptionResolver<Array<ResolversTypes['discount_codes']>, "discount_codes", ParentType, ContextType, RequireFields<Subscription_RootDiscount_CodesArgs, never>>;
  discount_codes_aggregate?: SubscriptionResolver<ResolversTypes['discount_codes_aggregate'], "discount_codes_aggregate", ParentType, ContextType, RequireFields<Subscription_RootDiscount_Codes_AggregateArgs, never>>;
  discount_codes_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['discount_codes']>, "discount_codes_by_pk", ParentType, ContextType, RequireFields<Subscription_RootDiscount_Codes_By_PkArgs, 'id'>>;
  estimated_scores?: SubscriptionResolver<Array<ResolversTypes['estimated_scores']>, "estimated_scores", ParentType, ContextType, RequireFields<Subscription_RootEstimated_ScoresArgs, never>>;
  estimated_scores_aggregate?: SubscriptionResolver<ResolversTypes['estimated_scores_aggregate'], "estimated_scores_aggregate", ParentType, ContextType, RequireFields<Subscription_RootEstimated_Scores_AggregateArgs, never>>;
  estimated_scores_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['estimated_scores']>, "estimated_scores_by_pk", ParentType, ContextType, RequireFields<Subscription_RootEstimated_Scores_By_PkArgs, 'id'>>;
  exams?: SubscriptionResolver<Array<ResolversTypes['exams']>, "exams", ParentType, ContextType, RequireFields<Subscription_RootExamsArgs, never>>;
  exams_aggregate?: SubscriptionResolver<ResolversTypes['exams_aggregate'], "exams_aggregate", ParentType, ContextType, RequireFields<Subscription_RootExams_AggregateArgs, never>>;
  exams_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['exams']>, "exams_by_pk", ParentType, ContextType, RequireFields<Subscription_RootExams_By_PkArgs, 'id'>>;
  feedbacks?: SubscriptionResolver<Array<ResolversTypes['feedbacks']>, "feedbacks", ParentType, ContextType, RequireFields<Subscription_RootFeedbacksArgs, never>>;
  feedbacks_aggregate?: SubscriptionResolver<ResolversTypes['feedbacks_aggregate'], "feedbacks_aggregate", ParentType, ContextType, RequireFields<Subscription_RootFeedbacks_AggregateArgs, never>>;
  feedbacks_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['feedbacks']>, "feedbacks_by_pk", ParentType, ContextType, RequireFields<Subscription_RootFeedbacks_By_PkArgs, 'id'>>;
  institutions?: SubscriptionResolver<Array<ResolversTypes['institutions']>, "institutions", ParentType, ContextType, RequireFields<Subscription_RootInstitutionsArgs, never>>;
  institutions_aggregate?: SubscriptionResolver<ResolversTypes['institutions_aggregate'], "institutions_aggregate", ParentType, ContextType, RequireFields<Subscription_RootInstitutions_AggregateArgs, never>>;
  institutions_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['institutions']>, "institutions_by_pk", ParentType, ContextType, RequireFields<Subscription_RootInstitutions_By_PkArgs, 'id'>>;
  lessons?: SubscriptionResolver<Array<ResolversTypes['lessons']>, "lessons", ParentType, ContextType, RequireFields<Subscription_RootLessonsArgs, never>>;
  lessons_aggregate?: SubscriptionResolver<ResolversTypes['lessons_aggregate'], "lessons_aggregate", ParentType, ContextType, RequireFields<Subscription_RootLessons_AggregateArgs, never>>;
  lessons_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['lessons']>, "lessons_by_pk", ParentType, ContextType, RequireFields<Subscription_RootLessons_By_PkArgs, 'id'>>;
  plans?: SubscriptionResolver<Array<ResolversTypes['plans']>, "plans", ParentType, ContextType, RequireFields<Subscription_RootPlansArgs, never>>;
  plans_aggregate?: SubscriptionResolver<ResolversTypes['plans_aggregate'], "plans_aggregate", ParentType, ContextType, RequireFields<Subscription_RootPlans_AggregateArgs, never>>;
  plans_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['plans']>, "plans_by_pk", ParentType, ContextType, RequireFields<Subscription_RootPlans_By_PkArgs, 'id'>>;
  profile_sphere_association?: SubscriptionResolver<Array<ResolversTypes['profile_sphere_association']>, "profile_sphere_association", ParentType, ContextType, RequireFields<Subscription_RootProfile_Sphere_AssociationArgs, never>>;
  profile_sphere_association_aggregate?: SubscriptionResolver<ResolversTypes['profile_sphere_association_aggregate'], "profile_sphere_association_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProfile_Sphere_Association_AggregateArgs, never>>;
  profiles?: SubscriptionResolver<Array<ResolversTypes['profiles']>, "profiles", ParentType, ContextType, RequireFields<Subscription_RootProfilesArgs, never>>;
  profiles_aggregate?: SubscriptionResolver<ResolversTypes['profiles_aggregate'], "profiles_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProfiles_AggregateArgs, never>>;
  profiles_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['profiles']>, "profiles_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProfiles_By_PkArgs, 'id'>>;
  question_lesson_association?: SubscriptionResolver<Array<ResolversTypes['question_lesson_association']>, "question_lesson_association", ParentType, ContextType, RequireFields<Subscription_RootQuestion_Lesson_AssociationArgs, never>>;
  question_lesson_association_aggregate?: SubscriptionResolver<ResolversTypes['question_lesson_association_aggregate'], "question_lesson_association_aggregate", ParentType, ContextType, RequireFields<Subscription_RootQuestion_Lesson_Association_AggregateArgs, never>>;
  question_lesson_association_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['question_lesson_association']>, "question_lesson_association_by_pk", ParentType, ContextType, RequireFields<Subscription_RootQuestion_Lesson_Association_By_PkArgs, 'lesson_id' | 'question_id'>>;
  questions?: SubscriptionResolver<Array<ResolversTypes['questions']>, "questions", ParentType, ContextType, RequireFields<Subscription_RootQuestionsArgs, never>>;
  questions_aggregate?: SubscriptionResolver<ResolversTypes['questions_aggregate'], "questions_aggregate", ParentType, ContextType, RequireFields<Subscription_RootQuestions_AggregateArgs, never>>;
  questions_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['questions']>, "questions_by_pk", ParentType, ContextType, RequireFields<Subscription_RootQuestions_By_PkArgs, 'id'>>;
  registration_billings?: SubscriptionResolver<Array<ResolversTypes['registration_billings']>, "registration_billings", ParentType, ContextType, RequireFields<Subscription_RootRegistration_BillingsArgs, never>>;
  registration_billings_aggregate?: SubscriptionResolver<ResolversTypes['registration_billings_aggregate'], "registration_billings_aggregate", ParentType, ContextType, RequireFields<Subscription_RootRegistration_Billings_AggregateArgs, never>>;
  registration_billings_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['registration_billings']>, "registration_billings_by_pk", ParentType, ContextType, RequireFields<Subscription_RootRegistration_Billings_By_PkArgs, 'id'>>;
  registrations?: SubscriptionResolver<Array<ResolversTypes['registrations']>, "registrations", ParentType, ContextType, RequireFields<Subscription_RootRegistrationsArgs, never>>;
  registrations_aggregate?: SubscriptionResolver<ResolversTypes['registrations_aggregate'], "registrations_aggregate", ParentType, ContextType, RequireFields<Subscription_RootRegistrations_AggregateArgs, never>>;
  registrations_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['registrations']>, "registrations_by_pk", ParentType, ContextType, RequireFields<Subscription_RootRegistrations_By_PkArgs, 'id'>>;
  result_plan_association?: SubscriptionResolver<Array<ResolversTypes['result_plan_association']>, "result_plan_association", ParentType, ContextType, RequireFields<Subscription_RootResult_Plan_AssociationArgs, never>>;
  result_plan_association_aggregate?: SubscriptionResolver<ResolversTypes['result_plan_association_aggregate'], "result_plan_association_aggregate", ParentType, ContextType, RequireFields<Subscription_RootResult_Plan_Association_AggregateArgs, never>>;
  result_plan_association_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['result_plan_association']>, "result_plan_association_by_pk", ParentType, ContextType, RequireFields<Subscription_RootResult_Plan_Association_By_PkArgs, 'plan_id' | 'result_id'>>;
  results?: SubscriptionResolver<Array<ResolversTypes['results']>, "results", ParentType, ContextType, RequireFields<Subscription_RootResultsArgs, never>>;
  results_aggregate?: SubscriptionResolver<ResolversTypes['results_aggregate'], "results_aggregate", ParentType, ContextType, RequireFields<Subscription_RootResults_AggregateArgs, never>>;
  results_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['results']>, "results_by_pk", ParentType, ContextType, RequireFields<Subscription_RootResults_By_PkArgs, 'id'>>;
  scores?: SubscriptionResolver<Array<ResolversTypes['scores']>, "scores", ParentType, ContextType, RequireFields<Subscription_RootScoresArgs, never>>;
  scores_aggregate?: SubscriptionResolver<ResolversTypes['scores_aggregate'], "scores_aggregate", ParentType, ContextType, RequireFields<Subscription_RootScores_AggregateArgs, never>>;
  scores_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['scores']>, "scores_by_pk", ParentType, ContextType, RequireFields<Subscription_RootScores_By_PkArgs, 'lesson_id' | 'user_id'>>;
  spheres?: SubscriptionResolver<Array<ResolversTypes['spheres']>, "spheres", ParentType, ContextType, RequireFields<Subscription_RootSpheresArgs, never>>;
  spheres_aggregate?: SubscriptionResolver<ResolversTypes['spheres_aggregate'], "spheres_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSpheres_AggregateArgs, never>>;
  spheres_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['spheres']>, "spheres_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSpheres_By_PkArgs, 'id'>>;
  supports?: SubscriptionResolver<Array<ResolversTypes['supports']>, "supports", ParentType, ContextType, RequireFields<Subscription_RootSupportsArgs, never>>;
  supports_aggregate?: SubscriptionResolver<ResolversTypes['supports_aggregate'], "supports_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSupports_AggregateArgs, never>>;
  supports_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['supports']>, "supports_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSupports_By_PkArgs, 'id'>>;
  users?: SubscriptionResolver<Array<ResolversTypes['users']>, "users", ParentType, ContextType, RequireFields<Subscription_RootUsersArgs, never>>;
  users_aggregate?: SubscriptionResolver<ResolversTypes['users_aggregate'], "users_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUsers_AggregateArgs, never>>;
  users_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['users']>, "users_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUsers_By_PkArgs, 'id'>>;
};

export type SupportsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports'] = ResolversParentTypes['supports']> = {
  exam?: Resolver<Maybe<ResolversTypes['exams']>, ParentType, ContextType>;
  exam_audio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exam_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  questions?: Resolver<Array<ResolversTypes['questions']>, ParentType, ContextType, RequireFields<SupportsQuestionsArgs, never>>;
  questions_aggregate?: Resolver<ResolversTypes['questions_aggregate'], ParentType, ContextType, RequireFields<SupportsQuestions_AggregateArgs, never>>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  training_audio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_aggregate'] = ResolversParentTypes['supports_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['supports_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['supports']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_aggregate_fields'] = ResolversParentTypes['supports_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['supports_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Supports_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['supports_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['supports_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['supports_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['supports_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['supports_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['supports_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['supports_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['supports_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['supports_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_avg_fields'] = ResolversParentTypes['supports_avg_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_max_fields'] = ResolversParentTypes['supports_max_fields']> = {
  exam_audio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exam_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  training_audio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_min_fields'] = ResolversParentTypes['supports_min_fields']> = {
  exam_audio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exam_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  training_audio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_mutation_response'] = ResolversParentTypes['supports_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['supports']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_stddev_fields'] = ResolversParentTypes['supports_stddev_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_stddev_pop_fields'] = ResolversParentTypes['supports_stddev_pop_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_stddev_samp_fields'] = ResolversParentTypes['supports_stddev_samp_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_sum_fields'] = ResolversParentTypes['supports_sum_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_var_pop_fields'] = ResolversParentTypes['supports_var_pop_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_var_samp_fields'] = ResolversParentTypes['supports_var_samp_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Supports_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supports_variance_fields'] = ResolversParentTypes['supports_variance_fields']> = {
  exam_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lesson_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  part?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TimestampScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['timestamp'], any> {
  name: 'timestamp';
}

export interface TimestamptzScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['timestamptz'], any> {
  name: 'timestamptz';
}

export type UsersResolvers<ContextType = any, ParentType extends ResolversParentTypes['users'] = ResolversParentTypes['users']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bills?: Resolver<Array<ResolversTypes['bills']>, ParentType, ContextType, RequireFields<UsersBillsArgs, never>>;
  bills_aggregate?: Resolver<ResolversTypes['bills_aggregate'], ParentType, ContextType, RequireFields<UsersBills_AggregateArgs, never>>;
  birth_year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  estimated_scores?: Resolver<Array<ResolversTypes['estimated_scores']>, ParentType, ContextType, RequireFields<UsersEstimated_ScoresArgs, never>>;
  estimated_scores_aggregate?: Resolver<ResolversTypes['estimated_scores_aggregate'], ParentType, ContextType, RequireFields<UsersEstimated_Scores_AggregateArgs, never>>;
  first_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  is_generated_password?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  is_student?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  last_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password_hash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profiles?: Resolver<Array<ResolversTypes['profiles']>, ParentType, ContextType, RequireFields<UsersProfilesArgs, never>>;
  profiles_aggregate?: Resolver<ResolversTypes['profiles_aggregate'], ParentType, ContextType, RequireFields<UsersProfiles_AggregateArgs, never>>;
  referral?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reset_password_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  results?: Resolver<Array<ResolversTypes['results']>, ParentType, ContextType, RequireFields<UsersResultsArgs, never>>;
  results_aggregate?: Resolver<ResolversTypes['results_aggregate'], ParentType, ContextType, RequireFields<UsersResults_AggregateArgs, never>>;
  scores?: Resolver<Array<ResolversTypes['scores']>, ParentType, ContextType, RequireFields<UsersScoresArgs, never>>;
  scores_aggregate?: Resolver<ResolversTypes['scores_aggregate'], ParentType, ContextType, RequireFields<UsersScores_AggregateArgs, never>>;
  token_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_aggregate'] = ResolversParentTypes['users_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['users_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['users']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_aggregate_fields'] = ResolversParentTypes['users_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['users_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<Users_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['users_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['users_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['users_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['users_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['users_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['users_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['users_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['users_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['users_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_avg_fields'] = ResolversParentTypes['users_avg_fields']> = {
  birth_year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  token_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_max_fields'] = ResolversParentTypes['users_max_fields']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birth_year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  first_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  last_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password_hash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reset_password_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_min_fields'] = ResolversParentTypes['users_min_fields']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birth_year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  first_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  last_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password_hash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reset_password_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_mutation_response'] = ResolversParentTypes['users_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['users']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_stddev_fields'] = ResolversParentTypes['users_stddev_fields']> = {
  birth_year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  token_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_stddev_pop_fields'] = ResolversParentTypes['users_stddev_pop_fields']> = {
  birth_year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  token_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_stddev_samp_fields'] = ResolversParentTypes['users_stddev_samp_fields']> = {
  birth_year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  token_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_sum_fields'] = ResolversParentTypes['users_sum_fields']> = {
  birth_year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  token_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_var_pop_fields'] = ResolversParentTypes['users_var_pop_fields']> = {
  birth_year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  token_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_var_samp_fields'] = ResolversParentTypes['users_var_samp_fields']> = {
  birth_year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  token_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_variance_fields'] = ResolversParentTypes['users_variance_fields']> = {
  birth_year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  token_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  activation_codes?: Activation_CodesResolvers<ContextType>;
  activation_codes_aggregate?: Activation_Codes_AggregateResolvers<ContextType>;
  activation_codes_aggregate_fields?: Activation_Codes_Aggregate_FieldsResolvers<ContextType>;
  activation_codes_avg_fields?: Activation_Codes_Avg_FieldsResolvers<ContextType>;
  activation_codes_max_fields?: Activation_Codes_Max_FieldsResolvers<ContextType>;
  activation_codes_min_fields?: Activation_Codes_Min_FieldsResolvers<ContextType>;
  activation_codes_mutation_response?: Activation_Codes_Mutation_ResponseResolvers<ContextType>;
  activation_codes_stddev_fields?: Activation_Codes_Stddev_FieldsResolvers<ContextType>;
  activation_codes_stddev_pop_fields?: Activation_Codes_Stddev_Pop_FieldsResolvers<ContextType>;
  activation_codes_stddev_samp_fields?: Activation_Codes_Stddev_Samp_FieldsResolvers<ContextType>;
  activation_codes_sum_fields?: Activation_Codes_Sum_FieldsResolvers<ContextType>;
  activation_codes_var_pop_fields?: Activation_Codes_Var_Pop_FieldsResolvers<ContextType>;
  activation_codes_var_samp_fields?: Activation_Codes_Var_Samp_FieldsResolvers<ContextType>;
  activation_codes_variance_fields?: Activation_Codes_Variance_FieldsResolvers<ContextType>;
  answers?: AnswersResolvers<ContextType>;
  answers_aggregate?: Answers_AggregateResolvers<ContextType>;
  answers_aggregate_fields?: Answers_Aggregate_FieldsResolvers<ContextType>;
  answers_avg_fields?: Answers_Avg_FieldsResolvers<ContextType>;
  answers_choice_association?: Answers_Choice_AssociationResolvers<ContextType>;
  answers_choice_association_aggregate?: Answers_Choice_Association_AggregateResolvers<ContextType>;
  answers_choice_association_aggregate_fields?: Answers_Choice_Association_Aggregate_FieldsResolvers<ContextType>;
  answers_choice_association_avg_fields?: Answers_Choice_Association_Avg_FieldsResolvers<ContextType>;
  answers_choice_association_max_fields?: Answers_Choice_Association_Max_FieldsResolvers<ContextType>;
  answers_choice_association_min_fields?: Answers_Choice_Association_Min_FieldsResolvers<ContextType>;
  answers_choice_association_mutation_response?: Answers_Choice_Association_Mutation_ResponseResolvers<ContextType>;
  answers_choice_association_stddev_fields?: Answers_Choice_Association_Stddev_FieldsResolvers<ContextType>;
  answers_choice_association_stddev_pop_fields?: Answers_Choice_Association_Stddev_Pop_FieldsResolvers<ContextType>;
  answers_choice_association_stddev_samp_fields?: Answers_Choice_Association_Stddev_Samp_FieldsResolvers<ContextType>;
  answers_choice_association_sum_fields?: Answers_Choice_Association_Sum_FieldsResolvers<ContextType>;
  answers_choice_association_var_pop_fields?: Answers_Choice_Association_Var_Pop_FieldsResolvers<ContextType>;
  answers_choice_association_var_samp_fields?: Answers_Choice_Association_Var_Samp_FieldsResolvers<ContextType>;
  answers_choice_association_variance_fields?: Answers_Choice_Association_Variance_FieldsResolvers<ContextType>;
  answers_max_fields?: Answers_Max_FieldsResolvers<ContextType>;
  answers_min_fields?: Answers_Min_FieldsResolvers<ContextType>;
  answers_mutation_response?: Answers_Mutation_ResponseResolvers<ContextType>;
  answers_stddev_fields?: Answers_Stddev_FieldsResolvers<ContextType>;
  answers_stddev_pop_fields?: Answers_Stddev_Pop_FieldsResolvers<ContextType>;
  answers_stddev_samp_fields?: Answers_Stddev_Samp_FieldsResolvers<ContextType>;
  answers_sum_fields?: Answers_Sum_FieldsResolvers<ContextType>;
  answers_var_pop_fields?: Answers_Var_Pop_FieldsResolvers<ContextType>;
  answers_var_samp_fields?: Answers_Var_Samp_FieldsResolvers<ContextType>;
  answers_variance_fields?: Answers_Variance_FieldsResolvers<ContextType>;
  bills?: BillsResolvers<ContextType>;
  bills_aggregate?: Bills_AggregateResolvers<ContextType>;
  bills_aggregate_fields?: Bills_Aggregate_FieldsResolvers<ContextType>;
  bills_avg_fields?: Bills_Avg_FieldsResolvers<ContextType>;
  bills_max_fields?: Bills_Max_FieldsResolvers<ContextType>;
  bills_min_fields?: Bills_Min_FieldsResolvers<ContextType>;
  bills_mutation_response?: Bills_Mutation_ResponseResolvers<ContextType>;
  bills_stddev_fields?: Bills_Stddev_FieldsResolvers<ContextType>;
  bills_stddev_pop_fields?: Bills_Stddev_Pop_FieldsResolvers<ContextType>;
  bills_stddev_samp_fields?: Bills_Stddev_Samp_FieldsResolvers<ContextType>;
  bills_sum_fields?: Bills_Sum_FieldsResolvers<ContextType>;
  bills_var_pop_fields?: Bills_Var_Pop_FieldsResolvers<ContextType>;
  bills_var_samp_fields?: Bills_Var_Samp_FieldsResolvers<ContextType>;
  bills_variance_fields?: Bills_Variance_FieldsResolvers<ContextType>;
  bright_assessment?: Bright_AssessmentResolvers<ContextType>;
  bright_assessment_aggregate?: Bright_Assessment_AggregateResolvers<ContextType>;
  bright_assessment_aggregate_fields?: Bright_Assessment_Aggregate_FieldsResolvers<ContextType>;
  bright_assessment_avg_fields?: Bright_Assessment_Avg_FieldsResolvers<ContextType>;
  bright_assessment_max_fields?: Bright_Assessment_Max_FieldsResolvers<ContextType>;
  bright_assessment_min_fields?: Bright_Assessment_Min_FieldsResolvers<ContextType>;
  bright_assessment_mutation_response?: Bright_Assessment_Mutation_ResponseResolvers<ContextType>;
  bright_assessment_stddev_fields?: Bright_Assessment_Stddev_FieldsResolvers<ContextType>;
  bright_assessment_stddev_pop_fields?: Bright_Assessment_Stddev_Pop_FieldsResolvers<ContextType>;
  bright_assessment_stddev_samp_fields?: Bright_Assessment_Stddev_Samp_FieldsResolvers<ContextType>;
  bright_assessment_sum_fields?: Bright_Assessment_Sum_FieldsResolvers<ContextType>;
  bright_assessment_var_pop_fields?: Bright_Assessment_Var_Pop_FieldsResolvers<ContextType>;
  bright_assessment_var_samp_fields?: Bright_Assessment_Var_Samp_FieldsResolvers<ContextType>;
  bright_assessment_variance_fields?: Bright_Assessment_Variance_FieldsResolvers<ContextType>;
  bright_assessments?: Bright_AssessmentsResolvers<ContextType>;
  bright_assessments_aggregate?: Bright_Assessments_AggregateResolvers<ContextType>;
  bright_assessments_aggregate_fields?: Bright_Assessments_Aggregate_FieldsResolvers<ContextType>;
  bright_assessments_avg_fields?: Bright_Assessments_Avg_FieldsResolvers<ContextType>;
  bright_assessments_max_fields?: Bright_Assessments_Max_FieldsResolvers<ContextType>;
  bright_assessments_min_fields?: Bright_Assessments_Min_FieldsResolvers<ContextType>;
  bright_assessments_mutation_response?: Bright_Assessments_Mutation_ResponseResolvers<ContextType>;
  bright_assessments_stddev_fields?: Bright_Assessments_Stddev_FieldsResolvers<ContextType>;
  bright_assessments_stddev_pop_fields?: Bright_Assessments_Stddev_Pop_FieldsResolvers<ContextType>;
  bright_assessments_stddev_samp_fields?: Bright_Assessments_Stddev_Samp_FieldsResolvers<ContextType>;
  bright_assessments_sum_fields?: Bright_Assessments_Sum_FieldsResolvers<ContextType>;
  bright_assessments_var_pop_fields?: Bright_Assessments_Var_Pop_FieldsResolvers<ContextType>;
  bright_assessments_var_samp_fields?: Bright_Assessments_Var_Samp_FieldsResolvers<ContextType>;
  bright_assessments_variance_fields?: Bright_Assessments_Variance_FieldsResolvers<ContextType>;
  bright_branch?: Bright_BranchResolvers<ContextType>;
  bright_branch_aggregate?: Bright_Branch_AggregateResolvers<ContextType>;
  bright_branch_aggregate_fields?: Bright_Branch_Aggregate_FieldsResolvers<ContextType>;
  bright_branch_avg_fields?: Bright_Branch_Avg_FieldsResolvers<ContextType>;
  bright_branch_max_fields?: Bright_Branch_Max_FieldsResolvers<ContextType>;
  bright_branch_min_fields?: Bright_Branch_Min_FieldsResolvers<ContextType>;
  bright_branch_mutation_response?: Bright_Branch_Mutation_ResponseResolvers<ContextType>;
  bright_branch_stddev_fields?: Bright_Branch_Stddev_FieldsResolvers<ContextType>;
  bright_branch_stddev_pop_fields?: Bright_Branch_Stddev_Pop_FieldsResolvers<ContextType>;
  bright_branch_stddev_samp_fields?: Bright_Branch_Stddev_Samp_FieldsResolvers<ContextType>;
  bright_branch_sum_fields?: Bright_Branch_Sum_FieldsResolvers<ContextType>;
  bright_branch_var_pop_fields?: Bright_Branch_Var_Pop_FieldsResolvers<ContextType>;
  bright_branch_var_samp_fields?: Bright_Branch_Var_Samp_FieldsResolvers<ContextType>;
  bright_branch_variance_fields?: Bright_Branch_Variance_FieldsResolvers<ContextType>;
  bright_candidate?: Bright_CandidateResolvers<ContextType>;
  bright_candidate_aggregate?: Bright_Candidate_AggregateResolvers<ContextType>;
  bright_candidate_aggregate_fields?: Bright_Candidate_Aggregate_FieldsResolvers<ContextType>;
  bright_candidate_avg_fields?: Bright_Candidate_Avg_FieldsResolvers<ContextType>;
  bright_candidate_max_fields?: Bright_Candidate_Max_FieldsResolvers<ContextType>;
  bright_candidate_min_fields?: Bright_Candidate_Min_FieldsResolvers<ContextType>;
  bright_candidate_mutation_response?: Bright_Candidate_Mutation_ResponseResolvers<ContextType>;
  bright_candidate_stddev_fields?: Bright_Candidate_Stddev_FieldsResolvers<ContextType>;
  bright_candidate_stddev_pop_fields?: Bright_Candidate_Stddev_Pop_FieldsResolvers<ContextType>;
  bright_candidate_stddev_samp_fields?: Bright_Candidate_Stddev_Samp_FieldsResolvers<ContextType>;
  bright_candidate_sum_fields?: Bright_Candidate_Sum_FieldsResolvers<ContextType>;
  bright_candidate_var_pop_fields?: Bright_Candidate_Var_Pop_FieldsResolvers<ContextType>;
  bright_candidate_var_samp_fields?: Bright_Candidate_Var_Samp_FieldsResolvers<ContextType>;
  bright_candidate_variance_fields?: Bright_Candidate_Variance_FieldsResolvers<ContextType>;
  bright_manager?: Bright_ManagerResolvers<ContextType>;
  bright_manager_aggregate?: Bright_Manager_AggregateResolvers<ContextType>;
  bright_manager_aggregate_fields?: Bright_Manager_Aggregate_FieldsResolvers<ContextType>;
  bright_manager_avg_fields?: Bright_Manager_Avg_FieldsResolvers<ContextType>;
  bright_manager_max_fields?: Bright_Manager_Max_FieldsResolvers<ContextType>;
  bright_manager_min_fields?: Bright_Manager_Min_FieldsResolvers<ContextType>;
  bright_manager_mutation_response?: Bright_Manager_Mutation_ResponseResolvers<ContextType>;
  bright_manager_stddev_fields?: Bright_Manager_Stddev_FieldsResolvers<ContextType>;
  bright_manager_stddev_pop_fields?: Bright_Manager_Stddev_Pop_FieldsResolvers<ContextType>;
  bright_manager_stddev_samp_fields?: Bright_Manager_Stddev_Samp_FieldsResolvers<ContextType>;
  bright_manager_sum_fields?: Bright_Manager_Sum_FieldsResolvers<ContextType>;
  bright_manager_var_pop_fields?: Bright_Manager_Var_Pop_FieldsResolvers<ContextType>;
  bright_manager_var_samp_fields?: Bright_Manager_Var_Samp_FieldsResolvers<ContextType>;
  bright_manager_variance_fields?: Bright_Manager_Variance_FieldsResolvers<ContextType>;
  categories?: CategoriesResolvers<ContextType>;
  categories_aggregate?: Categories_AggregateResolvers<ContextType>;
  categories_aggregate_fields?: Categories_Aggregate_FieldsResolvers<ContextType>;
  categories_avg_fields?: Categories_Avg_FieldsResolvers<ContextType>;
  categories_max_fields?: Categories_Max_FieldsResolvers<ContextType>;
  categories_min_fields?: Categories_Min_FieldsResolvers<ContextType>;
  categories_mutation_response?: Categories_Mutation_ResponseResolvers<ContextType>;
  categories_stddev_fields?: Categories_Stddev_FieldsResolvers<ContextType>;
  categories_stddev_pop_fields?: Categories_Stddev_Pop_FieldsResolvers<ContextType>;
  categories_stddev_samp_fields?: Categories_Stddev_Samp_FieldsResolvers<ContextType>;
  categories_sum_fields?: Categories_Sum_FieldsResolvers<ContextType>;
  categories_var_pop_fields?: Categories_Var_Pop_FieldsResolvers<ContextType>;
  categories_var_samp_fields?: Categories_Var_Samp_FieldsResolvers<ContextType>;
  categories_variance_fields?: Categories_Variance_FieldsResolvers<ContextType>;
  choices?: ChoicesResolvers<ContextType>;
  choices_aggregate?: Choices_AggregateResolvers<ContextType>;
  choices_aggregate_fields?: Choices_Aggregate_FieldsResolvers<ContextType>;
  choices_avg_fields?: Choices_Avg_FieldsResolvers<ContextType>;
  choices_max_fields?: Choices_Max_FieldsResolvers<ContextType>;
  choices_min_fields?: Choices_Min_FieldsResolvers<ContextType>;
  choices_mutation_response?: Choices_Mutation_ResponseResolvers<ContextType>;
  choices_stddev_fields?: Choices_Stddev_FieldsResolvers<ContextType>;
  choices_stddev_pop_fields?: Choices_Stddev_Pop_FieldsResolvers<ContextType>;
  choices_stddev_samp_fields?: Choices_Stddev_Samp_FieldsResolvers<ContextType>;
  choices_sum_fields?: Choices_Sum_FieldsResolvers<ContextType>;
  choices_var_pop_fields?: Choices_Var_Pop_FieldsResolvers<ContextType>;
  choices_var_samp_fields?: Choices_Var_Samp_FieldsResolvers<ContextType>;
  choices_variance_fields?: Choices_Variance_FieldsResolvers<ContextType>;
  credits_log?: Credits_LogResolvers<ContextType>;
  credits_log_aggregate?: Credits_Log_AggregateResolvers<ContextType>;
  credits_log_aggregate_fields?: Credits_Log_Aggregate_FieldsResolvers<ContextType>;
  credits_log_avg_fields?: Credits_Log_Avg_FieldsResolvers<ContextType>;
  credits_log_max_fields?: Credits_Log_Max_FieldsResolvers<ContextType>;
  credits_log_min_fields?: Credits_Log_Min_FieldsResolvers<ContextType>;
  credits_log_mutation_response?: Credits_Log_Mutation_ResponseResolvers<ContextType>;
  credits_log_stddev_fields?: Credits_Log_Stddev_FieldsResolvers<ContextType>;
  credits_log_stddev_pop_fields?: Credits_Log_Stddev_Pop_FieldsResolvers<ContextType>;
  credits_log_stddev_samp_fields?: Credits_Log_Stddev_Samp_FieldsResolvers<ContextType>;
  credits_log_sum_fields?: Credits_Log_Sum_FieldsResolvers<ContextType>;
  credits_log_var_pop_fields?: Credits_Log_Var_Pop_FieldsResolvers<ContextType>;
  credits_log_var_samp_fields?: Credits_Log_Var_Samp_FieldsResolvers<ContextType>;
  credits_log_variance_fields?: Credits_Log_Variance_FieldsResolvers<ContextType>;
  discount_codes?: Discount_CodesResolvers<ContextType>;
  discount_codes_aggregate?: Discount_Codes_AggregateResolvers<ContextType>;
  discount_codes_aggregate_fields?: Discount_Codes_Aggregate_FieldsResolvers<ContextType>;
  discount_codes_avg_fields?: Discount_Codes_Avg_FieldsResolvers<ContextType>;
  discount_codes_max_fields?: Discount_Codes_Max_FieldsResolvers<ContextType>;
  discount_codes_min_fields?: Discount_Codes_Min_FieldsResolvers<ContextType>;
  discount_codes_mutation_response?: Discount_Codes_Mutation_ResponseResolvers<ContextType>;
  discount_codes_stddev_fields?: Discount_Codes_Stddev_FieldsResolvers<ContextType>;
  discount_codes_stddev_pop_fields?: Discount_Codes_Stddev_Pop_FieldsResolvers<ContextType>;
  discount_codes_stddev_samp_fields?: Discount_Codes_Stddev_Samp_FieldsResolvers<ContextType>;
  discount_codes_sum_fields?: Discount_Codes_Sum_FieldsResolvers<ContextType>;
  discount_codes_var_pop_fields?: Discount_Codes_Var_Pop_FieldsResolvers<ContextType>;
  discount_codes_var_samp_fields?: Discount_Codes_Var_Samp_FieldsResolvers<ContextType>;
  discount_codes_variance_fields?: Discount_Codes_Variance_FieldsResolvers<ContextType>;
  estimated_scores?: Estimated_ScoresResolvers<ContextType>;
  estimated_scores_aggregate?: Estimated_Scores_AggregateResolvers<ContextType>;
  estimated_scores_aggregate_fields?: Estimated_Scores_Aggregate_FieldsResolvers<ContextType>;
  estimated_scores_avg_fields?: Estimated_Scores_Avg_FieldsResolvers<ContextType>;
  estimated_scores_max_fields?: Estimated_Scores_Max_FieldsResolvers<ContextType>;
  estimated_scores_min_fields?: Estimated_Scores_Min_FieldsResolvers<ContextType>;
  estimated_scores_mutation_response?: Estimated_Scores_Mutation_ResponseResolvers<ContextType>;
  estimated_scores_stddev_fields?: Estimated_Scores_Stddev_FieldsResolvers<ContextType>;
  estimated_scores_stddev_pop_fields?: Estimated_Scores_Stddev_Pop_FieldsResolvers<ContextType>;
  estimated_scores_stddev_samp_fields?: Estimated_Scores_Stddev_Samp_FieldsResolvers<ContextType>;
  estimated_scores_sum_fields?: Estimated_Scores_Sum_FieldsResolvers<ContextType>;
  estimated_scores_var_pop_fields?: Estimated_Scores_Var_Pop_FieldsResolvers<ContextType>;
  estimated_scores_var_samp_fields?: Estimated_Scores_Var_Samp_FieldsResolvers<ContextType>;
  estimated_scores_variance_fields?: Estimated_Scores_Variance_FieldsResolvers<ContextType>;
  exam_types?: GraphQLScalarType;
  exams?: ExamsResolvers<ContextType>;
  exams_aggregate?: Exams_AggregateResolvers<ContextType>;
  exams_aggregate_fields?: Exams_Aggregate_FieldsResolvers<ContextType>;
  exams_avg_fields?: Exams_Avg_FieldsResolvers<ContextType>;
  exams_max_fields?: Exams_Max_FieldsResolvers<ContextType>;
  exams_min_fields?: Exams_Min_FieldsResolvers<ContextType>;
  exams_mutation_response?: Exams_Mutation_ResponseResolvers<ContextType>;
  exams_stddev_fields?: Exams_Stddev_FieldsResolvers<ContextType>;
  exams_stddev_pop_fields?: Exams_Stddev_Pop_FieldsResolvers<ContextType>;
  exams_stddev_samp_fields?: Exams_Stddev_Samp_FieldsResolvers<ContextType>;
  exams_sum_fields?: Exams_Sum_FieldsResolvers<ContextType>;
  exams_var_pop_fields?: Exams_Var_Pop_FieldsResolvers<ContextType>;
  exams_var_samp_fields?: Exams_Var_Samp_FieldsResolvers<ContextType>;
  exams_variance_fields?: Exams_Variance_FieldsResolvers<ContextType>;
  feedbacks?: FeedbacksResolvers<ContextType>;
  feedbacks_aggregate?: Feedbacks_AggregateResolvers<ContextType>;
  feedbacks_aggregate_fields?: Feedbacks_Aggregate_FieldsResolvers<ContextType>;
  feedbacks_avg_fields?: Feedbacks_Avg_FieldsResolvers<ContextType>;
  feedbacks_max_fields?: Feedbacks_Max_FieldsResolvers<ContextType>;
  feedbacks_min_fields?: Feedbacks_Min_FieldsResolvers<ContextType>;
  feedbacks_mutation_response?: Feedbacks_Mutation_ResponseResolvers<ContextType>;
  feedbacks_stddev_fields?: Feedbacks_Stddev_FieldsResolvers<ContextType>;
  feedbacks_stddev_pop_fields?: Feedbacks_Stddev_Pop_FieldsResolvers<ContextType>;
  feedbacks_stddev_samp_fields?: Feedbacks_Stddev_Samp_FieldsResolvers<ContextType>;
  feedbacks_sum_fields?: Feedbacks_Sum_FieldsResolvers<ContextType>;
  feedbacks_var_pop_fields?: Feedbacks_Var_Pop_FieldsResolvers<ContextType>;
  feedbacks_var_samp_fields?: Feedbacks_Var_Samp_FieldsResolvers<ContextType>;
  feedbacks_variance_fields?: Feedbacks_Variance_FieldsResolvers<ContextType>;
  float8?: GraphQLScalarType;
  institutions?: InstitutionsResolvers<ContextType>;
  institutions_aggregate?: Institutions_AggregateResolvers<ContextType>;
  institutions_aggregate_fields?: Institutions_Aggregate_FieldsResolvers<ContextType>;
  institutions_avg_fields?: Institutions_Avg_FieldsResolvers<ContextType>;
  institutions_max_fields?: Institutions_Max_FieldsResolvers<ContextType>;
  institutions_min_fields?: Institutions_Min_FieldsResolvers<ContextType>;
  institutions_mutation_response?: Institutions_Mutation_ResponseResolvers<ContextType>;
  institutions_stddev_fields?: Institutions_Stddev_FieldsResolvers<ContextType>;
  institutions_stddev_pop_fields?: Institutions_Stddev_Pop_FieldsResolvers<ContextType>;
  institutions_stddev_samp_fields?: Institutions_Stddev_Samp_FieldsResolvers<ContextType>;
  institutions_sum_fields?: Institutions_Sum_FieldsResolvers<ContextType>;
  institutions_var_pop_fields?: Institutions_Var_Pop_FieldsResolvers<ContextType>;
  institutions_var_samp_fields?: Institutions_Var_Samp_FieldsResolvers<ContextType>;
  institutions_variance_fields?: Institutions_Variance_FieldsResolvers<ContextType>;
  jsonb?: GraphQLScalarType;
  lessons?: LessonsResolvers<ContextType>;
  lessons_aggregate?: Lessons_AggregateResolvers<ContextType>;
  lessons_aggregate_fields?: Lessons_Aggregate_FieldsResolvers<ContextType>;
  lessons_avg_fields?: Lessons_Avg_FieldsResolvers<ContextType>;
  lessons_max_fields?: Lessons_Max_FieldsResolvers<ContextType>;
  lessons_min_fields?: Lessons_Min_FieldsResolvers<ContextType>;
  lessons_mutation_response?: Lessons_Mutation_ResponseResolvers<ContextType>;
  lessons_stddev_fields?: Lessons_Stddev_FieldsResolvers<ContextType>;
  lessons_stddev_pop_fields?: Lessons_Stddev_Pop_FieldsResolvers<ContextType>;
  lessons_stddev_samp_fields?: Lessons_Stddev_Samp_FieldsResolvers<ContextType>;
  lessons_sum_fields?: Lessons_Sum_FieldsResolvers<ContextType>;
  lessons_var_pop_fields?: Lessons_Var_Pop_FieldsResolvers<ContextType>;
  lessons_var_samp_fields?: Lessons_Var_Samp_FieldsResolvers<ContextType>;
  lessons_variance_fields?: Lessons_Variance_FieldsResolvers<ContextType>;
  mutation_root?: Mutation_RootResolvers<ContextType>;
  numeric?: GraphQLScalarType;
  plans?: PlansResolvers<ContextType>;
  plans_aggregate?: Plans_AggregateResolvers<ContextType>;
  plans_aggregate_fields?: Plans_Aggregate_FieldsResolvers<ContextType>;
  plans_avg_fields?: Plans_Avg_FieldsResolvers<ContextType>;
  plans_max_fields?: Plans_Max_FieldsResolvers<ContextType>;
  plans_min_fields?: Plans_Min_FieldsResolvers<ContextType>;
  plans_mutation_response?: Plans_Mutation_ResponseResolvers<ContextType>;
  plans_stddev_fields?: Plans_Stddev_FieldsResolvers<ContextType>;
  plans_stddev_pop_fields?: Plans_Stddev_Pop_FieldsResolvers<ContextType>;
  plans_stddev_samp_fields?: Plans_Stddev_Samp_FieldsResolvers<ContextType>;
  plans_sum_fields?: Plans_Sum_FieldsResolvers<ContextType>;
  plans_var_pop_fields?: Plans_Var_Pop_FieldsResolvers<ContextType>;
  plans_var_samp_fields?: Plans_Var_Samp_FieldsResolvers<ContextType>;
  plans_variance_fields?: Plans_Variance_FieldsResolvers<ContextType>;
  profile_sphere_association?: Profile_Sphere_AssociationResolvers<ContextType>;
  profile_sphere_association_aggregate?: Profile_Sphere_Association_AggregateResolvers<ContextType>;
  profile_sphere_association_aggregate_fields?: Profile_Sphere_Association_Aggregate_FieldsResolvers<ContextType>;
  profile_sphere_association_avg_fields?: Profile_Sphere_Association_Avg_FieldsResolvers<ContextType>;
  profile_sphere_association_max_fields?: Profile_Sphere_Association_Max_FieldsResolvers<ContextType>;
  profile_sphere_association_min_fields?: Profile_Sphere_Association_Min_FieldsResolvers<ContextType>;
  profile_sphere_association_mutation_response?: Profile_Sphere_Association_Mutation_ResponseResolvers<ContextType>;
  profile_sphere_association_stddev_fields?: Profile_Sphere_Association_Stddev_FieldsResolvers<ContextType>;
  profile_sphere_association_stddev_pop_fields?: Profile_Sphere_Association_Stddev_Pop_FieldsResolvers<ContextType>;
  profile_sphere_association_stddev_samp_fields?: Profile_Sphere_Association_Stddev_Samp_FieldsResolvers<ContextType>;
  profile_sphere_association_sum_fields?: Profile_Sphere_Association_Sum_FieldsResolvers<ContextType>;
  profile_sphere_association_var_pop_fields?: Profile_Sphere_Association_Var_Pop_FieldsResolvers<ContextType>;
  profile_sphere_association_var_samp_fields?: Profile_Sphere_Association_Var_Samp_FieldsResolvers<ContextType>;
  profile_sphere_association_variance_fields?: Profile_Sphere_Association_Variance_FieldsResolvers<ContextType>;
  profiles?: ProfilesResolvers<ContextType>;
  profiles_aggregate?: Profiles_AggregateResolvers<ContextType>;
  profiles_aggregate_fields?: Profiles_Aggregate_FieldsResolvers<ContextType>;
  profiles_avg_fields?: Profiles_Avg_FieldsResolvers<ContextType>;
  profiles_max_fields?: Profiles_Max_FieldsResolvers<ContextType>;
  profiles_min_fields?: Profiles_Min_FieldsResolvers<ContextType>;
  profiles_mutation_response?: Profiles_Mutation_ResponseResolvers<ContextType>;
  profiles_stddev_fields?: Profiles_Stddev_FieldsResolvers<ContextType>;
  profiles_stddev_pop_fields?: Profiles_Stddev_Pop_FieldsResolvers<ContextType>;
  profiles_stddev_samp_fields?: Profiles_Stddev_Samp_FieldsResolvers<ContextType>;
  profiles_sum_fields?: Profiles_Sum_FieldsResolvers<ContextType>;
  profiles_var_pop_fields?: Profiles_Var_Pop_FieldsResolvers<ContextType>;
  profiles_var_samp_fields?: Profiles_Var_Samp_FieldsResolvers<ContextType>;
  profiles_variance_fields?: Profiles_Variance_FieldsResolvers<ContextType>;
  query_root?: Query_RootResolvers<ContextType>;
  question_lesson_association?: Question_Lesson_AssociationResolvers<ContextType>;
  question_lesson_association_aggregate?: Question_Lesson_Association_AggregateResolvers<ContextType>;
  question_lesson_association_aggregate_fields?: Question_Lesson_Association_Aggregate_FieldsResolvers<ContextType>;
  question_lesson_association_avg_fields?: Question_Lesson_Association_Avg_FieldsResolvers<ContextType>;
  question_lesson_association_max_fields?: Question_Lesson_Association_Max_FieldsResolvers<ContextType>;
  question_lesson_association_min_fields?: Question_Lesson_Association_Min_FieldsResolvers<ContextType>;
  question_lesson_association_mutation_response?: Question_Lesson_Association_Mutation_ResponseResolvers<ContextType>;
  question_lesson_association_stddev_fields?: Question_Lesson_Association_Stddev_FieldsResolvers<ContextType>;
  question_lesson_association_stddev_pop_fields?: Question_Lesson_Association_Stddev_Pop_FieldsResolvers<ContextType>;
  question_lesson_association_stddev_samp_fields?: Question_Lesson_Association_Stddev_Samp_FieldsResolvers<ContextType>;
  question_lesson_association_sum_fields?: Question_Lesson_Association_Sum_FieldsResolvers<ContextType>;
  question_lesson_association_var_pop_fields?: Question_Lesson_Association_Var_Pop_FieldsResolvers<ContextType>;
  question_lesson_association_var_samp_fields?: Question_Lesson_Association_Var_Samp_FieldsResolvers<ContextType>;
  question_lesson_association_variance_fields?: Question_Lesson_Association_Variance_FieldsResolvers<ContextType>;
  questions?: QuestionsResolvers<ContextType>;
  questions_aggregate?: Questions_AggregateResolvers<ContextType>;
  questions_aggregate_fields?: Questions_Aggregate_FieldsResolvers<ContextType>;
  questions_avg_fields?: Questions_Avg_FieldsResolvers<ContextType>;
  questions_max_fields?: Questions_Max_FieldsResolvers<ContextType>;
  questions_min_fields?: Questions_Min_FieldsResolvers<ContextType>;
  questions_mutation_response?: Questions_Mutation_ResponseResolvers<ContextType>;
  questions_stddev_fields?: Questions_Stddev_FieldsResolvers<ContextType>;
  questions_stddev_pop_fields?: Questions_Stddev_Pop_FieldsResolvers<ContextType>;
  questions_stddev_samp_fields?: Questions_Stddev_Samp_FieldsResolvers<ContextType>;
  questions_sum_fields?: Questions_Sum_FieldsResolvers<ContextType>;
  questions_var_pop_fields?: Questions_Var_Pop_FieldsResolvers<ContextType>;
  questions_var_samp_fields?: Questions_Var_Samp_FieldsResolvers<ContextType>;
  questions_variance_fields?: Questions_Variance_FieldsResolvers<ContextType>;
  registration_billings?: Registration_BillingsResolvers<ContextType>;
  registration_billings_aggregate?: Registration_Billings_AggregateResolvers<ContextType>;
  registration_billings_aggregate_fields?: Registration_Billings_Aggregate_FieldsResolvers<ContextType>;
  registration_billings_avg_fields?: Registration_Billings_Avg_FieldsResolvers<ContextType>;
  registration_billings_max_fields?: Registration_Billings_Max_FieldsResolvers<ContextType>;
  registration_billings_min_fields?: Registration_Billings_Min_FieldsResolvers<ContextType>;
  registration_billings_mutation_response?: Registration_Billings_Mutation_ResponseResolvers<ContextType>;
  registration_billings_stddev_fields?: Registration_Billings_Stddev_FieldsResolvers<ContextType>;
  registration_billings_stddev_pop_fields?: Registration_Billings_Stddev_Pop_FieldsResolvers<ContextType>;
  registration_billings_stddev_samp_fields?: Registration_Billings_Stddev_Samp_FieldsResolvers<ContextType>;
  registration_billings_sum_fields?: Registration_Billings_Sum_FieldsResolvers<ContextType>;
  registration_billings_var_pop_fields?: Registration_Billings_Var_Pop_FieldsResolvers<ContextType>;
  registration_billings_var_samp_fields?: Registration_Billings_Var_Samp_FieldsResolvers<ContextType>;
  registration_billings_variance_fields?: Registration_Billings_Variance_FieldsResolvers<ContextType>;
  registrations?: RegistrationsResolvers<ContextType>;
  registrations_aggregate?: Registrations_AggregateResolvers<ContextType>;
  registrations_aggregate_fields?: Registrations_Aggregate_FieldsResolvers<ContextType>;
  registrations_avg_fields?: Registrations_Avg_FieldsResolvers<ContextType>;
  registrations_max_fields?: Registrations_Max_FieldsResolvers<ContextType>;
  registrations_min_fields?: Registrations_Min_FieldsResolvers<ContextType>;
  registrations_mutation_response?: Registrations_Mutation_ResponseResolvers<ContextType>;
  registrations_stddev_fields?: Registrations_Stddev_FieldsResolvers<ContextType>;
  registrations_stddev_pop_fields?: Registrations_Stddev_Pop_FieldsResolvers<ContextType>;
  registrations_stddev_samp_fields?: Registrations_Stddev_Samp_FieldsResolvers<ContextType>;
  registrations_sum_fields?: Registrations_Sum_FieldsResolvers<ContextType>;
  registrations_var_pop_fields?: Registrations_Var_Pop_FieldsResolvers<ContextType>;
  registrations_var_samp_fields?: Registrations_Var_Samp_FieldsResolvers<ContextType>;
  registrations_variance_fields?: Registrations_Variance_FieldsResolvers<ContextType>;
  result_plan_association?: Result_Plan_AssociationResolvers<ContextType>;
  result_plan_association_aggregate?: Result_Plan_Association_AggregateResolvers<ContextType>;
  result_plan_association_aggregate_fields?: Result_Plan_Association_Aggregate_FieldsResolvers<ContextType>;
  result_plan_association_avg_fields?: Result_Plan_Association_Avg_FieldsResolvers<ContextType>;
  result_plan_association_max_fields?: Result_Plan_Association_Max_FieldsResolvers<ContextType>;
  result_plan_association_min_fields?: Result_Plan_Association_Min_FieldsResolvers<ContextType>;
  result_plan_association_mutation_response?: Result_Plan_Association_Mutation_ResponseResolvers<ContextType>;
  result_plan_association_stddev_fields?: Result_Plan_Association_Stddev_FieldsResolvers<ContextType>;
  result_plan_association_stddev_pop_fields?: Result_Plan_Association_Stddev_Pop_FieldsResolvers<ContextType>;
  result_plan_association_stddev_samp_fields?: Result_Plan_Association_Stddev_Samp_FieldsResolvers<ContextType>;
  result_plan_association_sum_fields?: Result_Plan_Association_Sum_FieldsResolvers<ContextType>;
  result_plan_association_var_pop_fields?: Result_Plan_Association_Var_Pop_FieldsResolvers<ContextType>;
  result_plan_association_var_samp_fields?: Result_Plan_Association_Var_Samp_FieldsResolvers<ContextType>;
  result_plan_association_variance_fields?: Result_Plan_Association_Variance_FieldsResolvers<ContextType>;
  results?: ResultsResolvers<ContextType>;
  results_aggregate?: Results_AggregateResolvers<ContextType>;
  results_aggregate_fields?: Results_Aggregate_FieldsResolvers<ContextType>;
  results_avg_fields?: Results_Avg_FieldsResolvers<ContextType>;
  results_max_fields?: Results_Max_FieldsResolvers<ContextType>;
  results_min_fields?: Results_Min_FieldsResolvers<ContextType>;
  results_mutation_response?: Results_Mutation_ResponseResolvers<ContextType>;
  results_stddev_fields?: Results_Stddev_FieldsResolvers<ContextType>;
  results_stddev_pop_fields?: Results_Stddev_Pop_FieldsResolvers<ContextType>;
  results_stddev_samp_fields?: Results_Stddev_Samp_FieldsResolvers<ContextType>;
  results_sum_fields?: Results_Sum_FieldsResolvers<ContextType>;
  results_var_pop_fields?: Results_Var_Pop_FieldsResolvers<ContextType>;
  results_var_samp_fields?: Results_Var_Samp_FieldsResolvers<ContextType>;
  results_variance_fields?: Results_Variance_FieldsResolvers<ContextType>;
  scores?: ScoresResolvers<ContextType>;
  scores_aggregate?: Scores_AggregateResolvers<ContextType>;
  scores_aggregate_fields?: Scores_Aggregate_FieldsResolvers<ContextType>;
  scores_avg_fields?: Scores_Avg_FieldsResolvers<ContextType>;
  scores_max_fields?: Scores_Max_FieldsResolvers<ContextType>;
  scores_min_fields?: Scores_Min_FieldsResolvers<ContextType>;
  scores_mutation_response?: Scores_Mutation_ResponseResolvers<ContextType>;
  scores_stddev_fields?: Scores_Stddev_FieldsResolvers<ContextType>;
  scores_stddev_pop_fields?: Scores_Stddev_Pop_FieldsResolvers<ContextType>;
  scores_stddev_samp_fields?: Scores_Stddev_Samp_FieldsResolvers<ContextType>;
  scores_sum_fields?: Scores_Sum_FieldsResolvers<ContextType>;
  scores_var_pop_fields?: Scores_Var_Pop_FieldsResolvers<ContextType>;
  scores_var_samp_fields?: Scores_Var_Samp_FieldsResolvers<ContextType>;
  scores_variance_fields?: Scores_Variance_FieldsResolvers<ContextType>;
  spheres?: SpheresResolvers<ContextType>;
  spheres_aggregate?: Spheres_AggregateResolvers<ContextType>;
  spheres_aggregate_fields?: Spheres_Aggregate_FieldsResolvers<ContextType>;
  spheres_avg_fields?: Spheres_Avg_FieldsResolvers<ContextType>;
  spheres_max_fields?: Spheres_Max_FieldsResolvers<ContextType>;
  spheres_min_fields?: Spheres_Min_FieldsResolvers<ContextType>;
  spheres_mutation_response?: Spheres_Mutation_ResponseResolvers<ContextType>;
  spheres_stddev_fields?: Spheres_Stddev_FieldsResolvers<ContextType>;
  spheres_stddev_pop_fields?: Spheres_Stddev_Pop_FieldsResolvers<ContextType>;
  spheres_stddev_samp_fields?: Spheres_Stddev_Samp_FieldsResolvers<ContextType>;
  spheres_sum_fields?: Spheres_Sum_FieldsResolvers<ContextType>;
  spheres_var_pop_fields?: Spheres_Var_Pop_FieldsResolvers<ContextType>;
  spheres_var_samp_fields?: Spheres_Var_Samp_FieldsResolvers<ContextType>;
  spheres_variance_fields?: Spheres_Variance_FieldsResolvers<ContextType>;
  subscription_root?: Subscription_RootResolvers<ContextType>;
  supports?: SupportsResolvers<ContextType>;
  supports_aggregate?: Supports_AggregateResolvers<ContextType>;
  supports_aggregate_fields?: Supports_Aggregate_FieldsResolvers<ContextType>;
  supports_avg_fields?: Supports_Avg_FieldsResolvers<ContextType>;
  supports_max_fields?: Supports_Max_FieldsResolvers<ContextType>;
  supports_min_fields?: Supports_Min_FieldsResolvers<ContextType>;
  supports_mutation_response?: Supports_Mutation_ResponseResolvers<ContextType>;
  supports_stddev_fields?: Supports_Stddev_FieldsResolvers<ContextType>;
  supports_stddev_pop_fields?: Supports_Stddev_Pop_FieldsResolvers<ContextType>;
  supports_stddev_samp_fields?: Supports_Stddev_Samp_FieldsResolvers<ContextType>;
  supports_sum_fields?: Supports_Sum_FieldsResolvers<ContextType>;
  supports_var_pop_fields?: Supports_Var_Pop_FieldsResolvers<ContextType>;
  supports_var_samp_fields?: Supports_Var_Samp_FieldsResolvers<ContextType>;
  supports_variance_fields?: Supports_Variance_FieldsResolvers<ContextType>;
  timestamp?: GraphQLScalarType;
  timestamptz?: GraphQLScalarType;
  users?: UsersResolvers<ContextType>;
  users_aggregate?: Users_AggregateResolvers<ContextType>;
  users_aggregate_fields?: Users_Aggregate_FieldsResolvers<ContextType>;
  users_avg_fields?: Users_Avg_FieldsResolvers<ContextType>;
  users_max_fields?: Users_Max_FieldsResolvers<ContextType>;
  users_min_fields?: Users_Min_FieldsResolvers<ContextType>;
  users_mutation_response?: Users_Mutation_ResponseResolvers<ContextType>;
  users_stddev_fields?: Users_Stddev_FieldsResolvers<ContextType>;
  users_stddev_pop_fields?: Users_Stddev_Pop_FieldsResolvers<ContextType>;
  users_stddev_samp_fields?: Users_Stddev_Samp_FieldsResolvers<ContextType>;
  users_sum_fields?: Users_Sum_FieldsResolvers<ContextType>;
  users_var_pop_fields?: Users_Var_Pop_FieldsResolvers<ContextType>;
  users_var_samp_fields?: Users_Var_Samp_FieldsResolvers<ContextType>;
  users_variance_fields?: Users_Variance_FieldsResolvers<ContextType>;
};


/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
 */
export type IResolvers<ContextType = any> = Resolvers<ContextType>;
export type DirectiveResolvers<ContextType = any> = {
  NgModule?: NgModuleDirectiveResolver<any, any, ContextType>;
  namedClient?: NamedClientDirectiveResolver<any, any, ContextType>;
};


/**
 * @deprecated
 * Use "DirectiveResolvers" root object instead. If you wish to get "IDirectiveResolvers", add "typesPrefix: I" to your config.
 */
export type IDirectiveResolvers<ContextType = any> = DirectiveResolvers<ContextType>;
export const GetAllInstitutionsDocument = gql`
    query getAllInstitutions {
  institutions {
    name
    id
    credits
    logo
    exams
    slug
    credit_duration
    credits_logs {
      billed_at
      created_at
      created_by
      credits
      id
      info
      institution_id
      institution {
        id
        name
        credits
      }
      profile {
        user {
          email
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllInstitutionsGQL extends Apollo.Query<GetAllInstitutionsQuery, GetAllInstitutionsQueryVariables> {
    document = GetAllInstitutionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllInstitutionsByExamDocument = gql`
    query getAllInstitutionsByExam($exam: String!) {
  institutions(where: {exams: {_has_key: $exam}}) {
    name
    id
    credits
    logo
    exams
    slug
    is_root_institution
    parent_institution {
      name
    }
    parent_institution_id
    credit_duration
    credits_logs {
      billed_at
      created_at
      created_by
      credits
      id
      info
      institution_id
      institution {
        id
        name
        credits
      }
      profile {
        user {
          email
        }
      }
    }
    subInstitutions {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllInstitutionsByExamGQL extends Apollo.Query<GetAllInstitutionsByExamQuery, GetAllInstitutionsByExamQueryVariables> {
    document = GetAllInstitutionsByExamDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRegistrationBillingsDocument = gql`
    query GetRegistrationBillings {
  registration_billings {
    created_at
    created_by
    id
    info
    institution_id
    institution {
      name
    }
    profile {
      user {
        email
      }
    }
    updated_at
    registrations_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRegistrationBillingsGQL extends Apollo.Query<GetRegistrationBillingsQuery, GetRegistrationBillingsQueryVariables> {
    document = GetRegistrationBillingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRegistrationsDocument = gql`
    query GetRegistrations {
  registrations {
    level
    registration_billing_id
    institution_id
    institution {
      parent_institution_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRegistrationsGQL extends Apollo.Query<GetRegistrationsQuery, GetRegistrationsQueryVariables> {
    document = GetRegistrationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRegistrationByRegistrationBillingIdDocument = gql`
    mutation UpdateRegistrationByRegistrationBillingId($registrationBillingId: Int!, $registrationsIds: [Int!]!) {
  update_registrations(where: {id: {_in: $registrationsIds}}, _set: {registration_billing_id: $registrationBillingId}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRegistrationByRegistrationBillingIdGQL extends Apollo.Mutation<UpdateRegistrationByRegistrationBillingIdMutation, UpdateRegistrationByRegistrationBillingIdMutationVariables> {
    document = UpdateRegistrationByRegistrationBillingIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAnswersDocument = gql`
    query GetAnswers($exam: exam_types!, $supportParts: [Int!]!, $institutionId: Int!, $profileIds: [Int!]!) {
  answers(where: {exam_type: {_eq: $exam}, part: {_in: $supportParts}, profile: {institution_id: {_eq: $institutionId}, is_manager: {_eq: false}, id: {_in: $profileIds}}, extra_value: {_is_null: false}, _or: [{is_mock: {_eq: true}}, {need_feedback: {_eq: true}}]}) {
    extra_value
    id
    feedback_by
    feedback_at
    feedback_score
    feedback
    result_id
    is_mock
    result {
      listening_score
      oral_score
      writing_score
      reading_score
    }
    created_at
    user {
      first_name
      last_name
      email
    }
    question {
      value
      support {
        part
        id
        exam {
          level
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAnswersGQL extends Apollo.Query<GetAnswersQuery, GetAnswersQueryVariables> {
    document = GetAnswersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAnswersByProfileIdDocument = gql`
    query GetAnswersByProfileId($exam: exam_types!, $supportParts: [Int!]!, $profileId: Int!) {
  answers(where: {exam_type: {_eq: $exam}, part: {_in: $supportParts}, profile: {id: {_eq: $profileId}}, extra_value: {_is_null: false}, _or: [{is_mock: {_eq: true}}, {need_feedback: {_eq: true}}]}) {
    extra_value
    id
    is_mock
    result_id
    feedback_by
    feedback_at
    feedback_score
    feedback
    created_at
    question {
      value
      support {
        part
        id
        exam {
          level
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAnswersByProfileIdGQL extends Apollo.Query<GetAnswersByProfileIdQuery, GetAnswersByProfileIdQueryVariables> {
    document = GetAnswersByProfileIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLightAnswersByResultIdDocument = gql`
    query GetLightAnswersByResultId($resultId: Int!) {
  answers(where: {result_id: {_eq: $resultId}}) {
    feedback_score
    part
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLightAnswersByResultIdGQL extends Apollo.Query<GetLightAnswersByResultIdQuery, GetLightAnswersByResultIdQueryVariables> {
    document = GetLightAnswersByResultIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserWithProfilesByUsernameDocument = gql`
    query getUserWithProfilesByUsername($username: String!) {
  users(where: {username: {_eq: $username}}) {
    address
    birth_year
    city
    email
    first_name
    id
    is_student
    last_name
    password_hash
    postal_code
    profiles {
      institution_id
      is_teacher
      is_manager
      exam_type
      id
      user_id
      expiration_date
      is_admin
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserWithProfilesByUsernameGQL extends Apollo.Query<GetUserWithProfilesByUsernameQuery, GetUserWithProfilesByUsernameQueryVariables> {
    document = GetUserWithProfilesByUsernameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const Get_Bright_Assessment_By_PkDocument = gql`
    query get_bright_assessment_by_pk($pk: Int!) {
  bright_assessment(where: {id: {_eq: $pk}}, limit: 1) {
    assessments_id
    bright_assessment_id
    id
    tester_id
    bright_assessment {
      createdDate
      endDate
      id
      institutionId
      openedDate
      teacherId
      title
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Get_Bright_Assessment_By_PkGQL extends Apollo.Query<Get_Bright_Assessment_By_PkQuery, Get_Bright_Assessment_By_PkQueryVariables> {
    document = Get_Bright_Assessment_By_PkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const Get_Bright_Assessments_And_Teacher_IdDocument = gql`
    query get_bright_assessments_and_teacher_id($teacherId: Int!, $id: Int!) {
  bright_assessments(where: {teacherId: {_eq: $teacherId}, id: {_eq: $id}}) {
    teacherId
    openedDate
    institutionId
    id
    title
    endDate
    bright_assessments {
      id
      assessments_id
      bright_assessment_id
      profile {
        user_id
        user {
          email
          first_name
          last_name
          username
        }
        time_spent
        objective
        last_time_spent_update
        is_teacher
        is_manager
        institution_id
        id
        expiration_date
        exam_type
        current_exam_id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Get_Bright_Assessments_And_Teacher_IdGQL extends Apollo.Query<Get_Bright_Assessments_And_Teacher_IdQuery, Get_Bright_Assessments_And_Teacher_IdQueryVariables> {
    document = Get_Bright_Assessments_And_Teacher_IdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFullProfilesByIdDocument = gql`
    query getFullProfilesById($id: Int!) {
  profiles_by_pk(id: $id) {
    current_exam_id
    exam_type
    expiration_date
    id
    institution {
      id
      logo
      name
      bright_branch {
        bright_branch_id
      }
    }
    is_manager
    is_teacher
    last_time_spent_update
    objective
    time_spent
    user {
      first_name
      last_name
      email
    }
    bright_candidates {
      bright_candidate_id
      manager_id
    }
    bright_manager {
      bright_manager_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFullProfilesByIdGQL extends Apollo.Query<GetFullProfilesByIdQuery, GetFullProfilesByIdQueryVariables> {
    document = GetFullProfilesByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertBrightBranchDocument = gql`
    mutation insertBrightBranch($brightBranchId: Int!, $institutionId: Int!) {
  insert_bright_branch(objects: {bright_branch_id: $brightBranchId, institution_id: $institutionId}) {
    returning {
      institution_id
      bright_branch_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertBrightBranchGQL extends Apollo.Mutation<InsertBrightBranchMutation, InsertBrightBranchMutationVariables> {
    document = InsertBrightBranchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertBrightCandidateDocument = gql`
    mutation insertBrightCandidate($brightCandidateId: Int!, $candidateId: Int!, $managerId: Int!) {
  insert_bright_candidate(objects: {candidate_id: $candidateId, bright_candidate_id: $brightCandidateId, manager_id: $managerId}) {
    returning {
      bright_candidate_id
      candidate_id
      manager_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertBrightCandidateGQL extends Apollo.Mutation<InsertBrightCandidateMutation, InsertBrightCandidateMutationVariables> {
    document = InsertBrightCandidateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertBrightManagerDocument = gql`
    mutation insertBrightManager($brightManagerId: Int!, $managerId: Int!) {
  insert_bright_manager(objects: {bright_manager_id: $brightManagerId, manager_id: $managerId}) {
    returning {
      bright_manager_id
      manager_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertBrightManagerGQL extends Apollo.Mutation<InsertBrightManagerMutation, InsertBrightManagerMutationVariables> {
    document = InsertBrightManagerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const Update_Bright_AssessmentDocument = gql`
    mutation update_bright_assessment($id: Int!, $assessment_id: Int!) {
  update_bright_assessment(where: {id: {_eq: $id}}, _set: {assessments_id: $assessment_id}) {
    returning {
      assessments_id
      bright_assessment_id
      id
      tester_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Update_Bright_AssessmentGQL extends Apollo.Mutation<Update_Bright_AssessmentMutation, Update_Bright_AssessmentMutationVariables> {
    document = Update_Bright_AssessmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActivationCodeByCodeDocument = gql`
    query getActivationCodeByCode($code: String!) {
  activation_codes(where: {code: {_eq: $code}}, limit: 1) {
    activated_by
    activation_date
    code
    extra_days
    id
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActivationCodeByCodeGQL extends Apollo.Query<GetActivationCodeByCodeQuery, GetActivationCodeByCodeQueryVariables> {
    document = GetActivationCodeByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCouponsByProfileIdDocument = gql`
    query getCouponsByProfileId($profileId: Int!) {
  __typename
  activation_codes(where: {activated_by: {_eq: $profileId}}) {
    activation_date
    activated_by
    code
    id
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCouponsByProfileIdGQL extends Apollo.Query<GetCouponsByProfileIdQuery, GetCouponsByProfileIdQueryVariables> {
    document = GetCouponsByProfileIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCouponByProfileIdDocument = gql`
    mutation InsertCouponByProfileId($profileId: Int!, $activationDate: timestamp!, $promoCode: String!, $type: String!) {
  __typename
  insert_activation_codes(objects: {activated_by: $profileId, activation_date: $activationDate, code: $promoCode, type: $type}) {
    returning {
      activated_by
      activation_date
      code
      id
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertCouponByProfileIdGQL extends Apollo.Mutation<InsertCouponByProfileIdMutation, InsertCouponByProfileIdMutationVariables> {
    document = InsertCouponByProfileIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateActivationCodesByIdDocument = gql`
    mutation updateActivationCodesById($id: Int!, $object: activation_codes_set_input!) {
  __typename
  update_activation_codes(where: {id: {_eq: $id}}, _set: $object) {
    returning {
      activated_by
      activation_date
      code
      extra_days
      id
      type
    }
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateActivationCodesByIdGQL extends Apollo.Mutation<UpdateActivationCodesByIdMutation, UpdateActivationCodesByIdMutationVariables> {
    document = UpdateActivationCodesByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCreditsLogDocument = gql`
    query GetCreditsLog {
  credits_log {
    billed_at
    created_at
    created_by
    credits
    id
    info
    institution_id
    institution {
      name
    }
    profile {
      user {
        email
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCreditsLogGQL extends Apollo.Query<GetCreditsLogQuery, GetCreditsLogQueryVariables> {
    document = GetCreditsLogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInstitutionsDocument = gql`
    query GetInstitutions {
  institutions {
    credits
    id
    logo
    name
    slug
    credit_duration
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInstitutionsGQL extends Apollo.Query<GetInstitutionsQuery, GetInstitutionsQueryVariables> {
    document = GetInstitutionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSubInstitutionsByPkDocument = gql`
    query GetSubInstitutionsByPk($institutionPk: Int!) {
  institutions_by_pk(id: $institutionPk) {
    subInstitutions {
      name
      id
      credits
      logo
      name
      slug
      credit_duration
      registrations {
        id
        created_by
        email
        created_at
        duration
        level
        creator {
          email
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSubInstitutionsByPkGQL extends Apollo.Query<GetSubInstitutionsByPkQuery, GetSubInstitutionsByPkQueryVariables> {
    document = GetSubInstitutionsByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileByProfileIdDocument = gql`
    query getProfileByProfileId($profileId: Int!) {
  __typename
  profiles(where: {id: {_eq: $profileId}}, limit: 1) {
    expiration_date
    last_time_spent_update
    objective
    id
    time_spent
    institution_id
    exam_type
    user {
      address
      birth_year
      city
      email
      first_name
      id
      is_student
      last_name
      profiles {
        expiration_date
      }
    }
    estimated_scores(order_by: {created_at: desc}) {
      score
      created_at
      exam_type
    }
    answers_aggregate {
      aggregate {
        count
      }
    }
    activation_codes {
      activated_by
      activation_date
      code
      id
      type
    }
    is_manager
    is_teacher
    bills {
      days
      date
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileByProfileIdGQL extends Apollo.Query<GetProfileByProfileIdQuery, GetProfileByProfileIdQueryVariables> {
    document = GetProfileByProfileIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSpheresFromProfileIdDocument = gql`
    query GetSpheresFromProfileId($profileId: Int!) {
  profile_sphere_association(where: {profile_id: {_eq: $profileId}}) {
    sphere {
      name
      is_global
      teacher_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSpheresFromProfileIdGQL extends Apollo.Query<GetSpheresFromProfileIdQuery, GetSpheresFromProfileIdQueryVariables> {
    document = GetSpheresFromProfileIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const Update_ProfilesForExpirationDateDocument = gql`
    mutation update_profilesForExpirationDate($id: Int!, $expirationDate: timestamp!) {
  __typename
  update_profiles(where: {id: {_eq: $id}}, _set: {expiration_date: $expirationDate}) {
    returning {
      id
      expiration_date
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Update_ProfilesForExpirationDateGQL extends Apollo.Mutation<Update_ProfilesForExpirationDateMutation, Update_ProfilesForExpirationDateMutationVariables> {
    document = Update_ProfilesForExpirationDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAnswersFromResultsByPkDocument = gql`
    query getAnswersFromResultsByPk($id: Int!) {
  results_by_pk(id: $id) {
    listening_score
    reading_score
    score
    answers(order_by: {created_at: asc}) {
      created_at
      exam_type
      extra_value
      is_correct
      is_mock
      question_id
      part
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAnswersFromResultsByPkGQL extends Apollo.Query<GetAnswersFromResultsByPkQuery, GetAnswersFromResultsByPkQueryVariables> {
    document = GetAnswersFromResultsByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStudentsProfileByInstitudionIdDocument = gql`
    query getStudentsProfileByInstitudionId($institutionId: Int!, $examType: exam_types!) {
  __typename
  profiles(where: {institution_id: {_eq: $institutionId}, is_manager: {_eq: false}, is_teacher: {_eq: false}, exam_type: {_eq: $examType}}) {
    expiration_date
    last_time_spent_update
    objective
    time_spent
    level
    user {
      address
      birth_year
      city
      email
      first_name
      id
      is_student
      last_name
      profiles {
        expiration_date
        last_time_spent_update
      }
    }
    estimated_scores(order_by: {created_at: desc}, where: {type: {_eq: "automatic"}}) {
      score
      created_at
      exam_type
    }
    manual_estimated_scores: estimated_scores(order_by: {created_at: desc}, where: {type: {_eq: "manual"}}) {
      score
      created_at
      exam_type
    }
    answers_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStudentsProfileByInstitudionIdGQL extends Apollo.Query<GetStudentsProfileByInstitudionIdQuery, GetStudentsProfileByInstitudionIdQueryVariables> {
    document = GetStudentsProfileByInstitudionIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStudentsProfileByInstitudionIdAndSphereDocument = gql`
    query getStudentsProfileByInstitudionIdAndSphere($institutionId: Int!, $examType: exam_types!, $sphereId: Int!) {
  __typename
  profiles(where: {institution_id: {_eq: $institutionId}, is_manager: {_eq: false}, is_teacher: {_eq: false}, exam_type: {_eq: $examType}, profile_sphere_associations: {sphere_id: {_eq: $sphereId}}}) {
    expiration_date
    last_time_spent_update
    objective
    time_spent
    level
    user {
      address
      birth_year
      city
      email
      first_name
      id
      is_student
      last_name
      profiles {
        expiration_date
        last_time_spent_update
      }
    }
    estimated_scores(order_by: {created_at: desc}, where: {type: {_eq: "automatic"}}) {
      score
      created_at
      exam_type
    }
    manual_estimated_scores: estimated_scores(order_by: {created_at: desc}, where: {type: {_eq: "manual"}}) {
      score
      created_at
      exam_type
    }
    answers_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStudentsProfileByInstitudionIdAndSphereGQL extends Apollo.Query<GetStudentsProfileByInstitudionIdAndSphereQuery, GetStudentsProfileByInstitudionIdAndSphereQueryVariables> {
    document = GetStudentsProfileByInstitudionIdAndSphereDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStudentProfileByInstitudionIdAndProfileIdDocument = gql`
    query getStudentProfileByInstitudionIdAndProfileId($institutionId: Int!, $profileId: Int!, $examType: exam_types!) {
  __typename
  profiles(where: {institution_id: {_eq: $institutionId}, is_manager: {_eq: false}, is_teacher: {_eq: false}, exam_type: {_eq: $examType}, id: {_eq: $profileId}}, limit: 1) {
    expiration_date
    last_time_spent_update
    objective
    time_spent
    user {
      address
      birth_year
      city
      email
      first_name
      id
      is_student
      last_name
      profiles {
        expiration_date
        last_time_spent_update
      }
      scores {
        id
        known_date
        lesson {
          title
        }
      }
    }
    estimated_scores(order_by: {created_at: desc}, where: {type: {_eq: "automatic"}}) {
      score
      created_at
      exam_type
    }
    manual_estimated_scores: estimated_scores(order_by: {created_at: desc}, where: {type: {_eq: "manual"}}) {
      score
      created_at
      exam_type
    }
    answers_aggregate {
      aggregate {
        count
      }
    }
    institution {
      logo
    }
    answers {
      created_at
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStudentProfileByInstitudionIdAndProfileIdGQL extends Apollo.Query<GetStudentProfileByInstitudionIdAndProfileIdQuery, GetStudentProfileByInstitudionIdAndProfileIdQueryVariables> {
    document = GetStudentProfileByInstitudionIdAndProfileIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSupportByPkDocument = gql`
    query GetSupportByPk($id: Int!) {
  supports_by_pk(id: $id) {
    exam_audio
    exam_id
    exam {
      level
    }
    id
    image
    instructions
    part
    text
    training_audio
    questions {
      choices {
        id
        image
        is_correct
        question_id
        text
      }
      correction
      id
      text
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSupportByPkGQL extends Apollo.Query<GetSupportByPkQuery, GetSupportByPkQueryVariables> {
    document = GetSupportByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }